
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aH5kf", function(module, exports) {

$parcel$export(module.exports, "register", () => $7c920d0fac348c0f$export$6503ec6e8aabbaf, (v) => $7c920d0fac348c0f$export$6503ec6e8aabbaf = v);
var $7c920d0fac348c0f$export$6503ec6e8aabbaf;
var $7c920d0fac348c0f$export$f7ad0328861e2f03;
"use strict";
var $7c920d0fac348c0f$var$mapping = new Map();
function $7c920d0fac348c0f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$7c920d0fac348c0f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $7c920d0fac348c0f$var$resolve(id) {
    var resolved = $7c920d0fac348c0f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$7c920d0fac348c0f$export$6503ec6e8aabbaf = $7c920d0fac348c0f$var$register;
$7c920d0fac348c0f$export$f7ad0328861e2f03 = $7c920d0fac348c0f$var$resolve;

});

parcelRegister("2QVmd", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $213cee128d2f0e73$export$ffb0004e005737fa, (v) => $213cee128d2f0e73$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $213cee128d2f0e73$export$34b9dba7ce09269b, (v) => $213cee128d2f0e73$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $213cee128d2f0e73$export$25062201e9e25d76, (v) => $213cee128d2f0e73$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $213cee128d2f0e73$export$ffb0004e005737fa;
var $213cee128d2f0e73$export$34b9dba7ce09269b;
var $213cee128d2f0e73$export$25062201e9e25d76;
'use strict';

var $ajtHG = parcelRequire("ajtHG");
var $213cee128d2f0e73$var$k = Symbol.for("react.element"), $213cee128d2f0e73$var$l = Symbol.for("react.fragment"), $213cee128d2f0e73$var$m = Object.prototype.hasOwnProperty, $213cee128d2f0e73$var$n = $ajtHG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $213cee128d2f0e73$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $213cee128d2f0e73$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$213cee128d2f0e73$var$m.call(a, b) && !$213cee128d2f0e73$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $213cee128d2f0e73$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $213cee128d2f0e73$var$n.current
    };
}
$213cee128d2f0e73$export$ffb0004e005737fa = $213cee128d2f0e73$var$l;
$213cee128d2f0e73$export$34b9dba7ce09269b = $213cee128d2f0e73$var$q;
$213cee128d2f0e73$export$25062201e9e25d76 = $213cee128d2f0e73$var$q;

});
parcelRegister("ajtHG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aWZ3F"));

});
parcelRegister("aWZ3F", function(module, exports) {

$parcel$export(module.exports, "Children", () => $7f8eaf0ea10aa8bf$export$dca3b0875bd9a954, (v) => $7f8eaf0ea10aa8bf$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $7f8eaf0ea10aa8bf$export$16fa2f45be04daa8, (v) => $7f8eaf0ea10aa8bf$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $7f8eaf0ea10aa8bf$export$ffb0004e005737fa, (v) => $7f8eaf0ea10aa8bf$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $7f8eaf0ea10aa8bf$export$e2c29f18771995cb, (v) => $7f8eaf0ea10aa8bf$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $7f8eaf0ea10aa8bf$export$221d75b3f55bb0bd, (v) => $7f8eaf0ea10aa8bf$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $7f8eaf0ea10aa8bf$export$5f8d39834fd61797, (v) => $7f8eaf0ea10aa8bf$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7f8eaf0ea10aa8bf$export$74bf444e3cd11ea5, (v) => $7f8eaf0ea10aa8bf$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7f8eaf0ea10aa8bf$export$ae55be85d98224ed, (v) => $7f8eaf0ea10aa8bf$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $7f8eaf0ea10aa8bf$export$3ba232387fd5d6dd, (v) => $7f8eaf0ea10aa8bf$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $7f8eaf0ea10aa8bf$export$e530037191fcd5d7, (v) => $7f8eaf0ea10aa8bf$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $7f8eaf0ea10aa8bf$export$fd42f52fd3ae1109, (v) => $7f8eaf0ea10aa8bf$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $7f8eaf0ea10aa8bf$export$c8a8987d4410bf2d, (v) => $7f8eaf0ea10aa8bf$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $7f8eaf0ea10aa8bf$export$d38cd72104c1f0e9, (v) => $7f8eaf0ea10aa8bf$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $7f8eaf0ea10aa8bf$export$7d1e3a5e95ceca43, (v) => $7f8eaf0ea10aa8bf$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $7f8eaf0ea10aa8bf$export$257a8862b851cb5b, (v) => $7f8eaf0ea10aa8bf$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $7f8eaf0ea10aa8bf$export$a8257692ac88316c, (v) => $7f8eaf0ea10aa8bf$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $7f8eaf0ea10aa8bf$export$488013bae63b21da, (v) => $7f8eaf0ea10aa8bf$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $7f8eaf0ea10aa8bf$export$7c73462e0d25e514, (v) => $7f8eaf0ea10aa8bf$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $7f8eaf0ea10aa8bf$export$7568632d0d33d16d, (v) => $7f8eaf0ea10aa8bf$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $7f8eaf0ea10aa8bf$export$88948ce120ea2619, (v) => $7f8eaf0ea10aa8bf$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $7f8eaf0ea10aa8bf$export$35808ee640e87ca7, (v) => $7f8eaf0ea10aa8bf$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $7f8eaf0ea10aa8bf$export$fae74005e78b1a27, (v) => $7f8eaf0ea10aa8bf$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $7f8eaf0ea10aa8bf$export$dc8fbce3eb94dc1e, (v) => $7f8eaf0ea10aa8bf$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $7f8eaf0ea10aa8bf$export$6a7bc4e911dc01cf, (v) => $7f8eaf0ea10aa8bf$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $7f8eaf0ea10aa8bf$export$6d9c69b0de29b591, (v) => $7f8eaf0ea10aa8bf$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $7f8eaf0ea10aa8bf$export$f680877a34711e37, (v) => $7f8eaf0ea10aa8bf$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $7f8eaf0ea10aa8bf$export$d5a552a76deda3c2, (v) => $7f8eaf0ea10aa8bf$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $7f8eaf0ea10aa8bf$export$aaabe4eda9ed9969, (v) => $7f8eaf0ea10aa8bf$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $7f8eaf0ea10aa8bf$export$e5c5a5f917a5871c, (v) => $7f8eaf0ea10aa8bf$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $7f8eaf0ea10aa8bf$export$1538c33de8887b59, (v) => $7f8eaf0ea10aa8bf$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $7f8eaf0ea10aa8bf$export$13e3392192263954, (v) => $7f8eaf0ea10aa8bf$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $7f8eaf0ea10aa8bf$export$b8f5890fc79d6aca, (v) => $7f8eaf0ea10aa8bf$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $7f8eaf0ea10aa8bf$export$60241385465d0a34, (v) => $7f8eaf0ea10aa8bf$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $7f8eaf0ea10aa8bf$export$306c0aa65ff9ec16, (v) => $7f8eaf0ea10aa8bf$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $7f8eaf0ea10aa8bf$export$7b286972b8d8ccbf, (v) => $7f8eaf0ea10aa8bf$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $7f8eaf0ea10aa8bf$export$83d89fbfd8236492, (v) => $7f8eaf0ea10aa8bf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7f8eaf0ea10aa8bf$export$dca3b0875bd9a954;
var $7f8eaf0ea10aa8bf$export$16fa2f45be04daa8;
var $7f8eaf0ea10aa8bf$export$ffb0004e005737fa;
var $7f8eaf0ea10aa8bf$export$e2c29f18771995cb;
var $7f8eaf0ea10aa8bf$export$221d75b3f55bb0bd;
var $7f8eaf0ea10aa8bf$export$5f8d39834fd61797;
var $7f8eaf0ea10aa8bf$export$74bf444e3cd11ea5;
var $7f8eaf0ea10aa8bf$export$ae55be85d98224ed;
var $7f8eaf0ea10aa8bf$export$3ba232387fd5d6dd;
var $7f8eaf0ea10aa8bf$export$e530037191fcd5d7;
var $7f8eaf0ea10aa8bf$export$fd42f52fd3ae1109;
var $7f8eaf0ea10aa8bf$export$c8a8987d4410bf2d;
var $7f8eaf0ea10aa8bf$export$d38cd72104c1f0e9;
var $7f8eaf0ea10aa8bf$export$7d1e3a5e95ceca43;
var $7f8eaf0ea10aa8bf$export$257a8862b851cb5b;
var $7f8eaf0ea10aa8bf$export$a8257692ac88316c;
var $7f8eaf0ea10aa8bf$export$488013bae63b21da;
var $7f8eaf0ea10aa8bf$export$7c73462e0d25e514;
var $7f8eaf0ea10aa8bf$export$7568632d0d33d16d;
var $7f8eaf0ea10aa8bf$export$88948ce120ea2619;
var $7f8eaf0ea10aa8bf$export$35808ee640e87ca7;
var $7f8eaf0ea10aa8bf$export$fae74005e78b1a27;
var $7f8eaf0ea10aa8bf$export$dc8fbce3eb94dc1e;
var $7f8eaf0ea10aa8bf$export$6a7bc4e911dc01cf;
var $7f8eaf0ea10aa8bf$export$6d9c69b0de29b591;
var $7f8eaf0ea10aa8bf$export$f680877a34711e37;
var $7f8eaf0ea10aa8bf$export$d5a552a76deda3c2;
var $7f8eaf0ea10aa8bf$export$aaabe4eda9ed9969;
var $7f8eaf0ea10aa8bf$export$e5c5a5f917a5871c;
var $7f8eaf0ea10aa8bf$export$1538c33de8887b59;
var $7f8eaf0ea10aa8bf$export$13e3392192263954;
var $7f8eaf0ea10aa8bf$export$b8f5890fc79d6aca;
var $7f8eaf0ea10aa8bf$export$60241385465d0a34;
var $7f8eaf0ea10aa8bf$export$306c0aa65ff9ec16;
var $7f8eaf0ea10aa8bf$export$7b286972b8d8ccbf;
var $7f8eaf0ea10aa8bf$export$83d89fbfd8236492;
'use strict';
var $7f8eaf0ea10aa8bf$var$l = Symbol.for("react.element"), $7f8eaf0ea10aa8bf$var$n = Symbol.for("react.portal"), $7f8eaf0ea10aa8bf$var$p = Symbol.for("react.fragment"), $7f8eaf0ea10aa8bf$var$q = Symbol.for("react.strict_mode"), $7f8eaf0ea10aa8bf$var$r = Symbol.for("react.profiler"), $7f8eaf0ea10aa8bf$var$t = Symbol.for("react.provider"), $7f8eaf0ea10aa8bf$var$u = Symbol.for("react.context"), $7f8eaf0ea10aa8bf$var$v = Symbol.for("react.forward_ref"), $7f8eaf0ea10aa8bf$var$w = Symbol.for("react.suspense"), $7f8eaf0ea10aa8bf$var$x = Symbol.for("react.memo"), $7f8eaf0ea10aa8bf$var$y = Symbol.for("react.lazy"), $7f8eaf0ea10aa8bf$var$z = Symbol.iterator;
function $7f8eaf0ea10aa8bf$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7f8eaf0ea10aa8bf$var$z && a[$7f8eaf0ea10aa8bf$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7f8eaf0ea10aa8bf$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7f8eaf0ea10aa8bf$var$C = Object.assign, $7f8eaf0ea10aa8bf$var$D = {};
function $7f8eaf0ea10aa8bf$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7f8eaf0ea10aa8bf$var$D;
    this.updater = e || $7f8eaf0ea10aa8bf$var$B;
}
$7f8eaf0ea10aa8bf$var$E.prototype.isReactComponent = {};
$7f8eaf0ea10aa8bf$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7f8eaf0ea10aa8bf$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7f8eaf0ea10aa8bf$var$F() {}
$7f8eaf0ea10aa8bf$var$F.prototype = $7f8eaf0ea10aa8bf$var$E.prototype;
function $7f8eaf0ea10aa8bf$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7f8eaf0ea10aa8bf$var$D;
    this.updater = e || $7f8eaf0ea10aa8bf$var$B;
}
var $7f8eaf0ea10aa8bf$var$H = $7f8eaf0ea10aa8bf$var$G.prototype = new $7f8eaf0ea10aa8bf$var$F;
$7f8eaf0ea10aa8bf$var$H.constructor = $7f8eaf0ea10aa8bf$var$G;
$7f8eaf0ea10aa8bf$var$C($7f8eaf0ea10aa8bf$var$H, $7f8eaf0ea10aa8bf$var$E.prototype);
$7f8eaf0ea10aa8bf$var$H.isPureReactComponent = !0;
var $7f8eaf0ea10aa8bf$var$I = Array.isArray, $7f8eaf0ea10aa8bf$var$J = Object.prototype.hasOwnProperty, $7f8eaf0ea10aa8bf$var$K = {
    current: null
}, $7f8eaf0ea10aa8bf$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7f8eaf0ea10aa8bf$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7f8eaf0ea10aa8bf$var$J.call(b, d) && !$7f8eaf0ea10aa8bf$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7f8eaf0ea10aa8bf$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7f8eaf0ea10aa8bf$var$K.current
    };
}
function $7f8eaf0ea10aa8bf$var$N(a, b) {
    return {
        $$typeof: $7f8eaf0ea10aa8bf$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7f8eaf0ea10aa8bf$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7f8eaf0ea10aa8bf$var$l;
}
function $7f8eaf0ea10aa8bf$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7f8eaf0ea10aa8bf$var$P = /\/+/g;
function $7f8eaf0ea10aa8bf$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7f8eaf0ea10aa8bf$var$escape("" + a.key) : b.toString(36);
}
function $7f8eaf0ea10aa8bf$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7f8eaf0ea10aa8bf$var$l:
                case $7f8eaf0ea10aa8bf$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7f8eaf0ea10aa8bf$var$Q(h, 0) : d, $7f8eaf0ea10aa8bf$var$I(c) ? (e = "", null != a && (e = a.replace($7f8eaf0ea10aa8bf$var$P, "$&/") + "/"), $7f8eaf0ea10aa8bf$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7f8eaf0ea10aa8bf$var$O(c) && (c = $7f8eaf0ea10aa8bf$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7f8eaf0ea10aa8bf$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7f8eaf0ea10aa8bf$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7f8eaf0ea10aa8bf$var$Q(k, g);
        h += $7f8eaf0ea10aa8bf$var$R(k, b, e, f, c);
    }
    else if (f = $7f8eaf0ea10aa8bf$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7f8eaf0ea10aa8bf$var$Q(k, g++), h += $7f8eaf0ea10aa8bf$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7f8eaf0ea10aa8bf$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7f8eaf0ea10aa8bf$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7f8eaf0ea10aa8bf$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7f8eaf0ea10aa8bf$var$U = {
    current: null
}, $7f8eaf0ea10aa8bf$var$V = {
    transition: null
}, $7f8eaf0ea10aa8bf$var$W = {
    ReactCurrentDispatcher: $7f8eaf0ea10aa8bf$var$U,
    ReactCurrentBatchConfig: $7f8eaf0ea10aa8bf$var$V,
    ReactCurrentOwner: $7f8eaf0ea10aa8bf$var$K
};
function $7f8eaf0ea10aa8bf$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$7f8eaf0ea10aa8bf$export$dca3b0875bd9a954 = {
    map: $7f8eaf0ea10aa8bf$var$S,
    forEach: function(a, b, e) {
        $7f8eaf0ea10aa8bf$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7f8eaf0ea10aa8bf$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7f8eaf0ea10aa8bf$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7f8eaf0ea10aa8bf$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7f8eaf0ea10aa8bf$export$16fa2f45be04daa8 = $7f8eaf0ea10aa8bf$var$E;
$7f8eaf0ea10aa8bf$export$ffb0004e005737fa = $7f8eaf0ea10aa8bf$var$p;
$7f8eaf0ea10aa8bf$export$e2c29f18771995cb = $7f8eaf0ea10aa8bf$var$r;
$7f8eaf0ea10aa8bf$export$221d75b3f55bb0bd = $7f8eaf0ea10aa8bf$var$G;
$7f8eaf0ea10aa8bf$export$5f8d39834fd61797 = $7f8eaf0ea10aa8bf$var$q;
$7f8eaf0ea10aa8bf$export$74bf444e3cd11ea5 = $7f8eaf0ea10aa8bf$var$w;
$7f8eaf0ea10aa8bf$export$ae55be85d98224ed = $7f8eaf0ea10aa8bf$var$W;
$7f8eaf0ea10aa8bf$export$3ba232387fd5d6dd = $7f8eaf0ea10aa8bf$var$X;
$7f8eaf0ea10aa8bf$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7f8eaf0ea10aa8bf$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7f8eaf0ea10aa8bf$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7f8eaf0ea10aa8bf$var$J.call(b, f) && !$7f8eaf0ea10aa8bf$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7f8eaf0ea10aa8bf$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7f8eaf0ea10aa8bf$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7f8eaf0ea10aa8bf$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7f8eaf0ea10aa8bf$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7f8eaf0ea10aa8bf$export$c8a8987d4410bf2d = $7f8eaf0ea10aa8bf$var$M;
$7f8eaf0ea10aa8bf$export$d38cd72104c1f0e9 = function(a) {
    var b = $7f8eaf0ea10aa8bf$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7f8eaf0ea10aa8bf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7f8eaf0ea10aa8bf$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7f8eaf0ea10aa8bf$var$v,
        render: a
    };
};
$7f8eaf0ea10aa8bf$export$a8257692ac88316c = $7f8eaf0ea10aa8bf$var$O;
$7f8eaf0ea10aa8bf$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7f8eaf0ea10aa8bf$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7f8eaf0ea10aa8bf$var$T
    };
};
$7f8eaf0ea10aa8bf$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7f8eaf0ea10aa8bf$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7f8eaf0ea10aa8bf$export$7568632d0d33d16d = function(a) {
    var b = $7f8eaf0ea10aa8bf$var$V.transition;
    $7f8eaf0ea10aa8bf$var$V.transition = {};
    try {
        a();
    } finally{
        $7f8eaf0ea10aa8bf$var$V.transition = b;
    }
};
$7f8eaf0ea10aa8bf$export$88948ce120ea2619 = $7f8eaf0ea10aa8bf$var$X;
$7f8eaf0ea10aa8bf$export$35808ee640e87ca7 = function(a, b) {
    return $7f8eaf0ea10aa8bf$var$U.current.useCallback(a, b);
};
$7f8eaf0ea10aa8bf$export$fae74005e78b1a27 = function(a) {
    return $7f8eaf0ea10aa8bf$var$U.current.useContext(a);
};
$7f8eaf0ea10aa8bf$export$dc8fbce3eb94dc1e = function() {};
$7f8eaf0ea10aa8bf$export$6a7bc4e911dc01cf = function(a) {
    return $7f8eaf0ea10aa8bf$var$U.current.useDeferredValue(a);
};
$7f8eaf0ea10aa8bf$export$6d9c69b0de29b591 = function(a, b) {
    return $7f8eaf0ea10aa8bf$var$U.current.useEffect(a, b);
};
$7f8eaf0ea10aa8bf$export$f680877a34711e37 = function() {
    return $7f8eaf0ea10aa8bf$var$U.current.useId();
};
$7f8eaf0ea10aa8bf$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7f8eaf0ea10aa8bf$var$U.current.useImperativeHandle(a, b, e);
};
$7f8eaf0ea10aa8bf$export$aaabe4eda9ed9969 = function(a, b) {
    return $7f8eaf0ea10aa8bf$var$U.current.useInsertionEffect(a, b);
};
$7f8eaf0ea10aa8bf$export$e5c5a5f917a5871c = function(a, b) {
    return $7f8eaf0ea10aa8bf$var$U.current.useLayoutEffect(a, b);
};
$7f8eaf0ea10aa8bf$export$1538c33de8887b59 = function(a, b) {
    return $7f8eaf0ea10aa8bf$var$U.current.useMemo(a, b);
};
$7f8eaf0ea10aa8bf$export$13e3392192263954 = function(a, b, e) {
    return $7f8eaf0ea10aa8bf$var$U.current.useReducer(a, b, e);
};
$7f8eaf0ea10aa8bf$export$b8f5890fc79d6aca = function(a) {
    return $7f8eaf0ea10aa8bf$var$U.current.useRef(a);
};
$7f8eaf0ea10aa8bf$export$60241385465d0a34 = function(a) {
    return $7f8eaf0ea10aa8bf$var$U.current.useState(a);
};
$7f8eaf0ea10aa8bf$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7f8eaf0ea10aa8bf$var$U.current.useSyncExternalStore(a, b, e);
};
$7f8eaf0ea10aa8bf$export$7b286972b8d8ccbf = function() {
    return $7f8eaf0ea10aa8bf$var$U.current.useTransition();
};
$7f8eaf0ea10aa8bf$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("cPf3G", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $9565edbe45899661$export$ae55be85d98224ed, (v) => $9565edbe45899661$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $9565edbe45899661$export$d39a5bbd09211389, (v) => $9565edbe45899661$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $9565edbe45899661$export$882461b6382ed46c, (v) => $9565edbe45899661$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $9565edbe45899661$export$466bfc07425424d5, (v) => $9565edbe45899661$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $9565edbe45899661$export$cd75ccfd720a3cd4, (v) => $9565edbe45899661$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $9565edbe45899661$export$fa8d919ba61d84db, (v) => $9565edbe45899661$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $9565edbe45899661$export$757ceba2d55c277e, (v) => $9565edbe45899661$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $9565edbe45899661$export$b3890eb0ae9dca99, (v) => $9565edbe45899661$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $9565edbe45899661$export$502457920280e6be, (v) => $9565edbe45899661$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $9565edbe45899661$export$c78a37762a8d58e1, (v) => $9565edbe45899661$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $9565edbe45899661$export$dc54d992c10e8a18, (v) => $9565edbe45899661$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $9565edbe45899661$export$83d89fbfd8236492, (v) => $9565edbe45899661$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9565edbe45899661$export$ae55be85d98224ed;
var $9565edbe45899661$export$d39a5bbd09211389;
var $9565edbe45899661$export$882461b6382ed46c;
var $9565edbe45899661$export$466bfc07425424d5;
var $9565edbe45899661$export$cd75ccfd720a3cd4;
var $9565edbe45899661$export$fa8d919ba61d84db;
var $9565edbe45899661$export$757ceba2d55c277e;
var $9565edbe45899661$export$b3890eb0ae9dca99;
var $9565edbe45899661$export$502457920280e6be;
var $9565edbe45899661$export$c78a37762a8d58e1;
var $9565edbe45899661$export$dc54d992c10e8a18;
var $9565edbe45899661$export$83d89fbfd8236492;
'use strict';

var $ajtHG = parcelRequire("ajtHG");

var $5dQG5 = parcelRequire("5dQG5");
function $9565edbe45899661$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9565edbe45899661$var$da = new Set, $9565edbe45899661$var$ea = {};
function $9565edbe45899661$var$fa(a, b) {
    $9565edbe45899661$var$ha(a, b);
    $9565edbe45899661$var$ha(a + "Capture", b);
}
function $9565edbe45899661$var$ha(a, b) {
    $9565edbe45899661$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9565edbe45899661$var$da.add(b[a]);
}
var $9565edbe45899661$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9565edbe45899661$var$ja = Object.prototype.hasOwnProperty, $9565edbe45899661$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9565edbe45899661$var$la = {}, $9565edbe45899661$var$ma = {};
function $9565edbe45899661$var$oa(a) {
    if ($9565edbe45899661$var$ja.call($9565edbe45899661$var$ma, a)) return !0;
    if ($9565edbe45899661$var$ja.call($9565edbe45899661$var$la, a)) return !1;
    if ($9565edbe45899661$var$ka.test(a)) return $9565edbe45899661$var$ma[a] = !0;
    $9565edbe45899661$var$la[a] = !0;
    return !1;
}
function $9565edbe45899661$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9565edbe45899661$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9565edbe45899661$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9565edbe45899661$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9565edbe45899661$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9565edbe45899661$var$z[b] = new $9565edbe45899661$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9565edbe45899661$var$ra = /[\-:]([a-z])/g;
function $9565edbe45899661$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9565edbe45899661$var$ra, $9565edbe45899661$var$sa);
    $9565edbe45899661$var$z[b] = new $9565edbe45899661$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9565edbe45899661$var$ra, $9565edbe45899661$var$sa);
    $9565edbe45899661$var$z[b] = new $9565edbe45899661$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9565edbe45899661$var$ra, $9565edbe45899661$var$sa);
    $9565edbe45899661$var$z[b] = new $9565edbe45899661$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9565edbe45899661$var$z.xlinkHref = new $9565edbe45899661$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9565edbe45899661$var$z[a] = new $9565edbe45899661$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9565edbe45899661$var$ta(a, b, c, d) {
    var e = $9565edbe45899661$var$z.hasOwnProperty(b) ? $9565edbe45899661$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9565edbe45899661$var$qa(b, c, e, d) && (c = null), d || null === e ? $9565edbe45899661$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9565edbe45899661$var$ua = $ajtHG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9565edbe45899661$var$va = Symbol.for("react.element"), $9565edbe45899661$var$wa = Symbol.for("react.portal"), $9565edbe45899661$var$ya = Symbol.for("react.fragment"), $9565edbe45899661$var$za = Symbol.for("react.strict_mode"), $9565edbe45899661$var$Aa = Symbol.for("react.profiler"), $9565edbe45899661$var$Ba = Symbol.for("react.provider"), $9565edbe45899661$var$Ca = Symbol.for("react.context"), $9565edbe45899661$var$Da = Symbol.for("react.forward_ref"), $9565edbe45899661$var$Ea = Symbol.for("react.suspense"), $9565edbe45899661$var$Fa = Symbol.for("react.suspense_list"), $9565edbe45899661$var$Ga = Symbol.for("react.memo"), $9565edbe45899661$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9565edbe45899661$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9565edbe45899661$var$Ja = Symbol.iterator;
function $9565edbe45899661$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9565edbe45899661$var$Ja && a[$9565edbe45899661$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9565edbe45899661$var$A = Object.assign, $9565edbe45899661$var$La;
function $9565edbe45899661$var$Ma(a) {
    if (void 0 === $9565edbe45899661$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9565edbe45899661$var$La = b && b[1] || "";
    }
    return "\n" + $9565edbe45899661$var$La + a;
}
var $9565edbe45899661$var$Na = !1;
function $9565edbe45899661$var$Oa(a, b) {
    if (!a || $9565edbe45899661$var$Na) return "";
    $9565edbe45899661$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9565edbe45899661$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9565edbe45899661$var$Ma(a) : "";
}
function $9565edbe45899661$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9565edbe45899661$var$Ma(a.type);
        case 16:
            return $9565edbe45899661$var$Ma("Lazy");
        case 13:
            return $9565edbe45899661$var$Ma("Suspense");
        case 19:
            return $9565edbe45899661$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9565edbe45899661$var$Oa(a.type, !1), a;
        case 11:
            return a = $9565edbe45899661$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9565edbe45899661$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9565edbe45899661$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9565edbe45899661$var$ya:
            return "Fragment";
        case $9565edbe45899661$var$wa:
            return "Portal";
        case $9565edbe45899661$var$Aa:
            return "Profiler";
        case $9565edbe45899661$var$za:
            return "StrictMode";
        case $9565edbe45899661$var$Ea:
            return "Suspense";
        case $9565edbe45899661$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9565edbe45899661$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9565edbe45899661$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9565edbe45899661$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9565edbe45899661$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9565edbe45899661$var$Qa(a.type) || "Memo";
        case $9565edbe45899661$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9565edbe45899661$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9565edbe45899661$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9565edbe45899661$var$Qa(b);
        case 8:
            return b === $9565edbe45899661$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9565edbe45899661$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9565edbe45899661$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9565edbe45899661$var$Ua(a) {
    var b = $9565edbe45899661$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9565edbe45899661$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9565edbe45899661$var$Ua(a));
}
function $9565edbe45899661$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9565edbe45899661$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9565edbe45899661$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9565edbe45899661$var$Ya(a, b) {
    var c = b.checked;
    return $9565edbe45899661$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9565edbe45899661$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9565edbe45899661$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9565edbe45899661$var$ab(a, b) {
    b = b.checked;
    null != b && $9565edbe45899661$var$ta(a, "checked", b, !1);
}
function $9565edbe45899661$var$bb(a, b) {
    $9565edbe45899661$var$ab(a, b);
    var c = $9565edbe45899661$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9565edbe45899661$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9565edbe45899661$var$cb(a, b.type, $9565edbe45899661$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9565edbe45899661$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9565edbe45899661$var$cb(a, b, c) {
    if ("number" !== b || $9565edbe45899661$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9565edbe45899661$var$eb = Array.isArray;
function $9565edbe45899661$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9565edbe45899661$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9565edbe45899661$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9565edbe45899661$var$p(91));
    return $9565edbe45899661$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9565edbe45899661$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9565edbe45899661$var$p(92));
            if ($9565edbe45899661$var$eb(c)) {
                if (1 < c.length) throw Error($9565edbe45899661$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9565edbe45899661$var$Sa(c)
    };
}
function $9565edbe45899661$var$ib(a, b) {
    var c = $9565edbe45899661$var$Sa(b.value), d = $9565edbe45899661$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9565edbe45899661$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9565edbe45899661$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9565edbe45899661$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9565edbe45899661$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9565edbe45899661$var$mb, $9565edbe45899661$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9565edbe45899661$var$mb = $9565edbe45899661$var$mb || document.createElement("div");
        $9565edbe45899661$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9565edbe45899661$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9565edbe45899661$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9565edbe45899661$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9565edbe45899661$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9565edbe45899661$var$pb).forEach(function(a) {
    $9565edbe45899661$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9565edbe45899661$var$pb[b] = $9565edbe45899661$var$pb[a];
    });
});
function $9565edbe45899661$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9565edbe45899661$var$pb.hasOwnProperty(a) && $9565edbe45899661$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9565edbe45899661$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9565edbe45899661$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9565edbe45899661$var$tb = $9565edbe45899661$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9565edbe45899661$var$ub(a, b) {
    if (b) {
        if ($9565edbe45899661$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9565edbe45899661$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9565edbe45899661$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9565edbe45899661$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9565edbe45899661$var$p(62));
    }
}
function $9565edbe45899661$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9565edbe45899661$var$wb = null;
function $9565edbe45899661$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9565edbe45899661$var$yb = null, $9565edbe45899661$var$zb = null, $9565edbe45899661$var$Ab = null;
function $9565edbe45899661$var$Bb(a) {
    if (a = $9565edbe45899661$var$Cb(a)) {
        if ("function" !== typeof $9565edbe45899661$var$yb) throw Error($9565edbe45899661$var$p(280));
        var b = a.stateNode;
        b && (b = $9565edbe45899661$var$Db(b), $9565edbe45899661$var$yb(a.stateNode, a.type, b));
    }
}
function $9565edbe45899661$var$Eb(a) {
    $9565edbe45899661$var$zb ? $9565edbe45899661$var$Ab ? $9565edbe45899661$var$Ab.push(a) : $9565edbe45899661$var$Ab = [
        a
    ] : $9565edbe45899661$var$zb = a;
}
function $9565edbe45899661$var$Fb() {
    if ($9565edbe45899661$var$zb) {
        var a = $9565edbe45899661$var$zb, b = $9565edbe45899661$var$Ab;
        $9565edbe45899661$var$Ab = $9565edbe45899661$var$zb = null;
        $9565edbe45899661$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9565edbe45899661$var$Bb(b[a]);
    }
}
function $9565edbe45899661$var$Gb(a, b) {
    return a(b);
}
function $9565edbe45899661$var$Hb() {}
var $9565edbe45899661$var$Ib = !1;
function $9565edbe45899661$var$Jb(a, b, c) {
    if ($9565edbe45899661$var$Ib) return a(b, c);
    $9565edbe45899661$var$Ib = !0;
    try {
        return $9565edbe45899661$var$Gb(a, b, c);
    } finally{
        if ($9565edbe45899661$var$Ib = !1, null !== $9565edbe45899661$var$zb || null !== $9565edbe45899661$var$Ab) $9565edbe45899661$var$Hb(), $9565edbe45899661$var$Fb();
    }
}
function $9565edbe45899661$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9565edbe45899661$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9565edbe45899661$var$p(231, b, typeof c));
    return c;
}
var $9565edbe45899661$var$Lb = !1;
if ($9565edbe45899661$var$ia) try {
    var $9565edbe45899661$var$Mb = {};
    Object.defineProperty($9565edbe45899661$var$Mb, "passive", {
        get: function() {
            $9565edbe45899661$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9565edbe45899661$var$Mb, $9565edbe45899661$var$Mb);
    window.removeEventListener("test", $9565edbe45899661$var$Mb, $9565edbe45899661$var$Mb);
} catch (a) {
    $9565edbe45899661$var$Lb = !1;
}
function $9565edbe45899661$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9565edbe45899661$var$Ob = !1, $9565edbe45899661$var$Pb = null, $9565edbe45899661$var$Qb = !1, $9565edbe45899661$var$Rb = null, $9565edbe45899661$var$Sb = {
    onError: function(a) {
        $9565edbe45899661$var$Ob = !0;
        $9565edbe45899661$var$Pb = a;
    }
};
function $9565edbe45899661$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9565edbe45899661$var$Ob = !1;
    $9565edbe45899661$var$Pb = null;
    $9565edbe45899661$var$Nb.apply($9565edbe45899661$var$Sb, arguments);
}
function $9565edbe45899661$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9565edbe45899661$var$Tb.apply(this, arguments);
    if ($9565edbe45899661$var$Ob) {
        if ($9565edbe45899661$var$Ob) {
            var l = $9565edbe45899661$var$Pb;
            $9565edbe45899661$var$Ob = !1;
            $9565edbe45899661$var$Pb = null;
        } else throw Error($9565edbe45899661$var$p(198));
        $9565edbe45899661$var$Qb || ($9565edbe45899661$var$Qb = !0, $9565edbe45899661$var$Rb = l);
    }
}
function $9565edbe45899661$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9565edbe45899661$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9565edbe45899661$var$Xb(a) {
    if ($9565edbe45899661$var$Vb(a) !== a) throw Error($9565edbe45899661$var$p(188));
}
function $9565edbe45899661$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9565edbe45899661$var$Vb(a);
        if (null === b) throw Error($9565edbe45899661$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9565edbe45899661$var$Xb(e), a;
                if (f === d) return $9565edbe45899661$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9565edbe45899661$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9565edbe45899661$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9565edbe45899661$var$p(190));
    }
    if (3 !== c.tag) throw Error($9565edbe45899661$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9565edbe45899661$var$Zb(a) {
    a = $9565edbe45899661$var$Yb(a);
    return null !== a ? $9565edbe45899661$var$$b(a) : null;
}
function $9565edbe45899661$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9565edbe45899661$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9565edbe45899661$var$ac = $5dQG5.unstable_scheduleCallback, $9565edbe45899661$var$bc = $5dQG5.unstable_cancelCallback, $9565edbe45899661$var$cc = $5dQG5.unstable_shouldYield, $9565edbe45899661$var$dc = $5dQG5.unstable_requestPaint, $9565edbe45899661$var$B = $5dQG5.unstable_now, $9565edbe45899661$var$ec = $5dQG5.unstable_getCurrentPriorityLevel, $9565edbe45899661$var$fc = $5dQG5.unstable_ImmediatePriority, $9565edbe45899661$var$gc = $5dQG5.unstable_UserBlockingPriority, $9565edbe45899661$var$hc = $5dQG5.unstable_NormalPriority, $9565edbe45899661$var$ic = $5dQG5.unstable_LowPriority, $9565edbe45899661$var$jc = $5dQG5.unstable_IdlePriority, $9565edbe45899661$var$kc = null, $9565edbe45899661$var$lc = null;
function $9565edbe45899661$var$mc(a) {
    if ($9565edbe45899661$var$lc && "function" === typeof $9565edbe45899661$var$lc.onCommitFiberRoot) try {
        $9565edbe45899661$var$lc.onCommitFiberRoot($9565edbe45899661$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9565edbe45899661$var$oc = Math.clz32 ? Math.clz32 : $9565edbe45899661$var$nc, $9565edbe45899661$var$pc = Math.log, $9565edbe45899661$var$qc = Math.LN2;
function $9565edbe45899661$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9565edbe45899661$var$pc(a) / $9565edbe45899661$var$qc | 0) | 0;
}
var $9565edbe45899661$var$rc = 64, $9565edbe45899661$var$sc = 4194304;
function $9565edbe45899661$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9565edbe45899661$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9565edbe45899661$var$tc(h) : (f &= g, 0 !== f && (d = $9565edbe45899661$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9565edbe45899661$var$tc(g) : 0 !== f && (d = $9565edbe45899661$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9565edbe45899661$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9565edbe45899661$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9565edbe45899661$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9565edbe45899661$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9565edbe45899661$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9565edbe45899661$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9565edbe45899661$var$yc() {
    var a = $9565edbe45899661$var$rc;
    $9565edbe45899661$var$rc <<= 1;
    0 === ($9565edbe45899661$var$rc & 4194240) && ($9565edbe45899661$var$rc = 64);
    return a;
}
function $9565edbe45899661$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9565edbe45899661$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9565edbe45899661$var$oc(b);
    a[b] = c;
}
function $9565edbe45899661$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9565edbe45899661$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9565edbe45899661$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9565edbe45899661$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9565edbe45899661$var$C = 0;
function $9565edbe45899661$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9565edbe45899661$var$Ec, $9565edbe45899661$var$Fc, $9565edbe45899661$var$Gc, $9565edbe45899661$var$Hc, $9565edbe45899661$var$Ic, $9565edbe45899661$var$Jc = !1, $9565edbe45899661$var$Kc = [], $9565edbe45899661$var$Lc = null, $9565edbe45899661$var$Mc = null, $9565edbe45899661$var$Nc = null, $9565edbe45899661$var$Oc = new Map, $9565edbe45899661$var$Pc = new Map, $9565edbe45899661$var$Qc = [], $9565edbe45899661$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9565edbe45899661$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9565edbe45899661$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9565edbe45899661$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9565edbe45899661$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9565edbe45899661$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9565edbe45899661$var$Pc.delete(b.pointerId);
    }
}
function $9565edbe45899661$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9565edbe45899661$var$Cb(b), null !== b && $9565edbe45899661$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9565edbe45899661$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9565edbe45899661$var$Lc = $9565edbe45899661$var$Tc($9565edbe45899661$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9565edbe45899661$var$Mc = $9565edbe45899661$var$Tc($9565edbe45899661$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9565edbe45899661$var$Nc = $9565edbe45899661$var$Tc($9565edbe45899661$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9565edbe45899661$var$Oc.set(f, $9565edbe45899661$var$Tc($9565edbe45899661$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9565edbe45899661$var$Pc.set(f, $9565edbe45899661$var$Tc($9565edbe45899661$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9565edbe45899661$var$Vc(a) {
    var b = $9565edbe45899661$var$Wc(a.target);
    if (null !== b) {
        var c = $9565edbe45899661$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9565edbe45899661$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9565edbe45899661$var$Ic(a.priority, function() {
                        $9565edbe45899661$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9565edbe45899661$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9565edbe45899661$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9565edbe45899661$var$wb = d;
            c.target.dispatchEvent(d);
            $9565edbe45899661$var$wb = null;
        } else return b = $9565edbe45899661$var$Cb(c), null !== b && $9565edbe45899661$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9565edbe45899661$var$Zc(a, b, c) {
    $9565edbe45899661$var$Xc(a) && c.delete(b);
}
function $9565edbe45899661$var$$c() {
    $9565edbe45899661$var$Jc = !1;
    null !== $9565edbe45899661$var$Lc && $9565edbe45899661$var$Xc($9565edbe45899661$var$Lc) && ($9565edbe45899661$var$Lc = null);
    null !== $9565edbe45899661$var$Mc && $9565edbe45899661$var$Xc($9565edbe45899661$var$Mc) && ($9565edbe45899661$var$Mc = null);
    null !== $9565edbe45899661$var$Nc && $9565edbe45899661$var$Xc($9565edbe45899661$var$Nc) && ($9565edbe45899661$var$Nc = null);
    $9565edbe45899661$var$Oc.forEach($9565edbe45899661$var$Zc);
    $9565edbe45899661$var$Pc.forEach($9565edbe45899661$var$Zc);
}
function $9565edbe45899661$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9565edbe45899661$var$Jc || ($9565edbe45899661$var$Jc = !0, $5dQG5.unstable_scheduleCallback($5dQG5.unstable_NormalPriority, $9565edbe45899661$var$$c)));
}
function $9565edbe45899661$var$bd(a) {
    function b(b) {
        return $9565edbe45899661$var$ad(b, a);
    }
    if (0 < $9565edbe45899661$var$Kc.length) {
        $9565edbe45899661$var$ad($9565edbe45899661$var$Kc[0], a);
        for(var c = 1; c < $9565edbe45899661$var$Kc.length; c++){
            var d = $9565edbe45899661$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9565edbe45899661$var$Lc && $9565edbe45899661$var$ad($9565edbe45899661$var$Lc, a);
    null !== $9565edbe45899661$var$Mc && $9565edbe45899661$var$ad($9565edbe45899661$var$Mc, a);
    null !== $9565edbe45899661$var$Nc && $9565edbe45899661$var$ad($9565edbe45899661$var$Nc, a);
    $9565edbe45899661$var$Oc.forEach(b);
    $9565edbe45899661$var$Pc.forEach(b);
    for(c = 0; c < $9565edbe45899661$var$Qc.length; c++)d = $9565edbe45899661$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9565edbe45899661$var$Qc.length && (c = $9565edbe45899661$var$Qc[0], null === c.blockedOn);)$9565edbe45899661$var$Vc(c), null === c.blockedOn && $9565edbe45899661$var$Qc.shift();
}
var $9565edbe45899661$var$cd = $9565edbe45899661$var$ua.ReactCurrentBatchConfig, $9565edbe45899661$var$dd = !0;
function $9565edbe45899661$var$ed(a, b, c, d) {
    var e = $9565edbe45899661$var$C, f = $9565edbe45899661$var$cd.transition;
    $9565edbe45899661$var$cd.transition = null;
    try {
        $9565edbe45899661$var$C = 1, $9565edbe45899661$var$fd(a, b, c, d);
    } finally{
        $9565edbe45899661$var$C = e, $9565edbe45899661$var$cd.transition = f;
    }
}
function $9565edbe45899661$var$gd(a, b, c, d) {
    var e = $9565edbe45899661$var$C, f = $9565edbe45899661$var$cd.transition;
    $9565edbe45899661$var$cd.transition = null;
    try {
        $9565edbe45899661$var$C = 4, $9565edbe45899661$var$fd(a, b, c, d);
    } finally{
        $9565edbe45899661$var$C = e, $9565edbe45899661$var$cd.transition = f;
    }
}
function $9565edbe45899661$var$fd(a, b, c, d) {
    if ($9565edbe45899661$var$dd) {
        var e = $9565edbe45899661$var$Yc(a, b, c, d);
        if (null === e) $9565edbe45899661$var$hd(a, b, d, $9565edbe45899661$var$id, c), $9565edbe45899661$var$Sc(a, d);
        else if ($9565edbe45899661$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9565edbe45899661$var$Sc(a, d), b & 4 && -1 < $9565edbe45899661$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9565edbe45899661$var$Cb(e);
                null !== f && $9565edbe45899661$var$Ec(f);
                f = $9565edbe45899661$var$Yc(a, b, c, d);
                null === f && $9565edbe45899661$var$hd(a, b, d, $9565edbe45899661$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9565edbe45899661$var$hd(a, b, d, null, c);
    }
}
var $9565edbe45899661$var$id = null;
function $9565edbe45899661$var$Yc(a, b, c, d) {
    $9565edbe45899661$var$id = null;
    a = $9565edbe45899661$var$xb(d);
    a = $9565edbe45899661$var$Wc(a);
    if (null !== a) {
        if (b = $9565edbe45899661$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9565edbe45899661$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9565edbe45899661$var$id = a;
    return null;
}
function $9565edbe45899661$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9565edbe45899661$var$ec()){
                case $9565edbe45899661$var$fc:
                    return 1;
                case $9565edbe45899661$var$gc:
                    return 4;
                case $9565edbe45899661$var$hc:
                case $9565edbe45899661$var$ic:
                    return 16;
                case $9565edbe45899661$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9565edbe45899661$var$kd = null, $9565edbe45899661$var$ld = null, $9565edbe45899661$var$md = null;
function $9565edbe45899661$var$nd() {
    if ($9565edbe45899661$var$md) return $9565edbe45899661$var$md;
    var a, b = $9565edbe45899661$var$ld, c = b.length, d, e = "value" in $9565edbe45899661$var$kd ? $9565edbe45899661$var$kd.value : $9565edbe45899661$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9565edbe45899661$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9565edbe45899661$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9565edbe45899661$var$pd() {
    return !0;
}
function $9565edbe45899661$var$qd() {
    return !1;
}
function $9565edbe45899661$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9565edbe45899661$var$pd : $9565edbe45899661$var$qd;
        this.isPropagationStopped = $9565edbe45899661$var$qd;
        return this;
    }
    $9565edbe45899661$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9565edbe45899661$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9565edbe45899661$var$pd);
        },
        persist: function() {},
        isPersistent: $9565edbe45899661$var$pd
    });
    return b;
}
var $9565edbe45899661$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9565edbe45899661$var$td = $9565edbe45899661$var$rd($9565edbe45899661$var$sd), $9565edbe45899661$var$ud = $9565edbe45899661$var$A({}, $9565edbe45899661$var$sd, {
    view: 0,
    detail: 0
}), $9565edbe45899661$var$vd = $9565edbe45899661$var$rd($9565edbe45899661$var$ud), $9565edbe45899661$var$wd, $9565edbe45899661$var$xd, $9565edbe45899661$var$yd, $9565edbe45899661$var$Ad = $9565edbe45899661$var$A({}, $9565edbe45899661$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9565edbe45899661$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9565edbe45899661$var$yd && ($9565edbe45899661$var$yd && "mousemove" === a.type ? ($9565edbe45899661$var$wd = a.screenX - $9565edbe45899661$var$yd.screenX, $9565edbe45899661$var$xd = a.screenY - $9565edbe45899661$var$yd.screenY) : $9565edbe45899661$var$xd = $9565edbe45899661$var$wd = 0, $9565edbe45899661$var$yd = a);
        return $9565edbe45899661$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9565edbe45899661$var$xd;
    }
}), $9565edbe45899661$var$Bd = $9565edbe45899661$var$rd($9565edbe45899661$var$Ad), $9565edbe45899661$var$Cd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$Ad, {
    dataTransfer: 0
}), $9565edbe45899661$var$Dd = $9565edbe45899661$var$rd($9565edbe45899661$var$Cd), $9565edbe45899661$var$Ed = $9565edbe45899661$var$A({}, $9565edbe45899661$var$ud, {
    relatedTarget: 0
}), $9565edbe45899661$var$Fd = $9565edbe45899661$var$rd($9565edbe45899661$var$Ed), $9565edbe45899661$var$Gd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9565edbe45899661$var$Hd = $9565edbe45899661$var$rd($9565edbe45899661$var$Gd), $9565edbe45899661$var$Id = $9565edbe45899661$var$A({}, $9565edbe45899661$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9565edbe45899661$var$Jd = $9565edbe45899661$var$rd($9565edbe45899661$var$Id), $9565edbe45899661$var$Kd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$sd, {
    data: 0
}), $9565edbe45899661$var$Ld = $9565edbe45899661$var$rd($9565edbe45899661$var$Kd), $9565edbe45899661$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9565edbe45899661$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9565edbe45899661$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9565edbe45899661$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9565edbe45899661$var$Od[a]) ? !!b[a] : !1;
}
function $9565edbe45899661$var$zd() {
    return $9565edbe45899661$var$Pd;
}
var $9565edbe45899661$var$Qd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9565edbe45899661$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9565edbe45899661$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9565edbe45899661$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9565edbe45899661$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9565edbe45899661$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9565edbe45899661$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9565edbe45899661$var$Rd = $9565edbe45899661$var$rd($9565edbe45899661$var$Qd), $9565edbe45899661$var$Sd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9565edbe45899661$var$Td = $9565edbe45899661$var$rd($9565edbe45899661$var$Sd), $9565edbe45899661$var$Ud = $9565edbe45899661$var$A({}, $9565edbe45899661$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9565edbe45899661$var$zd
}), $9565edbe45899661$var$Vd = $9565edbe45899661$var$rd($9565edbe45899661$var$Ud), $9565edbe45899661$var$Wd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9565edbe45899661$var$Xd = $9565edbe45899661$var$rd($9565edbe45899661$var$Wd), $9565edbe45899661$var$Yd = $9565edbe45899661$var$A({}, $9565edbe45899661$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9565edbe45899661$var$Zd = $9565edbe45899661$var$rd($9565edbe45899661$var$Yd), $9565edbe45899661$var$$d = [
    9,
    13,
    27,
    32
], $9565edbe45899661$var$ae = $9565edbe45899661$var$ia && "CompositionEvent" in window, $9565edbe45899661$var$be = null;
$9565edbe45899661$var$ia && "documentMode" in document && ($9565edbe45899661$var$be = document.documentMode);
var $9565edbe45899661$var$ce = $9565edbe45899661$var$ia && "TextEvent" in window && !$9565edbe45899661$var$be, $9565edbe45899661$var$de = $9565edbe45899661$var$ia && (!$9565edbe45899661$var$ae || $9565edbe45899661$var$be && 8 < $9565edbe45899661$var$be && 11 >= $9565edbe45899661$var$be), $9565edbe45899661$var$ee = String.fromCharCode(32), $9565edbe45899661$var$fe = !1;
function $9565edbe45899661$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9565edbe45899661$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9565edbe45899661$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9565edbe45899661$var$ie = !1;
function $9565edbe45899661$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9565edbe45899661$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9565edbe45899661$var$fe = !0;
            return $9565edbe45899661$var$ee;
        case "textInput":
            return a = b.data, a === $9565edbe45899661$var$ee && $9565edbe45899661$var$fe ? null : a;
        default:
            return null;
    }
}
function $9565edbe45899661$var$ke(a, b) {
    if ($9565edbe45899661$var$ie) return "compositionend" === a || !$9565edbe45899661$var$ae && $9565edbe45899661$var$ge(a, b) ? (a = $9565edbe45899661$var$nd(), $9565edbe45899661$var$md = $9565edbe45899661$var$ld = $9565edbe45899661$var$kd = null, $9565edbe45899661$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9565edbe45899661$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9565edbe45899661$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9565edbe45899661$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9565edbe45899661$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9565edbe45899661$var$ne(a, b, c, d) {
    $9565edbe45899661$var$Eb(d);
    b = $9565edbe45899661$var$oe(b, "onChange");
    0 < b.length && (c = new $9565edbe45899661$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9565edbe45899661$var$pe = null, $9565edbe45899661$var$qe = null;
function $9565edbe45899661$var$re(a) {
    $9565edbe45899661$var$se(a, 0);
}
function $9565edbe45899661$var$te(a) {
    var b = $9565edbe45899661$var$ue(a);
    if ($9565edbe45899661$var$Wa(b)) return a;
}
function $9565edbe45899661$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9565edbe45899661$var$we = !1;
if ($9565edbe45899661$var$ia) {
    var $9565edbe45899661$var$xe;
    if ($9565edbe45899661$var$ia) {
        var $9565edbe45899661$var$ye = "oninput" in document;
        if (!$9565edbe45899661$var$ye) {
            var $9565edbe45899661$var$ze = document.createElement("div");
            $9565edbe45899661$var$ze.setAttribute("oninput", "return;");
            $9565edbe45899661$var$ye = "function" === typeof $9565edbe45899661$var$ze.oninput;
        }
        $9565edbe45899661$var$xe = $9565edbe45899661$var$ye;
    } else $9565edbe45899661$var$xe = !1;
    $9565edbe45899661$var$we = $9565edbe45899661$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9565edbe45899661$var$Ae() {
    $9565edbe45899661$var$pe && ($9565edbe45899661$var$pe.detachEvent("onpropertychange", $9565edbe45899661$var$Be), $9565edbe45899661$var$qe = $9565edbe45899661$var$pe = null);
}
function $9565edbe45899661$var$Be(a) {
    if ("value" === a.propertyName && $9565edbe45899661$var$te($9565edbe45899661$var$qe)) {
        var b = [];
        $9565edbe45899661$var$ne(b, $9565edbe45899661$var$qe, a, $9565edbe45899661$var$xb(a));
        $9565edbe45899661$var$Jb($9565edbe45899661$var$re, b);
    }
}
function $9565edbe45899661$var$Ce(a, b, c) {
    "focusin" === a ? ($9565edbe45899661$var$Ae(), $9565edbe45899661$var$pe = b, $9565edbe45899661$var$qe = c, $9565edbe45899661$var$pe.attachEvent("onpropertychange", $9565edbe45899661$var$Be)) : "focusout" === a && $9565edbe45899661$var$Ae();
}
function $9565edbe45899661$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9565edbe45899661$var$te($9565edbe45899661$var$qe);
}
function $9565edbe45899661$var$Ee(a, b) {
    if ("click" === a) return $9565edbe45899661$var$te(b);
}
function $9565edbe45899661$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9565edbe45899661$var$te(b);
}
function $9565edbe45899661$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9565edbe45899661$var$He = "function" === typeof Object.is ? Object.is : $9565edbe45899661$var$Ge;
function $9565edbe45899661$var$Ie(a, b) {
    if ($9565edbe45899661$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9565edbe45899661$var$ja.call(b, e) || !$9565edbe45899661$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9565edbe45899661$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9565edbe45899661$var$Ke(a, b) {
    var c = $9565edbe45899661$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9565edbe45899661$var$Je(c);
    }
}
function $9565edbe45899661$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9565edbe45899661$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9565edbe45899661$var$Me() {
    for(var a = window, b = $9565edbe45899661$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9565edbe45899661$var$Xa(a.document);
    }
    return b;
}
function $9565edbe45899661$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9565edbe45899661$var$Oe(a) {
    var b = $9565edbe45899661$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9565edbe45899661$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9565edbe45899661$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9565edbe45899661$var$Ke(c, f);
                var g = $9565edbe45899661$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9565edbe45899661$var$Pe = $9565edbe45899661$var$ia && "documentMode" in document && 11 >= document.documentMode, $9565edbe45899661$var$Qe = null, $9565edbe45899661$var$Re = null, $9565edbe45899661$var$Se = null, $9565edbe45899661$var$Te = !1;
function $9565edbe45899661$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9565edbe45899661$var$Te || null == $9565edbe45899661$var$Qe || $9565edbe45899661$var$Qe !== $9565edbe45899661$var$Xa(d) || (d = $9565edbe45899661$var$Qe, "selectionStart" in d && $9565edbe45899661$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9565edbe45899661$var$Se && $9565edbe45899661$var$Ie($9565edbe45899661$var$Se, d) || ($9565edbe45899661$var$Se = d, d = $9565edbe45899661$var$oe($9565edbe45899661$var$Re, "onSelect"), 0 < d.length && (b = new $9565edbe45899661$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9565edbe45899661$var$Qe)));
}
function $9565edbe45899661$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9565edbe45899661$var$We = {
    animationend: $9565edbe45899661$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9565edbe45899661$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9565edbe45899661$var$Ve("Animation", "AnimationStart"),
    transitionend: $9565edbe45899661$var$Ve("Transition", "TransitionEnd")
}, $9565edbe45899661$var$Xe = {}, $9565edbe45899661$var$Ye = {};
$9565edbe45899661$var$ia && ($9565edbe45899661$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9565edbe45899661$var$We.animationend.animation, delete $9565edbe45899661$var$We.animationiteration.animation, delete $9565edbe45899661$var$We.animationstart.animation), "TransitionEvent" in window || delete $9565edbe45899661$var$We.transitionend.transition);
function $9565edbe45899661$var$Ze(a) {
    if ($9565edbe45899661$var$Xe[a]) return $9565edbe45899661$var$Xe[a];
    if (!$9565edbe45899661$var$We[a]) return a;
    var b = $9565edbe45899661$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9565edbe45899661$var$Ye) return $9565edbe45899661$var$Xe[a] = b[c];
    return a;
}
var $9565edbe45899661$var$$e = $9565edbe45899661$var$Ze("animationend"), $9565edbe45899661$var$af = $9565edbe45899661$var$Ze("animationiteration"), $9565edbe45899661$var$bf = $9565edbe45899661$var$Ze("animationstart"), $9565edbe45899661$var$cf = $9565edbe45899661$var$Ze("transitionend"), $9565edbe45899661$var$df = new Map, $9565edbe45899661$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9565edbe45899661$var$ff(a, b) {
    $9565edbe45899661$var$df.set(a, b);
    $9565edbe45899661$var$fa(b, [
        a
    ]);
}
for(var $9565edbe45899661$var$gf = 0; $9565edbe45899661$var$gf < $9565edbe45899661$var$ef.length; $9565edbe45899661$var$gf++){
    var $9565edbe45899661$var$hf = $9565edbe45899661$var$ef[$9565edbe45899661$var$gf], $9565edbe45899661$var$jf = $9565edbe45899661$var$hf.toLowerCase(), $9565edbe45899661$var$kf = $9565edbe45899661$var$hf[0].toUpperCase() + $9565edbe45899661$var$hf.slice(1);
    $9565edbe45899661$var$ff($9565edbe45899661$var$jf, "on" + $9565edbe45899661$var$kf);
}
$9565edbe45899661$var$ff($9565edbe45899661$var$$e, "onAnimationEnd");
$9565edbe45899661$var$ff($9565edbe45899661$var$af, "onAnimationIteration");
$9565edbe45899661$var$ff($9565edbe45899661$var$bf, "onAnimationStart");
$9565edbe45899661$var$ff("dblclick", "onDoubleClick");
$9565edbe45899661$var$ff("focusin", "onFocus");
$9565edbe45899661$var$ff("focusout", "onBlur");
$9565edbe45899661$var$ff($9565edbe45899661$var$cf, "onTransitionEnd");
$9565edbe45899661$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9565edbe45899661$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9565edbe45899661$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9565edbe45899661$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9565edbe45899661$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9565edbe45899661$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9565edbe45899661$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9565edbe45899661$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9565edbe45899661$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9565edbe45899661$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9565edbe45899661$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9565edbe45899661$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9565edbe45899661$var$lf));
function $9565edbe45899661$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9565edbe45899661$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9565edbe45899661$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9565edbe45899661$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9565edbe45899661$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9565edbe45899661$var$Qb) throw a = $9565edbe45899661$var$Rb, $9565edbe45899661$var$Qb = !1, $9565edbe45899661$var$Rb = null, a;
}
function $9565edbe45899661$var$D(a, b) {
    var c = b[$9565edbe45899661$var$of];
    void 0 === c && (c = b[$9565edbe45899661$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9565edbe45899661$var$pf(b, a, 2, !1), c.add(d));
}
function $9565edbe45899661$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9565edbe45899661$var$pf(c, a, d, b);
}
var $9565edbe45899661$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9565edbe45899661$var$sf(a) {
    if (!a[$9565edbe45899661$var$rf]) {
        a[$9565edbe45899661$var$rf] = !0;
        $9565edbe45899661$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9565edbe45899661$var$mf.has(b) || $9565edbe45899661$var$qf(b, !1, a), $9565edbe45899661$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9565edbe45899661$var$rf] || (b[$9565edbe45899661$var$rf] = !0, $9565edbe45899661$var$qf("selectionchange", !1, b));
    }
}
function $9565edbe45899661$var$pf(a, b, c, d) {
    switch($9565edbe45899661$var$jd(b)){
        case 1:
            var e = $9565edbe45899661$var$ed;
            break;
        case 4:
            e = $9565edbe45899661$var$gd;
            break;
        default:
            e = $9565edbe45899661$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9565edbe45899661$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9565edbe45899661$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9565edbe45899661$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9565edbe45899661$var$Jb(function() {
        var d = f, e = $9565edbe45899661$var$xb(c), g = [];
        a: {
            var h = $9565edbe45899661$var$df.get(a);
            if (void 0 !== h) {
                var k = $9565edbe45899661$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9565edbe45899661$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9565edbe45899661$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9565edbe45899661$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9565edbe45899661$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9565edbe45899661$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9565edbe45899661$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9565edbe45899661$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9565edbe45899661$var$Vd;
                        break;
                    case $9565edbe45899661$var$$e:
                    case $9565edbe45899661$var$af:
                    case $9565edbe45899661$var$bf:
                        k = $9565edbe45899661$var$Hd;
                        break;
                    case $9565edbe45899661$var$cf:
                        k = $9565edbe45899661$var$Xd;
                        break;
                    case "scroll":
                        k = $9565edbe45899661$var$vd;
                        break;
                    case "wheel":
                        k = $9565edbe45899661$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9565edbe45899661$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9565edbe45899661$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9565edbe45899661$var$Kb(w, x), null != F && t.push($9565edbe45899661$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9565edbe45899661$var$wb && (n = c.relatedTarget || c.fromElement) && ($9565edbe45899661$var$Wc(n) || n[$9565edbe45899661$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9565edbe45899661$var$Wc(n) : null, null !== n && (J = $9565edbe45899661$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9565edbe45899661$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9565edbe45899661$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9565edbe45899661$var$ue(k);
                        u = null == n ? h : $9565edbe45899661$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9565edbe45899661$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9565edbe45899661$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9565edbe45899661$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9565edbe45899661$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9565edbe45899661$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9565edbe45899661$var$vf(t);
                                x = $9565edbe45899661$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9565edbe45899661$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9565edbe45899661$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9565edbe45899661$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9565edbe45899661$var$ve;
                else if ($9565edbe45899661$var$me(h)) {
                    if ($9565edbe45899661$var$we) na = $9565edbe45899661$var$Fe;
                    else {
                        na = $9565edbe45899661$var$De;
                        var xa = $9565edbe45899661$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9565edbe45899661$var$Ee);
                if (na && (na = na(a, d))) {
                    $9565edbe45899661$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9565edbe45899661$var$cb(h, "number", h.value);
            }
            xa = d ? $9565edbe45899661$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9565edbe45899661$var$me(xa) || "true" === xa.contentEditable) $9565edbe45899661$var$Qe = xa, $9565edbe45899661$var$Re = d, $9565edbe45899661$var$Se = null;
                    break;
                case "focusout":
                    $9565edbe45899661$var$Se = $9565edbe45899661$var$Re = $9565edbe45899661$var$Qe = null;
                    break;
                case "mousedown":
                    $9565edbe45899661$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9565edbe45899661$var$Te = !1;
                    $9565edbe45899661$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9565edbe45899661$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9565edbe45899661$var$Ue(g, c, e);
            }
            var $a;
            if ($9565edbe45899661$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9565edbe45899661$var$ie ? $9565edbe45899661$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9565edbe45899661$var$de && "ko" !== c.locale && ($9565edbe45899661$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9565edbe45899661$var$ie && ($a = $9565edbe45899661$var$nd()) : ($9565edbe45899661$var$kd = e, $9565edbe45899661$var$ld = "value" in $9565edbe45899661$var$kd ? $9565edbe45899661$var$kd.value : $9565edbe45899661$var$kd.textContent, $9565edbe45899661$var$ie = !0)), xa = $9565edbe45899661$var$oe(d, ba), 0 < xa.length && (ba = new $9565edbe45899661$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9565edbe45899661$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9565edbe45899661$var$ce ? $9565edbe45899661$var$je(a, c) : $9565edbe45899661$var$ke(a, c)) d = $9565edbe45899661$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9565edbe45899661$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9565edbe45899661$var$se(g, b);
    });
}
function $9565edbe45899661$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9565edbe45899661$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9565edbe45899661$var$Kb(a, c), null != f && d.unshift($9565edbe45899661$var$tf(a, f, e)), f = $9565edbe45899661$var$Kb(a, b), null != f && d.push($9565edbe45899661$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9565edbe45899661$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9565edbe45899661$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9565edbe45899661$var$Kb(c, f), null != k && g.unshift($9565edbe45899661$var$tf(c, k, h))) : e || (k = $9565edbe45899661$var$Kb(c, f), null != k && g.push($9565edbe45899661$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9565edbe45899661$var$xf = /\r\n?/g, $9565edbe45899661$var$yf = /\u0000|\uFFFD/g;
function $9565edbe45899661$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9565edbe45899661$var$xf, "\n").replace($9565edbe45899661$var$yf, "");
}
function $9565edbe45899661$var$Af(a, b, c) {
    b = $9565edbe45899661$var$zf(b);
    if ($9565edbe45899661$var$zf(a) !== b && c) throw Error($9565edbe45899661$var$p(425));
}
function $9565edbe45899661$var$Bf() {}
var $9565edbe45899661$var$Cf = null, $9565edbe45899661$var$Df = null;
function $9565edbe45899661$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9565edbe45899661$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9565edbe45899661$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9565edbe45899661$var$Hf = "function" === typeof Promise ? Promise : void 0, $9565edbe45899661$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9565edbe45899661$var$Hf ? function(a) {
    return $9565edbe45899661$var$Hf.resolve(null).then(a).catch($9565edbe45899661$var$If);
} : $9565edbe45899661$var$Ff;
function $9565edbe45899661$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9565edbe45899661$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9565edbe45899661$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9565edbe45899661$var$bd(b);
}
function $9565edbe45899661$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9565edbe45899661$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9565edbe45899661$var$Nf = Math.random().toString(36).slice(2), $9565edbe45899661$var$Of = "__reactFiber$" + $9565edbe45899661$var$Nf, $9565edbe45899661$var$Pf = "__reactProps$" + $9565edbe45899661$var$Nf, $9565edbe45899661$var$uf = "__reactContainer$" + $9565edbe45899661$var$Nf, $9565edbe45899661$var$of = "__reactEvents$" + $9565edbe45899661$var$Nf, $9565edbe45899661$var$Qf = "__reactListeners$" + $9565edbe45899661$var$Nf, $9565edbe45899661$var$Rf = "__reactHandles$" + $9565edbe45899661$var$Nf;
function $9565edbe45899661$var$Wc(a) {
    var b = a[$9565edbe45899661$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9565edbe45899661$var$uf] || c[$9565edbe45899661$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9565edbe45899661$var$Mf(a); null !== a;){
                if (c = a[$9565edbe45899661$var$Of]) return c;
                a = $9565edbe45899661$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9565edbe45899661$var$Cb(a) {
    a = a[$9565edbe45899661$var$Of] || a[$9565edbe45899661$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9565edbe45899661$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9565edbe45899661$var$p(33));
}
function $9565edbe45899661$var$Db(a) {
    return a[$9565edbe45899661$var$Pf] || null;
}
var $9565edbe45899661$var$Sf = [], $9565edbe45899661$var$Tf = -1;
function $9565edbe45899661$var$Uf(a) {
    return {
        current: a
    };
}
function $9565edbe45899661$var$E(a) {
    0 > $9565edbe45899661$var$Tf || (a.current = $9565edbe45899661$var$Sf[$9565edbe45899661$var$Tf], $9565edbe45899661$var$Sf[$9565edbe45899661$var$Tf] = null, $9565edbe45899661$var$Tf--);
}
function $9565edbe45899661$var$G(a, b) {
    $9565edbe45899661$var$Tf++;
    $9565edbe45899661$var$Sf[$9565edbe45899661$var$Tf] = a.current;
    a.current = b;
}
var $9565edbe45899661$var$Vf = {}, $9565edbe45899661$var$H = $9565edbe45899661$var$Uf($9565edbe45899661$var$Vf), $9565edbe45899661$var$Wf = $9565edbe45899661$var$Uf(!1), $9565edbe45899661$var$Xf = $9565edbe45899661$var$Vf;
function $9565edbe45899661$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9565edbe45899661$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9565edbe45899661$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9565edbe45899661$var$$f() {
    $9565edbe45899661$var$E($9565edbe45899661$var$Wf);
    $9565edbe45899661$var$E($9565edbe45899661$var$H);
}
function $9565edbe45899661$var$ag(a, b, c) {
    if ($9565edbe45899661$var$H.current !== $9565edbe45899661$var$Vf) throw Error($9565edbe45899661$var$p(168));
    $9565edbe45899661$var$G($9565edbe45899661$var$H, b);
    $9565edbe45899661$var$G($9565edbe45899661$var$Wf, c);
}
function $9565edbe45899661$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9565edbe45899661$var$p(108, $9565edbe45899661$var$Ra(a) || "Unknown", e));
    return $9565edbe45899661$var$A({}, c, d);
}
function $9565edbe45899661$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9565edbe45899661$var$Vf;
    $9565edbe45899661$var$Xf = $9565edbe45899661$var$H.current;
    $9565edbe45899661$var$G($9565edbe45899661$var$H, a);
    $9565edbe45899661$var$G($9565edbe45899661$var$Wf, $9565edbe45899661$var$Wf.current);
    return !0;
}
function $9565edbe45899661$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9565edbe45899661$var$p(169));
    c ? (a = $9565edbe45899661$var$bg(a, b, $9565edbe45899661$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9565edbe45899661$var$E($9565edbe45899661$var$Wf), $9565edbe45899661$var$E($9565edbe45899661$var$H), $9565edbe45899661$var$G($9565edbe45899661$var$H, a)) : $9565edbe45899661$var$E($9565edbe45899661$var$Wf);
    $9565edbe45899661$var$G($9565edbe45899661$var$Wf, c);
}
var $9565edbe45899661$var$eg = null, $9565edbe45899661$var$fg = !1, $9565edbe45899661$var$gg = !1;
function $9565edbe45899661$var$hg(a) {
    null === $9565edbe45899661$var$eg ? $9565edbe45899661$var$eg = [
        a
    ] : $9565edbe45899661$var$eg.push(a);
}
function $9565edbe45899661$var$ig(a) {
    $9565edbe45899661$var$fg = !0;
    $9565edbe45899661$var$hg(a);
}
function $9565edbe45899661$var$jg() {
    if (!$9565edbe45899661$var$gg && null !== $9565edbe45899661$var$eg) {
        $9565edbe45899661$var$gg = !0;
        var a = 0, b = $9565edbe45899661$var$C;
        try {
            var c = $9565edbe45899661$var$eg;
            for($9565edbe45899661$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9565edbe45899661$var$eg = null;
            $9565edbe45899661$var$fg = !1;
        } catch (e) {
            throw null !== $9565edbe45899661$var$eg && ($9565edbe45899661$var$eg = $9565edbe45899661$var$eg.slice(a + 1)), $9565edbe45899661$var$ac($9565edbe45899661$var$fc, $9565edbe45899661$var$jg), e;
        } finally{
            $9565edbe45899661$var$C = b, $9565edbe45899661$var$gg = !1;
        }
    }
    return null;
}
var $9565edbe45899661$var$kg = [], $9565edbe45899661$var$lg = 0, $9565edbe45899661$var$mg = null, $9565edbe45899661$var$ng = 0, $9565edbe45899661$var$og = [], $9565edbe45899661$var$pg = 0, $9565edbe45899661$var$qg = null, $9565edbe45899661$var$rg = 1, $9565edbe45899661$var$sg = "";
function $9565edbe45899661$var$tg(a, b) {
    $9565edbe45899661$var$kg[$9565edbe45899661$var$lg++] = $9565edbe45899661$var$ng;
    $9565edbe45899661$var$kg[$9565edbe45899661$var$lg++] = $9565edbe45899661$var$mg;
    $9565edbe45899661$var$mg = a;
    $9565edbe45899661$var$ng = b;
}
function $9565edbe45899661$var$ug(a, b, c) {
    $9565edbe45899661$var$og[$9565edbe45899661$var$pg++] = $9565edbe45899661$var$rg;
    $9565edbe45899661$var$og[$9565edbe45899661$var$pg++] = $9565edbe45899661$var$sg;
    $9565edbe45899661$var$og[$9565edbe45899661$var$pg++] = $9565edbe45899661$var$qg;
    $9565edbe45899661$var$qg = a;
    var d = $9565edbe45899661$var$rg;
    a = $9565edbe45899661$var$sg;
    var e = 32 - $9565edbe45899661$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9565edbe45899661$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9565edbe45899661$var$rg = 1 << 32 - $9565edbe45899661$var$oc(b) + e | c << e | d;
        $9565edbe45899661$var$sg = f + a;
    } else $9565edbe45899661$var$rg = 1 << f | c << e | d, $9565edbe45899661$var$sg = a;
}
function $9565edbe45899661$var$vg(a) {
    null !== a.return && ($9565edbe45899661$var$tg(a, 1), $9565edbe45899661$var$ug(a, 1, 0));
}
function $9565edbe45899661$var$wg(a) {
    for(; a === $9565edbe45899661$var$mg;)$9565edbe45899661$var$mg = $9565edbe45899661$var$kg[--$9565edbe45899661$var$lg], $9565edbe45899661$var$kg[$9565edbe45899661$var$lg] = null, $9565edbe45899661$var$ng = $9565edbe45899661$var$kg[--$9565edbe45899661$var$lg], $9565edbe45899661$var$kg[$9565edbe45899661$var$lg] = null;
    for(; a === $9565edbe45899661$var$qg;)$9565edbe45899661$var$qg = $9565edbe45899661$var$og[--$9565edbe45899661$var$pg], $9565edbe45899661$var$og[$9565edbe45899661$var$pg] = null, $9565edbe45899661$var$sg = $9565edbe45899661$var$og[--$9565edbe45899661$var$pg], $9565edbe45899661$var$og[$9565edbe45899661$var$pg] = null, $9565edbe45899661$var$rg = $9565edbe45899661$var$og[--$9565edbe45899661$var$pg], $9565edbe45899661$var$og[$9565edbe45899661$var$pg] = null;
}
var $9565edbe45899661$var$xg = null, $9565edbe45899661$var$yg = null, $9565edbe45899661$var$I = !1, $9565edbe45899661$var$zg = null;
function $9565edbe45899661$var$Ag(a, b) {
    var c = $9565edbe45899661$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9565edbe45899661$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9565edbe45899661$var$xg = a, $9565edbe45899661$var$yg = $9565edbe45899661$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9565edbe45899661$var$xg = a, $9565edbe45899661$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9565edbe45899661$var$qg ? {
                id: $9565edbe45899661$var$rg,
                overflow: $9565edbe45899661$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9565edbe45899661$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9565edbe45899661$var$xg = a, $9565edbe45899661$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9565edbe45899661$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9565edbe45899661$var$Eg(a) {
    if ($9565edbe45899661$var$I) {
        var b = $9565edbe45899661$var$yg;
        if (b) {
            var c = b;
            if (!$9565edbe45899661$var$Cg(a, b)) {
                if ($9565edbe45899661$var$Dg(a)) throw Error($9565edbe45899661$var$p(418));
                b = $9565edbe45899661$var$Lf(c.nextSibling);
                var d = $9565edbe45899661$var$xg;
                b && $9565edbe45899661$var$Cg(a, b) ? $9565edbe45899661$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9565edbe45899661$var$I = !1, $9565edbe45899661$var$xg = a);
            }
        } else {
            if ($9565edbe45899661$var$Dg(a)) throw Error($9565edbe45899661$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9565edbe45899661$var$I = !1;
            $9565edbe45899661$var$xg = a;
        }
    }
}
function $9565edbe45899661$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9565edbe45899661$var$xg = a;
}
function $9565edbe45899661$var$Gg(a) {
    if (a !== $9565edbe45899661$var$xg) return !1;
    if (!$9565edbe45899661$var$I) return $9565edbe45899661$var$Fg(a), $9565edbe45899661$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9565edbe45899661$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9565edbe45899661$var$yg)) {
        if ($9565edbe45899661$var$Dg(a)) throw $9565edbe45899661$var$Hg(), Error($9565edbe45899661$var$p(418));
        for(; b;)$9565edbe45899661$var$Ag(a, b), b = $9565edbe45899661$var$Lf(b.nextSibling);
    }
    $9565edbe45899661$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9565edbe45899661$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9565edbe45899661$var$yg = $9565edbe45899661$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9565edbe45899661$var$yg = null;
        }
    } else $9565edbe45899661$var$yg = $9565edbe45899661$var$xg ? $9565edbe45899661$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9565edbe45899661$var$Hg() {
    for(var a = $9565edbe45899661$var$yg; a;)a = $9565edbe45899661$var$Lf(a.nextSibling);
}
function $9565edbe45899661$var$Ig() {
    $9565edbe45899661$var$yg = $9565edbe45899661$var$xg = null;
    $9565edbe45899661$var$I = !1;
}
function $9565edbe45899661$var$Jg(a) {
    null === $9565edbe45899661$var$zg ? $9565edbe45899661$var$zg = [
        a
    ] : $9565edbe45899661$var$zg.push(a);
}
var $9565edbe45899661$var$Kg = $9565edbe45899661$var$ua.ReactCurrentBatchConfig;
function $9565edbe45899661$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9565edbe45899661$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9565edbe45899661$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9565edbe45899661$var$p(284));
        if (!c._owner) throw Error($9565edbe45899661$var$p(290, a));
    }
    return a;
}
function $9565edbe45899661$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9565edbe45899661$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9565edbe45899661$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $9565edbe45899661$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9565edbe45899661$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9565edbe45899661$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9565edbe45899661$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9565edbe45899661$var$Ha && $9565edbe45899661$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $9565edbe45899661$var$Lg(a, b, c), d.return = a, d;
        d = $9565edbe45899661$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9565edbe45899661$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9565edbe45899661$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9565edbe45899661$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9565edbe45899661$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9565edbe45899661$var$va:
                    return c = $9565edbe45899661$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $9565edbe45899661$var$Lg(a, null, b), c.return = a, c;
                case $9565edbe45899661$var$wa:
                    return b = $9565edbe45899661$var$Sg(b, a.mode, c), b.return = a, b;
                case $9565edbe45899661$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9565edbe45899661$var$eb(b) || $9565edbe45899661$var$Ka(b)) return b = $9565edbe45899661$var$Tg(b, a.mode, c, null), b.return = a, b;
            $9565edbe45899661$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9565edbe45899661$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9565edbe45899661$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9565edbe45899661$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9565edbe45899661$var$eb(c) || $9565edbe45899661$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9565edbe45899661$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9565edbe45899661$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9565edbe45899661$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9565edbe45899661$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9565edbe45899661$var$eb(d) || $9565edbe45899661$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9565edbe45899661$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9565edbe45899661$var$I && $9565edbe45899661$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9565edbe45899661$var$I && $9565edbe45899661$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9565edbe45899661$var$I && $9565edbe45899661$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9565edbe45899661$var$Ka(h);
        if ("function" !== typeof l) throw Error($9565edbe45899661$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9565edbe45899661$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9565edbe45899661$var$I && $9565edbe45899661$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9565edbe45899661$var$I && $9565edbe45899661$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9565edbe45899661$var$I && $9565edbe45899661$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9565edbe45899661$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9565edbe45899661$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9565edbe45899661$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9565edbe45899661$var$Ha && $9565edbe45899661$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9565edbe45899661$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9565edbe45899661$var$ya ? (d = $9565edbe45899661$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9565edbe45899661$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $9565edbe45899661$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9565edbe45899661$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9565edbe45899661$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9565edbe45899661$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9565edbe45899661$var$eb(f)) return n(a, d, f, h);
            if ($9565edbe45899661$var$Ka(f)) return t(a, d, f, h);
            $9565edbe45899661$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9565edbe45899661$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9565edbe45899661$var$Ug = $9565edbe45899661$var$Og(!0), $9565edbe45899661$var$Vg = $9565edbe45899661$var$Og(!1), $9565edbe45899661$var$Wg = $9565edbe45899661$var$Uf(null), $9565edbe45899661$var$Xg = null, $9565edbe45899661$var$Yg = null, $9565edbe45899661$var$Zg = null;
function $9565edbe45899661$var$$g() {
    $9565edbe45899661$var$Zg = $9565edbe45899661$var$Yg = $9565edbe45899661$var$Xg = null;
}
function $9565edbe45899661$var$ah(a) {
    var b = $9565edbe45899661$var$Wg.current;
    $9565edbe45899661$var$E($9565edbe45899661$var$Wg);
    a._currentValue = b;
}
function $9565edbe45899661$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9565edbe45899661$var$ch(a, b) {
    $9565edbe45899661$var$Xg = a;
    $9565edbe45899661$var$Zg = $9565edbe45899661$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9565edbe45899661$var$dh = !0), a.firstContext = null);
}
function $9565edbe45899661$var$eh(a) {
    var b = a._currentValue;
    if ($9565edbe45899661$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9565edbe45899661$var$Yg) {
            if (null === $9565edbe45899661$var$Xg) throw Error($9565edbe45899661$var$p(308));
            $9565edbe45899661$var$Yg = a;
            $9565edbe45899661$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9565edbe45899661$var$Yg = $9565edbe45899661$var$Yg.next = a;
    }
    return b;
}
var $9565edbe45899661$var$fh = null;
function $9565edbe45899661$var$gh(a) {
    null === $9565edbe45899661$var$fh ? $9565edbe45899661$var$fh = [
        a
    ] : $9565edbe45899661$var$fh.push(a);
}
function $9565edbe45899661$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9565edbe45899661$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9565edbe45899661$var$ih(a, d);
}
function $9565edbe45899661$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9565edbe45899661$var$jh = !1;
function $9565edbe45899661$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9565edbe45899661$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9565edbe45899661$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9565edbe45899661$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9565edbe45899661$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9565edbe45899661$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9565edbe45899661$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9565edbe45899661$var$ih(a, c);
}
function $9565edbe45899661$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9565edbe45899661$var$Cc(a, c);
    }
}
function $9565edbe45899661$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9565edbe45899661$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $9565edbe45899661$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9565edbe45899661$var$A({}, q, r);
                            break a;
                        case 2:
                            $9565edbe45899661$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9565edbe45899661$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9565edbe45899661$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9565edbe45899661$var$p(191, e));
            e.call(d);
        }
    }
}
var $9565edbe45899661$var$th = {}, $9565edbe45899661$var$uh = $9565edbe45899661$var$Uf($9565edbe45899661$var$th), $9565edbe45899661$var$vh = $9565edbe45899661$var$Uf($9565edbe45899661$var$th), $9565edbe45899661$var$wh = $9565edbe45899661$var$Uf($9565edbe45899661$var$th);
function $9565edbe45899661$var$xh(a) {
    if (a === $9565edbe45899661$var$th) throw Error($9565edbe45899661$var$p(174));
    return a;
}
function $9565edbe45899661$var$yh(a, b) {
    $9565edbe45899661$var$G($9565edbe45899661$var$wh, b);
    $9565edbe45899661$var$G($9565edbe45899661$var$vh, a);
    $9565edbe45899661$var$G($9565edbe45899661$var$uh, $9565edbe45899661$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9565edbe45899661$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9565edbe45899661$var$lb(b, a);
    }
    $9565edbe45899661$var$E($9565edbe45899661$var$uh);
    $9565edbe45899661$var$G($9565edbe45899661$var$uh, b);
}
function $9565edbe45899661$var$zh() {
    $9565edbe45899661$var$E($9565edbe45899661$var$uh);
    $9565edbe45899661$var$E($9565edbe45899661$var$vh);
    $9565edbe45899661$var$E($9565edbe45899661$var$wh);
}
function $9565edbe45899661$var$Ah(a) {
    $9565edbe45899661$var$xh($9565edbe45899661$var$wh.current);
    var b = $9565edbe45899661$var$xh($9565edbe45899661$var$uh.current);
    var c = $9565edbe45899661$var$lb(b, a.type);
    b !== c && ($9565edbe45899661$var$G($9565edbe45899661$var$vh, a), $9565edbe45899661$var$G($9565edbe45899661$var$uh, c));
}
function $9565edbe45899661$var$Bh(a) {
    $9565edbe45899661$var$vh.current === a && ($9565edbe45899661$var$E($9565edbe45899661$var$uh), $9565edbe45899661$var$E($9565edbe45899661$var$vh));
}
var $9565edbe45899661$var$L = $9565edbe45899661$var$Uf(0);
function $9565edbe45899661$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9565edbe45899661$var$Dh = [];
function $9565edbe45899661$var$Eh() {
    for(var a = 0; a < $9565edbe45899661$var$Dh.length; a++)$9565edbe45899661$var$Dh[a]._workInProgressVersionPrimary = null;
    $9565edbe45899661$var$Dh.length = 0;
}
var $9565edbe45899661$var$Fh = $9565edbe45899661$var$ua.ReactCurrentDispatcher, $9565edbe45899661$var$Gh = $9565edbe45899661$var$ua.ReactCurrentBatchConfig, $9565edbe45899661$var$Hh = 0, $9565edbe45899661$var$M = null, $9565edbe45899661$var$N = null, $9565edbe45899661$var$O = null, $9565edbe45899661$var$Ih = !1, $9565edbe45899661$var$Jh = !1, $9565edbe45899661$var$Kh = 0, $9565edbe45899661$var$Lh = 0;
function $9565edbe45899661$var$P() {
    throw Error($9565edbe45899661$var$p(321));
}
function $9565edbe45899661$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9565edbe45899661$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9565edbe45899661$var$Nh(a, b, c, d, e, f) {
    $9565edbe45899661$var$Hh = f;
    $9565edbe45899661$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9565edbe45899661$var$Fh.current = null === a || null === a.memoizedState ? $9565edbe45899661$var$Oh : $9565edbe45899661$var$Ph;
    a = c(d, e);
    if ($9565edbe45899661$var$Jh) {
        f = 0;
        do {
            $9565edbe45899661$var$Jh = !1;
            $9565edbe45899661$var$Kh = 0;
            if (25 <= f) throw Error($9565edbe45899661$var$p(301));
            f += 1;
            $9565edbe45899661$var$O = $9565edbe45899661$var$N = null;
            b.updateQueue = null;
            $9565edbe45899661$var$Fh.current = $9565edbe45899661$var$Qh;
            a = c(d, e);
        }while ($9565edbe45899661$var$Jh);
    }
    $9565edbe45899661$var$Fh.current = $9565edbe45899661$var$Rh;
    b = null !== $9565edbe45899661$var$N && null !== $9565edbe45899661$var$N.next;
    $9565edbe45899661$var$Hh = 0;
    $9565edbe45899661$var$O = $9565edbe45899661$var$N = $9565edbe45899661$var$M = null;
    $9565edbe45899661$var$Ih = !1;
    if (b) throw Error($9565edbe45899661$var$p(300));
    return a;
}
function $9565edbe45899661$var$Sh() {
    var a = 0 !== $9565edbe45899661$var$Kh;
    $9565edbe45899661$var$Kh = 0;
    return a;
}
function $9565edbe45899661$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9565edbe45899661$var$O ? $9565edbe45899661$var$M.memoizedState = $9565edbe45899661$var$O = a : $9565edbe45899661$var$O = $9565edbe45899661$var$O.next = a;
    return $9565edbe45899661$var$O;
}
function $9565edbe45899661$var$Uh() {
    if (null === $9565edbe45899661$var$N) {
        var a = $9565edbe45899661$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9565edbe45899661$var$N.next;
    var b = null === $9565edbe45899661$var$O ? $9565edbe45899661$var$M.memoizedState : $9565edbe45899661$var$O.next;
    if (null !== b) $9565edbe45899661$var$O = b, $9565edbe45899661$var$N = a;
    else {
        if (null === a) throw Error($9565edbe45899661$var$p(310));
        $9565edbe45899661$var$N = a;
        a = {
            memoizedState: $9565edbe45899661$var$N.memoizedState,
            baseState: $9565edbe45899661$var$N.baseState,
            baseQueue: $9565edbe45899661$var$N.baseQueue,
            queue: $9565edbe45899661$var$N.queue,
            next: null
        };
        null === $9565edbe45899661$var$O ? $9565edbe45899661$var$M.memoizedState = $9565edbe45899661$var$O = a : $9565edbe45899661$var$O = $9565edbe45899661$var$O.next = a;
    }
    return $9565edbe45899661$var$O;
}
function $9565edbe45899661$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9565edbe45899661$var$Wh(a) {
    var b = $9565edbe45899661$var$Uh(), c = b.queue;
    if (null === c) throw Error($9565edbe45899661$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9565edbe45899661$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9565edbe45899661$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9565edbe45899661$var$M.lanes |= m;
                $9565edbe45899661$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9565edbe45899661$var$He(d, b.memoizedState) || ($9565edbe45899661$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9565edbe45899661$var$M.lanes |= f, $9565edbe45899661$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9565edbe45899661$var$Xh(a) {
    var b = $9565edbe45899661$var$Uh(), c = b.queue;
    if (null === c) throw Error($9565edbe45899661$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9565edbe45899661$var$He(f, b.memoizedState) || ($9565edbe45899661$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9565edbe45899661$var$Yh() {}
function $9565edbe45899661$var$Zh(a, b) {
    var c = $9565edbe45899661$var$M, d = $9565edbe45899661$var$Uh(), e = b(), f = !$9565edbe45899661$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9565edbe45899661$var$dh = !0);
    d = d.queue;
    $9565edbe45899661$var$$h($9565edbe45899661$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9565edbe45899661$var$O && $9565edbe45899661$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9565edbe45899661$var$bi(9, $9565edbe45899661$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $9565edbe45899661$var$Q) throw Error($9565edbe45899661$var$p(349));
        0 !== ($9565edbe45899661$var$Hh & 30) || $9565edbe45899661$var$di(c, b, e);
    }
    return e;
}
function $9565edbe45899661$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9565edbe45899661$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9565edbe45899661$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9565edbe45899661$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9565edbe45899661$var$ei(b) && $9565edbe45899661$var$fi(a);
}
function $9565edbe45899661$var$ai(a, b, c) {
    return c(function() {
        $9565edbe45899661$var$ei(b) && $9565edbe45899661$var$fi(a);
    });
}
function $9565edbe45899661$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9565edbe45899661$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9565edbe45899661$var$fi(a) {
    var b = $9565edbe45899661$var$ih(a, 1);
    null !== b && $9565edbe45899661$var$gi(b, a, 1, -1);
}
function $9565edbe45899661$var$hi(a) {
    var b = $9565edbe45899661$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9565edbe45899661$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9565edbe45899661$var$ii.bind(null, $9565edbe45899661$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9565edbe45899661$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9565edbe45899661$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9565edbe45899661$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9565edbe45899661$var$ji() {
    return $9565edbe45899661$var$Uh().memoizedState;
}
function $9565edbe45899661$var$ki(a, b, c, d) {
    var e = $9565edbe45899661$var$Th();
    $9565edbe45899661$var$M.flags |= a;
    e.memoizedState = $9565edbe45899661$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9565edbe45899661$var$li(a, b, c, d) {
    var e = $9565edbe45899661$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9565edbe45899661$var$N) {
        var g = $9565edbe45899661$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $9565edbe45899661$var$Mh(d, g.deps)) {
            e.memoizedState = $9565edbe45899661$var$bi(b, c, f, d);
            return;
        }
    }
    $9565edbe45899661$var$M.flags |= a;
    e.memoizedState = $9565edbe45899661$var$bi(1 | b, c, f, d);
}
function $9565edbe45899661$var$mi(a, b) {
    return $9565edbe45899661$var$ki(8390656, 8, a, b);
}
function $9565edbe45899661$var$$h(a, b) {
    return $9565edbe45899661$var$li(2048, 8, a, b);
}
function $9565edbe45899661$var$ni(a, b) {
    return $9565edbe45899661$var$li(4, 2, a, b);
}
function $9565edbe45899661$var$oi(a, b) {
    return $9565edbe45899661$var$li(4, 4, a, b);
}
function $9565edbe45899661$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9565edbe45899661$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9565edbe45899661$var$li(4, 4, $9565edbe45899661$var$pi.bind(null, b, a), c);
}
function $9565edbe45899661$var$ri() {}
function $9565edbe45899661$var$si(a, b) {
    var c = $9565edbe45899661$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9565edbe45899661$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9565edbe45899661$var$ti(a, b) {
    var c = $9565edbe45899661$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9565edbe45899661$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9565edbe45899661$var$ui(a, b, c) {
    if (0 === ($9565edbe45899661$var$Hh & 21)) return a.baseState && (a.baseState = !1, $9565edbe45899661$var$dh = !0), a.memoizedState = c;
    $9565edbe45899661$var$He(c, b) || (c = $9565edbe45899661$var$yc(), $9565edbe45899661$var$M.lanes |= c, $9565edbe45899661$var$rh |= c, a.baseState = !0);
    return b;
}
function $9565edbe45899661$var$vi(a, b) {
    var c = $9565edbe45899661$var$C;
    $9565edbe45899661$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9565edbe45899661$var$Gh.transition;
    $9565edbe45899661$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9565edbe45899661$var$C = c, $9565edbe45899661$var$Gh.transition = d;
    }
}
function $9565edbe45899661$var$wi() {
    return $9565edbe45899661$var$Uh().memoizedState;
}
function $9565edbe45899661$var$xi(a, b, c) {
    var d = $9565edbe45899661$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9565edbe45899661$var$zi(a)) $9565edbe45899661$var$Ai(b, c);
    else if (c = $9565edbe45899661$var$hh(a, b, c, d), null !== c) {
        var e = $9565edbe45899661$var$R();
        $9565edbe45899661$var$gi(c, a, d, e);
        $9565edbe45899661$var$Bi(c, b, d);
    }
}
function $9565edbe45899661$var$ii(a, b, c) {
    var d = $9565edbe45899661$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9565edbe45899661$var$zi(a)) $9565edbe45899661$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9565edbe45899661$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9565edbe45899661$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9565edbe45899661$var$hh(a, b, e, d);
        null !== c && (e = $9565edbe45899661$var$R(), $9565edbe45899661$var$gi(c, a, d, e), $9565edbe45899661$var$Bi(c, b, d));
    }
}
function $9565edbe45899661$var$zi(a) {
    var b = a.alternate;
    return a === $9565edbe45899661$var$M || null !== b && b === $9565edbe45899661$var$M;
}
function $9565edbe45899661$var$Ai(a, b) {
    $9565edbe45899661$var$Jh = $9565edbe45899661$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9565edbe45899661$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9565edbe45899661$var$Cc(a, c);
    }
}
var $9565edbe45899661$var$Rh = {
    readContext: $9565edbe45899661$var$eh,
    useCallback: $9565edbe45899661$var$P,
    useContext: $9565edbe45899661$var$P,
    useEffect: $9565edbe45899661$var$P,
    useImperativeHandle: $9565edbe45899661$var$P,
    useInsertionEffect: $9565edbe45899661$var$P,
    useLayoutEffect: $9565edbe45899661$var$P,
    useMemo: $9565edbe45899661$var$P,
    useReducer: $9565edbe45899661$var$P,
    useRef: $9565edbe45899661$var$P,
    useState: $9565edbe45899661$var$P,
    useDebugValue: $9565edbe45899661$var$P,
    useDeferredValue: $9565edbe45899661$var$P,
    useTransition: $9565edbe45899661$var$P,
    useMutableSource: $9565edbe45899661$var$P,
    useSyncExternalStore: $9565edbe45899661$var$P,
    useId: $9565edbe45899661$var$P,
    unstable_isNewReconciler: !1
}, $9565edbe45899661$var$Oh = {
    readContext: $9565edbe45899661$var$eh,
    useCallback: function(a, b) {
        $9565edbe45899661$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9565edbe45899661$var$eh,
    useEffect: $9565edbe45899661$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9565edbe45899661$var$ki(4194308, 4, $9565edbe45899661$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9565edbe45899661$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9565edbe45899661$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9565edbe45899661$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9565edbe45899661$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9565edbe45899661$var$xi.bind(null, $9565edbe45899661$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9565edbe45899661$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9565edbe45899661$var$hi,
    useDebugValue: $9565edbe45899661$var$ri,
    useDeferredValue: function(a) {
        return $9565edbe45899661$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $9565edbe45899661$var$hi(!1), b = a[0];
        a = $9565edbe45899661$var$vi.bind(null, a[1]);
        $9565edbe45899661$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9565edbe45899661$var$M, e = $9565edbe45899661$var$Th();
        if ($9565edbe45899661$var$I) {
            if (void 0 === c) throw Error($9565edbe45899661$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9565edbe45899661$var$Q) throw Error($9565edbe45899661$var$p(349));
            0 !== ($9565edbe45899661$var$Hh & 30) || $9565edbe45899661$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9565edbe45899661$var$mi($9565edbe45899661$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9565edbe45899661$var$bi(9, $9565edbe45899661$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9565edbe45899661$var$Th(), b = $9565edbe45899661$var$Q.identifierPrefix;
        if ($9565edbe45899661$var$I) {
            var c = $9565edbe45899661$var$sg;
            var d = $9565edbe45899661$var$rg;
            c = (d & ~(1 << 32 - $9565edbe45899661$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9565edbe45899661$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9565edbe45899661$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9565edbe45899661$var$Ph = {
    readContext: $9565edbe45899661$var$eh,
    useCallback: $9565edbe45899661$var$si,
    useContext: $9565edbe45899661$var$eh,
    useEffect: $9565edbe45899661$var$$h,
    useImperativeHandle: $9565edbe45899661$var$qi,
    useInsertionEffect: $9565edbe45899661$var$ni,
    useLayoutEffect: $9565edbe45899661$var$oi,
    useMemo: $9565edbe45899661$var$ti,
    useReducer: $9565edbe45899661$var$Wh,
    useRef: $9565edbe45899661$var$ji,
    useState: function() {
        return $9565edbe45899661$var$Wh($9565edbe45899661$var$Vh);
    },
    useDebugValue: $9565edbe45899661$var$ri,
    useDeferredValue: function(a) {
        var b = $9565edbe45899661$var$Uh();
        return $9565edbe45899661$var$ui(b, $9565edbe45899661$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9565edbe45899661$var$Wh($9565edbe45899661$var$Vh)[0], b = $9565edbe45899661$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9565edbe45899661$var$Yh,
    useSyncExternalStore: $9565edbe45899661$var$Zh,
    useId: $9565edbe45899661$var$wi,
    unstable_isNewReconciler: !1
}, $9565edbe45899661$var$Qh = {
    readContext: $9565edbe45899661$var$eh,
    useCallback: $9565edbe45899661$var$si,
    useContext: $9565edbe45899661$var$eh,
    useEffect: $9565edbe45899661$var$$h,
    useImperativeHandle: $9565edbe45899661$var$qi,
    useInsertionEffect: $9565edbe45899661$var$ni,
    useLayoutEffect: $9565edbe45899661$var$oi,
    useMemo: $9565edbe45899661$var$ti,
    useReducer: $9565edbe45899661$var$Xh,
    useRef: $9565edbe45899661$var$ji,
    useState: function() {
        return $9565edbe45899661$var$Xh($9565edbe45899661$var$Vh);
    },
    useDebugValue: $9565edbe45899661$var$ri,
    useDeferredValue: function(a) {
        var b = $9565edbe45899661$var$Uh();
        return null === $9565edbe45899661$var$N ? b.memoizedState = a : $9565edbe45899661$var$ui(b, $9565edbe45899661$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9565edbe45899661$var$Xh($9565edbe45899661$var$Vh)[0], b = $9565edbe45899661$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9565edbe45899661$var$Yh,
    useSyncExternalStore: $9565edbe45899661$var$Zh,
    useId: $9565edbe45899661$var$wi,
    unstable_isNewReconciler: !1
};
function $9565edbe45899661$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $9565edbe45899661$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9565edbe45899661$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9565edbe45899661$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9565edbe45899661$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9565edbe45899661$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9565edbe45899661$var$R(), e = $9565edbe45899661$var$yi(a), f = $9565edbe45899661$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9565edbe45899661$var$nh(a, f, e);
        null !== b && ($9565edbe45899661$var$gi(b, a, e, d), $9565edbe45899661$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9565edbe45899661$var$R(), e = $9565edbe45899661$var$yi(a), f = $9565edbe45899661$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9565edbe45899661$var$nh(a, f, e);
        null !== b && ($9565edbe45899661$var$gi(b, a, e, d), $9565edbe45899661$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9565edbe45899661$var$R(), d = $9565edbe45899661$var$yi(a), e = $9565edbe45899661$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9565edbe45899661$var$nh(a, e, d);
        null !== b && ($9565edbe45899661$var$gi(b, a, d, c), $9565edbe45899661$var$oh(b, a, d));
    }
};
function $9565edbe45899661$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9565edbe45899661$var$Ie(c, d) || !$9565edbe45899661$var$Ie(e, f) : !0;
}
function $9565edbe45899661$var$Gi(a, b, c) {
    var d = !1, e = $9565edbe45899661$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9565edbe45899661$var$eh(f) : (e = $9565edbe45899661$var$Zf(b) ? $9565edbe45899661$var$Xf : $9565edbe45899661$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9565edbe45899661$var$Yf(a, e) : $9565edbe45899661$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9565edbe45899661$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9565edbe45899661$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9565edbe45899661$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $9565edbe45899661$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $9565edbe45899661$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9565edbe45899661$var$eh(f) : (f = $9565edbe45899661$var$Zf(b) ? $9565edbe45899661$var$Xf : $9565edbe45899661$var$H.current, e.context = $9565edbe45899661$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9565edbe45899661$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9565edbe45899661$var$Ei.enqueueReplaceState(e, e.state, null), $9565edbe45899661$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9565edbe45899661$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $9565edbe45899661$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9565edbe45899661$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9565edbe45899661$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9565edbe45899661$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $9565edbe45899661$var$Ni(a, b, c) {
    c = $9565edbe45899661$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9565edbe45899661$var$Oi || ($9565edbe45899661$var$Oi = !0, $9565edbe45899661$var$Pi = d);
        $9565edbe45899661$var$Li(a, b);
    };
    return c;
}
function $9565edbe45899661$var$Qi(a, b, c) {
    c = $9565edbe45899661$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9565edbe45899661$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9565edbe45899661$var$Li(a, b);
        "function" !== typeof d && (null === $9565edbe45899661$var$Ri ? $9565edbe45899661$var$Ri = new Set([
            this
        ]) : $9565edbe45899661$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9565edbe45899661$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9565edbe45899661$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9565edbe45899661$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $9565edbe45899661$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9565edbe45899661$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9565edbe45899661$var$mh(-1, 1), b.tag = 2, $9565edbe45899661$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9565edbe45899661$var$Wi = $9565edbe45899661$var$ua.ReactCurrentOwner, $9565edbe45899661$var$dh = !1;
function $9565edbe45899661$var$Xi(a, b, c, d) {
    b.child = null === a ? $9565edbe45899661$var$Vg(b, null, c, d) : $9565edbe45899661$var$Ug(b, a.child, c, d);
}
function $9565edbe45899661$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9565edbe45899661$var$ch(b, e);
    d = $9565edbe45899661$var$Nh(a, b, c, d, f, e);
    c = $9565edbe45899661$var$Sh();
    if (null !== a && !$9565edbe45899661$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9565edbe45899661$var$Zi(a, b, e);
    $9565edbe45899661$var$I && c && $9565edbe45899661$var$vg(b);
    b.flags |= 1;
    $9565edbe45899661$var$Xi(a, b, d, e);
    return b.child;
}
function $9565edbe45899661$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9565edbe45899661$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9565edbe45899661$var$bj(a, b, f, d, e);
        a = $9565edbe45899661$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9565edbe45899661$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9565edbe45899661$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $9565edbe45899661$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9565edbe45899661$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9565edbe45899661$var$Ie(f, d) && a.ref === b.ref) {
            if ($9565edbe45899661$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9565edbe45899661$var$dh = !0);
            else return b.lanes = a.lanes, $9565edbe45899661$var$Zi(a, b, e);
        }
    }
    return $9565edbe45899661$var$cj(a, b, c, d, e);
}
function $9565edbe45899661$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9565edbe45899661$var$G($9565edbe45899661$var$ej, $9565edbe45899661$var$fj), $9565edbe45899661$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9565edbe45899661$var$G($9565edbe45899661$var$ej, $9565edbe45899661$var$fj), $9565edbe45899661$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9565edbe45899661$var$G($9565edbe45899661$var$ej, $9565edbe45899661$var$fj);
            $9565edbe45899661$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9565edbe45899661$var$G($9565edbe45899661$var$ej, $9565edbe45899661$var$fj), $9565edbe45899661$var$fj |= d;
    $9565edbe45899661$var$Xi(a, b, e, c);
    return b.child;
}
function $9565edbe45899661$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9565edbe45899661$var$cj(a, b, c, d, e) {
    var f = $9565edbe45899661$var$Zf(c) ? $9565edbe45899661$var$Xf : $9565edbe45899661$var$H.current;
    f = $9565edbe45899661$var$Yf(b, f);
    $9565edbe45899661$var$ch(b, e);
    c = $9565edbe45899661$var$Nh(a, b, c, d, f, e);
    d = $9565edbe45899661$var$Sh();
    if (null !== a && !$9565edbe45899661$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9565edbe45899661$var$Zi(a, b, e);
    $9565edbe45899661$var$I && d && $9565edbe45899661$var$vg(b);
    b.flags |= 1;
    $9565edbe45899661$var$Xi(a, b, c, e);
    return b.child;
}
function $9565edbe45899661$var$hj(a, b, c, d, e) {
    if ($9565edbe45899661$var$Zf(c)) {
        var f = !0;
        $9565edbe45899661$var$cg(b);
    } else f = !1;
    $9565edbe45899661$var$ch(b, e);
    if (null === b.stateNode) $9565edbe45899661$var$ij(a, b), $9565edbe45899661$var$Gi(b, c, d), $9565edbe45899661$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9565edbe45899661$var$eh(l) : (l = $9565edbe45899661$var$Zf(c) ? $9565edbe45899661$var$Xf : $9565edbe45899661$var$H.current, l = $9565edbe45899661$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9565edbe45899661$var$Hi(b, g, d, l);
        $9565edbe45899661$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $9565edbe45899661$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9565edbe45899661$var$Wf.current || $9565edbe45899661$var$jh ? ("function" === typeof m && ($9565edbe45899661$var$Di(b, c, m, d), k = b.memoizedState), (h = $9565edbe45899661$var$jh || $9565edbe45899661$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9565edbe45899661$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9565edbe45899661$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9565edbe45899661$var$eh(k) : (k = $9565edbe45899661$var$Zf(c) ? $9565edbe45899661$var$Xf : $9565edbe45899661$var$H.current, k = $9565edbe45899661$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9565edbe45899661$var$Hi(b, g, d, k);
        $9565edbe45899661$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $9565edbe45899661$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9565edbe45899661$var$Wf.current || $9565edbe45899661$var$jh ? ("function" === typeof y && ($9565edbe45899661$var$Di(b, c, y, d), n = b.memoizedState), (l = $9565edbe45899661$var$jh || $9565edbe45899661$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9565edbe45899661$var$jj(a, b, c, d, f, e);
}
function $9565edbe45899661$var$jj(a, b, c, d, e, f) {
    $9565edbe45899661$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9565edbe45899661$var$dg(b, c, !1), $9565edbe45899661$var$Zi(a, b, f);
    d = b.stateNode;
    $9565edbe45899661$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9565edbe45899661$var$Ug(b, a.child, null, f), b.child = $9565edbe45899661$var$Ug(b, null, h, f)) : $9565edbe45899661$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9565edbe45899661$var$dg(b, c, !0);
    return b.child;
}
function $9565edbe45899661$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9565edbe45899661$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9565edbe45899661$var$ag(a, b.context, !1);
    $9565edbe45899661$var$yh(a, b.containerInfo);
}
function $9565edbe45899661$var$lj(a, b, c, d, e) {
    $9565edbe45899661$var$Ig();
    $9565edbe45899661$var$Jg(e);
    b.flags |= 256;
    $9565edbe45899661$var$Xi(a, b, c, d);
    return b.child;
}
var $9565edbe45899661$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9565edbe45899661$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9565edbe45899661$var$oj(a, b, c) {
    var d = b.pendingProps, e = $9565edbe45899661$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9565edbe45899661$var$G($9565edbe45899661$var$L, e & 1);
    if (null === a) {
        $9565edbe45899661$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9565edbe45899661$var$pj(g, d, 0, null), a = $9565edbe45899661$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9565edbe45899661$var$nj(c), b.memoizedState = $9565edbe45899661$var$mj, a) : $9565edbe45899661$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9565edbe45899661$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9565edbe45899661$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9565edbe45899661$var$Pg(h, f) : (f = $9565edbe45899661$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9565edbe45899661$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9565edbe45899661$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9565edbe45899661$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9565edbe45899661$var$qj(a, b) {
    b = $9565edbe45899661$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9565edbe45899661$var$sj(a, b, c, d) {
    null !== d && $9565edbe45899661$var$Jg(d);
    $9565edbe45899661$var$Ug(b, a.child, null, c);
    a = $9565edbe45899661$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9565edbe45899661$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9565edbe45899661$var$Ki(Error($9565edbe45899661$var$p(422))), $9565edbe45899661$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9565edbe45899661$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9565edbe45899661$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9565edbe45899661$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $9565edbe45899661$var$nj(g);
        b.memoizedState = $9565edbe45899661$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9565edbe45899661$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9565edbe45899661$var$p(419));
        d = $9565edbe45899661$var$Ki(f, d, void 0);
        return $9565edbe45899661$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9565edbe45899661$var$dh || h) {
        d = $9565edbe45899661$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9565edbe45899661$var$ih(a, e), $9565edbe45899661$var$gi(d, a, e, -1));
        }
        $9565edbe45899661$var$tj();
        d = $9565edbe45899661$var$Ki(Error($9565edbe45899661$var$p(421)));
        return $9565edbe45899661$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9565edbe45899661$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9565edbe45899661$var$yg = $9565edbe45899661$var$Lf(e.nextSibling);
    $9565edbe45899661$var$xg = b;
    $9565edbe45899661$var$I = !0;
    $9565edbe45899661$var$zg = null;
    null !== a && ($9565edbe45899661$var$og[$9565edbe45899661$var$pg++] = $9565edbe45899661$var$rg, $9565edbe45899661$var$og[$9565edbe45899661$var$pg++] = $9565edbe45899661$var$sg, $9565edbe45899661$var$og[$9565edbe45899661$var$pg++] = $9565edbe45899661$var$qg, $9565edbe45899661$var$rg = a.id, $9565edbe45899661$var$sg = a.overflow, $9565edbe45899661$var$qg = b);
    b = $9565edbe45899661$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9565edbe45899661$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9565edbe45899661$var$bh(a.return, b, c);
}
function $9565edbe45899661$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9565edbe45899661$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9565edbe45899661$var$Xi(a, b, d.children, c);
    d = $9565edbe45899661$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9565edbe45899661$var$vj(a, c, b);
            else if (19 === a.tag) $9565edbe45899661$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9565edbe45899661$var$G($9565edbe45899661$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9565edbe45899661$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9565edbe45899661$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9565edbe45899661$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9565edbe45899661$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $9565edbe45899661$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9565edbe45899661$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9565edbe45899661$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9565edbe45899661$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9565edbe45899661$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9565edbe45899661$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9565edbe45899661$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9565edbe45899661$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $9565edbe45899661$var$kj(b);
            $9565edbe45899661$var$Ig();
            break;
        case 5:
            $9565edbe45899661$var$Ah(b);
            break;
        case 1:
            $9565edbe45899661$var$Zf(b.type) && $9565edbe45899661$var$cg(b);
            break;
        case 4:
            $9565edbe45899661$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9565edbe45899661$var$G($9565edbe45899661$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9565edbe45899661$var$G($9565edbe45899661$var$L, $9565edbe45899661$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9565edbe45899661$var$oj(a, b, c);
                $9565edbe45899661$var$G($9565edbe45899661$var$L, $9565edbe45899661$var$L.current & 1);
                a = $9565edbe45899661$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9565edbe45899661$var$G($9565edbe45899661$var$L, $9565edbe45899661$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9565edbe45899661$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9565edbe45899661$var$G($9565edbe45899661$var$L, $9565edbe45899661$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9565edbe45899661$var$dj(a, b, c);
    }
    return $9565edbe45899661$var$Zi(a, b, c);
}
var $9565edbe45899661$var$zj, $9565edbe45899661$var$Aj, $9565edbe45899661$var$Bj, $9565edbe45899661$var$Cj;
$9565edbe45899661$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9565edbe45899661$var$Aj = function() {};
$9565edbe45899661$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9565edbe45899661$var$xh($9565edbe45899661$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9565edbe45899661$var$Ya(a, e);
                d = $9565edbe45899661$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9565edbe45899661$var$A({}, e, {
                    value: void 0
                });
                d = $9565edbe45899661$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9565edbe45899661$var$gb(a, e);
                d = $9565edbe45899661$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9565edbe45899661$var$Bf);
        }
        $9565edbe45899661$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9565edbe45899661$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9565edbe45899661$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9565edbe45899661$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9565edbe45899661$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9565edbe45899661$var$Dj(a, b) {
    if (!$9565edbe45899661$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9565edbe45899661$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9565edbe45899661$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $9565edbe45899661$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9565edbe45899661$var$S(b), null;
        case 1:
            return $9565edbe45899661$var$Zf(b.type) && $9565edbe45899661$var$$f(), $9565edbe45899661$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9565edbe45899661$var$zh();
            $9565edbe45899661$var$E($9565edbe45899661$var$Wf);
            $9565edbe45899661$var$E($9565edbe45899661$var$H);
            $9565edbe45899661$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9565edbe45899661$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9565edbe45899661$var$zg && ($9565edbe45899661$var$Fj($9565edbe45899661$var$zg), $9565edbe45899661$var$zg = null));
            $9565edbe45899661$var$Aj(a, b);
            $9565edbe45899661$var$S(b);
            return null;
        case 5:
            $9565edbe45899661$var$Bh(b);
            var e = $9565edbe45899661$var$xh($9565edbe45899661$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9565edbe45899661$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9565edbe45899661$var$p(166));
                    $9565edbe45899661$var$S(b);
                    return null;
                }
                a = $9565edbe45899661$var$xh($9565edbe45899661$var$uh.current);
                if ($9565edbe45899661$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9565edbe45899661$var$Of] = b;
                    d[$9565edbe45899661$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9565edbe45899661$var$D("cancel", d);
                            $9565edbe45899661$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9565edbe45899661$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9565edbe45899661$var$lf.length; e++)$9565edbe45899661$var$D($9565edbe45899661$var$lf[e], d);
                            break;
                        case "source":
                            $9565edbe45899661$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9565edbe45899661$var$D("error", d);
                            $9565edbe45899661$var$D("load", d);
                            break;
                        case "details":
                            $9565edbe45899661$var$D("toggle", d);
                            break;
                        case "input":
                            $9565edbe45899661$var$Za(d, f);
                            $9565edbe45899661$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9565edbe45899661$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9565edbe45899661$var$hb(d, f), $9565edbe45899661$var$D("invalid", d);
                    }
                    $9565edbe45899661$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9565edbe45899661$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9565edbe45899661$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9565edbe45899661$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9565edbe45899661$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9565edbe45899661$var$Va(d);
                            $9565edbe45899661$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9565edbe45899661$var$Va(d);
                            $9565edbe45899661$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9565edbe45899661$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9565edbe45899661$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9565edbe45899661$var$Of] = b;
                    a[$9565edbe45899661$var$Pf] = d;
                    $9565edbe45899661$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9565edbe45899661$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9565edbe45899661$var$D("cancel", a);
                                $9565edbe45899661$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9565edbe45899661$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9565edbe45899661$var$lf.length; e++)$9565edbe45899661$var$D($9565edbe45899661$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9565edbe45899661$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9565edbe45899661$var$D("error", a);
                                $9565edbe45899661$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9565edbe45899661$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9565edbe45899661$var$Za(a, d);
                                e = $9565edbe45899661$var$Ya(a, d);
                                $9565edbe45899661$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9565edbe45899661$var$A({}, d, {
                                    value: void 0
                                });
                                $9565edbe45899661$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9565edbe45899661$var$hb(a, d);
                                e = $9565edbe45899661$var$gb(a, d);
                                $9565edbe45899661$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9565edbe45899661$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9565edbe45899661$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9565edbe45899661$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9565edbe45899661$var$ob(a, k) : "number" === typeof k && $9565edbe45899661$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9565edbe45899661$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9565edbe45899661$var$D("scroll", a) : null != k && $9565edbe45899661$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9565edbe45899661$var$Va(a);
                                $9565edbe45899661$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9565edbe45899661$var$Va(a);
                                $9565edbe45899661$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9565edbe45899661$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9565edbe45899661$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9565edbe45899661$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9565edbe45899661$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9565edbe45899661$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9565edbe45899661$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9565edbe45899661$var$p(166));
                c = $9565edbe45899661$var$xh($9565edbe45899661$var$wh.current);
                $9565edbe45899661$var$xh($9565edbe45899661$var$uh.current);
                if ($9565edbe45899661$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9565edbe45899661$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9565edbe45899661$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9565edbe45899661$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9565edbe45899661$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9565edbe45899661$var$Of] = b, b.stateNode = d;
            }
            $9565edbe45899661$var$S(b);
            return null;
        case 13:
            $9565edbe45899661$var$E($9565edbe45899661$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9565edbe45899661$var$I && null !== $9565edbe45899661$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9565edbe45899661$var$Hg(), $9565edbe45899661$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9565edbe45899661$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9565edbe45899661$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9565edbe45899661$var$p(317));
                        f[$9565edbe45899661$var$Of] = b;
                    } else $9565edbe45899661$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9565edbe45899661$var$S(b);
                    f = !1;
                } else null !== $9565edbe45899661$var$zg && ($9565edbe45899661$var$Fj($9565edbe45899661$var$zg), $9565edbe45899661$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9565edbe45899661$var$L.current & 1) ? 0 === $9565edbe45899661$var$T && ($9565edbe45899661$var$T = 3) : $9565edbe45899661$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9565edbe45899661$var$S(b);
            return null;
        case 4:
            return $9565edbe45899661$var$zh(), $9565edbe45899661$var$Aj(a, b), null === a && $9565edbe45899661$var$sf(b.stateNode.containerInfo), $9565edbe45899661$var$S(b), null;
        case 10:
            return $9565edbe45899661$var$ah(b.type._context), $9565edbe45899661$var$S(b), null;
        case 17:
            return $9565edbe45899661$var$Zf(b.type) && $9565edbe45899661$var$$f(), $9565edbe45899661$var$S(b), null;
        case 19:
            $9565edbe45899661$var$E($9565edbe45899661$var$L);
            f = b.memoizedState;
            if (null === f) return $9565edbe45899661$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9565edbe45899661$var$Dj(f, !1);
                else {
                    if (0 !== $9565edbe45899661$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9565edbe45899661$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9565edbe45899661$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9565edbe45899661$var$G($9565edbe45899661$var$L, $9565edbe45899661$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9565edbe45899661$var$B() > $9565edbe45899661$var$Gj && (b.flags |= 128, d = !0, $9565edbe45899661$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9565edbe45899661$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9565edbe45899661$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9565edbe45899661$var$I) return $9565edbe45899661$var$S(b), null;
                    } else 2 * $9565edbe45899661$var$B() - f.renderingStartTime > $9565edbe45899661$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $9565edbe45899661$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9565edbe45899661$var$B(), b.sibling = null, c = $9565edbe45899661$var$L.current, $9565edbe45899661$var$G($9565edbe45899661$var$L, d ? c & 1 | 2 : c & 1), b;
            $9565edbe45899661$var$S(b);
            return null;
        case 22:
        case 23:
            return $9565edbe45899661$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9565edbe45899661$var$fj & 1073741824) && ($9565edbe45899661$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9565edbe45899661$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9565edbe45899661$var$p(156, b.tag));
}
function $9565edbe45899661$var$Ij(a, b) {
    $9565edbe45899661$var$wg(b);
    switch(b.tag){
        case 1:
            return $9565edbe45899661$var$Zf(b.type) && $9565edbe45899661$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9565edbe45899661$var$zh(), $9565edbe45899661$var$E($9565edbe45899661$var$Wf), $9565edbe45899661$var$E($9565edbe45899661$var$H), $9565edbe45899661$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9565edbe45899661$var$Bh(b), null;
        case 13:
            $9565edbe45899661$var$E($9565edbe45899661$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9565edbe45899661$var$p(340));
                $9565edbe45899661$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9565edbe45899661$var$E($9565edbe45899661$var$L), null;
        case 4:
            return $9565edbe45899661$var$zh(), null;
        case 10:
            return $9565edbe45899661$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $9565edbe45899661$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9565edbe45899661$var$Jj = !1, $9565edbe45899661$var$U = !1, $9565edbe45899661$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $9565edbe45899661$var$V = null;
function $9565edbe45899661$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9565edbe45899661$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9565edbe45899661$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9565edbe45899661$var$W(a, b, d);
    }
}
var $9565edbe45899661$var$Nj = !1;
function $9565edbe45899661$var$Oj(a, b) {
    $9565edbe45899661$var$Cf = $9565edbe45899661$var$dd;
    a = $9565edbe45899661$var$Me();
    if ($9565edbe45899661$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9565edbe45899661$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9565edbe45899661$var$dd = !1;
    for($9565edbe45899661$var$V = b; null !== $9565edbe45899661$var$V;)if (b = $9565edbe45899661$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9565edbe45899661$var$V = a;
    else for(; null !== $9565edbe45899661$var$V;){
        b = $9565edbe45899661$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9565edbe45899661$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9565edbe45899661$var$p(163));
            }
        } catch (F) {
            $9565edbe45899661$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9565edbe45899661$var$V = a;
            break;
        }
        $9565edbe45899661$var$V = b.return;
    }
    n = $9565edbe45899661$var$Nj;
    $9565edbe45899661$var$Nj = !1;
    return n;
}
function $9565edbe45899661$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9565edbe45899661$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9565edbe45899661$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9565edbe45899661$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9565edbe45899661$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9565edbe45899661$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9565edbe45899661$var$Of], delete b[$9565edbe45899661$var$Pf], delete b[$9565edbe45899661$var$of], delete b[$9565edbe45899661$var$Qf], delete b[$9565edbe45899661$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9565edbe45899661$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9565edbe45899661$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9565edbe45899661$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9565edbe45899661$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9565edbe45899661$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9565edbe45899661$var$Vj(a, b, c), a = a.sibling; null !== a;)$9565edbe45899661$var$Vj(a, b, c), a = a.sibling;
}
function $9565edbe45899661$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9565edbe45899661$var$Wj(a, b, c), a = a.sibling; null !== a;)$9565edbe45899661$var$Wj(a, b, c), a = a.sibling;
}
var $9565edbe45899661$var$X = null, $9565edbe45899661$var$Xj = !1;
function $9565edbe45899661$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$9565edbe45899661$var$Zj(a, b, c), c = c.sibling;
}
function $9565edbe45899661$var$Zj(a, b, c) {
    if ($9565edbe45899661$var$lc && "function" === typeof $9565edbe45899661$var$lc.onCommitFiberUnmount) try {
        $9565edbe45899661$var$lc.onCommitFiberUnmount($9565edbe45899661$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9565edbe45899661$var$U || $9565edbe45899661$var$Lj(c, b);
        case 6:
            var d = $9565edbe45899661$var$X, e = $9565edbe45899661$var$Xj;
            $9565edbe45899661$var$X = null;
            $9565edbe45899661$var$Yj(a, b, c);
            $9565edbe45899661$var$X = d;
            $9565edbe45899661$var$Xj = e;
            null !== $9565edbe45899661$var$X && ($9565edbe45899661$var$Xj ? (a = $9565edbe45899661$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9565edbe45899661$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9565edbe45899661$var$X && ($9565edbe45899661$var$Xj ? (a = $9565edbe45899661$var$X, c = c.stateNode, 8 === a.nodeType ? $9565edbe45899661$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9565edbe45899661$var$Kf(a, c), $9565edbe45899661$var$bd(a)) : $9565edbe45899661$var$Kf($9565edbe45899661$var$X, c.stateNode));
            break;
        case 4:
            d = $9565edbe45899661$var$X;
            e = $9565edbe45899661$var$Xj;
            $9565edbe45899661$var$X = c.stateNode.containerInfo;
            $9565edbe45899661$var$Xj = !0;
            $9565edbe45899661$var$Yj(a, b, c);
            $9565edbe45899661$var$X = d;
            $9565edbe45899661$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9565edbe45899661$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9565edbe45899661$var$Mj(c, b, g) : 0 !== (f & 4) && $9565edbe45899661$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9565edbe45899661$var$Yj(a, b, c);
            break;
        case 1:
            if (!$9565edbe45899661$var$U && ($9565edbe45899661$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9565edbe45899661$var$W(c, b, h);
            }
            $9565edbe45899661$var$Yj(a, b, c);
            break;
        case 21:
            $9565edbe45899661$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9565edbe45899661$var$U = (d = $9565edbe45899661$var$U) || null !== c.memoizedState, $9565edbe45899661$var$Yj(a, b, c), $9565edbe45899661$var$U = d) : $9565edbe45899661$var$Yj(a, b, c);
            break;
        default:
            $9565edbe45899661$var$Yj(a, b, c);
    }
}
function $9565edbe45899661$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9565edbe45899661$var$Kj);
        b.forEach(function(b) {
            var d = $9565edbe45899661$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9565edbe45899661$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9565edbe45899661$var$X = h.stateNode;
                        $9565edbe45899661$var$Xj = !1;
                        break a;
                    case 3:
                        $9565edbe45899661$var$X = h.stateNode.containerInfo;
                        $9565edbe45899661$var$Xj = !0;
                        break a;
                    case 4:
                        $9565edbe45899661$var$X = h.stateNode.containerInfo;
                        $9565edbe45899661$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9565edbe45899661$var$X) throw Error($9565edbe45899661$var$p(160));
            $9565edbe45899661$var$Zj(f, g, e);
            $9565edbe45899661$var$X = null;
            $9565edbe45899661$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9565edbe45899661$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9565edbe45899661$var$dk(b, a), b = b.sibling;
}
function $9565edbe45899661$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            if (d & 4) {
                try {
                    $9565edbe45899661$var$Pj(3, a, a.return), $9565edbe45899661$var$Qj(3, a);
                } catch (t) {
                    $9565edbe45899661$var$W(a, a.return, t);
                }
                try {
                    $9565edbe45899661$var$Pj(5, a, a.return);
                } catch (t) {
                    $9565edbe45899661$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            d & 512 && null !== c && $9565edbe45899661$var$Lj(c, c.return);
            break;
        case 5:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            d & 512 && null !== c && $9565edbe45899661$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9565edbe45899661$var$ob(e, "");
                } catch (t) {
                    $9565edbe45899661$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9565edbe45899661$var$ab(e, f);
                    $9565edbe45899661$var$vb(h, g);
                    var l = $9565edbe45899661$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9565edbe45899661$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9565edbe45899661$var$nb(e, q) : "children" === m ? $9565edbe45899661$var$ob(e, q) : $9565edbe45899661$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9565edbe45899661$var$bb(e, f);
                            break;
                        case "textarea":
                            $9565edbe45899661$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9565edbe45899661$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9565edbe45899661$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9565edbe45899661$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9565edbe45899661$var$Pf] = f;
                } catch (t) {
                    $9565edbe45899661$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9565edbe45899661$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9565edbe45899661$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9565edbe45899661$var$bd(b.containerInfo);
            } catch (t) {
                $9565edbe45899661$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            break;
        case 13:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9565edbe45899661$var$fk = $9565edbe45899661$var$B()));
            d & 4 && $9565edbe45899661$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9565edbe45899661$var$U = (l = $9565edbe45899661$var$U) || m, $9565edbe45899661$var$ck(b, a), $9565edbe45899661$var$U = l) : $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9565edbe45899661$var$V = a, m = a.child; null !== m;){
                    for(q = $9565edbe45899661$var$V = m; null !== $9565edbe45899661$var$V;){
                        r = $9565edbe45899661$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9565edbe45899661$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $9565edbe45899661$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9565edbe45899661$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9565edbe45899661$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9565edbe45899661$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9565edbe45899661$var$V = y) : $9565edbe45899661$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9565edbe45899661$var$rb("display", g));
                            } catch (t) {
                                $9565edbe45899661$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9565edbe45899661$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9565edbe45899661$var$ck(b, a);
            $9565edbe45899661$var$ek(a);
            d & 4 && $9565edbe45899661$var$ak(a);
            break;
        case 21:
            break;
        default:
            $9565edbe45899661$var$ck(b, a), $9565edbe45899661$var$ek(a);
    }
}
function $9565edbe45899661$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9565edbe45899661$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9565edbe45899661$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9565edbe45899661$var$ob(e, ""), d.flags &= -33);
                    var f = $9565edbe45899661$var$Uj(a);
                    $9565edbe45899661$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9565edbe45899661$var$Uj(a);
                    $9565edbe45899661$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($9565edbe45899661$var$p(161));
            }
        } catch (k) {
            $9565edbe45899661$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9565edbe45899661$var$hk(a, b, c) {
    $9565edbe45899661$var$V = a;
    $9565edbe45899661$var$ik(a, b, c);
}
function $9565edbe45899661$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9565edbe45899661$var$V;){
        var e = $9565edbe45899661$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9565edbe45899661$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9565edbe45899661$var$U;
                h = $9565edbe45899661$var$Jj;
                var l = $9565edbe45899661$var$U;
                $9565edbe45899661$var$Jj = g;
                if (($9565edbe45899661$var$U = k) && !l) for($9565edbe45899661$var$V = e; null !== $9565edbe45899661$var$V;)g = $9565edbe45899661$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9565edbe45899661$var$jk(e) : null !== k ? (k.return = g, $9565edbe45899661$var$V = k) : $9565edbe45899661$var$jk(e);
                for(; null !== f;)$9565edbe45899661$var$V = f, $9565edbe45899661$var$ik(f, b, c), f = f.sibling;
                $9565edbe45899661$var$V = e;
                $9565edbe45899661$var$Jj = h;
                $9565edbe45899661$var$U = l;
            }
            $9565edbe45899661$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9565edbe45899661$var$V = f) : $9565edbe45899661$var$kk(a, b, c);
    }
}
function $9565edbe45899661$var$kk(a) {
    for(; null !== $9565edbe45899661$var$V;){
        var b = $9565edbe45899661$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9565edbe45899661$var$U || $9565edbe45899661$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9565edbe45899661$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9565edbe45899661$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9565edbe45899661$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9565edbe45899661$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9565edbe45899661$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9565edbe45899661$var$p(163));
                }
                $9565edbe45899661$var$U || b.flags & 512 && $9565edbe45899661$var$Rj(b);
            } catch (r) {
                $9565edbe45899661$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9565edbe45899661$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9565edbe45899661$var$V = c;
            break;
        }
        $9565edbe45899661$var$V = b.return;
    }
}
function $9565edbe45899661$var$gk(a) {
    for(; null !== $9565edbe45899661$var$V;){
        var b = $9565edbe45899661$var$V;
        if (b === a) {
            $9565edbe45899661$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9565edbe45899661$var$V = c;
            break;
        }
        $9565edbe45899661$var$V = b.return;
    }
}
function $9565edbe45899661$var$jk(a) {
    for(; null !== $9565edbe45899661$var$V;){
        var b = $9565edbe45899661$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9565edbe45899661$var$Qj(4, b);
                    } catch (k) {
                        $9565edbe45899661$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9565edbe45899661$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9565edbe45899661$var$Rj(b);
                    } catch (k) {
                        $9565edbe45899661$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9565edbe45899661$var$Rj(b);
                    } catch (k) {
                        $9565edbe45899661$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9565edbe45899661$var$W(b, b.return, k);
        }
        if (b === a) {
            $9565edbe45899661$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9565edbe45899661$var$V = h;
            break;
        }
        $9565edbe45899661$var$V = b.return;
    }
}
var $9565edbe45899661$var$lk = Math.ceil, $9565edbe45899661$var$mk = $9565edbe45899661$var$ua.ReactCurrentDispatcher, $9565edbe45899661$var$nk = $9565edbe45899661$var$ua.ReactCurrentOwner, $9565edbe45899661$var$ok = $9565edbe45899661$var$ua.ReactCurrentBatchConfig, $9565edbe45899661$var$K = 0, $9565edbe45899661$var$Q = null, $9565edbe45899661$var$Y = null, $9565edbe45899661$var$Z = 0, $9565edbe45899661$var$fj = 0, $9565edbe45899661$var$ej = $9565edbe45899661$var$Uf(0), $9565edbe45899661$var$T = 0, $9565edbe45899661$var$pk = null, $9565edbe45899661$var$rh = 0, $9565edbe45899661$var$qk = 0, $9565edbe45899661$var$rk = 0, $9565edbe45899661$var$sk = null, $9565edbe45899661$var$tk = null, $9565edbe45899661$var$fk = 0, $9565edbe45899661$var$Gj = Infinity, $9565edbe45899661$var$uk = null, $9565edbe45899661$var$Oi = !1, $9565edbe45899661$var$Pi = null, $9565edbe45899661$var$Ri = null, $9565edbe45899661$var$vk = !1, $9565edbe45899661$var$wk = null, $9565edbe45899661$var$xk = 0, $9565edbe45899661$var$yk = 0, $9565edbe45899661$var$zk = null, $9565edbe45899661$var$Ak = -1, $9565edbe45899661$var$Bk = 0;
function $9565edbe45899661$var$R() {
    return 0 !== ($9565edbe45899661$var$K & 6) ? $9565edbe45899661$var$B() : -1 !== $9565edbe45899661$var$Ak ? $9565edbe45899661$var$Ak : $9565edbe45899661$var$Ak = $9565edbe45899661$var$B();
}
function $9565edbe45899661$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9565edbe45899661$var$K & 2) && 0 !== $9565edbe45899661$var$Z) return $9565edbe45899661$var$Z & -$9565edbe45899661$var$Z;
    if (null !== $9565edbe45899661$var$Kg.transition) return 0 === $9565edbe45899661$var$Bk && ($9565edbe45899661$var$Bk = $9565edbe45899661$var$yc()), $9565edbe45899661$var$Bk;
    a = $9565edbe45899661$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9565edbe45899661$var$jd(a.type);
    return a;
}
function $9565edbe45899661$var$gi(a, b, c, d) {
    if (50 < $9565edbe45899661$var$yk) throw $9565edbe45899661$var$yk = 0, $9565edbe45899661$var$zk = null, Error($9565edbe45899661$var$p(185));
    $9565edbe45899661$var$Ac(a, c, d);
    if (0 === ($9565edbe45899661$var$K & 2) || a !== $9565edbe45899661$var$Q) a === $9565edbe45899661$var$Q && (0 === ($9565edbe45899661$var$K & 2) && ($9565edbe45899661$var$qk |= c), 4 === $9565edbe45899661$var$T && $9565edbe45899661$var$Ck(a, $9565edbe45899661$var$Z)), $9565edbe45899661$var$Dk(a, d), 1 === c && 0 === $9565edbe45899661$var$K && 0 === (b.mode & 1) && ($9565edbe45899661$var$Gj = $9565edbe45899661$var$B() + 500, $9565edbe45899661$var$fg && $9565edbe45899661$var$jg());
}
function $9565edbe45899661$var$Dk(a, b) {
    var c = a.callbackNode;
    $9565edbe45899661$var$wc(a, b);
    var d = $9565edbe45899661$var$uc(a, a === $9565edbe45899661$var$Q ? $9565edbe45899661$var$Z : 0);
    if (0 === d) null !== c && $9565edbe45899661$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9565edbe45899661$var$bc(c);
        if (1 === b) 0 === a.tag ? $9565edbe45899661$var$ig($9565edbe45899661$var$Ek.bind(null, a)) : $9565edbe45899661$var$hg($9565edbe45899661$var$Ek.bind(null, a)), $9565edbe45899661$var$Jf(function() {
            0 === ($9565edbe45899661$var$K & 6) && $9565edbe45899661$var$jg();
        }), c = null;
        else {
            switch($9565edbe45899661$var$Dc(d)){
                case 1:
                    c = $9565edbe45899661$var$fc;
                    break;
                case 4:
                    c = $9565edbe45899661$var$gc;
                    break;
                case 16:
                    c = $9565edbe45899661$var$hc;
                    break;
                case 536870912:
                    c = $9565edbe45899661$var$jc;
                    break;
                default:
                    c = $9565edbe45899661$var$hc;
            }
            c = $9565edbe45899661$var$Fk(c, $9565edbe45899661$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9565edbe45899661$var$Gk(a, b) {
    $9565edbe45899661$var$Ak = -1;
    $9565edbe45899661$var$Bk = 0;
    if (0 !== ($9565edbe45899661$var$K & 6)) throw Error($9565edbe45899661$var$p(327));
    var c = a.callbackNode;
    if ($9565edbe45899661$var$Hk() && a.callbackNode !== c) return null;
    var d = $9565edbe45899661$var$uc(a, a === $9565edbe45899661$var$Q ? $9565edbe45899661$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9565edbe45899661$var$Ik(a, d);
    else {
        b = d;
        var e = $9565edbe45899661$var$K;
        $9565edbe45899661$var$K |= 2;
        var f = $9565edbe45899661$var$Jk();
        if ($9565edbe45899661$var$Q !== a || $9565edbe45899661$var$Z !== b) $9565edbe45899661$var$uk = null, $9565edbe45899661$var$Gj = $9565edbe45899661$var$B() + 500, $9565edbe45899661$var$Kk(a, b);
        for(;;)try {
            $9565edbe45899661$var$Lk();
            break;
        } catch (h) {
            $9565edbe45899661$var$Mk(a, h);
        }
        $9565edbe45899661$var$$g();
        $9565edbe45899661$var$mk.current = f;
        $9565edbe45899661$var$K = e;
        null !== $9565edbe45899661$var$Y ? b = 0 : ($9565edbe45899661$var$Q = null, $9565edbe45899661$var$Z = 0, b = $9565edbe45899661$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9565edbe45899661$var$xc(a), 0 !== e && (d = e, b = $9565edbe45899661$var$Nk(a, e)));
        if (1 === b) throw c = $9565edbe45899661$var$pk, $9565edbe45899661$var$Kk(a, 0), $9565edbe45899661$var$Ck(a, d), $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B()), c;
        if (6 === b) $9565edbe45899661$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9565edbe45899661$var$Ok(e) && (b = $9565edbe45899661$var$Ik(a, d), 2 === b && (f = $9565edbe45899661$var$xc(a), 0 !== f && (d = f, b = $9565edbe45899661$var$Nk(a, f))), 1 === b)) throw c = $9565edbe45899661$var$pk, $9565edbe45899661$var$Kk(a, 0), $9565edbe45899661$var$Ck(a, d), $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9565edbe45899661$var$p(345));
                case 2:
                    $9565edbe45899661$var$Pk(a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk);
                    break;
                case 3:
                    $9565edbe45899661$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $9565edbe45899661$var$fk + 500 - $9565edbe45899661$var$B(), 10 < b)) {
                        if (0 !== $9565edbe45899661$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9565edbe45899661$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9565edbe45899661$var$Ff($9565edbe45899661$var$Pk.bind(null, a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk), b);
                        break;
                    }
                    $9565edbe45899661$var$Pk(a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk);
                    break;
                case 4:
                    $9565edbe45899661$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9565edbe45899661$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9565edbe45899661$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9565edbe45899661$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9565edbe45899661$var$Ff($9565edbe45899661$var$Pk.bind(null, a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk), d);
                        break;
                    }
                    $9565edbe45899661$var$Pk(a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk);
                    break;
                case 5:
                    $9565edbe45899661$var$Pk(a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk);
                    break;
                default:
                    throw Error($9565edbe45899661$var$p(329));
            }
        }
    }
    $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B());
    return a.callbackNode === c ? $9565edbe45899661$var$Gk.bind(null, a) : null;
}
function $9565edbe45899661$var$Nk(a, b) {
    var c = $9565edbe45899661$var$sk;
    a.current.memoizedState.isDehydrated && ($9565edbe45899661$var$Kk(a, b).flags |= 256);
    a = $9565edbe45899661$var$Ik(a, b);
    2 !== a && (b = $9565edbe45899661$var$tk, $9565edbe45899661$var$tk = c, null !== b && $9565edbe45899661$var$Fj(b));
    return a;
}
function $9565edbe45899661$var$Fj(a) {
    null === $9565edbe45899661$var$tk ? $9565edbe45899661$var$tk = a : $9565edbe45899661$var$tk.push.apply($9565edbe45899661$var$tk, a);
}
function $9565edbe45899661$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9565edbe45899661$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9565edbe45899661$var$Ck(a, b) {
    b &= ~$9565edbe45899661$var$rk;
    b &= ~$9565edbe45899661$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9565edbe45899661$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9565edbe45899661$var$Ek(a) {
    if (0 !== ($9565edbe45899661$var$K & 6)) throw Error($9565edbe45899661$var$p(327));
    $9565edbe45899661$var$Hk();
    var b = $9565edbe45899661$var$uc(a, 0);
    if (0 === (b & 1)) return $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B()), null;
    var c = $9565edbe45899661$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9565edbe45899661$var$xc(a);
        0 !== d && (b = d, c = $9565edbe45899661$var$Nk(a, d));
    }
    if (1 === c) throw c = $9565edbe45899661$var$pk, $9565edbe45899661$var$Kk(a, 0), $9565edbe45899661$var$Ck(a, b), $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B()), c;
    if (6 === c) throw Error($9565edbe45899661$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9565edbe45899661$var$Pk(a, $9565edbe45899661$var$tk, $9565edbe45899661$var$uk);
    $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B());
    return null;
}
function $9565edbe45899661$var$Qk(a, b) {
    var c = $9565edbe45899661$var$K;
    $9565edbe45899661$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9565edbe45899661$var$K = c, 0 === $9565edbe45899661$var$K && ($9565edbe45899661$var$Gj = $9565edbe45899661$var$B() + 500, $9565edbe45899661$var$fg && $9565edbe45899661$var$jg());
    }
}
function $9565edbe45899661$var$Rk(a) {
    null !== $9565edbe45899661$var$wk && 0 === $9565edbe45899661$var$wk.tag && 0 === ($9565edbe45899661$var$K & 6) && $9565edbe45899661$var$Hk();
    var b = $9565edbe45899661$var$K;
    $9565edbe45899661$var$K |= 1;
    var c = $9565edbe45899661$var$ok.transition, d = $9565edbe45899661$var$C;
    try {
        if ($9565edbe45899661$var$ok.transition = null, $9565edbe45899661$var$C = 1, a) return a();
    } finally{
        $9565edbe45899661$var$C = d, $9565edbe45899661$var$ok.transition = c, $9565edbe45899661$var$K = b, 0 === ($9565edbe45899661$var$K & 6) && $9565edbe45899661$var$jg();
    }
}
function $9565edbe45899661$var$Hj() {
    $9565edbe45899661$var$fj = $9565edbe45899661$var$ej.current;
    $9565edbe45899661$var$E($9565edbe45899661$var$ej);
}
function $9565edbe45899661$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9565edbe45899661$var$Gf(c));
    if (null !== $9565edbe45899661$var$Y) for(c = $9565edbe45899661$var$Y.return; null !== c;){
        var d = c;
        $9565edbe45899661$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9565edbe45899661$var$$f();
                break;
            case 3:
                $9565edbe45899661$var$zh();
                $9565edbe45899661$var$E($9565edbe45899661$var$Wf);
                $9565edbe45899661$var$E($9565edbe45899661$var$H);
                $9565edbe45899661$var$Eh();
                break;
            case 5:
                $9565edbe45899661$var$Bh(d);
                break;
            case 4:
                $9565edbe45899661$var$zh();
                break;
            case 13:
                $9565edbe45899661$var$E($9565edbe45899661$var$L);
                break;
            case 19:
                $9565edbe45899661$var$E($9565edbe45899661$var$L);
                break;
            case 10:
                $9565edbe45899661$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $9565edbe45899661$var$Hj();
        }
        c = c.return;
    }
    $9565edbe45899661$var$Q = a;
    $9565edbe45899661$var$Y = a = $9565edbe45899661$var$Pg(a.current, null);
    $9565edbe45899661$var$Z = $9565edbe45899661$var$fj = b;
    $9565edbe45899661$var$T = 0;
    $9565edbe45899661$var$pk = null;
    $9565edbe45899661$var$rk = $9565edbe45899661$var$qk = $9565edbe45899661$var$rh = 0;
    $9565edbe45899661$var$tk = $9565edbe45899661$var$sk = null;
    if (null !== $9565edbe45899661$var$fh) {
        for(b = 0; b < $9565edbe45899661$var$fh.length; b++)if (c = $9565edbe45899661$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9565edbe45899661$var$fh = null;
    }
    return a;
}
function $9565edbe45899661$var$Mk(a, b) {
    do {
        var c = $9565edbe45899661$var$Y;
        try {
            $9565edbe45899661$var$$g();
            $9565edbe45899661$var$Fh.current = $9565edbe45899661$var$Rh;
            if ($9565edbe45899661$var$Ih) {
                for(var d = $9565edbe45899661$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9565edbe45899661$var$Ih = !1;
            }
            $9565edbe45899661$var$Hh = 0;
            $9565edbe45899661$var$O = $9565edbe45899661$var$N = $9565edbe45899661$var$M = null;
            $9565edbe45899661$var$Jh = !1;
            $9565edbe45899661$var$Kh = 0;
            $9565edbe45899661$var$nk.current = null;
            if (null === c || null === c.return) {
                $9565edbe45899661$var$T = 1;
                $9565edbe45899661$var$pk = b;
                $9565edbe45899661$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9565edbe45899661$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9565edbe45899661$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9565edbe45899661$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $9565edbe45899661$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9565edbe45899661$var$Si(f, l, b);
                            $9565edbe45899661$var$tj();
                            break a;
                        }
                        k = Error($9565edbe45899661$var$p(426));
                    }
                } else if ($9565edbe45899661$var$I && h.mode & 1) {
                    var J = $9565edbe45899661$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9565edbe45899661$var$Vi(J, g, h, f, b);
                        $9565edbe45899661$var$Jg($9565edbe45899661$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $9565edbe45899661$var$Ji(k, h);
                4 !== $9565edbe45899661$var$T && ($9565edbe45899661$var$T = 2);
                null === $9565edbe45899661$var$sk ? $9565edbe45899661$var$sk = [
                    f
                ] : $9565edbe45899661$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9565edbe45899661$var$Ni(f, k, b);
                            $9565edbe45899661$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9565edbe45899661$var$Ri || !$9565edbe45899661$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9565edbe45899661$var$Qi(f, h, b);
                                $9565edbe45899661$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9565edbe45899661$var$Sk(c);
        } catch (na) {
            b = na;
            $9565edbe45899661$var$Y === c && null !== c && ($9565edbe45899661$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9565edbe45899661$var$Jk() {
    var a = $9565edbe45899661$var$mk.current;
    $9565edbe45899661$var$mk.current = $9565edbe45899661$var$Rh;
    return null === a ? $9565edbe45899661$var$Rh : a;
}
function $9565edbe45899661$var$tj() {
    if (0 === $9565edbe45899661$var$T || 3 === $9565edbe45899661$var$T || 2 === $9565edbe45899661$var$T) $9565edbe45899661$var$T = 4;
    null === $9565edbe45899661$var$Q || 0 === ($9565edbe45899661$var$rh & 268435455) && 0 === ($9565edbe45899661$var$qk & 268435455) || $9565edbe45899661$var$Ck($9565edbe45899661$var$Q, $9565edbe45899661$var$Z);
}
function $9565edbe45899661$var$Ik(a, b) {
    var c = $9565edbe45899661$var$K;
    $9565edbe45899661$var$K |= 2;
    var d = $9565edbe45899661$var$Jk();
    if ($9565edbe45899661$var$Q !== a || $9565edbe45899661$var$Z !== b) $9565edbe45899661$var$uk = null, $9565edbe45899661$var$Kk(a, b);
    for(;;)try {
        $9565edbe45899661$var$Tk();
        break;
    } catch (e) {
        $9565edbe45899661$var$Mk(a, e);
    }
    $9565edbe45899661$var$$g();
    $9565edbe45899661$var$K = c;
    $9565edbe45899661$var$mk.current = d;
    if (null !== $9565edbe45899661$var$Y) throw Error($9565edbe45899661$var$p(261));
    $9565edbe45899661$var$Q = null;
    $9565edbe45899661$var$Z = 0;
    return $9565edbe45899661$var$T;
}
function $9565edbe45899661$var$Tk() {
    for(; null !== $9565edbe45899661$var$Y;)$9565edbe45899661$var$Uk($9565edbe45899661$var$Y);
}
function $9565edbe45899661$var$Lk() {
    for(; null !== $9565edbe45899661$var$Y && !$9565edbe45899661$var$cc();)$9565edbe45899661$var$Uk($9565edbe45899661$var$Y);
}
function $9565edbe45899661$var$Uk(a) {
    var b = $9565edbe45899661$var$Vk(a.alternate, a, $9565edbe45899661$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9565edbe45899661$var$Sk(a) : $9565edbe45899661$var$Y = b;
    $9565edbe45899661$var$nk.current = null;
}
function $9565edbe45899661$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9565edbe45899661$var$Ej(c, b, $9565edbe45899661$var$fj), null !== c) {
                $9565edbe45899661$var$Y = c;
                return;
            }
        } else {
            c = $9565edbe45899661$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9565edbe45899661$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9565edbe45899661$var$T = 6;
                $9565edbe45899661$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9565edbe45899661$var$Y = b;
            return;
        }
        $9565edbe45899661$var$Y = b = a;
    }while (null !== b);
    0 === $9565edbe45899661$var$T && ($9565edbe45899661$var$T = 5);
}
function $9565edbe45899661$var$Pk(a, b, c) {
    var d = $9565edbe45899661$var$C, e = $9565edbe45899661$var$ok.transition;
    try {
        $9565edbe45899661$var$ok.transition = null, $9565edbe45899661$var$C = 1, $9565edbe45899661$var$Wk(a, b, c, d);
    } finally{
        $9565edbe45899661$var$ok.transition = e, $9565edbe45899661$var$C = d;
    }
    return null;
}
function $9565edbe45899661$var$Wk(a, b, c, d) {
    do $9565edbe45899661$var$Hk();
    while (null !== $9565edbe45899661$var$wk);
    if (0 !== ($9565edbe45899661$var$K & 6)) throw Error($9565edbe45899661$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9565edbe45899661$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9565edbe45899661$var$Bc(a, f);
    a === $9565edbe45899661$var$Q && ($9565edbe45899661$var$Y = $9565edbe45899661$var$Q = null, $9565edbe45899661$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9565edbe45899661$var$vk || ($9565edbe45899661$var$vk = !0, $9565edbe45899661$var$Fk($9565edbe45899661$var$hc, function() {
        $9565edbe45899661$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9565edbe45899661$var$ok.transition;
        $9565edbe45899661$var$ok.transition = null;
        var g = $9565edbe45899661$var$C;
        $9565edbe45899661$var$C = 1;
        var h = $9565edbe45899661$var$K;
        $9565edbe45899661$var$K |= 4;
        $9565edbe45899661$var$nk.current = null;
        $9565edbe45899661$var$Oj(a, c);
        $9565edbe45899661$var$dk(c, a);
        $9565edbe45899661$var$Oe($9565edbe45899661$var$Df);
        $9565edbe45899661$var$dd = !!$9565edbe45899661$var$Cf;
        $9565edbe45899661$var$Df = $9565edbe45899661$var$Cf = null;
        a.current = c;
        $9565edbe45899661$var$hk(c, a, e);
        $9565edbe45899661$var$dc();
        $9565edbe45899661$var$K = h;
        $9565edbe45899661$var$C = g;
        $9565edbe45899661$var$ok.transition = f;
    } else a.current = c;
    $9565edbe45899661$var$vk && ($9565edbe45899661$var$vk = !1, $9565edbe45899661$var$wk = a, $9565edbe45899661$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($9565edbe45899661$var$Ri = null);
    $9565edbe45899661$var$mc(c.stateNode, d);
    $9565edbe45899661$var$Dk(a, $9565edbe45899661$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9565edbe45899661$var$Oi) throw $9565edbe45899661$var$Oi = !1, a = $9565edbe45899661$var$Pi, $9565edbe45899661$var$Pi = null, a;
    0 !== ($9565edbe45899661$var$xk & 1) && 0 !== a.tag && $9565edbe45899661$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9565edbe45899661$var$zk ? $9565edbe45899661$var$yk++ : ($9565edbe45899661$var$yk = 0, $9565edbe45899661$var$zk = a) : $9565edbe45899661$var$yk = 0;
    $9565edbe45899661$var$jg();
    return null;
}
function $9565edbe45899661$var$Hk() {
    if (null !== $9565edbe45899661$var$wk) {
        var a = $9565edbe45899661$var$Dc($9565edbe45899661$var$xk), b = $9565edbe45899661$var$ok.transition, c = $9565edbe45899661$var$C;
        try {
            $9565edbe45899661$var$ok.transition = null;
            $9565edbe45899661$var$C = 16 > a ? 16 : a;
            if (null === $9565edbe45899661$var$wk) var d = !1;
            else {
                a = $9565edbe45899661$var$wk;
                $9565edbe45899661$var$wk = null;
                $9565edbe45899661$var$xk = 0;
                if (0 !== ($9565edbe45899661$var$K & 6)) throw Error($9565edbe45899661$var$p(331));
                var e = $9565edbe45899661$var$K;
                $9565edbe45899661$var$K |= 4;
                for($9565edbe45899661$var$V = a.current; null !== $9565edbe45899661$var$V;){
                    var f = $9565edbe45899661$var$V, g = f.child;
                    if (0 !== ($9565edbe45899661$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9565edbe45899661$var$V = l; null !== $9565edbe45899661$var$V;){
                                    var m = $9565edbe45899661$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9565edbe45899661$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9565edbe45899661$var$V = q;
                                    else for(; null !== $9565edbe45899661$var$V;){
                                        m = $9565edbe45899661$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9565edbe45899661$var$Sj(m);
                                        if (m === l) {
                                            $9565edbe45899661$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9565edbe45899661$var$V = r;
                                            break;
                                        }
                                        $9565edbe45899661$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9565edbe45899661$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9565edbe45899661$var$V = g;
                    else b: for(; null !== $9565edbe45899661$var$V;){
                        f = $9565edbe45899661$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9565edbe45899661$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9565edbe45899661$var$V = x;
                            break b;
                        }
                        $9565edbe45899661$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9565edbe45899661$var$V = w; null !== $9565edbe45899661$var$V;){
                    g = $9565edbe45899661$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9565edbe45899661$var$V = u;
                    else b: for(g = w; null !== $9565edbe45899661$var$V;){
                        h = $9565edbe45899661$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9565edbe45899661$var$Qj(9, h);
                            }
                        } catch (na) {
                            $9565edbe45899661$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9565edbe45899661$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9565edbe45899661$var$V = F;
                            break b;
                        }
                        $9565edbe45899661$var$V = h.return;
                    }
                }
                $9565edbe45899661$var$K = e;
                $9565edbe45899661$var$jg();
                if ($9565edbe45899661$var$lc && "function" === typeof $9565edbe45899661$var$lc.onPostCommitFiberRoot) try {
                    $9565edbe45899661$var$lc.onPostCommitFiberRoot($9565edbe45899661$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9565edbe45899661$var$C = c, $9565edbe45899661$var$ok.transition = b;
        }
    }
    return !1;
}
function $9565edbe45899661$var$Xk(a, b, c) {
    b = $9565edbe45899661$var$Ji(c, b);
    b = $9565edbe45899661$var$Ni(a, b, 1);
    a = $9565edbe45899661$var$nh(a, b, 1);
    b = $9565edbe45899661$var$R();
    null !== a && ($9565edbe45899661$var$Ac(a, 1, b), $9565edbe45899661$var$Dk(a, b));
}
function $9565edbe45899661$var$W(a, b, c) {
    if (3 === a.tag) $9565edbe45899661$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9565edbe45899661$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9565edbe45899661$var$Ri || !$9565edbe45899661$var$Ri.has(d))) {
                a = $9565edbe45899661$var$Ji(c, a);
                a = $9565edbe45899661$var$Qi(b, a, 1);
                b = $9565edbe45899661$var$nh(b, a, 1);
                a = $9565edbe45899661$var$R();
                null !== b && ($9565edbe45899661$var$Ac(b, 1, a), $9565edbe45899661$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9565edbe45899661$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9565edbe45899661$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $9565edbe45899661$var$Q === a && ($9565edbe45899661$var$Z & c) === c && (4 === $9565edbe45899661$var$T || 3 === $9565edbe45899661$var$T && ($9565edbe45899661$var$Z & 130023424) === $9565edbe45899661$var$Z && 500 > $9565edbe45899661$var$B() - $9565edbe45899661$var$fk ? $9565edbe45899661$var$Kk(a, 0) : $9565edbe45899661$var$rk |= c);
    $9565edbe45899661$var$Dk(a, b);
}
function $9565edbe45899661$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9565edbe45899661$var$sc, $9565edbe45899661$var$sc <<= 1, 0 === ($9565edbe45899661$var$sc & 130023424) && ($9565edbe45899661$var$sc = 4194304)));
    var c = $9565edbe45899661$var$R();
    a = $9565edbe45899661$var$ih(a, b);
    null !== a && ($9565edbe45899661$var$Ac(a, b, c), $9565edbe45899661$var$Dk(a, c));
}
function $9565edbe45899661$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9565edbe45899661$var$Yk(a, c);
}
function $9565edbe45899661$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9565edbe45899661$var$p(314));
    }
    null !== d && d.delete(b);
    $9565edbe45899661$var$Yk(a, c);
}
var $9565edbe45899661$var$Vk;
$9565edbe45899661$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9565edbe45899661$var$Wf.current) $9565edbe45899661$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9565edbe45899661$var$dh = !1, $9565edbe45899661$var$yj(a, b, c);
            $9565edbe45899661$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9565edbe45899661$var$dh = !1, $9565edbe45899661$var$I && 0 !== (b.flags & 1048576) && $9565edbe45899661$var$ug(b, $9565edbe45899661$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9565edbe45899661$var$ij(a, b);
            a = b.pendingProps;
            var e = $9565edbe45899661$var$Yf(b, $9565edbe45899661$var$H.current);
            $9565edbe45899661$var$ch(b, c);
            e = $9565edbe45899661$var$Nh(null, b, d, a, e, c);
            var f = $9565edbe45899661$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9565edbe45899661$var$Zf(d) ? (f = !0, $9565edbe45899661$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9565edbe45899661$var$kh(b), e.updater = $9565edbe45899661$var$Ei, b.stateNode = e, e._reactInternals = b, $9565edbe45899661$var$Ii(b, d, a, c), b = $9565edbe45899661$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $9565edbe45899661$var$I && f && $9565edbe45899661$var$vg(b), $9565edbe45899661$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9565edbe45899661$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9565edbe45899661$var$Zk(d);
                a = $9565edbe45899661$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $9565edbe45899661$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9565edbe45899661$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9565edbe45899661$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9565edbe45899661$var$$i(null, b, d, $9565edbe45899661$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($9565edbe45899661$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9565edbe45899661$var$Ci(d, e), $9565edbe45899661$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9565edbe45899661$var$Ci(d, e), $9565edbe45899661$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $9565edbe45899661$var$kj(b);
                if (null === a) throw Error($9565edbe45899661$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9565edbe45899661$var$lh(a, b);
                $9565edbe45899661$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9565edbe45899661$var$Ji(Error($9565edbe45899661$var$p(423)), b);
                        b = $9565edbe45899661$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9565edbe45899661$var$Ji(Error($9565edbe45899661$var$p(424)), b);
                        b = $9565edbe45899661$var$lj(a, b, d, c, e);
                        break a;
                    } else for($9565edbe45899661$var$yg = $9565edbe45899661$var$Lf(b.stateNode.containerInfo.firstChild), $9565edbe45899661$var$xg = b, $9565edbe45899661$var$I = !0, $9565edbe45899661$var$zg = null, c = $9565edbe45899661$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9565edbe45899661$var$Ig();
                    if (d === e) {
                        b = $9565edbe45899661$var$Zi(a, b, c);
                        break a;
                    }
                    $9565edbe45899661$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9565edbe45899661$var$Ah(b), null === a && $9565edbe45899661$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9565edbe45899661$var$Ef(d, e) ? g = null : null !== f && $9565edbe45899661$var$Ef(d, f) && (b.flags |= 32), $9565edbe45899661$var$gj(a, b), $9565edbe45899661$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $9565edbe45899661$var$Eg(b), null;
        case 13:
            return $9565edbe45899661$var$oj(a, b, c);
        case 4:
            return $9565edbe45899661$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9565edbe45899661$var$Ug(b, null, d, c) : $9565edbe45899661$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9565edbe45899661$var$Ci(d, e), $9565edbe45899661$var$Yi(a, b, d, e, c);
        case 7:
            return $9565edbe45899661$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9565edbe45899661$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9565edbe45899661$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9565edbe45899661$var$G($9565edbe45899661$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9565edbe45899661$var$He(f.value, g)) {
                        if (f.children === e.children && !$9565edbe45899661$var$Wf.current) {
                            b = $9565edbe45899661$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9565edbe45899661$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9565edbe45899661$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9565edbe45899661$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9565edbe45899661$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9565edbe45899661$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9565edbe45899661$var$ch(b, c), e = $9565edbe45899661$var$eh(e), d = d(e), b.flags |= 1, $9565edbe45899661$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9565edbe45899661$var$Ci(d, b.pendingProps), e = $9565edbe45899661$var$Ci(d.type, e), $9565edbe45899661$var$$i(a, b, d, e, c);
        case 15:
            return $9565edbe45899661$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9565edbe45899661$var$Ci(d, e), $9565edbe45899661$var$ij(a, b), b.tag = 1, $9565edbe45899661$var$Zf(d) ? (a = !0, $9565edbe45899661$var$cg(b)) : a = !1, $9565edbe45899661$var$ch(b, c), $9565edbe45899661$var$Gi(b, d, e), $9565edbe45899661$var$Ii(b, d, e, c), $9565edbe45899661$var$jj(null, b, d, !0, a, c);
        case 19:
            return $9565edbe45899661$var$xj(a, b, c);
        case 22:
            return $9565edbe45899661$var$dj(a, b, c);
    }
    throw Error($9565edbe45899661$var$p(156, b.tag));
};
function $9565edbe45899661$var$Fk(a, b) {
    return $9565edbe45899661$var$ac(a, b);
}
function $9565edbe45899661$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9565edbe45899661$var$Bg(a, b, c, d) {
    return new $9565edbe45899661$var$$k(a, b, c, d);
}
function $9565edbe45899661$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9565edbe45899661$var$Zk(a) {
    if ("function" === typeof a) return $9565edbe45899661$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9565edbe45899661$var$Da) return 11;
        if (a === $9565edbe45899661$var$Ga) return 14;
    }
    return 2;
}
function $9565edbe45899661$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $9565edbe45899661$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9565edbe45899661$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9565edbe45899661$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9565edbe45899661$var$ya:
            return $9565edbe45899661$var$Tg(c.children, e, f, b);
        case $9565edbe45899661$var$za:
            g = 8;
            e |= 8;
            break;
        case $9565edbe45899661$var$Aa:
            return a = $9565edbe45899661$var$Bg(12, c, b, e | 2), a.elementType = $9565edbe45899661$var$Aa, a.lanes = f, a;
        case $9565edbe45899661$var$Ea:
            return a = $9565edbe45899661$var$Bg(13, c, b, e), a.elementType = $9565edbe45899661$var$Ea, a.lanes = f, a;
        case $9565edbe45899661$var$Fa:
            return a = $9565edbe45899661$var$Bg(19, c, b, e), a.elementType = $9565edbe45899661$var$Fa, a.lanes = f, a;
        case $9565edbe45899661$var$Ia:
            return $9565edbe45899661$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9565edbe45899661$var$Ba:
                    g = 10;
                    break a;
                case $9565edbe45899661$var$Ca:
                    g = 9;
                    break a;
                case $9565edbe45899661$var$Da:
                    g = 11;
                    break a;
                case $9565edbe45899661$var$Ga:
                    g = 14;
                    break a;
                case $9565edbe45899661$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9565edbe45899661$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9565edbe45899661$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9565edbe45899661$var$Tg(a, b, c, d) {
    a = $9565edbe45899661$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9565edbe45899661$var$pj(a, b, c, d) {
    a = $9565edbe45899661$var$Bg(22, a, d, b);
    a.elementType = $9565edbe45899661$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9565edbe45899661$var$Qg(a, b, c) {
    a = $9565edbe45899661$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9565edbe45899661$var$Sg(a, b, c) {
    b = $9565edbe45899661$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9565edbe45899661$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9565edbe45899661$var$zc(0);
    this.expirationTimes = $9565edbe45899661$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9565edbe45899661$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9565edbe45899661$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $9565edbe45899661$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9565edbe45899661$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9565edbe45899661$var$kh(f);
    return a;
}
function $9565edbe45899661$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9565edbe45899661$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9565edbe45899661$var$dl(a) {
    if (!a) return $9565edbe45899661$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9565edbe45899661$var$Vb(a) !== a || 1 !== a.tag) throw Error($9565edbe45899661$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9565edbe45899661$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9565edbe45899661$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9565edbe45899661$var$Zf(c)) return $9565edbe45899661$var$bg(a, c, b);
    }
    return b;
}
function $9565edbe45899661$var$el(a, b, c, d, e, f, g, h, k) {
    a = $9565edbe45899661$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $9565edbe45899661$var$dl(null);
    c = a.current;
    d = $9565edbe45899661$var$R();
    e = $9565edbe45899661$var$yi(c);
    f = $9565edbe45899661$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9565edbe45899661$var$nh(c, f, e);
    a.current.lanes = e;
    $9565edbe45899661$var$Ac(a, e, d);
    $9565edbe45899661$var$Dk(a, d);
    return a;
}
function $9565edbe45899661$var$fl(a, b, c, d) {
    var e = b.current, f = $9565edbe45899661$var$R(), g = $9565edbe45899661$var$yi(e);
    c = $9565edbe45899661$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9565edbe45899661$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9565edbe45899661$var$nh(e, b, g);
    null !== a && ($9565edbe45899661$var$gi(a, e, g, f), $9565edbe45899661$var$oh(a, e, g));
    return g;
}
function $9565edbe45899661$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9565edbe45899661$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9565edbe45899661$var$il(a, b) {
    $9565edbe45899661$var$hl(a, b);
    (a = a.alternate) && $9565edbe45899661$var$hl(a, b);
}
function $9565edbe45899661$var$jl() {
    return null;
}
var $9565edbe45899661$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9565edbe45899661$var$ll(a) {
    this._internalRoot = a;
}
$9565edbe45899661$var$ml.prototype.render = $9565edbe45899661$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9565edbe45899661$var$p(409));
    $9565edbe45899661$var$fl(a, b, null, null);
};
$9565edbe45899661$var$ml.prototype.unmount = $9565edbe45899661$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9565edbe45899661$var$Rk(function() {
            $9565edbe45899661$var$fl(null, a, null, null);
        });
        b[$9565edbe45899661$var$uf] = null;
    }
};
function $9565edbe45899661$var$ml(a) {
    this._internalRoot = a;
}
$9565edbe45899661$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9565edbe45899661$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9565edbe45899661$var$Qc.length && 0 !== b && b < $9565edbe45899661$var$Qc[c].priority; c++);
        $9565edbe45899661$var$Qc.splice(c, 0, a);
        0 === c && $9565edbe45899661$var$Vc(a);
    }
};
function $9565edbe45899661$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9565edbe45899661$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9565edbe45899661$var$pl() {}
function $9565edbe45899661$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9565edbe45899661$var$gl(g);
                f.call(a);
            };
        }
        var g = $9565edbe45899661$var$el(b, d, a, 0, null, !1, !1, "", $9565edbe45899661$var$pl);
        a._reactRootContainer = g;
        a[$9565edbe45899661$var$uf] = g.current;
        $9565edbe45899661$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9565edbe45899661$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9565edbe45899661$var$gl(k);
            h.call(a);
        };
    }
    var k = $9565edbe45899661$var$bl(a, 0, !1, null, null, !1, !1, "", $9565edbe45899661$var$pl);
    a._reactRootContainer = k;
    a[$9565edbe45899661$var$uf] = k.current;
    $9565edbe45899661$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9565edbe45899661$var$Rk(function() {
        $9565edbe45899661$var$fl(b, k, c, d);
    });
    return k;
}
function $9565edbe45899661$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9565edbe45899661$var$gl(g);
                h.call(a);
            };
        }
        $9565edbe45899661$var$fl(b, g, a, e);
    } else g = $9565edbe45899661$var$ql(c, b, a, e, d);
    return $9565edbe45899661$var$gl(g);
}
$9565edbe45899661$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9565edbe45899661$var$tc(b.pendingLanes);
                0 !== c && ($9565edbe45899661$var$Cc(b, c | 1), $9565edbe45899661$var$Dk(b, $9565edbe45899661$var$B()), 0 === ($9565edbe45899661$var$K & 6) && ($9565edbe45899661$var$Gj = $9565edbe45899661$var$B() + 500, $9565edbe45899661$var$jg()));
            }
            break;
        case 13:
            $9565edbe45899661$var$Rk(function() {
                var b = $9565edbe45899661$var$ih(a, 1);
                if (null !== b) {
                    var c = $9565edbe45899661$var$R();
                    $9565edbe45899661$var$gi(b, a, 1, c);
                }
            }), $9565edbe45899661$var$il(a, 1);
    }
};
$9565edbe45899661$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9565edbe45899661$var$ih(a, 134217728);
        if (null !== b) {
            var c = $9565edbe45899661$var$R();
            $9565edbe45899661$var$gi(b, a, 134217728, c);
        }
        $9565edbe45899661$var$il(a, 134217728);
    }
};
$9565edbe45899661$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9565edbe45899661$var$yi(a), c = $9565edbe45899661$var$ih(a, b);
        if (null !== c) {
            var d = $9565edbe45899661$var$R();
            $9565edbe45899661$var$gi(c, a, b, d);
        }
        $9565edbe45899661$var$il(a, b);
    }
};
$9565edbe45899661$var$Hc = function() {
    return $9565edbe45899661$var$C;
};
$9565edbe45899661$var$Ic = function(a, b) {
    var c = $9565edbe45899661$var$C;
    try {
        return $9565edbe45899661$var$C = a, b();
    } finally{
        $9565edbe45899661$var$C = c;
    }
};
$9565edbe45899661$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9565edbe45899661$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9565edbe45899661$var$Db(d);
                        if (!e) throw Error($9565edbe45899661$var$p(90));
                        $9565edbe45899661$var$Wa(d);
                        $9565edbe45899661$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9565edbe45899661$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9565edbe45899661$var$fb(a, !!c.multiple, b, !1);
    }
};
$9565edbe45899661$var$Gb = $9565edbe45899661$var$Qk;
$9565edbe45899661$var$Hb = $9565edbe45899661$var$Rk;
var $9565edbe45899661$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $9565edbe45899661$var$Cb,
        $9565edbe45899661$var$ue,
        $9565edbe45899661$var$Db,
        $9565edbe45899661$var$Eb,
        $9565edbe45899661$var$Fb,
        $9565edbe45899661$var$Qk
    ]
}, $9565edbe45899661$var$tl = {
    findFiberByHostInstance: $9565edbe45899661$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $9565edbe45899661$var$ul = {
    bundleType: $9565edbe45899661$var$tl.bundleType,
    version: $9565edbe45899661$var$tl.version,
    rendererPackageName: $9565edbe45899661$var$tl.rendererPackageName,
    rendererConfig: $9565edbe45899661$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9565edbe45899661$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9565edbe45899661$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9565edbe45899661$var$tl.findFiberByHostInstance || $9565edbe45899661$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9565edbe45899661$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9565edbe45899661$var$vl.isDisabled && $9565edbe45899661$var$vl.supportsFiber) try {
        $9565edbe45899661$var$kc = $9565edbe45899661$var$vl.inject($9565edbe45899661$var$ul), $9565edbe45899661$var$lc = $9565edbe45899661$var$vl;
    } catch (a) {}
}
$9565edbe45899661$export$ae55be85d98224ed = $9565edbe45899661$var$sl;
$9565edbe45899661$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9565edbe45899661$var$nl(b)) throw Error($9565edbe45899661$var$p(200));
    return $9565edbe45899661$var$cl(a, b, null, c);
};
$9565edbe45899661$export$882461b6382ed46c = function(a, b) {
    if (!$9565edbe45899661$var$nl(a)) throw Error($9565edbe45899661$var$p(299));
    var c = !1, d = "", e = $9565edbe45899661$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9565edbe45899661$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$9565edbe45899661$var$uf] = b.current;
    $9565edbe45899661$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9565edbe45899661$var$ll(b);
};
$9565edbe45899661$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9565edbe45899661$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9565edbe45899661$var$p(268, a));
    }
    a = $9565edbe45899661$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9565edbe45899661$export$cd75ccfd720a3cd4 = function(a) {
    return $9565edbe45899661$var$Rk(a);
};
$9565edbe45899661$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9565edbe45899661$var$ol(b)) throw Error($9565edbe45899661$var$p(200));
    return $9565edbe45899661$var$rl(null, a, b, !0, c);
};
$9565edbe45899661$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9565edbe45899661$var$nl(a)) throw Error($9565edbe45899661$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9565edbe45899661$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9565edbe45899661$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9565edbe45899661$var$uf] = b.current;
    $9565edbe45899661$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9565edbe45899661$var$ml(b);
};
$9565edbe45899661$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9565edbe45899661$var$ol(b)) throw Error($9565edbe45899661$var$p(200));
    return $9565edbe45899661$var$rl(null, a, b, !1, c);
};
$9565edbe45899661$export$502457920280e6be = function(a) {
    if (!$9565edbe45899661$var$ol(a)) throw Error($9565edbe45899661$var$p(40));
    return a._reactRootContainer ? ($9565edbe45899661$var$Rk(function() {
        $9565edbe45899661$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9565edbe45899661$var$uf] = null;
        });
    }), !0) : !1;
};
$9565edbe45899661$export$c78a37762a8d58e1 = $9565edbe45899661$var$Qk;
$9565edbe45899661$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9565edbe45899661$var$ol(c)) throw Error($9565edbe45899661$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9565edbe45899661$var$p(38));
    return $9565edbe45899661$var$rl(a, b, c, !1, d);
};
$9565edbe45899661$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("5dQG5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dLHrB"));

});
parcelRegister("dLHrB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a0615d42e3cdb7ca$export$c4744153514ff05d, (v) => $a0615d42e3cdb7ca$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a0615d42e3cdb7ca$export$3e506c1ccc9cc1a7, (v) => $a0615d42e3cdb7ca$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a0615d42e3cdb7ca$export$e26fe2ed2fa76875, (v) => $a0615d42e3cdb7ca$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a0615d42e3cdb7ca$export$502329bbf4b505b1, (v) => $a0615d42e3cdb7ca$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a0615d42e3cdb7ca$export$6e3807111c4874c4, (v) => $a0615d42e3cdb7ca$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a0615d42e3cdb7ca$export$c27134553091fb3a, (v) => $a0615d42e3cdb7ca$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a0615d42e3cdb7ca$export$33ee1acdc04fd2a2, (v) => $a0615d42e3cdb7ca$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a0615d42e3cdb7ca$export$b00a404bbd5edef2, (v) => $a0615d42e3cdb7ca$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a0615d42e3cdb7ca$export$8352ce38b91d0c62, (v) => $a0615d42e3cdb7ca$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a0615d42e3cdb7ca$export$d66a1c1c77bd778b, (v) => $a0615d42e3cdb7ca$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a0615d42e3cdb7ca$export$d3dfb8e4810cb555, (v) => $a0615d42e3cdb7ca$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a0615d42e3cdb7ca$export$839f9183b0465a69, (v) => $a0615d42e3cdb7ca$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a0615d42e3cdb7ca$export$72fdf0e06517287b, (v) => $a0615d42e3cdb7ca$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a0615d42e3cdb7ca$export$4b844e58a3e414b4, (v) => $a0615d42e3cdb7ca$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a0615d42e3cdb7ca$export$816d2913ae6b83b1, (v) => $a0615d42e3cdb7ca$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a0615d42e3cdb7ca$export$61bcfe829111a1d0, (v) => $a0615d42e3cdb7ca$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a0615d42e3cdb7ca$export$7ee8c9beb337bc3f, (v) => $a0615d42e3cdb7ca$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a0615d42e3cdb7ca$export$b5836b71941fa3ed, (v) => $a0615d42e3cdb7ca$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a0615d42e3cdb7ca$export$cf845f2c119da08a, (v) => $a0615d42e3cdb7ca$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0615d42e3cdb7ca$export$c4744153514ff05d;
var $a0615d42e3cdb7ca$export$3e506c1ccc9cc1a7;
var $a0615d42e3cdb7ca$export$e26fe2ed2fa76875;
var $a0615d42e3cdb7ca$export$502329bbf4b505b1;
var $a0615d42e3cdb7ca$export$6e3807111c4874c4;
var $a0615d42e3cdb7ca$export$c27134553091fb3a;
var $a0615d42e3cdb7ca$export$33ee1acdc04fd2a2;
var $a0615d42e3cdb7ca$export$b00a404bbd5edef2;
var $a0615d42e3cdb7ca$export$8352ce38b91d0c62;
var $a0615d42e3cdb7ca$export$d66a1c1c77bd778b;
var $a0615d42e3cdb7ca$export$d3dfb8e4810cb555;
var $a0615d42e3cdb7ca$export$839f9183b0465a69;
var $a0615d42e3cdb7ca$export$72fdf0e06517287b;
var $a0615d42e3cdb7ca$export$4b844e58a3e414b4;
var $a0615d42e3cdb7ca$export$816d2913ae6b83b1;
var $a0615d42e3cdb7ca$export$61bcfe829111a1d0;
var $a0615d42e3cdb7ca$export$7ee8c9beb337bc3f;
var $a0615d42e3cdb7ca$export$b5836b71941fa3ed;
var $a0615d42e3cdb7ca$export$cf845f2c119da08a;
'use strict';
function $a0615d42e3cdb7ca$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a0615d42e3cdb7ca$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a0615d42e3cdb7ca$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a0615d42e3cdb7ca$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a0615d42e3cdb7ca$var$g(C, c)) n < e && 0 > $a0615d42e3cdb7ca$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a0615d42e3cdb7ca$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a0615d42e3cdb7ca$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a0615d42e3cdb7ca$var$l = performance;
    $a0615d42e3cdb7ca$export$c4744153514ff05d = function() {
        return $a0615d42e3cdb7ca$var$l.now();
    };
} else {
    var $a0615d42e3cdb7ca$var$p = Date, $a0615d42e3cdb7ca$var$q = $a0615d42e3cdb7ca$var$p.now();
    $a0615d42e3cdb7ca$export$c4744153514ff05d = function() {
        return $a0615d42e3cdb7ca$var$p.now() - $a0615d42e3cdb7ca$var$q;
    };
}
var $a0615d42e3cdb7ca$var$r = [], $a0615d42e3cdb7ca$var$t = [], $a0615d42e3cdb7ca$var$u = 1, $a0615d42e3cdb7ca$var$v = null, $a0615d42e3cdb7ca$var$y = 3, $a0615d42e3cdb7ca$var$z = !1, $a0615d42e3cdb7ca$var$A = !1, $a0615d42e3cdb7ca$var$B = !1, $a0615d42e3cdb7ca$var$D = "function" === typeof setTimeout ? setTimeout : null, $a0615d42e3cdb7ca$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a0615d42e3cdb7ca$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a0615d42e3cdb7ca$var$G(a) {
    for(var b = $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$t); null !== b;){
        if (null === b.callback) $a0615d42e3cdb7ca$var$k($a0615d42e3cdb7ca$var$t);
        else if (b.startTime <= a) $a0615d42e3cdb7ca$var$k($a0615d42e3cdb7ca$var$t), b.sortIndex = b.expirationTime, $a0615d42e3cdb7ca$var$f($a0615d42e3cdb7ca$var$r, b);
        else break;
        b = $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$t);
    }
}
function $a0615d42e3cdb7ca$var$H(a) {
    $a0615d42e3cdb7ca$var$B = !1;
    $a0615d42e3cdb7ca$var$G(a);
    if (!$a0615d42e3cdb7ca$var$A) {
        if (null !== $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$r)) $a0615d42e3cdb7ca$var$A = !0, $a0615d42e3cdb7ca$var$I($a0615d42e3cdb7ca$var$J);
        else {
            var b = $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$t);
            null !== b && $a0615d42e3cdb7ca$var$K($a0615d42e3cdb7ca$var$H, b.startTime - a);
        }
    }
}
function $a0615d42e3cdb7ca$var$J(a, b) {
    $a0615d42e3cdb7ca$var$A = !1;
    $a0615d42e3cdb7ca$var$B && ($a0615d42e3cdb7ca$var$B = !1, $a0615d42e3cdb7ca$var$E($a0615d42e3cdb7ca$var$L), $a0615d42e3cdb7ca$var$L = -1);
    $a0615d42e3cdb7ca$var$z = !0;
    var c = $a0615d42e3cdb7ca$var$y;
    try {
        $a0615d42e3cdb7ca$var$G(b);
        for($a0615d42e3cdb7ca$var$v = $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$r); null !== $a0615d42e3cdb7ca$var$v && (!($a0615d42e3cdb7ca$var$v.expirationTime > b) || a && !$a0615d42e3cdb7ca$var$M());){
            var d = $a0615d42e3cdb7ca$var$v.callback;
            if ("function" === typeof d) {
                $a0615d42e3cdb7ca$var$v.callback = null;
                $a0615d42e3cdb7ca$var$y = $a0615d42e3cdb7ca$var$v.priorityLevel;
                var e = d($a0615d42e3cdb7ca$var$v.expirationTime <= b);
                b = $a0615d42e3cdb7ca$export$c4744153514ff05d();
                "function" === typeof e ? $a0615d42e3cdb7ca$var$v.callback = e : $a0615d42e3cdb7ca$var$v === $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$r) && $a0615d42e3cdb7ca$var$k($a0615d42e3cdb7ca$var$r);
                $a0615d42e3cdb7ca$var$G(b);
            } else $a0615d42e3cdb7ca$var$k($a0615d42e3cdb7ca$var$r);
            $a0615d42e3cdb7ca$var$v = $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$r);
        }
        if (null !== $a0615d42e3cdb7ca$var$v) var w = !0;
        else {
            var m = $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$t);
            null !== m && $a0615d42e3cdb7ca$var$K($a0615d42e3cdb7ca$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a0615d42e3cdb7ca$var$v = null, $a0615d42e3cdb7ca$var$y = c, $a0615d42e3cdb7ca$var$z = !1;
    }
}
var $a0615d42e3cdb7ca$var$N = !1, $a0615d42e3cdb7ca$var$O = null, $a0615d42e3cdb7ca$var$L = -1, $a0615d42e3cdb7ca$var$P = 5, $a0615d42e3cdb7ca$var$Q = -1;
function $a0615d42e3cdb7ca$var$M() {
    return $a0615d42e3cdb7ca$export$c4744153514ff05d() - $a0615d42e3cdb7ca$var$Q < $a0615d42e3cdb7ca$var$P ? !1 : !0;
}
function $a0615d42e3cdb7ca$var$R() {
    if (null !== $a0615d42e3cdb7ca$var$O) {
        var a = $a0615d42e3cdb7ca$export$c4744153514ff05d();
        $a0615d42e3cdb7ca$var$Q = a;
        var b = !0;
        try {
            b = $a0615d42e3cdb7ca$var$O(!0, a);
        } finally{
            b ? $a0615d42e3cdb7ca$var$S() : ($a0615d42e3cdb7ca$var$N = !1, $a0615d42e3cdb7ca$var$O = null);
        }
    } else $a0615d42e3cdb7ca$var$N = !1;
}
var $a0615d42e3cdb7ca$var$S;
if ("function" === typeof $a0615d42e3cdb7ca$var$F) $a0615d42e3cdb7ca$var$S = function() {
    $a0615d42e3cdb7ca$var$F($a0615d42e3cdb7ca$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a0615d42e3cdb7ca$var$T = new MessageChannel, $a0615d42e3cdb7ca$var$U = $a0615d42e3cdb7ca$var$T.port2;
    $a0615d42e3cdb7ca$var$T.port1.onmessage = $a0615d42e3cdb7ca$var$R;
    $a0615d42e3cdb7ca$var$S = function() {
        $a0615d42e3cdb7ca$var$U.postMessage(null);
    };
} else $a0615d42e3cdb7ca$var$S = function() {
    $a0615d42e3cdb7ca$var$D($a0615d42e3cdb7ca$var$R, 0);
};
function $a0615d42e3cdb7ca$var$I(a) {
    $a0615d42e3cdb7ca$var$O = a;
    $a0615d42e3cdb7ca$var$N || ($a0615d42e3cdb7ca$var$N = !0, $a0615d42e3cdb7ca$var$S());
}
function $a0615d42e3cdb7ca$var$K(a, b) {
    $a0615d42e3cdb7ca$var$L = $a0615d42e3cdb7ca$var$D(function() {
        a($a0615d42e3cdb7ca$export$c4744153514ff05d());
    }, b);
}
$a0615d42e3cdb7ca$export$3e506c1ccc9cc1a7 = 5;
$a0615d42e3cdb7ca$export$e26fe2ed2fa76875 = 1;
$a0615d42e3cdb7ca$export$502329bbf4b505b1 = 4;
$a0615d42e3cdb7ca$export$6e3807111c4874c4 = 3;
$a0615d42e3cdb7ca$export$c27134553091fb3a = null;
$a0615d42e3cdb7ca$export$33ee1acdc04fd2a2 = 2;
$a0615d42e3cdb7ca$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a0615d42e3cdb7ca$export$8352ce38b91d0c62 = function() {
    $a0615d42e3cdb7ca$var$A || $a0615d42e3cdb7ca$var$z || ($a0615d42e3cdb7ca$var$A = !0, $a0615d42e3cdb7ca$var$I($a0615d42e3cdb7ca$var$J));
};
$a0615d42e3cdb7ca$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a0615d42e3cdb7ca$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a0615d42e3cdb7ca$export$d3dfb8e4810cb555 = function() {
    return $a0615d42e3cdb7ca$var$y;
};
$a0615d42e3cdb7ca$export$839f9183b0465a69 = function() {
    return $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$r);
};
$a0615d42e3cdb7ca$export$72fdf0e06517287b = function(a) {
    switch($a0615d42e3cdb7ca$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a0615d42e3cdb7ca$var$y;
    }
    var c = $a0615d42e3cdb7ca$var$y;
    $a0615d42e3cdb7ca$var$y = b;
    try {
        return a();
    } finally{
        $a0615d42e3cdb7ca$var$y = c;
    }
};
$a0615d42e3cdb7ca$export$4b844e58a3e414b4 = function() {};
$a0615d42e3cdb7ca$export$816d2913ae6b83b1 = function() {};
$a0615d42e3cdb7ca$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a0615d42e3cdb7ca$var$y;
    $a0615d42e3cdb7ca$var$y = a;
    try {
        return b();
    } finally{
        $a0615d42e3cdb7ca$var$y = c;
    }
};
$a0615d42e3cdb7ca$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a0615d42e3cdb7ca$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a0615d42e3cdb7ca$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a0615d42e3cdb7ca$var$f($a0615d42e3cdb7ca$var$t, a), null === $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$r) && a === $a0615d42e3cdb7ca$var$h($a0615d42e3cdb7ca$var$t) && ($a0615d42e3cdb7ca$var$B ? ($a0615d42e3cdb7ca$var$E($a0615d42e3cdb7ca$var$L), $a0615d42e3cdb7ca$var$L = -1) : $a0615d42e3cdb7ca$var$B = !0, $a0615d42e3cdb7ca$var$K($a0615d42e3cdb7ca$var$H, c - d))) : (a.sortIndex = e, $a0615d42e3cdb7ca$var$f($a0615d42e3cdb7ca$var$r, a), $a0615d42e3cdb7ca$var$A || $a0615d42e3cdb7ca$var$z || ($a0615d42e3cdb7ca$var$A = !0, $a0615d42e3cdb7ca$var$I($a0615d42e3cdb7ca$var$J)));
    return a;
};
$a0615d42e3cdb7ca$export$b5836b71941fa3ed = $a0615d42e3cdb7ca$var$M;
$a0615d42e3cdb7ca$export$cf845f2c119da08a = function(a) {
    var b = $a0615d42e3cdb7ca$var$y;
    return function() {
        var c = $a0615d42e3cdb7ca$var$y;
        $a0615d42e3cdb7ca$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a0615d42e3cdb7ca$var$y = c;
        }
    };
};

});



parcelRegister("1VBZS", function(module, exports) {
module.exports = new URL("badge.9d0672e3.svg", import.meta.url).toString();

});

parcelRegister("dDAK1", function(module, exports) {
module.exports = new URL("cloud.87f15808.png", import.meta.url).toString();

});

parcelRegister("l4f2z", function(module, exports) {
module.exports = new URL("bubble.ad9f6cf1.png", import.meta.url).toString();

});

parcelRegister("8xFeJ", function(module, exports) {
module.exports = new URL("heart-3d.17de50cd.png", import.meta.url).toString();

});

parcelRegister("avBLG", function(module, exports) {
module.exports = new URL("smiley-3d.989a9f41.png", import.meta.url).toString();

});

parcelRegister("ixFFQ", function(module, exports) {
module.exports = new URL("badge-validation-1.50ae399f.png", import.meta.url).toString();

});

parcelRegister("9bOGD", function(module, exports) {
module.exports = new URL("badge-validation-2.3dcbfc77.png", import.meta.url).toString();

});

parcelRegister("bauHv", function(module, exports) {
module.exports = new URL("badge-validation-3.df095605.png", import.meta.url).toString();

});

parcelRegister("6BQXg", function(module, exports) {
module.exports = new URL("badge-validation-4.05f7451d.png", import.meta.url).toString();

});

parcelRegister("i1JUM", function(module, exports) {
module.exports = new URL("badge-validation-5.c6067dc5.png", import.meta.url).toString();

});

parcelRegister("hdM8F", function(module, exports) {
module.exports = new URL("logo-validation.1ffec413.svg", import.meta.url).toString();

});

parcelRegister("2pf9y", function(module, exports) {
module.exports = new URL("door.c2529e1e.svg", import.meta.url).toString();

});

parcelRegister("2KSlU", function(module, exports) {
module.exports = new URL("chrome2024.591c3281.png", import.meta.url).toString();

});

parcelRegister("9m2sy", function(module, exports) {
module.exports = new URL("unmuted.c6575961.svg", import.meta.url).toString();

});

parcelRegister("1eOKT", function(module, exports) {
module.exports = new URL("muted.a00d63a7.svg", import.meta.url).toString();

});

parcelRegister("jKhdP", function(module, exports) {
module.exports = new URL("airbudsYearly.46702769.svg", import.meta.url).toString();

});

parcelRegister("5IObX", function(module, exports) {
module.exports = new URL("close.17a322c2.svg", import.meta.url).toString();

});

parcelRegister("haq60", function(module, exports) {
module.exports = new URL("shape-stats-1.7689bf9c.svg", import.meta.url).toString();

});

parcelRegister("bOkMY", function(module, exports) {
module.exports = new URL("shape-stats-3.30e9ad2b.svg", import.meta.url).toString();

});

parcelRegister("cZAZL", function(module, exports) {
module.exports = new URL("shape-stats-4.beea19fa.svg", import.meta.url).toString();

});

parcelRegister("koCUj", function(module, exports) {
module.exports = new URL("flowerRecap.2bdaef3d.svg", import.meta.url).toString();

});

parcelRegister("4zSMw", function(module, exports) {
module.exports = new URL("airbudsyearlyShare.3e6ce785.svg", import.meta.url).toString();

});

parcelRegister("6Lxug", function(module, exports) {
module.exports = new URL("artistSingle.1a409839.svg", import.meta.url).toString();

});

parcelRegister("99iC1", function(module, exports) {
module.exports = new URL("singleBackgroundShape.8026b168.svg", import.meta.url).toString();

});

parcelRegister("gAHsj", function(module, exports) {
module.exports = new URL("singleBackgroundShape2.aaec7b35.svg", import.meta.url).toString();

});

parcelRegister("cPrpx", function(module, exports) {
module.exports = new URL("avatar1.4885f6c8.png", import.meta.url).toString();

});

parcelRegister("gTNGt", function(module, exports) {
module.exports = new URL("avatar2.0f7f94f3.png", import.meta.url).toString();

});

parcelRegister("3LZTk", function(module, exports) {
module.exports = new URL("avatar3.70e55385.png", import.meta.url).toString();

});

parcelRegister("9xsq5", function(module, exports) {
module.exports = new URL("avatar4.c6156adf.png", import.meta.url).toString();

});

parcelRegister("3lF1g", function(module, exports) {
module.exports = new URL("avatar5.57a7ad95.png", import.meta.url).toString();

});

parcelRegister("lOhS0", function(module, exports) {
module.exports = new URL("avatar6.d8f8eb58.png", import.meta.url).toString();

});

parcelRegister("9UWO6", function(module, exports) {
module.exports = new URL("avatar7.5b5cc50a.png", import.meta.url).toString();

});

parcelRegister("5EOJX", function(module, exports) {
module.exports = new URL("avatar8.9f2cdfcf.png", import.meta.url).toString();

});

parcelRegister("1QoVJ", function(module, exports) {
module.exports = new URL("check-read-outline.79cadad0.svg", import.meta.url).toString();

});

var $a98d20f216c65049$exports = {};

(parcelRequire("aH5kf")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gjX5N\",\"index.f62e6ab8.js\",\"bWngx\",\"badge.9d0672e3.svg\",\"1hvJK\",\"cloud.87f15808.png\",\"iiOdu\",\"bubble.ad9f6cf1.png\",\"1zlnL\",\"heart-3d.17de50cd.png\",\"5rS4j\",\"smiley-3d.989a9f41.png\",\"9hVeR\",\"badge-validation-1.50ae399f.png\",\"ddst7\",\"badge-validation-2.3dcbfc77.png\",\"02tSJ\",\"badge-validation-3.df095605.png\",\"6TJ7y\",\"badge-validation-4.05f7451d.png\",\"6LCxC\",\"badge-validation-5.c6067dc5.png\",\"66b4y\",\"logo-validation.1ffec413.svg\",\"cEdEL\",\"door.c2529e1e.svg\",\"7iuKP\",\"chrome2024.591c3281.png\",\"fXfYb\",\"unmuted.c6575961.svg\",\"iTuSX\",\"muted.a00d63a7.svg\",\"8b7c5\",\"airbudsYearly.46702769.svg\",\"hLjpb\",\"close.17a322c2.svg\",\"bc6gM\",\"shape-stats-1.7689bf9c.svg\",\"bjX49\",\"shape-stats-3.30e9ad2b.svg\",\"kdWgT\",\"shape-stats-4.beea19fa.svg\",\"iA98x\",\"flowerRecap.2bdaef3d.svg\",\"lDMM3\",\"airbudsyearlyShare.3e6ce785.svg\",\"8bTJO\",\"scratch.148ced95.jpg\",\"eaCRB\",\"artistSingle.1a409839.svg\",\"6iZzz\",\"singleBackgroundShape.8026b168.svg\",\"jfEJn\",\"singleBackgroundShape2.aaec7b35.svg\",\"3kHRf\",\"avatar1.4885f6c8.png\",\"isD3Z\",\"avatar2.0f7f94f3.png\",\"fA1bq\",\"avatar3.70e55385.png\",\"dKtsy\",\"avatar4.c6156adf.png\",\"esHy3\",\"avatar5.57a7ad95.png\",\"eJmBN\",\"avatar6.d8f8eb58.png\",\"iiCQP\",\"avatar7.5b5cc50a.png\",\"6RNiv\",\"avatar8.9f2cdfcf.png\",\"bwHYT\",\"check-read-outline.79cadad0.svg\",\"5h9CN\",\"index.52145f30.css\"]"));

var $9b3c114f2ec1a7b9$exports = {};
'use strict';

$9b3c114f2ec1a7b9$exports = (parcelRequire("2QVmd"));



var $ajtHG = parcelRequire("ajtHG");
var $d84eef864594d615$exports = {};

$parcel$export($d84eef864594d615$exports, "createRoot", () => $d84eef864594d615$export$882461b6382ed46c, (v) => $d84eef864594d615$export$882461b6382ed46c = v);
$parcel$export($d84eef864594d615$exports, "hydrateRoot", () => $d84eef864594d615$export$757ceba2d55c277e, (v) => $d84eef864594d615$export$757ceba2d55c277e = v);
var $d84eef864594d615$export$882461b6382ed46c;
var $d84eef864594d615$export$757ceba2d55c277e;
'use strict';
var $ae8f7e38845c4d50$exports = {};
'use strict';
function $ae8f7e38845c4d50$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ae8f7e38845c4d50$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ae8f7e38845c4d50$var$checkDCE();

$ae8f7e38845c4d50$exports = (parcelRequire("cPf3G"));


var $d84eef864594d615$var$i;
$d84eef864594d615$export$882461b6382ed46c = $ae8f7e38845c4d50$exports.createRoot;
$d84eef864594d615$export$757ceba2d55c277e = $ae8f7e38845c4d50$exports.hydrateRoot;


/**
 * react-router v7.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $ajtHG = parcelRequire("ajtHG");
var $560907ef6ac7a757$exports = {};
"use strict";
Object.defineProperty($560907ef6ac7a757$exports, "__esModule", {
    value: true
});
$560907ef6ac7a757$exports.encode = $560907ef6ac7a757$exports.decode = void 0;
var $87269bcde8519cd3$exports = {};
"use strict";
Object.defineProperty($87269bcde8519cd3$exports, "__esModule", {
    value: true
});
$87269bcde8519cd3$exports.flatten = void 0;
var $f2ea8471992c798a$exports = {};
"use strict";
Object.defineProperty($f2ea8471992c798a$exports, "__esModule", {
    value: true
});
$f2ea8471992c798a$exports.createLineSplittingTransform = $f2ea8471992c798a$exports.Deferred = $f2ea8471992c798a$exports.TYPE_PREVIOUS_RESOLVED = $f2ea8471992c798a$exports.TYPE_URL = $f2ea8471992c798a$exports.TYPE_SYMBOL = $f2ea8471992c798a$exports.TYPE_SET = $f2ea8471992c798a$exports.TYPE_REGEXP = $f2ea8471992c798a$exports.TYPE_PROMISE = $f2ea8471992c798a$exports.TYPE_NULL_OBJECT = $f2ea8471992c798a$exports.TYPE_MAP = $f2ea8471992c798a$exports.TYPE_ERROR = $f2ea8471992c798a$exports.TYPE_DATE = $f2ea8471992c798a$exports.TYPE_BIGINT = $f2ea8471992c798a$exports.UNDEFINED = $f2ea8471992c798a$exports.POSITIVE_INFINITY = $f2ea8471992c798a$exports.NULL = $f2ea8471992c798a$exports.NEGATIVE_ZERO = $f2ea8471992c798a$exports.NEGATIVE_INFINITY = $f2ea8471992c798a$exports.NAN = $f2ea8471992c798a$exports.HOLE = void 0;
$f2ea8471992c798a$exports.HOLE = -1;
$f2ea8471992c798a$exports.NAN = -2;
$f2ea8471992c798a$exports.NEGATIVE_INFINITY = -3;
$f2ea8471992c798a$exports.NEGATIVE_ZERO = -4;
$f2ea8471992c798a$exports.NULL = -5;
$f2ea8471992c798a$exports.POSITIVE_INFINITY = -6;
$f2ea8471992c798a$exports.UNDEFINED = -7;
$f2ea8471992c798a$exports.TYPE_BIGINT = "B";
$f2ea8471992c798a$exports.TYPE_DATE = "D";
$f2ea8471992c798a$exports.TYPE_ERROR = "E";
$f2ea8471992c798a$exports.TYPE_MAP = "M";
$f2ea8471992c798a$exports.TYPE_NULL_OBJECT = "N";
$f2ea8471992c798a$exports.TYPE_PROMISE = "P";
$f2ea8471992c798a$exports.TYPE_REGEXP = "R";
$f2ea8471992c798a$exports.TYPE_SET = "S";
$f2ea8471992c798a$exports.TYPE_SYMBOL = "Y";
$f2ea8471992c798a$exports.TYPE_URL = "U";
$f2ea8471992c798a$exports.TYPE_PREVIOUS_RESOLVED = "Z";
class $f2ea8471992c798a$var$Deferred {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
$f2ea8471992c798a$exports.Deferred = $f2ea8471992c798a$var$Deferred;
function $f2ea8471992c798a$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            // The last part might be a partial line, so keep it for the next chunk.
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            // If there's any leftover data, enqueue it before closing.
            if (leftover) controller.enqueue(leftover);
        }
    });
}
$f2ea8471992c798a$exports.createLineSplittingTransform = $f2ea8471992c798a$var$createLineSplittingTransform;


function $87269bcde8519cd3$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === undefined) return $f2ea8471992c798a$exports.UNDEFINED;
    if (input === null) return $f2ea8471992c798a$exports.NULL;
    if (Number.isNaN(input)) return $f2ea8471992c798a$exports.NAN;
    if (input === Number.POSITIVE_INFINITY) return $f2ea8471992c798a$exports.POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $f2ea8471992c798a$exports.NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $f2ea8471992c798a$exports.NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $87269bcde8519cd3$var$stringify.call(this, input, index);
    return index;
}
$87269bcde8519cd3$exports.flatten = $87269bcde8519cd3$var$flatten;
function $87269bcde8519cd3$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$87269bcde8519cd3$var$flatten.call(this, k)}":${$87269bcde8519cd3$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$f2ea8471992c798a$exports.TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$f2ea8471992c798a$exports.TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$f2ea8471992c798a$exports.NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$87269bcde8519cd3$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? $87269bcde8519cd3$var$flatten.call(this, input[i]) : $f2ea8471992c798a$exports.HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) str[index] = `["${$f2ea8471992c798a$exports.TYPE_DATE}",${input.getTime()}]`;
                        else if (input instanceof URL) str[index] = `["${$f2ea8471992c798a$exports.TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$f2ea8471992c798a$exports.TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$f2ea8471992c798a$exports.TYPE_SET}",${[
                                ...input
                            ].map((val)=>$87269bcde8519cd3$var$flatten.call(this, val)).join(",")}]`;
                            else str[index] = `["${$f2ea8471992c798a$exports.TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$f2ea8471992c798a$exports.TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    $87269bcde8519cd3$var$flatten.call(this, k),
                                    $87269bcde8519cd3$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index] = `["${$f2ea8471992c798a$exports.TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$f2ea8471992c798a$exports.TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$f2ea8471992c798a$exports.TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$f2ea8471992c798a$exports.TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($87269bcde8519cd3$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$87269bcde8519cd3$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>$87269bcde8519cd3$var$flatten.call(this, v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $87269bcde8519cd3$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $87269bcde8519cd3$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $87269bcde8519cd3$var$objectProtoNames;
}


var $7b85a30e57542037$exports = {};
"use strict";
Object.defineProperty($7b85a30e57542037$exports, "__esModule", {
    value: true
});
$7b85a30e57542037$exports.unflatten = void 0;

const $7b85a30e57542037$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : undefined;
function $7b85a30e57542037$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $7b85a30e57542037$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $7b85a30e57542037$var$hydrate.call(this, startIndex);
}
$7b85a30e57542037$exports.unflatten = $7b85a30e57542037$var$unflatten;
function $7b85a30e57542037$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case $f2ea8471992c798a$exports.UNDEFINED:
                set(undefined);
                continue;
            case $f2ea8471992c798a$exports.NULL:
                set(null);
                continue;
            case $f2ea8471992c798a$exports.NAN:
                set(NaN);
                continue;
            case $f2ea8471992c798a$exports.POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $f2ea8471992c798a$exports.NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $f2ea8471992c798a$exports.NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $f2ea8471992c798a$exports.TYPE_DATE:
                        set(hydrated[index] = new Date(b));
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_URL:
                        set(hydrated[index] = new URL(b));
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_BIGINT:
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_REGEXP:
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_SYMBOL:
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_SET:
                        const newSet = new Set();
                        hydrated[index] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_MAP:
                        const map = new Map();
                        hydrated[index] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_NULL_OBJECT:
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new $f2ea8471992c798a$exports.Deferred();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $7b85a30e57542037$var$globalObj && $7b85a30e57542037$var$globalObj[errorType] ? new $7b85a30e57542037$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case $f2ea8471992c798a$exports.TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        // Run plugins at the end so we have a chance to resolve primitives
                        // without running into a loop
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $f2ea8471992c798a$exports.HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}



async function $560907ef6ac7a757$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $f2ea8471992c798a$exports.Deferred();
    const reader = readable.pipeThrough((0, $f2ea8471992c798a$exports.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $560907ef6ac7a757$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $560907ef6ac7a757$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
$560907ef6ac7a757$exports.decode = $560907ef6ac7a757$var$decode;
async function $560907ef6ac7a757$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $7b85a30e57542037$exports.unflatten.call(this, line)
    };
}
async function $560907ef6ac7a757$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $f2ea8471992c798a$exports.TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $7b85a30e57542037$exports.unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $f2ea8471992c798a$exports.TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $7b85a30e57542037$exports.unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $560907ef6ac7a757$var$encode(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $87269bcde8519cd3$exports.flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $560907ef6ac7a757$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id = $87269bcde8519cd3$exports.flatten.call(encoder, resolved);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$f2ea8471992c798a$exports.TYPE_PROMISE}${deferredId}:[["${$f2ea8471992c798a$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$f2ea8471992c798a$exports.TYPE_PROMISE}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$f2ea8471992c798a$exports.TYPE_PROMISE}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id = $87269bcde8519cd3$exports.flatten.call(encoder, reason);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$f2ea8471992c798a$exports.TYPE_ERROR}${deferredId}:[["${$f2ea8471992c798a$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$f2ea8471992c798a$exports.TYPE_ERROR}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$f2ea8471992c798a$exports.TYPE_ERROR}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
$560907ef6ac7a757$exports.encode = $560907ef6ac7a757$var$encode;
function $560907ef6ac7a757$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}


var $9cb9235d62026ff5$exports = {};
"use strict";
Object.defineProperty($9cb9235d62026ff5$exports, "__esModule", {
    value: true
});
$9cb9235d62026ff5$exports.parse = $9cb9235d62026ff5$var$parse;
$9cb9235d62026ff5$exports.serialize = $9cb9235d62026ff5$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $9cb9235d62026ff5$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $9cb9235d62026ff5$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $9cb9235d62026ff5$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $9cb9235d62026ff5$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $9cb9235d62026ff5$var$__toString = Object.prototype.toString;
const $9cb9235d62026ff5$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $9cb9235d62026ff5$var$parse(str, options) {
    const obj = new $9cb9235d62026ff5$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $9cb9235d62026ff5$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $9cb9235d62026ff5$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $9cb9235d62026ff5$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $9cb9235d62026ff5$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $9cb9235d62026ff5$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $9cb9235d62026ff5$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $9cb9235d62026ff5$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $9cb9235d62026ff5$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$9cb9235d62026ff5$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$9cb9235d62026ff5$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$9cb9235d62026ff5$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$9cb9235d62026ff5$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$9cb9235d62026ff5$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $9cb9235d62026ff5$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $9cb9235d62026ff5$var$isDate(val) {
    return $9cb9235d62026ff5$var$__toString.call(val) === "[object Date]";
}


var $d205a8fac438c990$exports = {};
"use strict";
var $d205a8fac438c990$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $d205a8fac438c990$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $d205a8fac438c990$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($d205a8fac438c990$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $d205a8fac438c990$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $d205a8fac438c990$var$defaultParseOptions, options) : $d205a8fac438c990$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $d205a8fac438c990$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $d205a8fac438c990$var$parse(input, options) {
    options = options ? Object.assign({}, $d205a8fac438c990$var$defaultParseOptions, options) : $d205a8fac438c990$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($d205a8fac438c990$var$isNonEmptyString).map(function(str) {
        return $d205a8fac438c990$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($d205a8fac438c990$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $d205a8fac438c990$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $d205a8fac438c990$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$d205a8fac438c990$exports = $d205a8fac438c990$var$parse;
$d205a8fac438c990$exports.parse = $d205a8fac438c990$var$parse;
$d205a8fac438c990$exports.parseString = $d205a8fac438c990$var$parseString;
$d205a8fac438c990$exports.splitCookiesString = $d205a8fac438c990$var$splitCookiesString;


var $96c7c697f6acb9e3$import_meta = Object.assign(Object.create(null), {
    url: "file:///.yarn/__virtual__/react-router-virtual-f9c58f0e24/3/.yarn/berry/cache/react-router-npm-7.0.1-5f9672179e-10c0.zip/node_modules/react-router/dist/production/chunk-7R3XDUXW.mjs"
});
var $96c7c697f6acb9e3$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($96c7c697f6acb9e3$export$e19cd5f9376f8cee || {});
var $96c7c697f6acb9e3$var$PopStateEventType = "popstate";
function $96c7c697f6acb9e3$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $96c7c697f6acb9e3$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96c7c697f6acb9e3$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $96c7c697f6acb9e3$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $96c7c697f6acb9e3$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $96c7c697f6acb9e3$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $96c7c697f6acb9e3$export$fe53371bee54353d(to);
    }
    return $96c7c697f6acb9e3$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $96c7c697f6acb9e3$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $96c7c697f6acb9e3$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $96c7c697f6acb9e3$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96c7c697f6acb9e3$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $96c7c697f6acb9e3$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $96c7c697f6acb9e3$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96c7c697f6acb9e3$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96c7c697f6acb9e3$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $96c7c697f6acb9e3$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $96c7c697f6acb9e3$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $96c7c697f6acb9e3$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96c7c697f6acb9e3$var$createKey()
    };
    return location;
}
function $96c7c697f6acb9e3$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $96c7c697f6acb9e3$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96c7c697f6acb9e3$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $96c7c697f6acb9e3$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $96c7c697f6acb9e3$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $96c7c697f6acb9e3$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $96c7c697f6acb9e3$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href = typeof to === "string" ? to : $96c7c697f6acb9e3$export$fe53371bee54353d(to);
        href = href.replace(/ $/, "%20");
        $96c7c697f6acb9e3$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href}`);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($96c7c697f6acb9e3$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($96c7c697f6acb9e3$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $96c7c697f6acb9e3$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96c7c697f6acb9e3$var$isIndexRoute(route) {
    return route.index === true;
}
function $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96c7c697f6acb9e3$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $96c7c697f6acb9e3$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($96c7c697f6acb9e3$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $96c7c697f6acb9e3$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $96c7c697f6acb9e3$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $96c7c697f6acb9e3$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $96c7c697f6acb9e3$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $96c7c697f6acb9e3$var$flattenRoutes(routes);
    $96c7c697f6acb9e3$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $96c7c697f6acb9e3$var$decodePath(pathname);
        matches = $96c7c697f6acb9e3$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $96c7c697f6acb9e3$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96c7c697f6acb9e3$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96c7c697f6acb9e3$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $96c7c697f6acb9e3$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $96c7c697f6acb9e3$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $96c7c697f6acb9e3$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96c7c697f6acb9e3$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $96c7c697f6acb9e3$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $96c7c697f6acb9e3$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $96c7c697f6acb9e3$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $96c7c697f6acb9e3$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $96c7c697f6acb9e3$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $96c7c697f6acb9e3$var$paramRe = /^:[\w-]+$/;
var $96c7c697f6acb9e3$var$dynamicSegmentValue = 3;
var $96c7c697f6acb9e3$var$indexRouteValue = 2;
var $96c7c697f6acb9e3$var$emptySegmentValue = 1;
var $96c7c697f6acb9e3$var$staticSegmentValue = 10;
var $96c7c697f6acb9e3$var$splatPenalty = -2;
var $96c7c697f6acb9e3$var$isSplat = (s)=>s === "*";
function $96c7c697f6acb9e3$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($96c7c697f6acb9e3$var$isSplat)) initialScore += $96c7c697f6acb9e3$var$splatPenalty;
    if (index) initialScore += $96c7c697f6acb9e3$var$indexRouteValue;
    return segments.filter((s)=>!$96c7c697f6acb9e3$var$isSplat(s)).reduce((score, segment)=>score + ($96c7c697f6acb9e3$var$paramRe.test(segment) ? $96c7c697f6acb9e3$var$dynamicSegmentValue : segment === "" ? $96c7c697f6acb9e3$var$emptySegmentValue : $96c7c697f6acb9e3$var$staticSegmentValue), initialScore);
}
function $96c7c697f6acb9e3$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96c7c697f6acb9e3$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $96c7c697f6acb9e3$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $96c7c697f6acb9e3$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96c7c697f6acb9e3$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96c7c697f6acb9e3$var$normalizePathname($96c7c697f6acb9e3$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96c7c697f6acb9e3$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $96c7c697f6acb9e3$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96c7c697f6acb9e3$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $96c7c697f6acb9e3$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $96c7c697f6acb9e3$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $96c7c697f6acb9e3$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96c7c697f6acb9e3$var$compilePath(path, caseSensitive = false, end = true) {
    $96c7c697f6acb9e3$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $96c7c697f6acb9e3$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $96c7c697f6acb9e3$var$warning(false, `The URL path "${value}" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $96c7c697f6acb9e3$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $96c7c697f6acb9e3$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96c7c697f6acb9e3$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96c7c697f6acb9e3$var$normalizeSearch(search),
        hash: $96c7c697f6acb9e3$var$normalizeHash(hash)
    };
}
function $96c7c697f6acb9e3$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96c7c697f6acb9e3$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $96c7c697f6acb9e3$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $96c7c697f6acb9e3$var$getResolveToMatches(matches) {
    let pathMatches = $96c7c697f6acb9e3$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $96c7c697f6acb9e3$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $96c7c697f6acb9e3$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $96c7c697f6acb9e3$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $96c7c697f6acb9e3$var$getInvalidPathError("?", "pathname", "search", to));
        $96c7c697f6acb9e3$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $96c7c697f6acb9e3$var$getInvalidPathError("#", "pathname", "hash", to));
        $96c7c697f6acb9e3$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $96c7c697f6acb9e3$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $96c7c697f6acb9e3$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $96c7c697f6acb9e3$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $96c7c697f6acb9e3$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $96c7c697f6acb9e3$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $96c7c697f6acb9e3$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $96c7c697f6acb9e3$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $96c7c697f6acb9e3$export$4051a07651545597(data2, init) {
    return new $96c7c697f6acb9e3$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $96c7c697f6acb9e3$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $96c7c697f6acb9e3$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $96c7c697f6acb9e3$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $96c7c697f6acb9e3$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $96c7c697f6acb9e3$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $96c7c697f6acb9e3$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $96c7c697f6acb9e3$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $96c7c697f6acb9e3$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $96c7c697f6acb9e3$var$validMutationMethods = new Set($96c7c697f6acb9e3$var$validMutationMethodsArr);
var $96c7c697f6acb9e3$var$validRequestMethodsArr = [
    "GET",
    ...$96c7c697f6acb9e3$var$validMutationMethodsArr
];
var $96c7c697f6acb9e3$var$validRequestMethods = new Set($96c7c697f6acb9e3$var$validRequestMethodsArr);
var $96c7c697f6acb9e3$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $96c7c697f6acb9e3$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $96c7c697f6acb9e3$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $96c7c697f6acb9e3$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $96c7c697f6acb9e3$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $96c7c697f6acb9e3$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $96c7c697f6acb9e3$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $96c7c697f6acb9e3$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $96c7c697f6acb9e3$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $96c7c697f6acb9e3$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $96c7c697f6acb9e3$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $96c7c697f6acb9e3$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $96c7c697f6acb9e3$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $96c7c697f6acb9e3$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $96c7c697f6acb9e3$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$96c7c697f6acb9e3$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$96c7c697f6acb9e3$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96c7c697f6acb9e3$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $96c7c697f6acb9e3$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96c7c697f6acb9e3$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $96c7c697f6acb9e3$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$96c7c697f6acb9e3$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $96c7c697f6acb9e3$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $96c7c697f6acb9e3$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $96c7c697f6acb9e3$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96c7c697f6acb9e3$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96c7c697f6acb9e3$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $96c7c697f6acb9e3$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $96c7c697f6acb9e3$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $96c7c697f6acb9e3$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $96c7c697f6acb9e3$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $96c7c697f6acb9e3$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $96c7c697f6acb9e3$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        if (state.initialized && !isRevalidationRequired && $96c7c697f6acb9e3$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96c7c697f6acb9e3$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $96c7c697f6acb9e3$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $96c7c697f6acb9e3$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $96c7c697f6acb9e3$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($96c7c697f6acb9e3$var$isErrorResult(result) && $96c7c697f6acb9e3$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $96c7c697f6acb9e3$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $96c7c697f6acb9e3$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$96c7c697f6acb9e3$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $96c7c697f6acb9e3$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $96c7c697f6acb9e3$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $96c7c697f6acb9e3$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $96c7c697f6acb9e3$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($96c7c697f6acb9e3$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $96c7c697f6acb9e3$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($96c7c697f6acb9e3$var$isErrorResult(result)) {
            let boundaryMatch = $96c7c697f6acb9e3$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $96c7c697f6acb9e3$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $96c7c697f6acb9e3$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $96c7c697f6acb9e3$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $96c7c697f6acb9e3$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$96c7c697f6acb9e3$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $96c7c697f6acb9e3$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $96c7c697f6acb9e3$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $96c7c697f6acb9e3$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $96c7c697f6acb9e3$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $96c7c697f6acb9e3$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $96c7c697f6acb9e3$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $96c7c697f6acb9e3$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $96c7c697f6acb9e3$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96c7c697f6acb9e3$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $96c7c697f6acb9e3$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96c7c697f6acb9e3$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $96c7c697f6acb9e3$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $96c7c697f6acb9e3$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $96c7c697f6acb9e3$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($96c7c697f6acb9e3$var$isRedirectResult(actionResult) || $96c7c697f6acb9e3$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $96c7c697f6acb9e3$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($96c7c697f6acb9e3$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $96c7c697f6acb9e3$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $96c7c697f6acb9e3$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($96c7c697f6acb9e3$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $96c7c697f6acb9e3$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $96c7c697f6acb9e3$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $96c7c697f6acb9e3$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $96c7c697f6acb9e3$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $96c7c697f6acb9e3$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $96c7c697f6acb9e3$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $96c7c697f6acb9e3$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $96c7c697f6acb9e3$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $96c7c697f6acb9e3$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $96c7c697f6acb9e3$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $96c7c697f6acb9e3$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $96c7c697f6acb9e3$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96c7c697f6acb9e3$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $96c7c697f6acb9e3$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $96c7c697f6acb9e3$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $96c7c697f6acb9e3$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $96c7c697f6acb9e3$var$getDoneFetcher(void 0));
            return;
        }
        if ($96c7c697f6acb9e3$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $96c7c697f6acb9e3$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($96c7c697f6acb9e3$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $96c7c697f6acb9e3$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $96c7c697f6acb9e3$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $96c7c697f6acb9e3$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $96c7c697f6acb9e3$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $96c7c697f6acb9e3$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $96c7c697f6acb9e3$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($96c7c697f6acb9e3$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $96c7c697f6acb9e3$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $96c7c697f6acb9e3$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $96c7c697f6acb9e3$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($96c7c697f6acb9e3$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $96c7c697f6acb9e3$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $96c7c697f6acb9e3$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $96c7c697f6acb9e3$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $96c7c697f6acb9e3$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $96c7c697f6acb9e3$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $96c7c697f6acb9e3$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $96c7c697f6acb9e3$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $96c7c697f6acb9e3$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $96c7c697f6acb9e3$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $96c7c697f6acb9e3$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $96c7c697f6acb9e3$export$386d57f03f0b2883;
        $96c7c697f6acb9e3$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $96c7c697f6acb9e3$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $96c7c697f6acb9e3$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $96c7c697f6acb9e3$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $96c7c697f6acb9e3$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$96c7c697f6acb9e3$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $96c7c697f6acb9e3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $96c7c697f6acb9e3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $96c7c697f6acb9e3$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $96c7c697f6acb9e3$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $96c7c697f6acb9e3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $96c7c697f6acb9e3$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $96c7c697f6acb9e3$var$createStaticHandler(routes, opts) {
    $96c7c697f6acb9e3$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $96c7c697f6acb9e3$var$defaultMapRouteProperties;
    let dataRoutes = $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $96c7c697f6acb9e3$var$createLocation("", $96c7c697f6acb9e3$export$fe53371bee54353d(url), null, "default");
        let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$96c7c697f6acb9e3$var$isValidMethod(method) && method !== "HEAD") {
            let error = $96c7c697f6acb9e3$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $96c7c697f6acb9e3$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $96c7c697f6acb9e3$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96c7c697f6acb9e3$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($96c7c697f6acb9e3$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $96c7c697f6acb9e3$var$createLocation("", $96c7c697f6acb9e3$export$fe53371bee54353d(url), null, "default");
        let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$96c7c697f6acb9e3$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96c7c697f6acb9e3$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $96c7c697f6acb9e3$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $96c7c697f6acb9e3$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $96c7c697f6acb9e3$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $96c7c697f6acb9e3$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($96c7c697f6acb9e3$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $96c7c697f6acb9e3$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($96c7c697f6acb9e3$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $96c7c697f6acb9e3$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $96c7c697f6acb9e3$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($96c7c697f6acb9e3$var$isDataStrategyResult(e) && $96c7c697f6acb9e3$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($96c7c697f6acb9e3$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $96c7c697f6acb9e3$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $96c7c697f6acb9e3$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($96c7c697f6acb9e3$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($96c7c697f6acb9e3$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($96c7c697f6acb9e3$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $96c7c697f6acb9e3$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $96c7c697f6acb9e3$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $96c7c697f6acb9e3$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1]) ? $96c7c697f6acb9e3$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $96c7c697f6acb9e3$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $96c7c697f6acb9e3$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $96c7c697f6acb9e3$var$callDataStrategyImpl(dataStrategy || $96c7c697f6acb9e3$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($96c7c697f6acb9e3$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $96c7c697f6acb9e3$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($96c7c697f6acb9e3$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $96c7c697f6acb9e3$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $96c7c697f6acb9e3$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $96c7c697f6acb9e3$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $96c7c697f6acb9e3$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $96c7c697f6acb9e3$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $96c7c697f6acb9e3$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $96c7c697f6acb9e3$var$resolveTo(to ? to : ".", $96c7c697f6acb9e3$var$getResolveToMatches(contextualMatches), $96c7c697f6acb9e3$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $96c7c697f6acb9e3$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $96c7c697f6acb9e3$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $96c7c697f6acb9e3$export$fe53371bee54353d(path);
}
function $96c7c697f6acb9e3$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$96c7c697f6acb9e3$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96c7c697f6acb9e3$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96c7c697f6acb9e3$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $96c7c697f6acb9e3$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $96c7c697f6acb9e3$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$96c7c697f6acb9e3$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$96c7c697f6acb9e3$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96c7c697f6acb9e3$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $96c7c697f6acb9e3$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96c7c697f6acb9e3$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96c7c697f6acb9e3$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96c7c697f6acb9e3$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($96c7c697f6acb9e3$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $96c7c697f6acb9e3$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $96c7c697f6acb9e3$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $96c7c697f6acb9e3$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $96c7c697f6acb9e3$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $96c7c697f6acb9e3$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $96c7c697f6acb9e3$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $96c7c697f6acb9e3$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $96c7c697f6acb9e3$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($96c7c697f6acb9e3$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $96c7c697f6acb9e3$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96c7c697f6acb9e3$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $96c7c697f6acb9e3$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $96c7c697f6acb9e3$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $96c7c697f6acb9e3$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96c7c697f6acb9e3$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $96c7c697f6acb9e3$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $96c7c697f6acb9e3$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96c7c697f6acb9e3$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $96c7c697f6acb9e3$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $96c7c697f6acb9e3$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$96c7c697f6acb9e3$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $96c7c697f6acb9e3$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$96c7c697f6acb9e3$var$isSameRoute(aChild, bChild)));
}
async function $96c7c697f6acb9e3$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $96c7c697f6acb9e3$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $96c7c697f6acb9e3$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$96c7c697f6acb9e3$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $96c7c697f6acb9e3$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $96c7c697f6acb9e3$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $96c7c697f6acb9e3$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $96c7c697f6acb9e3$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $96c7c697f6acb9e3$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $96c7c697f6acb9e3$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $96c7c697f6acb9e3$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $96c7c697f6acb9e3$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($96c7c697f6acb9e3$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $96c7c697f6acb9e3$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($96c7c697f6acb9e3$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status
            };
            result = new $96c7c697f6acb9e3$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data);
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $96c7c697f6acb9e3$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($96c7c697f6acb9e3$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $96c7c697f6acb9e3$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $96c7c697f6acb9e3$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $96c7c697f6acb9e3$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $96c7c697f6acb9e3$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $96c7c697f6acb9e3$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $96c7c697f6acb9e3$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($96c7c697f6acb9e3$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $96c7c697f6acb9e3$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $96c7c697f6acb9e3$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96c7c697f6acb9e3$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $96c7c697f6acb9e3$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $96c7c697f6acb9e3$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $96c7c697f6acb9e3$export$f5708dca728d7177(!$96c7c697f6acb9e3$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96c7c697f6acb9e3$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $96c7c697f6acb9e3$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $96c7c697f6acb9e3$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $96c7c697f6acb9e3$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96c7c697f6acb9e3$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $96c7c697f6acb9e3$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $96c7c697f6acb9e3$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($96c7c697f6acb9e3$var$isErrorResult(result)) {
            let boundaryMatch = $96c7c697f6acb9e3$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($96c7c697f6acb9e3$var$isRedirectResult(result)) $96c7c697f6acb9e3$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $96c7c697f6acb9e3$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96c7c697f6acb9e3$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $96c7c697f6acb9e3$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $96c7c697f6acb9e3$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $96c7c697f6acb9e3$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $96c7c697f6acb9e3$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $96c7c697f6acb9e3$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96c7c697f6acb9e3$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $96c7c697f6acb9e3$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $96c7c697f6acb9e3$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($96c7c697f6acb9e3$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $96c7c697f6acb9e3$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(path) : path;
    return $96c7c697f6acb9e3$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $96c7c697f6acb9e3$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $96c7c697f6acb9e3$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $96c7c697f6acb9e3$var$isRedirectDataStrategyResult(result) {
    return $96c7c697f6acb9e3$var$isResponse(result.result) && $96c7c697f6acb9e3$var$redirectStatusCodes.has(result.result.status);
}
function $96c7c697f6acb9e3$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $96c7c697f6acb9e3$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $96c7c697f6acb9e3$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $96c7c697f6acb9e3$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96c7c697f6acb9e3$var$isRedirectStatusCode(statusCode) {
    return $96c7c697f6acb9e3$var$redirectStatusCodes.has(statusCode);
}
function $96c7c697f6acb9e3$var$isRedirectResponse(result) {
    return $96c7c697f6acb9e3$var$isResponse(result) && $96c7c697f6acb9e3$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $96c7c697f6acb9e3$var$isValidMethod(method) {
    return $96c7c697f6acb9e3$var$validRequestMethods.has(method.toUpperCase());
}
function $96c7c697f6acb9e3$var$isMutationMethod(method) {
    return $96c7c697f6acb9e3$var$validMutationMethods.has(method.toUpperCase());
}
function $96c7c697f6acb9e3$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $96c7c697f6acb9e3$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96c7c697f6acb9e3$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $96c7c697f6acb9e3$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96c7c697f6acb9e3$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $96c7c697f6acb9e3$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $96c7c697f6acb9e3$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96c7c697f6acb9e3$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $96c7c697f6acb9e3$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $96c7c697f6acb9e3$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $96c7c697f6acb9e3$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($96c7c697f6acb9e3$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $96c7c697f6acb9e3$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($96c7c697f6acb9e3$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $96c7c697f6acb9e3$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $96c7c697f6acb9e3$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $96c7c697f6acb9e3$export$2eeee58951ff3c1c = $ajtHG.createContext(null);
$96c7c697f6acb9e3$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $96c7c697f6acb9e3$export$315e3ffb01f217 = $ajtHG.createContext(null);
$96c7c697f6acb9e3$export$315e3ffb01f217.displayName = "DataRouterState";
var $96c7c697f6acb9e3$export$3681f408decb40d1 = $ajtHG.createContext({
    isTransitioning: false
});
$96c7c697f6acb9e3$export$3681f408decb40d1.displayName = "ViewTransition";
var $96c7c697f6acb9e3$export$cb3f1df1bef00a39 = $ajtHG.createContext(/* @__PURE__ */ new Map());
$96c7c697f6acb9e3$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $96c7c697f6acb9e3$var$AwaitContext = $ajtHG.createContext(null);
$96c7c697f6acb9e3$var$AwaitContext.displayName = "Await";
var $96c7c697f6acb9e3$export$3044ab7fdabeaee6 = $ajtHG.createContext(null);
$96c7c697f6acb9e3$export$3044ab7fdabeaee6.displayName = "Navigation";
var $96c7c697f6acb9e3$export$e6a44b110a0c44d3 = $ajtHG.createContext(null);
$96c7c697f6acb9e3$export$e6a44b110a0c44d3.displayName = "Location";
var $96c7c697f6acb9e3$export$aac280ed165a4397 = $ajtHG.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$96c7c697f6acb9e3$export$aac280ed165a4397.displayName = "Route";
var $96c7c697f6acb9e3$var$RouteErrorContext = $ajtHG.createContext(null);
$96c7c697f6acb9e3$var$RouteErrorContext.displayName = "RouteError";
var $96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS = false;
function $96c7c697f6acb9e3$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $96c7c697f6acb9e3$export$f5708dca728d7177($96c7c697f6acb9e3$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $96c7c697f6acb9e3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $96c7c697f6acb9e3$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $96c7c697f6acb9e3$export$9c954a9d03d32f4a() {
    return $ajtHG.useContext($96c7c697f6acb9e3$export$e6a44b110a0c44d3) != null;
}
function $96c7c697f6acb9e3$export$45d76561a5302f2b() {
    $96c7c697f6acb9e3$export$f5708dca728d7177($96c7c697f6acb9e3$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $ajtHG.useContext($96c7c697f6acb9e3$export$e6a44b110a0c44d3).location;
}
function $96c7c697f6acb9e3$export$1b3f31771c5d07c() {
    return $ajtHG.useContext($96c7c697f6acb9e3$export$e6a44b110a0c44d3).navigationType;
}
function $96c7c697f6acb9e3$export$6c330e8992e8a295(pattern) {
    $96c7c697f6acb9e3$export$f5708dca728d7177($96c7c697f6acb9e3$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    return $ajtHG.useMemo(()=>$96c7c697f6acb9e3$export$81336c211d5ff295(pattern, $96c7c697f6acb9e3$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $96c7c697f6acb9e3$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $96c7c697f6acb9e3$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6).static;
    if (!isStatic) $ajtHG.useLayoutEffect(cb);
}
function $96c7c697f6acb9e3$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    return isDataRoute ? $96c7c697f6acb9e3$var$useNavigateStable() : $96c7c697f6acb9e3$var$useNavigateUnstable();
}
function $96c7c697f6acb9e3$var$useNavigateUnstable() {
    $96c7c697f6acb9e3$export$f5708dca728d7177($96c7c697f6acb9e3$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $ajtHG.useContext($96c7c697f6acb9e3$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let { matches: matches } = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    let { pathname: locationPathname } = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($96c7c697f6acb9e3$var$getResolveToMatches(matches));
    let activeRef = $ajtHG.useRef(false);
    $96c7c697f6acb9e3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ajtHG.useCallback((to, options = {})=>{
        $96c7c697f6acb9e3$var$warning(activeRef.current, $96c7c697f6acb9e3$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $96c7c697f6acb9e3$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96c7c697f6acb9e3$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $96c7c697f6acb9e3$var$OutletContext = $ajtHG.createContext(null);
function $96c7c697f6acb9e3$export$4138103a3ae699cc() {
    return $ajtHG.useContext($96c7c697f6acb9e3$var$OutletContext);
}
function $96c7c697f6acb9e3$export$a3be3530d8e40d0b(context) {
    let outlet = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $96c7c697f6acb9e3$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $96c7c697f6acb9e3$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    let { pathname: locationPathname } = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($96c7c697f6acb9e3$var$getResolveToMatches(matches));
    return $ajtHG.useMemo(()=>$96c7c697f6acb9e3$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $96c7c697f6acb9e3$export$5d3fca4a98652595(routes, locationArg) {
    return $96c7c697f6acb9e3$var$useRoutesImpl(routes, locationArg);
}
function $96c7c697f6acb9e3$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $96c7c697f6acb9e3$export$f5708dca728d7177($96c7c697f6acb9e3$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2 } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $96c7c697f6acb9e3$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $96c7c697f6acb9e3$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $96c7c697f6acb9e3$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS) {
        $96c7c697f6acb9e3$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $96c7c697f6acb9e3$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $96c7c697f6acb9e3$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $96c7c697f6acb9e3$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $96c7c697f6acb9e3$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $96c7c697f6acb9e3$var$DefaultErrorComponent() {
    let error = $96c7c697f6acb9e3$export$ed527bf60f6e05f2();
    let message = $96c7c697f6acb9e3$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, /* @__PURE__ */ $ajtHG.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $ajtHG.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $ajtHG.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $ajtHG.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, /* @__PURE__ */ $ajtHG.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $ajtHG.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $ajtHG.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $96c7c697f6acb9e3$var$defaultErrorElement = /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$DefaultErrorComponent, null);
var $96c7c697f6acb9e3$var$RenderErrorBoundary = class extends $ajtHG.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $96c7c697f6acb9e3$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $ajtHG.useContext($96c7c697f6acb9e3$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $96c7c697f6acb9e3$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $96c7c697f6acb9e3$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $96c7c697f6acb9e3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $96c7c697f6acb9e3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $ajtHG.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $96c7c697f6acb9e3$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $96c7c697f6acb9e3$var$useDataRouterContext(hookName) {
    let ctx = $ajtHG.useContext($96c7c697f6acb9e3$export$2eeee58951ff3c1c);
    $96c7c697f6acb9e3$export$f5708dca728d7177(ctx, $96c7c697f6acb9e3$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $96c7c697f6acb9e3$var$useDataRouterState(hookName) {
    let state = $ajtHG.useContext($96c7c697f6acb9e3$export$315e3ffb01f217);
    $96c7c697f6acb9e3$export$f5708dca728d7177(state, $96c7c697f6acb9e3$var$getDataRouterConsoleError(hookName));
    return state;
}
function $96c7c697f6acb9e3$var$useRouteContext(hookName) {
    let route = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    $96c7c697f6acb9e3$export$f5708dca728d7177(route, $96c7c697f6acb9e3$var$getDataRouterConsoleError(hookName));
    return route;
}
function $96c7c697f6acb9e3$var$useCurrentRouteId(hookName) {
    let route = $96c7c697f6acb9e3$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $96c7c697f6acb9e3$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $96c7c697f6acb9e3$var$useRouteId() {
    return $96c7c697f6acb9e3$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $96c7c697f6acb9e3$export$d0fd4b7106de2769() {
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $96c7c697f6acb9e3$export$600dc272ed516c15() {
    let dataRouterContext = $96c7c697f6acb9e3$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $ajtHG.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $96c7c697f6acb9e3$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $96c7c697f6acb9e3$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $ajtHG.useMemo(()=>matches.map((m)=>$96c7c697f6acb9e3$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $96c7c697f6acb9e3$export$1448a5050d252c4d() {
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $96c7c697f6acb9e3$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $96c7c697f6acb9e3$export$fd5d37484eab868d(routeId) {
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $96c7c697f6acb9e3$export$fdc00f3f26066d5e() {
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $96c7c697f6acb9e3$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $96c7c697f6acb9e3$export$ed527bf60f6e05f2() {
    let error = $ajtHG.useContext($96c7c697f6acb9e3$var$RouteErrorContext);
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $96c7c697f6acb9e3$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $96c7c697f6acb9e3$export$78a72ddb39bdd145() {
    let value = $ajtHG.useContext($96c7c697f6acb9e3$var$AwaitContext);
    return value?._data;
}
function $96c7c697f6acb9e3$export$17f53340677d5831() {
    let value = $ajtHG.useContext($96c7c697f6acb9e3$var$AwaitContext);
    return value?._error;
}
var $96c7c697f6acb9e3$var$blockerId = 0;
function $96c7c697f6acb9e3$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $96c7c697f6acb9e3$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $96c7c697f6acb9e3$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $ajtHG.useState("");
    let blockerFunction = $ajtHG.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $96c7c697f6acb9e3$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $96c7c697f6acb9e3$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $ajtHG.useEffect(()=>{
        let key = String(++$96c7c697f6acb9e3$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $ajtHG.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $96c7c697f6acb9e3$export$386d57f03f0b2883;
}
function $96c7c697f6acb9e3$var$useNavigateStable() {
    let { router: router } = $96c7c697f6acb9e3$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $96c7c697f6acb9e3$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $ajtHG.useRef(false);
    $96c7c697f6acb9e3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ajtHG.useCallback(async (to, options = {})=>{
        $96c7c697f6acb9e3$var$warning(activeRef.current, $96c7c697f6acb9e3$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $96c7c697f6acb9e3$var$alreadyWarned = {};
function $96c7c697f6acb9e3$var$warningOnce(key, cond, message) {
    if (!cond && !$96c7c697f6acb9e3$var$alreadyWarned[key]) {
        $96c7c697f6acb9e3$var$alreadyWarned[key] = true;
        $96c7c697f6acb9e3$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $96c7c697f6acb9e3$var$alreadyWarned2 = {};
function $96c7c697f6acb9e3$var$warnOnce(condition, message) {
    if (!condition && !$96c7c697f6acb9e3$var$alreadyWarned2[message]) {
        $96c7c697f6acb9e3$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS2 = false;
function $96c7c697f6acb9e3$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $96c7c697f6acb9e3$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $ajtHG.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $96c7c697f6acb9e3$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $ajtHG.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($96c7c697f6acb9e3$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $96c7c697f6acb9e3$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $ajtHG.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $96c7c697f6acb9e3$export$f30f7e456d254e83(routes, opts) {
    return $96c7c697f6acb9e3$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $96c7c697f6acb9e3$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $96c7c697f6acb9e3$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $96c7c697f6acb9e3$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $96c7c697f6acb9e3$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $ajtHG.useState(router.state);
    let [pendingState, setPendingState] = $ajtHG.useState();
    let [vtContext, setVtContext] = $ajtHG.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $ajtHG.useState();
    let [transition, setTransition] = $ajtHG.useState();
    let [interruption, setInterruption] = $ajtHG.useState();
    let fetcherData = $ajtHG.useRef(/* @__PURE__ */ new Map());
    let setState = $ajtHG.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        $96c7c697f6acb9e3$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $96c7c697f6acb9e3$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $ajtHG.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $ajtHG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $ajtHG.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $96c7c697f6acb9e3$var$Deferred());
    }, [
        vtContext
    ]);
    $ajtHG.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $ajtHG.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $ajtHG.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $ajtHG.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $ajtHG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $ajtHG.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $96c7c697f6acb9e3$var$MemoizedDataRoutes = $ajtHG.memo($96c7c697f6acb9e3$var$DataRoutes);
function $96c7c697f6acb9e3$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $96c7c697f6acb9e3$var$useRoutesImpl(routes, void 0, state, future);
}
function $96c7c697f6acb9e3$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $ajtHG.useRef();
    if (historyRef.current == null) historyRef.current = $96c7c697f6acb9e3$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ajtHG.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ajtHG.useCallback((newState)=>{
        $ajtHG.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ajtHG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $96c7c697f6acb9e3$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $96c7c697f6acb9e3$export$f5708dca728d7177($96c7c697f6acb9e3$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    $96c7c697f6acb9e3$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    let { pathname: locationPathname } = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let navigate = $96c7c697f6acb9e3$export$9770f232ac06a008();
    let path = $96c7c697f6acb9e3$var$resolveTo(to, $96c7c697f6acb9e3$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $ajtHG.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $96c7c697f6acb9e3$export$910ae8079b2c2852(props) {
    return $96c7c697f6acb9e3$export$a3be3530d8e40d0b(props.context);
}
function $96c7c697f6acb9e3$export$e7b0ac011bb776c6(_props) {
    $96c7c697f6acb9e3$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $96c7c697f6acb9e3$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $96c7c697f6acb9e3$export$f5708dca728d7177(!$96c7c697f6acb9e3$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $ajtHG.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $96c7c697f6acb9e3$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $ajtHG.useMemo(()=>{
        let trailingPathname = $96c7c697f6acb9e3$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $96c7c697f6acb9e3$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $96c7c697f6acb9e3$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $96c7c697f6acb9e3$export$5d3fca4a98652595($96c7c697f6acb9e3$export$16da398f5434bdec(children), location);
}
function $96c7c697f6acb9e3$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$ResolveAwait, null, children));
}
var $96c7c697f6acb9e3$var$AwaitErrorBoundary = class extends $ajtHG.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $96c7c697f6acb9e3$var$ResolveAwait({ children: children }) {
    let data2 = $96c7c697f6acb9e3$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, toRender);
}
function $96c7c697f6acb9e3$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $ajtHG.Children.forEach(children, (element, index)=>{
        if (!$ajtHG.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $ajtHG.Fragment) {
            routes.push.apply(routes, $96c7c697f6acb9e3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $96c7c697f6acb9e3$export$f5708dca728d7177(element.type === $96c7c697f6acb9e3$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $96c7c697f6acb9e3$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $96c7c697f6acb9e3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
function $96c7c697f6acb9e3$export$daf73786167a7f72(matches) {
    return $96c7c697f6acb9e3$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $96c7c697f6acb9e3$var$defaultMethod = "get";
var $96c7c697f6acb9e3$var$defaultEncType = "application/x-www-form-urlencoded";
function $96c7c697f6acb9e3$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $96c7c697f6acb9e3$var$isButtonElement(object) {
    return $96c7c697f6acb9e3$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $96c7c697f6acb9e3$var$isFormElement(object) {
    return $96c7c697f6acb9e3$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $96c7c697f6acb9e3$var$isInputElement(object) {
    return $96c7c697f6acb9e3$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $96c7c697f6acb9e3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $96c7c697f6acb9e3$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$96c7c697f6acb9e3$var$isModifiedEvent(event);
}
function $96c7c697f6acb9e3$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $96c7c697f6acb9e3$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $96c7c697f6acb9e3$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $96c7c697f6acb9e3$var$_formDataSupportsSubmitter = null;
function $96c7c697f6acb9e3$var$isFormDataSubmitterSupported() {
    if ($96c7c697f6acb9e3$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $96c7c697f6acb9e3$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $96c7c697f6acb9e3$var$_formDataSupportsSubmitter = true;
    }
    return $96c7c697f6acb9e3$var$_formDataSupportsSubmitter;
}
var $96c7c697f6acb9e3$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $96c7c697f6acb9e3$var$getFormEncType(encType) {
    if (encType != null && !$96c7c697f6acb9e3$var$supportedFormEncTypes.has(encType)) {
        $96c7c697f6acb9e3$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$96c7c697f6acb9e3$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $96c7c697f6acb9e3$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($96c7c697f6acb9e3$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $96c7c697f6acb9e3$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $96c7c697f6acb9e3$var$defaultMethod;
        encType = $96c7c697f6acb9e3$var$getFormEncType(target.getAttribute("enctype")) || $96c7c697f6acb9e3$var$defaultEncType;
        formData = new FormData(target);
    } else if ($96c7c697f6acb9e3$var$isButtonElement(target) || $96c7c697f6acb9e3$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $96c7c697f6acb9e3$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $96c7c697f6acb9e3$var$defaultMethod;
        encType = $96c7c697f6acb9e3$var$getFormEncType(target.getAttribute("formenctype")) || $96c7c697f6acb9e3$var$getFormEncType(form.getAttribute("enctype")) || $96c7c697f6acb9e3$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$96c7c697f6acb9e3$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($96c7c697f6acb9e3$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $96c7c697f6acb9e3$var$defaultMethod;
        action = null;
        encType = $96c7c697f6acb9e3$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $96c7c697f6acb9e3$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $96c7c697f6acb9e3$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $96c7c697f6acb9e3$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $96c7c697f6acb9e3$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $96c7c697f6acb9e3$var$getCurrentPageModulePreloadHrefs(matches, manifest);
    return $96c7c697f6acb9e3$var$dedupeLinkDescriptors(descriptors, preloads);
}
async function $96c7c697f6acb9e3$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$96c7c697f6acb9e3$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        })));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$96c7c697f6acb9e3$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    let matchingLinks = styleLinks.filter((link)=>(!link.media || window.matchMedia(link.media).matches) && !document.querySelector(`link[rel="stylesheet"][href="${link.href}"]`));
    await Promise.all(matchingLinks.map($96c7c697f6acb9e3$var$prefetchStyleLink));
}
async function $96c7c697f6acb9e3$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $96c7c697f6acb9e3$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $96c7c697f6acb9e3$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $96c7c697f6acb9e3$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $96c7c697f6acb9e3$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $96c7c697f6acb9e3$var$dedupeLinkDescriptors(links.flat(1).filter($96c7c697f6acb9e3$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $96c7c697f6acb9e3$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $96c7c697f6acb9e3$var$getModuleLinkHrefs(matches, manifestPatch) {
    return $96c7c697f6acb9e3$var$dedupeHrefs(matches.map((match)=>{
        let route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $96c7c697f6acb9e3$var$getCurrentPageModulePreloadHrefs(matches, manifest) {
    return $96c7c697f6acb9e3$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $96c7c697f6acb9e3$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $96c7c697f6acb9e3$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $96c7c697f6acb9e3$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$96c7c697f6acb9e3$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($96c7c697f6acb9e3$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $96c7c697f6acb9e3$var$_isPreloadSupported;
function $96c7c697f6acb9e3$var$isPreloadSupported() {
    if ($96c7c697f6acb9e3$var$_isPreloadSupported !== void 0) return $96c7c697f6acb9e3$var$_isPreloadSupported;
    let el = document.createElement("link");
    $96c7c697f6acb9e3$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $96c7c697f6acb9e3$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $96c7c697f6acb9e3$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $96c7c697f6acb9e3$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $96c7c697f6acb9e3$var$escapeHtml(html) {
    return html.replace($96c7c697f6acb9e3$var$ESCAPE_REGEX, (match)=>$96c7c697f6acb9e3$var$ESCAPE_LOOKUP[match]);
}
function $96c7c697f6acb9e3$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $96c7c697f6acb9e3$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $96c7c697f6acb9e3$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $96c7c697f6acb9e3$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $ajtHG.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$96c7c697f6acb9e3$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, scriptTag, /* @__PURE__ */ $ajtHG.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, scriptTag, /* @__PURE__ */ $ajtHG.createElement($ajtHG.Suspense, null, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $96c7c697f6acb9e3$export$c7c51be9b423c4d6(manifest, routeModules, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $96c7c697f6acb9e3$var$singleFetchActionStrategy(request, matches);
        if (fetcherKey) return $96c7c697f6acb9e3$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $96c7c697f6acb9e3$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches);
    };
}
async function $96c7c697f6acb9e3$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $96c7c697f6acb9e3$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $96c7c697f6acb9e3$var$singleFetchUrl(request.url);
            let init = await $96c7c697f6acb9e3$var$createRequestInit(request);
            let { data: data2, status: status } = await $96c7c697f6acb9e3$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $96c7c697f6acb9e3$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($96c7c697f6acb9e3$var$isResponse(result.result) || $96c7c697f6acb9e3$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $96c7c697f6acb9e3$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $96c7c697f6acb9e3$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$96c7c697f6acb9e3$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $96c7c697f6acb9e3$var$createDeferred2();
    let url = $96c7c697f6acb9e3$var$stripIndexParam($96c7c697f6acb9e3$var$singleFetchUrl(request.url));
    let init = await $96c7c697f6acb9e3$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $96c7c697f6acb9e3$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $96c7c697f6acb9e3$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $96c7c697f6acb9e3$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $96c7c697f6acb9e3$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $96c7c697f6acb9e3$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $96c7c697f6acb9e3$var$stripIndexParam($96c7c697f6acb9e3$var$singleFetchUrl(request.url));
        let init = await $96c7c697f6acb9e3$var$createRequestInit(request);
        return $96c7c697f6acb9e3$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $96c7c697f6acb9e3$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $96c7c697f6acb9e3$var$fetchAndDecode(singleLoaderUrl, init);
        return $96c7c697f6acb9e3$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $96c7c697f6acb9e3$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $96c7c697f6acb9e3$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $96c7c697f6acb9e3$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $96c7c697f6acb9e3$export$f2680fa305b734ca(404, "Not Found", true);
    $96c7c697f6acb9e3$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $96c7c697f6acb9e3$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $96c7c697f6acb9e3$export$4023ad4ecd4126a2(body, global2) {
    return (0, $560907ef6ac7a757$exports.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $96c7c697f6acb9e3$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$96c7c697f6acb9e3$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $96c7c697f6acb9e3$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$96c7c697f6acb9e3$export$60644022b8b46aaa];
    if (redirect2) return $96c7c697f6acb9e3$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $96c7c697f6acb9e3$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $96c7c697f6acb9e3$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        return $96c7c697f6acb9e3$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $96c7c697f6acb9e3$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $96c7c697f6acb9e3$export$32e57f52df4b6e34 = class extends $ajtHG.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $96c7c697f6acb9e3$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $ajtHG.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($96c7c697f6acb9e3$export$972111febbeef05b(error)) return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $ajtHG.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $ajtHG.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $ajtHG.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $96c7c697f6acb9e3$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $96c7c697f6acb9e3$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $ajtHG.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $ajtHG.createElement("head", null, /* @__PURE__ */ $ajtHG.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $ajtHG.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $ajtHG.createElement("title", null, title)), /* @__PURE__ */ $ajtHG.createElement("body", null, /* @__PURE__ */ $ajtHG.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$ff0bf87698939488, null) : null)));
}
function $96c7c697f6acb9e3$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $ajtHG.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $96c7c697f6acb9e3$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $96c7c697f6acb9e3$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $96c7c697f6acb9e3$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $96c7c697f6acb9e3$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$RemixRootDefaultErrorBoundary, {
            error: $96c7c697f6acb9e3$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $ajtHG.createElement(routeModule.Layout, null, /* @__PURE__ */ $ajtHG.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $ajtHG.createElement(routeModule.Layout, null, /* @__PURE__ */ $ajtHG.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $ajtHG.createElement(routeModule.Layout, null, /* @__PURE__ */ $ajtHG.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $96c7c697f6acb9e3$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $96c7c697f6acb9e3$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $96c7c697f6acb9e3$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$96c7c697f6acb9e3$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $96c7c697f6acb9e3$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $96c7c697f6acb9e3$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return $96c7c697f6acb9e3$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, "", $96c7c697f6acb9e3$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $96c7c697f6acb9e3$var$preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        let fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        let msg2 = `You cannot call ${fn2} in SPA Mode (routeId: "${route.id}")`;
        console.error(msg2);
        throw new $96c7c697f6acb9e3$export$f2680fa305b734ca(400, "Bad Request", new Error(msg2), true);
    }
    let fn = type === "action" ? "serverAction()" : "serverLoader()";
    let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new $96c7c697f6acb9e3$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $96c7c697f6acb9e3$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $96c7c697f6acb9e3$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $96c7c697f6acb9e3$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, parentId = "", routesByParentId = $96c7c697f6acb9e3$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $96c7c697f6acb9e3$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $96c7c697f6acb9e3$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $96c7c697f6acb9e3$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$96c7c697f6acb9e3$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $96c7c697f6acb9e3$var$getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $96c7c697f6acb9e3$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) {
                            if (isSpaMode) return null;
                            return fetchServerLoader(singleFetch);
                        }
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $96c7c697f6acb9e3$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $96c7c697f6acb9e3$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $96c7c697f6acb9e3$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $96c7c697f6acb9e3$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $96c7c697f6acb9e3$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $96c7c697f6acb9e3$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            dataRoute.lazy = async ()=>{
                let mod = await $96c7c697f6acb9e3$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $96c7c697f6acb9e3$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $96c7c697f6acb9e3$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $96c7c697f6acb9e3$var$getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $96c7c697f6acb9e3$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $96c7c697f6acb9e3$var$getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return $96c7c697f6acb9e3$var$wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $96c7c697f6acb9e3$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $96c7c697f6acb9e3$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModule = await $96c7c697f6acb9e3$var$loadRouteModule(route, routeModules);
    await $96c7c697f6acb9e3$var$prefetchStyleLinks(route, routeModule);
    return {
        Component: $96c7c697f6acb9e3$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $96c7c697f6acb9e3$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $96c7c697f6acb9e3$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $96c7c697f6acb9e3$var$nextPaths = /* @__PURE__ */ new Set();
var $96c7c697f6acb9e3$var$discoveredPathsMaxSize = 1e3;
var $96c7c697f6acb9e3$var$discoveredPaths = /* @__PURE__ */ new Set();
var $96c7c697f6acb9e3$var$URL_LIMIT = 7680;
function $96c7c697f6acb9e3$var$isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function $96c7c697f6acb9e3$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $96c7c697f6acb9e3$export$72ab377a1030deb9(manifest, routeModules, isSpaMode, basename) {
    if (!$96c7c697f6acb9e3$var$isFogOfWarEnabled(isSpaMode)) return void 0;
    return async ({ path: path, patch: patch })=>{
        if ($96c7c697f6acb9e3$var$discoveredPaths.has(path)) return;
        await $96c7c697f6acb9e3$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, isSpaMode, basename, patch);
    };
}
function $96c7c697f6acb9e3$export$5ef046b23d96090d(router, manifest, routeModules, isSpaMode) {
    $ajtHG.useEffect(()=>{
        if (!$96c7c697f6acb9e3$var$isFogOfWarEnabled(isSpaMode) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let url = new URL(path, window.location.origin);
            if (!$96c7c697f6acb9e3$var$discoveredPaths.has(url.pathname)) $96c7c697f6acb9e3$var$nextPaths.add(url.pathname);
        }
        async function fetchPatches() {
            let lazyPaths = Array.from($96c7c697f6acb9e3$var$nextPaths.keys()).filter((path)=>{
                if ($96c7c697f6acb9e3$var$discoveredPaths.has(path)) {
                    $96c7c697f6acb9e3$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $96c7c697f6acb9e3$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>registerElement(el));
        fetchPatches();
        let debouncedFetchPatches = $96c7c697f6acb9e3$var$debounce(fetchPatches, 100);
        function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
        let observer = new MutationObserver((records)=>{
            let elements = /* @__PURE__ */ new Set();
            records.forEach((r)=>{
                [
                    r.target,
                    ...r.addedNodes
                ].forEach((node)=>{
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>elements.add(el));
                });
            });
            elements.forEach((el)=>registerElement(el));
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $96c7c697f6acb9e3$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $96c7c697f6acb9e3$var$URL_LIMIT) {
        $96c7c697f6acb9e3$var$nextPaths.clear();
        return;
    }
    let res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    else if (res.status >= 400) throw new Error(await res.text());
    let serverPatches = await res.json();
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$96c7c697f6acb9e3$var$addToFifoQueue(p, $96c7c697f6acb9e3$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $96c7c697f6acb9e3$export$af76e85f27ba0229(patches, routeModules, null, isSpaMode, parentId)));
}
function $96c7c697f6acb9e3$var$addToFifoQueue(path, queue) {
    if (queue.size >= $96c7c697f6acb9e3$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $96c7c697f6acb9e3$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $96c7c697f6acb9e3$var$useDataRouterContext2() {
    let context = $ajtHG.useContext($96c7c697f6acb9e3$export$2eeee58951ff3c1c);
    $96c7c697f6acb9e3$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $96c7c697f6acb9e3$var$useDataRouterStateContext() {
    let context = $ajtHG.useContext($96c7c697f6acb9e3$export$315e3ffb01f217);
    $96c7c697f6acb9e3$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $96c7c697f6acb9e3$export$208d6a3bc3aa62bd = $ajtHG.createContext(void 0);
$96c7c697f6acb9e3$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $96c7c697f6acb9e3$var$useFrameworkContext() {
    let context = $ajtHG.useContext($96c7c697f6acb9e3$export$208d6a3bc3aa62bd);
    $96c7c697f6acb9e3$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $96c7c697f6acb9e3$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $ajtHG.useContext($96c7c697f6acb9e3$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $ajtHG.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $ajtHG.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $ajtHG.useRef(null);
    $ajtHG.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $ajtHG.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $96c7c697f6acb9e3$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $96c7c697f6acb9e3$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $96c7c697f6acb9e3$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $96c7c697f6acb9e3$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $96c7c697f6acb9e3$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $96c7c697f6acb9e3$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $96c7c697f6acb9e3$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$96c7c697f6acb9e3$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $96c7c697f6acb9e3$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $96c7c697f6acb9e3$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $96c7c697f6acb9e3$var$useDataRouterStateContext();
    let matches = $96c7c697f6acb9e3$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $ajtHG.useMemo(()=>$96c7c697f6acb9e3$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, criticalCss ? /* @__PURE__ */ $ajtHG.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$96c7c697f6acb9e3$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $ajtHG.createElement("link", {
            key: key,
            ...link
        })));
}
function $96c7c697f6acb9e3$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $96c7c697f6acb9e3$var$useDataRouterContext2();
    let matches = $ajtHG.useMemo(()=>$96c7c697f6acb9e3$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) {
        console.warn(`Tried to prefetch ${page} but no routes matched.`);
        return null;
    }
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $96c7c697f6acb9e3$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $96c7c697f6acb9e3$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $ajtHG.useState([]);
    $ajtHG.useEffect(()=>{
        let interrupted = false;
        $96c7c697f6acb9e3$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $96c7c697f6acb9e3$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $96c7c697f6acb9e3$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $96c7c697f6acb9e3$var$useDataRouterStateContext();
    let newMatchesForData = $ajtHG.useMemo(()=>$96c7c697f6acb9e3$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $ajtHG.useMemo(()=>$96c7c697f6acb9e3$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $ajtHG.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $96c7c697f6acb9e3$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $ajtHG.useMemo(()=>$96c7c697f6acb9e3$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $96c7c697f6acb9e3$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $ajtHG.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $ajtHG.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $ajtHG.createElement("link", {
            key: key,
            ...link
        })));
}
function $96c7c697f6acb9e3$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $96c7c697f6acb9e3$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $96c7c697f6acb9e3$var$useDataRouterStateContext();
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let _matches = $96c7c697f6acb9e3$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$96c7c697f6acb9e3$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $ajtHG.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $ajtHG.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $ajtHG.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $ajtHG.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $ajtHG.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $96c7c697f6acb9e3$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $96c7c697f6acb9e3$var$isHydrated = false;
function $96c7c697f6acb9e3$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta } = $96c7c697f6acb9e3$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $96c7c697f6acb9e3$var$useDataRouterContext2();
    let { matches: routerMatches } = $96c7c697f6acb9e3$var$useDataRouterStateContext();
    let enableFogOfWar = $96c7c697f6acb9e3$var$isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $96c7c697f6acb9e3$var$getActiveMatches(routerMatches, null, isSpaMode);
    $ajtHG.useEffect(()=>{
        $96c7c697f6acb9e3$var$isHydrated = true;
    }, []);
    let initialScripts = $ajtHG.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, index)=>`import * as route${index} from ${JSON.stringify(manifest.routes[match.route.id].module)};`).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($96c7c697f6acb9e3$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, /* @__PURE__ */ $ajtHG.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $96c7c697f6acb9e3$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $ajtHG.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $96c7c697f6acb9e3$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let routePreloads = matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    let preloads = $96c7c697f6acb9e3$var$isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return $96c7c697f6acb9e3$var$isHydrated ? null : /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $ajtHG.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $ajtHG.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $96c7c697f6acb9e3$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $ajtHG.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $96c7c697f6acb9e3$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $96c7c697f6acb9e3$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $96c7c697f6acb9e3$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($96c7c697f6acb9e3$var$isBrowser) window.__reactRouterVersion = "7.0.1";
} catch (e) {}
function $96c7c697f6acb9e3$export$1f3f55432a00e06d(routes, opts) {
    return $96c7c697f6acb9e3$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $96c7c697f6acb9e3$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $96c7c697f6acb9e3$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $96c7c697f6acb9e3$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $96c7c697f6acb9e3$export$1ba7ed8a3a7b3765(routes, opts) {
    return $96c7c697f6acb9e3$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $96c7c697f6acb9e3$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $96c7c697f6acb9e3$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $96c7c697f6acb9e3$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $96c7c697f6acb9e3$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $96c7c697f6acb9e3$var$deserializeErrors(state.errors)
    };
    return state;
}
function $96c7c697f6acb9e3$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $96c7c697f6acb9e3$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $96c7c697f6acb9e3$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $ajtHG.useRef();
    if (historyRef.current == null) historyRef.current = $96c7c697f6acb9e3$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ajtHG.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ajtHG.useCallback((newState)=>{
        $ajtHG.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ajtHG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $96c7c697f6acb9e3$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $ajtHG.useRef();
    if (historyRef.current == null) historyRef.current = $96c7c697f6acb9e3$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ajtHG.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ajtHG.useCallback((newState)=>{
        $ajtHG.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ajtHG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $96c7c697f6acb9e3$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $ajtHG.useState({
        action: history.action,
        location: history.location
    });
    let setState = $ajtHG.useCallback((newState)=>{
        $ajtHG.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $ajtHG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$96c7c697f6acb9e3$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $96c7c697f6acb9e3$export$a6c7ac8248d6e38a = $ajtHG.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($96c7c697f6acb9e3$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $96c7c697f6acb9e3$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $96c7c697f6acb9e3$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $96c7c697f6acb9e3$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $96c7c697f6acb9e3$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $96c7c697f6acb9e3$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $ajtHG.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $96c7c697f6acb9e3$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, link, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$96c7c697f6acb9e3$export$a6c7ac8248d6e38a.displayName = "Link";
var $96c7c697f6acb9e3$export$b0d92dbee9b5b60d = $ajtHG.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $96c7c697f6acb9e3$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let routerState = $ajtHG.useContext($96c7c697f6acb9e3$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $96c7c697f6acb9e3$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $96c7c697f6acb9e3$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$96c7c697f6acb9e3$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $96c7c697f6acb9e3$export$a7fed597f4b8afd8 = $ajtHG.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $96c7c697f6acb9e3$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $96c7c697f6acb9e3$export$47c85c6e3a081d3();
    let formAction = $96c7c697f6acb9e3$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $ajtHG.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$96c7c697f6acb9e3$export$a7fed597f4b8afd8.displayName = "Form";
function $96c7c697f6acb9e3$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $ajtHG.useContext($96c7c697f6acb9e3$export$208d6a3bc3aa62bd);
    let { basename: basename } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let matches = $96c7c697f6acb9e3$export$2378eb7f5ff86053();
    $96c7c697f6acb9e3$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $ajtHG.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $96c7c697f6acb9e3$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $ajtHG.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $96c7c697f6acb9e3$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$96c7c697f6acb9e3$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $96c7c697f6acb9e3$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $96c7c697f6acb9e3$var$useDataRouterContext3(hookName) {
    let ctx = $ajtHG.useContext($96c7c697f6acb9e3$export$2eeee58951ff3c1c);
    $96c7c697f6acb9e3$export$f5708dca728d7177(ctx, $96c7c697f6acb9e3$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $96c7c697f6acb9e3$var$useDataRouterState2(hookName) {
    let state = $ajtHG.useContext($96c7c697f6acb9e3$export$315e3ffb01f217);
    $96c7c697f6acb9e3$export$f5708dca728d7177(state, $96c7c697f6acb9e3$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $96c7c697f6acb9e3$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $96c7c697f6acb9e3$export$9770f232ac06a008();
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let path = $96c7c697f6acb9e3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $ajtHG.useCallback((event)=>{
        if ($96c7c697f6acb9e3$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $96c7c697f6acb9e3$export$fe53371bee54353d(location) === $96c7c697f6acb9e3$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $96c7c697f6acb9e3$export$f1a78c17382fe22a(defaultInit) {
    $96c7c697f6acb9e3$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $ajtHG.useRef($96c7c697f6acb9e3$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $ajtHG.useRef(false);
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let searchParams = $ajtHG.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $96c7c697f6acb9e3$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $96c7c697f6acb9e3$export$9770f232ac06a008();
    let setSearchParams = $ajtHG.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $96c7c697f6acb9e3$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $96c7c697f6acb9e3$var$fetcherId = 0;
var $96c7c697f6acb9e3$var$getUniqueFetcherId = ()=>`__${String(++$96c7c697f6acb9e3$var$fetcherId)}__`;
function $96c7c697f6acb9e3$export$47c85c6e3a081d3() {
    let { router: router } = $96c7c697f6acb9e3$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let currentRouteId = $96c7c697f6acb9e3$var$useRouteId();
    return $ajtHG.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $96c7c697f6acb9e3$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $96c7c697f6acb9e3$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $96c7c697f6acb9e3$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let routeContext = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    $96c7c697f6acb9e3$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$96c7c697f6acb9e3$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $96c7c697f6acb9e3$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $96c7c697f6acb9e3$export$fe53371bee54353d(path);
}
function $96c7c697f6acb9e3$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $96c7c697f6acb9e3$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $96c7c697f6acb9e3$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $ajtHG.useContext($96c7c697f6acb9e3$export$cb3f1df1bef00a39);
    let route = $ajtHG.useContext($96c7c697f6acb9e3$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $96c7c697f6acb9e3$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $96c7c697f6acb9e3$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $96c7c697f6acb9e3$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $ajtHG.useId();
    let [fetcherKey, setFetcherKey] = $ajtHG.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $ajtHG.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $ajtHG.useCallback(async (href, opts)=>{
        $96c7c697f6acb9e3$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $96c7c697f6acb9e3$export$47c85c6e3a081d3();
    let submit = $ajtHG.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $ajtHG.useMemo(()=>{
        let FetcherForm2 = $ajtHG.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $96c7c697f6acb9e3$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $ajtHG.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $96c7c697f6acb9e3$export$fa996778a3a31087() {
    let state = $96c7c697f6acb9e3$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $96c7c697f6acb9e3$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $96c7c697f6acb9e3$var$savedScrollPositions = {};
function $96c7c697f6acb9e3$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $96c7c697f6acb9e3$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $96c7c697f6acb9e3$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $96c7c697f6acb9e3$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $96c7c697f6acb9e3$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $ajtHG.useContext($96c7c697f6acb9e3$export$3044ab7fdabeaee6);
    let location = $96c7c697f6acb9e3$export$45d76561a5302f2b();
    let matches = $96c7c697f6acb9e3$export$2378eb7f5ff86053();
    let navigation = $96c7c697f6acb9e3$export$d0fd4b7106de2769();
    $ajtHG.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $96c7c697f6acb9e3$var$usePageHide($ajtHG.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $96c7c697f6acb9e3$var$getScrollRestorationKey(location, matches, basename, getKey);
            $96c7c697f6acb9e3$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $96c7c697f6acb9e3$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($96c7c697f6acb9e3$var$savedScrollPositions));
        } catch (error) {
            $96c7c697f6acb9e3$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $ajtHG.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $96c7c697f6acb9e3$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $96c7c697f6acb9e3$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $ajtHG.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($96c7c697f6acb9e3$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$96c7c697f6acb9e3$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $ajtHG.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $96c7c697f6acb9e3$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $ajtHG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $96c7c697f6acb9e3$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $ajtHG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $96c7c697f6acb9e3$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $96c7c697f6acb9e3$export$b273b3273281a049(when);
    $ajtHG.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $ajtHG.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $96c7c697f6acb9e3$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $ajtHG.useContext($96c7c697f6acb9e3$export$3681f408decb40d1);
    $96c7c697f6acb9e3$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $96c7c697f6acb9e3$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $96c7c697f6acb9e3$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $96c7c697f6acb9e3$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $96c7c697f6acb9e3$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $96c7c697f6acb9e3$export$81336c211d5ff295(path.pathname, nextPath) != null || $96c7c697f6acb9e3$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $96c7c697f6acb9e3$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $96c7c697f6acb9e3$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $96c7c697f6acb9e3$var$getStatelessNavigator();
    return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $96c7c697f6acb9e3$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $96c7c697f6acb9e3$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $96c7c697f6acb9e3$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $96c7c697f6acb9e3$var$serializeErrors(context.errors)
        };
        let json = $96c7c697f6acb9e3$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $ajtHG.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $96c7c697f6acb9e3$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $96c7c697f6acb9e3$var$useRoutesImpl(routes, void 0, state, future);
}
function $96c7c697f6acb9e3$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($96c7c697f6acb9e3$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $96c7c697f6acb9e3$var$getStatelessNavigator() {
    return {
        createHref: $96c7c697f6acb9e3$var$createHref,
        encodeLocation: $96c7c697f6acb9e3$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $96c7c697f6acb9e3$export$3336b097a6fbc59a(routes, opts) {
    return $96c7c697f6acb9e3$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $96c7c697f6acb9e3$export$9269a41d8c4635e
    });
}
function $96c7c697f6acb9e3$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(routes, $96c7c697f6acb9e3$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $96c7c697f6acb9e3$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $96c7c697f6acb9e3$var$createHref,
        encodeLocation: $96c7c697f6acb9e3$var$encodeLocation,
        getFetcher () {
            return $96c7c697f6acb9e3$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $96c7c697f6acb9e3$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $96c7c697f6acb9e3$var$createHref(to) {
    return typeof to === "string" ? to : $96c7c697f6acb9e3$export$fe53371bee54353d(to);
}
function $96c7c697f6acb9e3$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $96c7c697f6acb9e3$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $96c7c697f6acb9e3$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $96c7c697f6acb9e3$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $96c7c697f6acb9e3$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $96c7c697f6acb9e3$var$htmlEscape(str) {
    return str.replace($96c7c697f6acb9e3$var$ESCAPE_REGEX2, (match)=>$96c7c697f6acb9e3$var$ESCAPE_LOOKUP2[match]);
}
function $96c7c697f6acb9e3$export$7246f7e18cebe1bd({ context: context, url: url, abortDelay: abortDelay, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $96c7c697f6acb9e3$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $96c7c697f6acb9e3$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $96c7c697f6acb9e3$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $ajtHG.createElement($ajtHG.Fragment, null, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            abortDelay: abortDelay,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $ajtHG.createElement($ajtHG.Suspense, null, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $96c7c697f6acb9e3$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $ajtHG.useRef();
        let remixContextRef = $ajtHG.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            let patched = $96c7c697f6acb9e3$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $96c7c697f6acb9e3$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $96c7c697f6acb9e3$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $ajtHG.createElement($96c7c697f6acb9e3$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $96c7c697f6acb9e3$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $96c7c697f6acb9e3$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $96c7c697f6acb9e3$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $96c7c697f6acb9e3$var$encoder = new TextEncoder();
var $96c7c697f6acb9e3$var$sign = async (value, secret)=>{
    let data2 = $96c7c697f6acb9e3$var$encoder.encode(value);
    let key = await $96c7c697f6acb9e3$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $96c7c697f6acb9e3$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $96c7c697f6acb9e3$var$encoder.encode(value);
    let key = await $96c7c697f6acb9e3$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $96c7c697f6acb9e3$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $96c7c697f6acb9e3$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $96c7c697f6acb9e3$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $96c7c697f6acb9e3$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $96c7c697f6acb9e3$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $96c7c697f6acb9e3$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9cb9235d62026ff5$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $96c7c697f6acb9e3$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9cb9235d62026ff5$exports.serialize)(name, value === "" ? "" : await $96c7c697f6acb9e3$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $96c7c697f6acb9e3$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $96c7c697f6acb9e3$var$encodeCookieValue(value, secrets) {
    let encoded = $96c7c697f6acb9e3$var$encodeData(value);
    if (secrets.length > 0) encoded = await $96c7c697f6acb9e3$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $96c7c697f6acb9e3$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $96c7c697f6acb9e3$var$unsign(value, secret);
            if (unsignedValue !== false) return $96c7c697f6acb9e3$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $96c7c697f6acb9e3$var$decodeData(value);
}
function $96c7c697f6acb9e3$var$encodeData(value) {
    return btoa($96c7c697f6acb9e3$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $96c7c697f6acb9e3$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($96c7c697f6acb9e3$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $96c7c697f6acb9e3$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $96c7c697f6acb9e3$var$hex(code, 2);
            else result += "%u" + $96c7c697f6acb9e3$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $96c7c697f6acb9e3$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $96c7c697f6acb9e3$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $96c7c697f6acb9e3$var$warnOnceAboutExpiresCookie(name, expires) {
    $96c7c697f6acb9e3$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $96c7c697f6acb9e3$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $96c7c697f6acb9e3$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($96c7c697f6acb9e3$export$e7973f87fd96e4f2 || {});
function $96c7c697f6acb9e3$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $96c7c697f6acb9e3$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $96c7c697f6acb9e3$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $96c7c697f6acb9e3$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $96c7c697f6acb9e3$var$serializeError(error, serverMode) {
    let sanitized = $96c7c697f6acb9e3$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $96c7c697f6acb9e3$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($96c7c697f6acb9e3$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $96c7c697f6acb9e3$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $96c7c697f6acb9e3$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $96c7c697f6acb9e3$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $96c7c697f6acb9e3$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $96c7c697f6acb9e3$var$stripRoutesParam($96c7c697f6acb9e3$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($96c7c697f6acb9e3$var$isDataWithResponseInit(result) && result.init && result.init.status && $96c7c697f6acb9e3$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $96c7c697f6acb9e3$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $96c7c697f6acb9e3$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $96c7c697f6acb9e3$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $96c7c697f6acb9e3$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $96c7c697f6acb9e3$var$createRoutes(manifest, parentId = "", routesByParentId = $96c7c697f6acb9e3$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $96c7c697f6acb9e3$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $96c7c697f6acb9e3$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $96c7c697f6acb9e3$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $96c7c697f6acb9e3$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $96c7c697f6acb9e3$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $96c7c697f6acb9e3$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $96c7c697f6acb9e3$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $96c7c697f6acb9e3$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$96c7c697f6acb9e3$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $96c7c697f6acb9e3$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $96c7c697f6acb9e3$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $96c7c697f6acb9e3$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $96c7c697f6acb9e3$var$escapeHtml2(html) {
    return html.replace($96c7c697f6acb9e3$var$ESCAPE_REGEX3, (match)=>$96c7c697f6acb9e3$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $96c7c697f6acb9e3$var$createServerHandoffString(serverHandoff) {
    return $96c7c697f6acb9e3$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $96c7c697f6acb9e3$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $96c7c697f6acb9e3$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$96c7c697f6acb9e3$var$globalDevServerHooksKey] = devServerHooks;
}
function $96c7c697f6acb9e3$var$getDevServerHooks() {
    return globalThis[$96c7c697f6acb9e3$var$globalDevServerHooksKey];
}
function $96c7c697f6acb9e3$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $96c7c697f6acb9e3$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $96c7c697f6acb9e3$var$prependCookies(errorHeaders, headers2);
            $96c7c697f6acb9e3$var$prependCookies(actionHeaders, headers2);
            $96c7c697f6acb9e3$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $96c7c697f6acb9e3$var$prependCookies(errorHeaders, headers);
        $96c7c697f6acb9e3$var$prependCookies(actionHeaders, headers);
        $96c7c697f6acb9e3$var$prependCookies(loaderHeaders, headers);
        $96c7c697f6acb9e3$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $96c7c697f6acb9e3$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $d205a8fac438c990$exports.splitCookiesString)(parentSetCookieString);
        cookies.forEach((cookie)=>{
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $96c7c697f6acb9e3$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $96c7c697f6acb9e3$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $96c7c697f6acb9e3$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $96c7c697f6acb9e3$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($96c7c697f6acb9e3$var$isResponse(result)) return {
            result: $96c7c697f6acb9e3$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $96c7c697f6acb9e3$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $96c7c697f6acb9e3$var$getDocumentHeaders(build, context);
        if ($96c7c697f6acb9e3$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $96c7c697f6acb9e3$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $96c7c697f6acb9e3$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$96c7c697f6acb9e3$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $96c7c697f6acb9e3$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $96c7c697f6acb9e3$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $96c7c697f6acb9e3$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($96c7c697f6acb9e3$var$isResponse(result)) return {
            result: {
                [$96c7c697f6acb9e3$export$60644022b8b46aaa]: $96c7c697f6acb9e3$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $96c7c697f6acb9e3$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $96c7c697f6acb9e3$var$getDocumentHeaders(build, context);
        if ($96c7c697f6acb9e3$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$96c7c697f6acb9e3$export$60644022b8b46aaa]: $96c7c697f6acb9e3$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $96c7c697f6acb9e3$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$96c7c697f6acb9e3$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $96c7c697f6acb9e3$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $96c7c697f6acb9e3$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $96c7c697f6acb9e3$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $96c7c697f6acb9e3$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $560907ef6ac7a757$exports.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $96c7c697f6acb9e3$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $96c7c697f6acb9e3$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $96c7c697f6acb9e3$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$96c7c697f6acb9e3$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $96c7c697f6acb9e3$var$derive(build, mode) {
    let routes = $96c7c697f6acb9e3$var$createRoutes(build.routes);
    let dataRoutes = $96c7c697f6acb9e3$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $96c7c697f6acb9e3$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $96c7c697f6acb9e3$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $96c7c697f6acb9e3$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $96c7c697f6acb9e3$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $96c7c697f6acb9e3$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $96c7c697f6acb9e3$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $96c7c697f6acb9e3$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $96c7c697f6acb9e3$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $96c7c697f6acb9e3$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
            let singleFetchMatches = $96c7c697f6acb9e3$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $96c7c697f6acb9e3$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($96c7c697f6acb9e3$var$isRedirectResponse(response)) {
                    let result = $96c7c697f6acb9e3$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$96c7c697f6acb9e3$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($96c7c697f6acb9e3$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $96c7c697f6acb9e3$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $96c7c697f6acb9e3$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $96c7c697f6acb9e3$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $96c7c697f6acb9e3$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $96c7c697f6acb9e3$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $96c7c697f6acb9e3$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $96c7c697f6acb9e3$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $96c7c697f6acb9e3$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $96c7c697f6acb9e3$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (status === 304) return new Response(null, {
        status: 304,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($96c7c697f6acb9e3$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $96c7c697f6acb9e3$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($96c7c697f6acb9e3$var$isResponse(context)) return context;
    let headers = $96c7c697f6acb9e3$var$getDocumentHeaders(build, context);
    if (context.statusCode === 304) return new Response(null, {
        status: 304,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$96c7c697f6acb9e3$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $96c7c697f6acb9e3$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $96c7c697f6acb9e3$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $96c7c697f6acb9e3$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $96c7c697f6acb9e3$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            isSpaMode: build.isSpaMode
        }),
        serverHandoffStream: $96c7c697f6acb9e3$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        isSpaMode: build.isSpaMode,
        serializeError: (err)=>$96c7c697f6acb9e3$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($96c7c697f6acb9e3$var$isResponse(error)) try {
            let data2 = await $96c7c697f6acb9e3$var$unwrapResponse(error);
            errorForSecondRender = new $96c7c697f6acb9e3$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $96c7c697f6acb9e3$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $96c7c697f6acb9e3$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $96c7c697f6acb9e3$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $96c7c697f6acb9e3$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                isSpaMode: build.isSpaMode
            }),
            serverHandoffStream: $96c7c697f6acb9e3$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $96c7c697f6acb9e3$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $96c7c697f6acb9e3$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        $96c7c697f6acb9e3$var$invariant3($96c7c697f6acb9e3$var$isResponse(response), "Expected a Response to be returned from resource route handler");
        return response;
    } catch (error) {
        if ($96c7c697f6acb9e3$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($96c7c697f6acb9e3$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $96c7c697f6acb9e3$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $96c7c697f6acb9e3$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $96c7c697f6acb9e3$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($96c7c697f6acb9e3$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $96c7c697f6acb9e3$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $96c7c697f6acb9e3$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $96c7c697f6acb9e3$var$flash(name) {
    return `__flash_${name}__`;
}
var $96c7c697f6acb9e3$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($96c7c697f6acb9e3$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $96c7c697f6acb9e3$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($96c7c697f6acb9e3$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $96c7c697f6acb9e3$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $96c7c697f6acb9e3$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $96c7c697f6acb9e3$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $96c7c697f6acb9e3$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $96c7c697f6acb9e3$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $96c7c697f6acb9e3$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $96c7c697f6acb9e3$var$warnOnceAboutSigningSessionCookie(cookie) {
    $96c7c697f6acb9e3$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $96c7c697f6acb9e3$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $96c7c697f6acb9e3$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $96c7c697f6acb9e3$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $96c7c697f6acb9e3$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $96c7c697f6acb9e3$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $96c7c697f6acb9e3$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $96c7c697f6acb9e3$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/dom/ssr/errors.ts
function $96c7c697f6acb9e3$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $96c7c697f6acb9e3$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}



parcelRequire("ajtHG");


parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");
// Create a Context
const $b6c962eba7db6225$var$DataContext = /*#__PURE__*/ (0, $ajtHG.createContext)();
const $b6c962eba7db6225$export$43c6ed89e8a21a35 = ({ children: children })=>{
    const [data, setData] = (0, $ajtHG.useState)(null);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($b6c962eba7db6225$var$DataContext.Provider, {
        value: {
            data: data,
            setData: setData
        },
        children: children
    });
};
const $b6c962eba7db6225$export$c1cf1cf4c5d51937 = ()=>(0, $ajtHG.useContext)($b6c962eba7db6225$var$DataContext);



parcelRequire("ajtHG");



parcelRequire("ajtHG");


var $ajtHG = parcelRequire("ajtHG");


var $ajtHG = parcelRequire("ajtHG");



function $f5d380161b2d224d$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $3d98cdcd9e935c82$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $c28129a2fcdfd85f$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $7be065c85343317e$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $5df4f1e8f75ff142$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $362c01d2b30f63d8$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $362c01d2b30f63d8$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $362c01d2b30f63d8$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $362c01d2b30f63d8$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $b6bbede3a032af0c$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $362c01d2b30f63d8$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $4d383567546b00bb$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $4d383567546b00bb$export$1405a65085f40b9 = [
    "initial",
    ...$4d383567546b00bb$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $7a2459a153995169$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $7a2459a153995169$export$7b42a0094fb00b6e = new Set($7a2459a153995169$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $715687867bb13e2f$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $715687867bb13e2f$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $f6338b7f7a58f33f$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $f6338b7f7a58f33f$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $f6338b7f7a58f33f$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $f6338b7f7a58f33f$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $f6338b7f7a58f33f$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $f6338b7f7a58f33f$var$keyframesTransition;
    else if ((0, $7a2459a153995169$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $f6338b7f7a58f33f$var$criticallyDampedSpring(keyframes[1]) : $f6338b7f7a58f33f$var$underDampedSpring;
    return $f6338b7f7a58f33f$var$ease;
};


function $1475c271f914e0a2$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


const $677ceb8a81976a74$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


const $aeab7bb04c87c30f$export$888a3d84909f9e3d = {
    current: false
};


const $f9c07df6f399fadf$var$isNotNull = (value)=>value !== null;
function $f9c07df6f399fadf$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($f9c07df6f399fadf$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


const $e3cb7a0786fb85a0$export$8793edee2d425525 = (any)=>any;



function $6c8a2182b88875e2$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $7d1c6bfe2b9686d8$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $7d1c6bfe2b9686d8$var$maxElapsed = 40;
function $7d1c6bfe2b9686d8$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $7d1c6bfe2b9686d8$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $6c8a2182b88875e2$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $677ceb8a81976a74$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $7d1c6bfe2b9686d8$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $7d1c6bfe2b9686d8$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $7d1c6bfe2b9686d8$export$71ecace0a033b35a.length; i++)steps[$7d1c6bfe2b9686d8$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $f4b7678cda54e417$export$2cef06c20297c17d, cancel: $f4b7678cda54e417$export$ec99c0ef4978dccb, state: $f4b7678cda54e417$export$fff89137e9e818ce, steps: $f4b7678cda54e417$export$1811c3a7e3af92f0 } = (0, $7d1c6bfe2b9686d8$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $e3cb7a0786fb85a0$export$8793edee2d425525), true);



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $95241440d244608f$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $95241440d244608f$var$subdivisionPrecision = 0.0000001;
const $95241440d244608f$var$subdivisionMaxIterations = 12;
function $95241440d244608f$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $95241440d244608f$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $95241440d244608f$var$subdivisionPrecision && ++i < $95241440d244608f$var$subdivisionMaxIterations);
    return currentT;
}
function $95241440d244608f$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $e3cb7a0786fb85a0$export$8793edee2d425525;
    const getTForX = (aX)=>$95241440d244608f$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $95241440d244608f$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $1c8865f361d7e032$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $5add3e2e46112629$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $42fc32190c1adfee$export$77edfce482316a60 = /*@__PURE__*/ (0, $95241440d244608f$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $42fc32190c1adfee$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $5add3e2e46112629$export$2c07eeff45156d4d)($42fc32190c1adfee$export$77edfce482316a60);
const $42fc32190c1adfee$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $1c8865f361d7e032$export$f946554fb8aeaf0d)($42fc32190c1adfee$export$b01116c84cdfe1a2);


const $c5d376adea09b745$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $42fc32190c1adfee$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $46ff946ce3fc4d37$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $46ff946ce3fc4d37$export$c8d67a19199d1a50 = (0, $5add3e2e46112629$export$2c07eeff45156d4d)($46ff946ce3fc4d37$export$e444123e42d03385);
const $46ff946ce3fc4d37$export$30d3455eee55bed5 = (0, $1c8865f361d7e032$export$f946554fb8aeaf0d)($46ff946ce3fc4d37$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $c4ff2e8e36e938d2$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $fcd8341c7cc93199$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $c4ff2e8e36e938d2$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $06304b9683179beb$export$491112666e282270 = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
let $06304b9683179beb$export$f5708dca728d7177 = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
var $06304b9683179beb$var$check, $06304b9683179beb$var$message, $06304b9683179beb$var$check1, $06304b9683179beb$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $a9cd1239fa048fdb$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $eca7cd7daa2f203d$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $eca7cd7daa2f203d$export$9de1236619d9e756 = /*@__PURE__*/ $eca7cd7daa2f203d$var$checkStringStartsWith("--");
const $eca7cd7daa2f203d$var$startsAsVariableToken = /*@__PURE__*/ $eca7cd7daa2f203d$var$checkStringStartsWith("var(--");
const $eca7cd7daa2f203d$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $eca7cd7daa2f203d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $eca7cd7daa2f203d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $eca7cd7daa2f203d$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $412b9befea7621d5$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $412b9befea7621d5$export$b9f0c1f373aee2b0(current) {
    const match = $412b9befea7621d5$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $412b9befea7621d5$var$maxDepth = 4;
function $412b9befea7621d5$export$289398774300c991(current, element, depth = 1) {
    (0, $06304b9683179beb$export$f5708dca728d7177)(depth <= $412b9befea7621d5$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $412b9befea7621d5$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $a9cd1239fa048fdb$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $eca7cd7daa2f203d$export$31f9caa2600b5723)(fallback) ? $412b9befea7621d5$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $af3e583a05cd24e4$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $af3e583a05cd24e4$export$58f0f39f63f3cf42 = {
    ...$af3e583a05cd24e4$export$98e628dec113755e,
    transform: (v)=>(0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $af3e583a05cd24e4$export$dcdf75081b88279d = {
    ...$af3e583a05cd24e4$export$98e628dec113755e,
    default: 1
};


const $8fbba1dc9f16e9ad$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $8fbba1dc9f16e9ad$export$41fc368e1a942b97 = /*@__PURE__*/ $8fbba1dc9f16e9ad$var$createUnitType("deg");
const $8fbba1dc9f16e9ad$export$626336c2cd4b14de = /*@__PURE__*/ $8fbba1dc9f16e9ad$var$createUnitType("%");
const $8fbba1dc9f16e9ad$export$91c0eda1d06bf008 = /*@__PURE__*/ $8fbba1dc9f16e9ad$var$createUnitType("px");
const $8fbba1dc9f16e9ad$export$f91e8c45a95a32f2 = /*@__PURE__*/ $8fbba1dc9f16e9ad$var$createUnitType("vh");
const $8fbba1dc9f16e9ad$export$aed3d7b7d206c196 = /*@__PURE__*/ $8fbba1dc9f16e9ad$var$createUnitType("vw");
const $8fbba1dc9f16e9ad$export$44e2e1705876d7ed = {
    ...$8fbba1dc9f16e9ad$export$626336c2cd4b14de,
    parse: (v)=>$8fbba1dc9f16e9ad$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$8fbba1dc9f16e9ad$export$626336c2cd4b14de.transform(v * 100)
};


const $7b2a9048a17303ee$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $7b2a9048a17303ee$export$8e5250d1aa9bf370 = (v)=>v === (0, $af3e583a05cd24e4$export$98e628dec113755e) || v === (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008);
const $7b2a9048a17303ee$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $7b2a9048a17303ee$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $7b2a9048a17303ee$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $7b2a9048a17303ee$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $7b2a9048a17303ee$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $7b2a9048a17303ee$var$nonTranslationalTransformKeys = (0, $7a2459a153995169$export$280dc01950909d86).filter((key)=>!$7b2a9048a17303ee$var$transformKeys.has(key));
function $7b2a9048a17303ee$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $7b2a9048a17303ee$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $7b2a9048a17303ee$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $7b2a9048a17303ee$var$getTranslateFromMatrix(4, 13),
    y: $7b2a9048a17303ee$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$7b2a9048a17303ee$export$781d46a8aa670d52.translateX = $7b2a9048a17303ee$export$781d46a8aa670d52.x;
$7b2a9048a17303ee$export$781d46a8aa670d52.translateY = $7b2a9048a17303ee$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $0e1fbeaeea9ea565$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $83b2dab4524adab4$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $1f8533aa7b5b7539$export$d176691c1998a1f5 = [
    (0, $af3e583a05cd24e4$export$98e628dec113755e),
    (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    (0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de),
    (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    (0, $8fbba1dc9f16e9ad$export$aed3d7b7d206c196),
    (0, $8fbba1dc9f16e9ad$export$f91e8c45a95a32f2),
    (0, $83b2dab4524adab4$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $1f8533aa7b5b7539$export$eefdd52e3ccae428 = (v)=>$1f8533aa7b5b7539$export$d176691c1998a1f5.find((0, $0e1fbeaeea9ea565$export$6eae4d0a6a7ca7cd)(v));




const $2e1a8a256a2f4570$var$toResolve = new Set();
let $2e1a8a256a2f4570$var$isScheduled = false;
let $2e1a8a256a2f4570$var$anyNeedsMeasurement = false;
function $2e1a8a256a2f4570$var$measureAllKeyframes() {
    if ($2e1a8a256a2f4570$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($2e1a8a256a2f4570$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $7b2a9048a17303ee$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $2e1a8a256a2f4570$var$anyNeedsMeasurement = false;
    $2e1a8a256a2f4570$var$isScheduled = false;
    $2e1a8a256a2f4570$var$toResolve.forEach((resolver)=>resolver.complete());
    $2e1a8a256a2f4570$var$toResolve.clear();
}
function $2e1a8a256a2f4570$var$readAllKeyframes() {
    $2e1a8a256a2f4570$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $2e1a8a256a2f4570$var$anyNeedsMeasurement = true;
    });
}
function $2e1a8a256a2f4570$export$78b96d2a12593b05() {
    $2e1a8a256a2f4570$var$readAllKeyframes();
    $2e1a8a256a2f4570$var$measureAllKeyframes();
}
class $2e1a8a256a2f4570$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $2e1a8a256a2f4570$var$toResolve.add(this);
            if (!$2e1a8a256a2f4570$var$isScheduled) {
                $2e1a8a256a2f4570$var$isScheduled = true;
                (0, $f4b7678cda54e417$export$2cef06c20297c17d).read($2e1a8a256a2f4570$var$readAllKeyframes);
                (0, $f4b7678cda54e417$export$2cef06c20297c17d).resolveKeyframes($2e1a8a256a2f4570$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $2e1a8a256a2f4570$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $2e1a8a256a2f4570$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $4914a9915a60153b$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $9b221644dd703c87$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $4c7d475022266922$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $7f21cfe5b16b7ff4$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ef2c3679f56a004e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $7f21cfe5b16b7ff4$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $4c7d475022266922$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ef2c3679f56a004e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $9b221644dd703c87$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $2aac7c727f563ba9$var$clampRgbUnit = (v)=>(0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(0, 255, v);
const $2aac7c727f563ba9$export$7a99c86b5b1f4c9e = {
    ...(0, $af3e583a05cd24e4$export$98e628dec113755e),
    transform: (v)=>Math.round($2aac7c727f563ba9$var$clampRgbUnit(v))
};
const $2aac7c727f563ba9$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $ef2c3679f56a004e$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $ef2c3679f56a004e$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $2aac7c727f563ba9$export$7a99c86b5b1f4c9e.transform(red) + ", " + $2aac7c727f563ba9$export$7a99c86b5b1f4c9e.transform(green) + ", " + $2aac7c727f563ba9$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $4914a9915a60153b$export$83d2e9e3e4ee39ed)((0, $af3e583a05cd24e4$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $fa91941c0e81bfd4$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $fa91941c0e81bfd4$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $ef2c3679f56a004e$export$2c8400d58aca05e)("#"),
    parse: $fa91941c0e81bfd4$var$parseHex,
    transform: (0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b).transform
};






const $24dfb57568118e7b$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $ef2c3679f56a004e$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $ef2c3679f56a004e$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de).transform((0, $4914a9915a60153b$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de).transform((0, $4914a9915a60153b$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $4914a9915a60153b$export$83d2e9e3e4ee39ed)((0, $af3e583a05cd24e4$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $a58c15eb6a659bc0$export$35e9368ef982300f = {
    test: (v)=>(0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b).test(v) || (0, $fa91941c0e81bfd4$export$834dfc94dde4b3d8).test(v) || (0, $24dfb57568118e7b$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b).test(v)) return (0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $24dfb57568118e7b$export$810b04175080204c).test(v)) return (0, $24dfb57568118e7b$export$810b04175080204c).parse(v);
        else return (0, $fa91941c0e81bfd4$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b).transform(v) : (0, $24dfb57568118e7b$export$810b04175080204c).transform(v);
    }
};


const $88e72eb26c7926f1$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $cb497529768be9f4$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $9b221644dd703c87$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $88e72eb26c7926f1$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $cb497529768be9f4$var$NUMBER_TOKEN = "number";
const $cb497529768be9f4$var$COLOR_TOKEN = "color";
const $cb497529768be9f4$var$VAR_TOKEN = "var";
const $cb497529768be9f4$var$VAR_FUNCTION_TOKEN = "var(";
const $cb497529768be9f4$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $cb497529768be9f4$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $cb497529768be9f4$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($cb497529768be9f4$var$complexRegex, (parsedValue)=>{
        if ((0, $a58c15eb6a659bc0$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($cb497529768be9f4$var$COLOR_TOKEN);
            values.push((0, $a58c15eb6a659bc0$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($cb497529768be9f4$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($cb497529768be9f4$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($cb497529768be9f4$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $cb497529768be9f4$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($cb497529768be9f4$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $cb497529768be9f4$var$parseComplexValue(v) {
    return $cb497529768be9f4$export$b61fc7c44bf646d5(v).values;
}
function $cb497529768be9f4$var$createTransformer(source) {
    const { split: split, types: types } = $cb497529768be9f4$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $cb497529768be9f4$var$NUMBER_TOKEN) output += (0, $4914a9915a60153b$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $cb497529768be9f4$var$COLOR_TOKEN) output += (0, $a58c15eb6a659bc0$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $cb497529768be9f4$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $cb497529768be9f4$var$getAnimatableNone(v) {
    const parsed = $cb497529768be9f4$var$parseComplexValue(v);
    const transformer = $cb497529768be9f4$var$createTransformer(v);
    return transformer(parsed.map($cb497529768be9f4$var$convertNumbersToZero));
}
const $cb497529768be9f4$export$83a0e34f1302825b = {
    test: $cb497529768be9f4$var$test,
    parse: $cb497529768be9f4$var$parseComplexValue,
    createTransformer: $cb497529768be9f4$var$createTransformer,
    getAnimatableNone: $cb497529768be9f4$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $e2760e85319de2df$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $e2760e85319de2df$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9b221644dd703c87$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $e2760e85319de2df$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $e2760e85319de2df$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $e2760e85319de2df$export$3dea766d36a8935f = {
    ...(0, $cb497529768be9f4$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($e2760e85319de2df$var$functionRegex);
        return functions ? functions.map($e2760e85319de2df$var$applyDefaultFilter).join(" ") : v;
    }
};







const $f9f9b25e0cfcde50$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderTopWidth: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderRightWidth: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderRadius: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    radius: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    maxWidth: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    height: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    maxHeight: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    top: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    right: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    bottom: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    left: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    paddingTop: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    paddingRight: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    paddingBottom: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    paddingLeft: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    margin: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    marginTop: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    marginRight: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    marginBottom: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    marginLeft: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008)
};




const $c229efbaff4b32ad$export$f2e4285fee37e26 = {
    rotate: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    rotateX: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    rotateY: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    rotateZ: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    scale: $af3e583a05cd24e4$export$dcdf75081b88279d,
    scaleX: (0, $af3e583a05cd24e4$export$dcdf75081b88279d),
    scaleY: (0, $af3e583a05cd24e4$export$dcdf75081b88279d),
    scaleZ: (0, $af3e583a05cd24e4$export$dcdf75081b88279d),
    skew: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    skewX: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    skewY: (0, $8fbba1dc9f16e9ad$export$41fc368e1a942b97),
    distance: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    translateX: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    translateY: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    translateZ: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    x: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    y: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    z: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    perspective: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    transformPerspective: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    opacity: (0, $af3e583a05cd24e4$export$58f0f39f63f3cf42),
    originX: (0, $8fbba1dc9f16e9ad$export$44e2e1705876d7ed),
    originY: (0, $8fbba1dc9f16e9ad$export$44e2e1705876d7ed),
    originZ: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008)
};



const $0a800a5a03c5dcaf$export$7d260a2a5f8bc19e = {
    ...(0, $af3e583a05cd24e4$export$98e628dec113755e),
    transform: Math.round
};


const $3cf7ecb9cf9566a1$export$eec14432cd1cb67b = {
    ...(0, $f9f9b25e0cfcde50$export$2fb74b0a4e7d7c4a),
    ...(0, $c229efbaff4b32ad$export$f2e4285fee37e26),
    zIndex: (0, $0a800a5a03c5dcaf$export$7d260a2a5f8bc19e),
    size: (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $af3e583a05cd24e4$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $af3e583a05cd24e4$export$58f0f39f63f3cf42),
    numOctaves: (0, $0a800a5a03c5dcaf$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $1d10ecb8b84625e9$export$98cd7c72c5a731fb = {
    ...(0, $3cf7ecb9cf9566a1$export$eec14432cd1cb67b),
    color: // Color props
    $a58c15eb6a659bc0$export$35e9368ef982300f,
    backgroundColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    outlineColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    fill: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    stroke: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    borderTopColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    borderRightColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    borderBottomColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    borderLeftColor: (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    filter: $e2760e85319de2df$export$3dea766d36a8935f,
    WebkitFilter: (0, $e2760e85319de2df$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $1d10ecb8b84625e9$export$67d1babe0338d23b = (key)=>$1d10ecb8b84625e9$export$98cd7c72c5a731fb[key];


function $24e5be6a11176d21$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $1d10ecb8b84625e9$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $e2760e85319de2df$export$3dea766d36a8935f)) defaultValueType = (0, $cb497529768be9f4$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $00961e60248a0117$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $00961e60248a0117$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$00961e60248a0117$var$invalidTemplates.has(keyframe) && (0, $cb497529768be9f4$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $24e5be6a11176d21$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $1bb5103377bd9ff4$export$4983792d11b61017 extends (0, $2e1a8a256a2f4570$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $eca7cd7daa2f203d$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $412b9befea7621d5$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $7b2a9048a17303ee$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $1f8533aa7b5b7539$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $1f8533aa7b5b7539$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $7b2a9048a17303ee$export$8e5250d1aa9bf370)(originType) && (0, $7b2a9048a17303ee$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $fcd8341c7cc93199$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $00961e60248a0117$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $7b2a9048a17303ee$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $7b2a9048a17303ee$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}




function $daeac1d30f06680c$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}




let $39e3972fc0251128$var$now;
function $39e3972fc0251128$var$clearTime() {
    $39e3972fc0251128$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $39e3972fc0251128$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($39e3972fc0251128$var$now === undefined) $39e3972fc0251128$export$2da9be4cfdb689b1.set((0, $f4b7678cda54e417$export$fff89137e9e818ce).isProcessing || (0, $677ceb8a81976a74$export$dd826089e3c5e502).useManualTiming ? (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp : performance.now());
        return $39e3972fc0251128$var$now;
    },
    set: (newTime)=>{
        $39e3972fc0251128$var$now = newTime;
        queueMicrotask($39e3972fc0251128$var$clearTime);
    }
};







/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $616fb9f026347e2f$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $cb497529768be9f4$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $f39609ff86209a73$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $f39609ff86209a73$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $616fb9f026347e2f$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $616fb9f026347e2f$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $06304b9683179beb$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $f39609ff86209a73$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $daeac1d30f06680c$export$6ab7812f1bac68be)(type)) && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $e4e52a2563c22e1c$var$MAX_RESOLVE_DELAY = 40;
class $e4e52a2563c22e1c$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $e4e52a2563c22e1c$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $2e1a8a256a2f4570$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $f39609ff86209a73$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $aeab7bb04c87c30f$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $f9c07df6f399fadf$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $d640842db8ae7ecd$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $c7c32befcc60f29e$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $efb38300354eaef2$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $8f59ca5bc89dfdd0$var$velocitySampleDuration = 5; // ms
function $8f59ca5bc89dfdd0$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $8f59ca5bc89dfdd0$var$velocitySampleDuration, 0);
    return (0, $efb38300354eaef2$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $bfe0113ab0f83af4$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};


const $661d4eda6bf78645$var$safeMin = 0.001;
function $661d4eda6bf78645$export$b15f158dc6d6f458({ duration: duration = (0, $bfe0113ab0f83af4$export$86436497e7b05d16).duration, bounce: bounce = (0, $bfe0113ab0f83af4$export$86436497e7b05d16).bounce, velocity: velocity = (0, $bfe0113ab0f83af4$export$86436497e7b05d16).velocity, mass: mass = (0, $bfe0113ab0f83af4$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $06304b9683179beb$export$491112666e282270)(duration <= (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)((0, $bfe0113ab0f83af4$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)((0, $bfe0113ab0f83af4$export$86436497e7b05d16).minDamping, (0, $bfe0113ab0f83af4$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)((0, $bfe0113ab0f83af4$export$86436497e7b05d16).minDuration, (0, $bfe0113ab0f83af4$export$86436497e7b05d16).maxDuration, (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $661d4eda6bf78645$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $661d4eda6bf78645$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $661d4eda6bf78645$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $661d4eda6bf78645$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$661d4eda6bf78645$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $661d4eda6bf78645$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).stiffness,
        damping: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $661d4eda6bf78645$var$rootIterations = 12;
function $661d4eda6bf78645$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $661d4eda6bf78645$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $661d4eda6bf78645$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $d6cc8f88fab19b6e$export$f4ff70a5b4808fd8 = 20000;
function $d6cc8f88fab19b6e$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $d6cc8f88fab19b6e$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $d6cc8f88fab19b6e$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




const $213f6b9aaf6a36bc$var$durationKeys = [
    "duration",
    "bounce"
];
const $213f6b9aaf6a36bc$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $213f6b9aaf6a36bc$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $213f6b9aaf6a36bc$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).velocity,
        stiffness: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).stiffness,
        damping: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).damping,
        mass: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$213f6b9aaf6a36bc$var$isSpringType(options, $213f6b9aaf6a36bc$var$physicsKeys) && $213f6b9aaf6a36bc$var$isSpringType(options, $213f6b9aaf6a36bc$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - options.bounce) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $661d4eda6bf78645$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $bfe0113ab0f83af4$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $213f6b9aaf6a36bc$export$b36281d89752ae66(optionsOrVisualDuration = (0, $bfe0113ab0f83af4$export$86436497e7b05d16).visualDuration, bounce = (0, $bfe0113ab0f83af4$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $213f6b9aaf6a36bc$var$getSpringOptions({
        ...options,
        velocity: -(0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $bfe0113ab0f83af4$export$86436497e7b05d16).restSpeed.granular : (0, $bfe0113ab0f83af4$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $bfe0113ab0f83af4$export$86436497e7b05d16).restDelta.granular : (0, $bfe0113ab0f83af4$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $661d4eda6bf78645$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $8f59ca5bc89dfdd0$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $d6cc8f88fab19b6e$export$cbdd6b3d40ea54e2)(generator), (0, $d6cc8f88fab19b6e$export$f4ff70a5b4808fd8));
            const easing = (0, $c7c32befcc60f29e$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}




function $dbddc57ba5f3846a$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $213f6b9aaf6a36bc$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $8f59ca5bc89dfdd0$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $8a3b4aca01359a5c$export$929e5a82286172a6 = /*@__PURE__*/ (0, $95241440d244608f$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $8a3b4aca01359a5c$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $95241440d244608f$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $8a3b4aca01359a5c$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $95241440d244608f$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $e1b1f19bb68401bb$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};









const $a8409c975f3cc95e$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $0517924f86f5984e$var$easingLookup = {
    linear: (0, $e3cb7a0786fb85a0$export$8793edee2d425525),
    easeIn: $8a3b4aca01359a5c$export$929e5a82286172a6,
    easeInOut: $8a3b4aca01359a5c$export$c07234257a03d5e9,
    easeOut: $8a3b4aca01359a5c$export$57636bb43b1ccbb0,
    circIn: $46ff946ce3fc4d37$export$e444123e42d03385,
    circInOut: $46ff946ce3fc4d37$export$30d3455eee55bed5,
    circOut: $46ff946ce3fc4d37$export$c8d67a19199d1a50,
    backIn: $42fc32190c1adfee$export$b01116c84cdfe1a2,
    backInOut: $42fc32190c1adfee$export$ddc5fd596f6c71b2,
    backOut: $42fc32190c1adfee$export$77edfce482316a60,
    anticipate: $c5d376adea09b745$export$6b0af63b873d419e
};
const $0517924f86f5984e$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $a8409c975f3cc95e$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $06304b9683179beb$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $95241440d244608f$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $06304b9683179beb$export$f5708dca728d7177)($0517924f86f5984e$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $0517924f86f5984e$var$easingLookup[definition];
    }
    return definition;
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $47eb4902933aeeba$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $47eb4902933aeeba$export$a4627e546088548d = (...transformers)=>transformers.reduce($47eb4902933aeeba$var$combineFunctions);




/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $0245bb99118c6d08$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $92b1ae16df42ade0$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $92b1ae16df42ade0$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $92b1ae16df42ade0$var$hueToRgb(p, q, hue + 1 / 3);
        green = $92b1ae16df42ade0$var$hueToRgb(p, q, hue);
        blue = $92b1ae16df42ade0$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $14c7a9c4f65ac8e1$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $eef3e79ec15fad3b$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $eef3e79ec15fad3b$var$colorTypes = [
    (0, $fa91941c0e81bfd4$export$834dfc94dde4b3d8),
    (0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b),
    (0, $24dfb57568118e7b$export$810b04175080204c)
];
const $eef3e79ec15fad3b$var$getColorType = (v)=>$eef3e79ec15fad3b$var$colorTypes.find((type)=>type.test(v));
function $eef3e79ec15fad3b$var$asRGBA(color) {
    const type = $eef3e79ec15fad3b$var$getColorType(color);
    (0, $06304b9683179beb$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $24dfb57568118e7b$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $92b1ae16df42ade0$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $eef3e79ec15fad3b$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $eef3e79ec15fad3b$var$asRGBA(from);
    const toRGBA = $eef3e79ec15fad3b$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $14c7a9c4f65ac8e1$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $eef3e79ec15fad3b$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $eef3e79ec15fad3b$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $eef3e79ec15fad3b$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $2aac7c727f563ba9$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $64f0e92bca687fd7$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $64f0e92bca687fd7$export$fed62ccc3fb1a568(origin, target) {
    if ($64f0e92bca687fd7$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $7a5dfe0f4d2b402d$var$mixNumber(a, b) {
    return (p)=>(0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $7a5dfe0f4d2b402d$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $7a5dfe0f4d2b402d$var$mixNumber;
    else if (typeof a === "string") return (0, $eca7cd7daa2f203d$export$31f9caa2600b5723)(a) ? (0, $14c7a9c4f65ac8e1$export$a6f92d4bae65c0f1) : (0, $a58c15eb6a659bc0$export$35e9368ef982300f).test(a) ? (0, $eef3e79ec15fad3b$export$51e568cf5c039bac) : $7a5dfe0f4d2b402d$export$65516310a87d8205;
    else if (Array.isArray(a)) return $7a5dfe0f4d2b402d$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $a58c15eb6a659bc0$export$35e9368ef982300f).test(a) ? (0, $eef3e79ec15fad3b$export$51e568cf5c039bac) : $7a5dfe0f4d2b402d$export$ebc23b6840c51ba1;
    return 0, $14c7a9c4f65ac8e1$export$a6f92d4bae65c0f1;
}
function $7a5dfe0f4d2b402d$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$7a5dfe0f4d2b402d$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $7a5dfe0f4d2b402d$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $7a5dfe0f4d2b402d$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $7a5dfe0f4d2b402d$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $7a5dfe0f4d2b402d$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $cb497529768be9f4$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $cb497529768be9f4$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $cb497529768be9f4$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $64f0e92bca687fd7$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $64f0e92bca687fd7$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $64f0e92bca687fd7$export$fed62ccc3fb1a568)(origin, target);
        return (0, $47eb4902933aeeba$export$a4627e546088548d)($7a5dfe0f4d2b402d$export$3bbefa2f402845c4($7a5dfe0f4d2b402d$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $06304b9683179beb$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $14c7a9c4f65ac8e1$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $764bee35a88d339d$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $7a5dfe0f4d2b402d$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $1f22497ec9267891$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $764bee35a88d339d$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $e3cb7a0786fb85a0$export$8793edee2d425525) : ease;
            mixer = (0, $47eb4902933aeeba$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $1f22497ec9267891$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $06304b9683179beb$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $1f22497ec9267891$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $952e38f368131131$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $2eee6ddf3c7f5b25$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $952e38f368131131$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $cc14d0f260104c6d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $db78e32c36f14628$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $8a3b4aca01359a5c$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $db78e32c36f14628$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $e1b1f19bb68401bb$export$216948827bbdc797)(ease) ? ease.map((0, $0517924f86f5984e$export$ef97fe084f156ca4)) : (0, $0517924f86f5984e$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $cc14d0f260104c6d$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $2eee6ddf3c7f5b25$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $1f22497ec9267891$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $db78e32c36f14628$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}











const $60cb483839cf9e15$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $f4b7678cda54e417$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $f4b7678cda54e417$export$fff89137e9e818ce).isProcessing ? (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp : (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now()
    };
};




const $8ca475bb5b1984b5$var$generators = {
    decay: (0, $dbddc57ba5f3846a$export$ee3ff3a17106998),
    inertia: $dbddc57ba5f3846a$export$ee3ff3a17106998,
    tween: (0, $db78e32c36f14628$export$d25ddfdf17c3ad3e),
    keyframes: (0, $db78e32c36f14628$export$d25ddfdf17c3ad3e),
    spring: $213f6b9aaf6a36bc$export$b36281d89752ae66
};
const $8ca475bb5b1984b5$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $8ca475bb5b1984b5$export$fd98d9cca67a58bc extends (0, $e4e52a2563c22e1c$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $2e1a8a256a2f4570$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $daeac1d30f06680c$export$6ab7812f1bac68be)(type) ? type : $8ca475bb5b1984b5$var$generators[type] || (0, $db78e32c36f14628$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $db78e32c36f14628$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $47eb4902933aeeba$export$a4627e546088548d)($8ca475bb5b1984b5$var$percentToProgress, (0, $764bee35a88d339d$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $d6cc8f88fab19b6e$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $f9c07df6f399fadf$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $60cb483839cf9e15$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $8ca475bb5b1984b5$export$ee9b76de7353d815(options) {
    return new $8ca475bb5b1984b5$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $1ca5104d5bc6ea4d$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




function $19880b06ac4fc713$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $9ff50e339768e142$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $8699c937652f5b68$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $19880b06ac4fc713$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $9ff50e339768e142$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $2ce2a9fd39511b47$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $8699c937652f5b68$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


function $70b2b3b06b1b881a$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $2ce2a9fd39511b47$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $70b2b3b06b1b881a$export$2cf569f5e2221176 || (0, $2ce2a9fd39511b47$export$866c1d07a1ac2ab)()) || (0, $a8409c975f3cc95e$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($70b2b3b06b1b881a$export$fcdd8f3f2160beda));
}
const $70b2b3b06b1b881a$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $70b2b3b06b1b881a$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $70b2b3b06b1b881a$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $70b2b3b06b1b881a$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $70b2b3b06b1b881a$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $70b2b3b06b1b881a$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $70b2b3b06b1b881a$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $2ce2a9fd39511b47$export$866c1d07a1ac2ab)()) return (0, $c7c32befcc60f29e$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $a8409c975f3cc95e$export$ff43f99925d7366b)(easing)) return $70b2b3b06b1b881a$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$70b2b3b06b1b881a$export$916ea73bcd3a6030(segmentEasing, duration) || $70b2b3b06b1b881a$export$2cf569f5e2221176.easeOut);
    else return $70b2b3b06b1b881a$export$2cf569f5e2221176[easing];
}


function $8e7621712e9c1530$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $70b2b3b06b1b881a$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $a64227efd99bacc3$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}





const $86b39df19c42871d$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $19880b06ac4fc713$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $ad9144b77acc2d26$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $ad9144b77acc2d26$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $ad9144b77acc2d26$var$requiresPregeneratedKeyframes(options) {
    return (0, $daeac1d30f06680c$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $70b2b3b06b1b881a$export$fcdd8f3f2160beda)(options.ease);
}
function $ad9144b77acc2d26$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $8ca475bb5b1984b5$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $ad9144b77acc2d26$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $ad9144b77acc2d26$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $ad9144b77acc2d26$var$sampleDelta,
        ease: "linear"
    };
}
const $ad9144b77acc2d26$var$unsupportedEasingFunctions = {
    anticipate: $c5d376adea09b745$export$6b0af63b873d419e,
    backInOut: $42fc32190c1adfee$export$ddc5fd596f6c71b2,
    circInOut: $46ff946ce3fc4d37$export$30d3455eee55bed5
};
function $ad9144b77acc2d26$var$isUnsupportedEase(key) {
    return key in $ad9144b77acc2d26$var$unsupportedEasingFunctions;
}
class $ad9144b77acc2d26$export$2a45abb4e6513325 extends (0, $e4e52a2563c22e1c$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $1bb5103377bd9ff4$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $2ce2a9fd39511b47$export$866c1d07a1ac2ab)() && $ad9144b77acc2d26$var$isUnsupportedEase(ease)) ease = $ad9144b77acc2d26$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($ad9144b77acc2d26$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $ad9144b77acc2d26$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $8e7621712e9c1530$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $a64227efd99bacc3$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $f9c07df6f399fadf$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $e3cb7a0786fb85a0$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $a64227efd99bacc3$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $e3cb7a0786fb85a0$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $8ca475bb5b1984b5$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $ad9144b77acc2d26$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $ad9144b77acc2d26$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return (0, $86b39df19c42871d$export$51ea9b46fb7a8c5d)() && name && (0, $1ca5104d5bc6ea4d$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




const $80d8f4d6e67acda6$export$20d68f04f30763a5 = (0, $19880b06ac4fc713$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $1db1b0191f772c6d$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $80d8f4d6e67acda6$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ef5e38bb715f0a8e$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $cbe55c6823b7435d$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $1475c271f914e0a2$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $ef5e38bb715f0a8e$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $f6338b7f7a58f33f$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $aeab7bb04c87c30f$export$888a3d84909f9e3d).current || (0, $677ceb8a81976a74$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $f9c07df6f399fadf$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $f4b7678cda54e417$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $1db1b0191f772c6d$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $ad9144b77acc2d26$export$2a45abb4e6513325).supports(options)) return new (0, $ad9144b77acc2d26$export$2a45abb4e6513325)(options);
        else return new (0, $8ca475bb5b1984b5$export$fd98d9cca67a58bc)(options);
    };



const $a02270f55ca51f0b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $a02270f55ca51f0b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $c28129a2fcdfd85f$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $45a95db56da9af08$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $45a95db56da9af08$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $45a95db56da9af08$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $e9341638631146bc$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $45a95db56da9af08$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $45a95db56da9af08$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $bd3a97a3202cbe66$var$MAX_VELOCITY_DELTA = 30;
const $bd3a97a3202cbe66$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $bd3a97a3202cbe66$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $bd3a97a3202cbe66$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.12.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $bd3a97a3202cbe66$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $e9341638631146bc$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $f4b7678cda54e417$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($bd3a97a3202cbe66$export$67fcd818a264039d.current) $bd3a97a3202cbe66$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $bd3a97a3202cbe66$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $bd3a97a3202cbe66$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $efb38300354eaef2$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $bd3a97a3202cbe66$export$ce8bdc721e76545f(init, options) {
    return new $bd3a97a3202cbe66$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $06d1661d0da5f347$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $bd3a97a3202cbe66$export$ce8bdc721e76545f)(value));
}
function $06d1661d0da5f347$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $b6bbede3a032af0c$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $a02270f55ca51f0b$export$5485128c47bd48bb)(target[key]);
        $06d1661d0da5f347$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $9b74efc8ade54cc6$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $7bb4541a74605791$export$ed7b8fa9dbf0105d = "framerAppearId";
const $7bb4541a74605791$export$8592e1c077c890a6 = "data-" + (0, $9b74efc8ade54cc6$export$9fd24a634729c672)($7bb4541a74605791$export$ed7b8fa9dbf0105d);


function $0dd174e75ffa479a$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $7bb4541a74605791$export$8592e1c077c890a6];
}


const $ae4ea0ff5eccee3a$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $3d1d44ca26acad89$export$98397f3adbf6259f(value) {
    return Boolean((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(value) && value.add);
}


function $e4d59c87cc7a73b8$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $3d1d44ca26acad89$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $783a78e7c86840b7$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $783a78e7c86840b7$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $783a78e7c86840b7$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $1475c271f914e0a2$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $0dd174e75ffa479a$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $f4b7678cda54e417$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $e4d59c87cc7a73b8$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $cbe55c6823b7435d$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $7a2459a153995169$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $f4b7678cda54e417$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $06d1661d0da5f347$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $37a3043c08dee7c8$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $b6bbede3a032af0c$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $783a78e7c86840b7$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $37a3043c08dee7c8$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $37a3043c08dee7c8$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($37a3043c08dee7c8$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($37a3043c08dee7c8$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $37a3043c08dee7c8$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $5192a6226ea2295a$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $37a3043c08dee7c8$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $37a3043c08dee7c8$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $b6bbede3a032af0c$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $783a78e7c86840b7$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $b1c4e1282a99df4b$var$numVariantProps = (0, $4d383567546b00bb$export$1405a65085f40b9).length;
function $b1c4e1282a99df4b$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $b1c4e1282a99df4b$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $b1c4e1282a99df4b$var$numVariantProps; i++){
        const name = (0, $4d383567546b00bb$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $5df4f1e8f75ff142$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $761322ce183c9482$var$reversePriorityOrder = [
    ...(0, $4d383567546b00bb$export$16e45afcc206d3a8)
].reverse();
const $761322ce183c9482$var$numAnimationTypes = (0, $4d383567546b00bb$export$16e45afcc206d3a8).length;
function $761322ce183c9482$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $5192a6226ea2295a$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $761322ce183c9482$export$bb53502b7a672aa8(visualElement) {
    let animate = $761322ce183c9482$var$animateList(visualElement);
    let state = $761322ce183c9482$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $b6bbede3a032af0c$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $b1c4e1282a99df4b$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $761322ce183c9482$var$numAnimationTypes; i++){
            const type = $761322ce183c9482$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $5df4f1e8f75ff142$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $3d98cdcd9e935c82$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $761322ce183c9482$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $c28129a2fcdfd85f$export$9153ad4c4999f4a0)(next) && (0, $c28129a2fcdfd85f$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $7be065c85343317e$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $761322ce183c9482$var$createState();
            isInitialRender = true;
        }
    };
}
function $761322ce183c9482$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $7be065c85343317e$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $761322ce183c9482$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $761322ce183c9482$var$createState() {
    return {
        animate: $761322ce183c9482$var$createTypeState(true),
        whileInView: $761322ce183c9482$var$createTypeState(),
        whileHover: $761322ce183c9482$var$createTypeState(),
        whileTap: $761322ce183c9482$var$createTypeState(),
        whileDrag: $761322ce183c9482$var$createTypeState(),
        whileFocus: $761322ce183c9482$var$createTypeState(),
        exit: $761322ce183c9482$var$createTypeState()
    };
}


class $82475d8a5717da4f$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $18eac9d9bd9668ed$export$b45b3fe5caabdca extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $761322ce183c9482$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $3d98cdcd9e935c82$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $b9a20f9b346fc0d1$var$id = 0;
class $b9a20f9b346fc0d1$export$4989d1eb6104cc6c extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $b9a20f9b346fc0d1$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $dac8efd164150afe$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $18eac9d9bd9668ed$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $b9a20f9b346fc0d1$export$4989d1eb6104cc6c)
    }
};





const $8e5b5a158bd14e55$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $efd86900444fb483$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $efd86900444fb483$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $8e5b5a158bd14e55$export$a4cf9c8a4b063a6e)(event) && handler(event, $efd86900444fb483$export$12f84bb882d06e1a(event));
};



function $0a1ac4f0361f34ba$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $d1e5d1e0a68a11c6$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(target, eventName, (0, $efd86900444fb483$export$c404e80f92c98d29)(handler), options);
}



const $3732d07f8f971ec2$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $3732d07f8f971ec2$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $3732d07f8f971ec2$export$9f17032d917177de(a.x, b.x);
    const yDelta = $3732d07f8f971ec2$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $024724f8fbf2e05c$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $024724f8fbf2e05c$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $3732d07f8f971ec2$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $f4b7678cda54e417$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $024724f8fbf2e05c$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $f4b7678cda54e417$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $024724f8fbf2e05c$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $024724f8fbf2e05c$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $8e5b5a158bd14e55$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $efd86900444fb483$export$12f84bb882d06e1a)(event);
        const initialInfo = $024724f8fbf2e05c$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $f4b7678cda54e417$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $024724f8fbf2e05c$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $47eb4902933aeeba$export$a4627e546088548d)((0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $024724f8fbf2e05c$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $024724f8fbf2e05c$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $024724f8fbf2e05c$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $024724f8fbf2e05c$var$subtractPoint(point, $024724f8fbf2e05c$var$lastDevicePoint(history)),
        offset: $024724f8fbf2e05c$var$subtractPoint(point, $024724f8fbf2e05c$var$startDevicePoint(history)),
        velocity: $024724f8fbf2e05c$var$getVelocity(history, 0.1)
    };
}
function $024724f8fbf2e05c$var$startDevicePoint(history) {
    return history[0];
}
function $024724f8fbf2e05c$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $024724f8fbf2e05c$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $024724f8fbf2e05c$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $2775257601283e84$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $2775257601283e84$var$globalHorizontalLock = $2775257601283e84$export$518c5fc2dcb7974b("dragHorizontal");
const $2775257601283e84$var$globalVerticalLock = $2775257601283e84$export$518c5fc2dcb7974b("dragVertical");
function $2775257601283e84$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $2775257601283e84$var$globalVerticalLock();
    else if (drag === "x") lock = $2775257601283e84$var$globalHorizontalLock();
    else {
        const openHorizontal = $2775257601283e84$var$globalHorizontalLock();
        const openVertical = $2775257601283e84$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $2775257601283e84$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $2775257601283e84$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $7aa8008e1e27cc21$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $e29f6157615280b5$var$SCALE_PRECISION = 0.0001;
const $e29f6157615280b5$var$SCALE_MIN = 1 - $e29f6157615280b5$var$SCALE_PRECISION;
const $e29f6157615280b5$var$SCALE_MAX = 1 + $e29f6157615280b5$var$SCALE_PRECISION;
const $e29f6157615280b5$var$TRANSLATE_PRECISION = 0.01;
const $e29f6157615280b5$var$TRANSLATE_MIN = 0 - $e29f6157615280b5$var$TRANSLATE_PRECISION;
const $e29f6157615280b5$var$TRANSLATE_MAX = 0 + $e29f6157615280b5$var$TRANSLATE_PRECISION;
function $e29f6157615280b5$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $e29f6157615280b5$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $e29f6157615280b5$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $e29f6157615280b5$export$c1c127004b72a37(target) / $e29f6157615280b5$export$c1c127004b72a37(source);
    delta.translate = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $e29f6157615280b5$var$SCALE_MIN && delta.scale <= $e29f6157615280b5$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $e29f6157615280b5$var$TRANSLATE_MIN && delta.translate <= $e29f6157615280b5$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $e29f6157615280b5$export$c0d25e96fc67d310(delta, source, target, origin) {
    $e29f6157615280b5$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $e29f6157615280b5$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $e29f6157615280b5$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $e29f6157615280b5$export$c1c127004b72a37(relative);
}
function $e29f6157615280b5$export$426154f9d100f99(target, relative, parent) {
    $e29f6157615280b5$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $e29f6157615280b5$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $e29f6157615280b5$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $e29f6157615280b5$export$c1c127004b72a37(layout);
}
function $e29f6157615280b5$export$2785bfcc929c5650(target, layout, parent) {
    $e29f6157615280b5$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $e29f6157615280b5$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $f088fa1086963306$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $f088fa1086963306$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $f088fa1086963306$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $f088fa1086963306$export$690c180aa5775042(layoutBox.x, left, right),
        y: $f088fa1086963306$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $f088fa1086963306$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $f088fa1086963306$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $f088fa1086963306$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $f088fa1086963306$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $f088fa1086963306$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $e29f6157615280b5$export$c1c127004b72a37)(source);
    const targetLength = (0, $e29f6157615280b5$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $f088fa1086963306$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $f088fa1086963306$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $f088fa1086963306$export$7c5eaef8f4723d22(dragElastic = $f088fa1086963306$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $f088fa1086963306$export$a3366d3bac43a742;
    return {
        x: $f088fa1086963306$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $f088fa1086963306$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $f088fa1086963306$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $f088fa1086963306$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $f088fa1086963306$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $f088fa1086963306$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $9f7f517a75b835d9$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $9f7f517a75b835d9$export$3d227df54007d73a = ()=>({
        x: $9f7f517a75b835d9$export$ff25708b37f72782(),
        y: $9f7f517a75b835d9$export$ff25708b37f72782()
    });
const $9f7f517a75b835d9$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $9f7f517a75b835d9$export$6459fc9e86be362e = ()=>({
        x: $9f7f517a75b835d9$export$6db76765312617ac(),
        y: $9f7f517a75b835d9$export$6db76765312617ac()
    });


function $ea8be9af2a8e54ff$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $ab8b7504c9f173d4$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $ab8b7504c9f173d4$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $ab8b7504c9f173d4$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $86aa8bfeeba567b3$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $86aa8bfeeba567b3$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$86aa8bfeeba567b3$var$isIdentityScale(scale) || !$86aa8bfeeba567b3$var$isIdentityScale(scaleX) || !$86aa8bfeeba567b3$var$isIdentityScale(scaleY);
}
function $86aa8bfeeba567b3$export$a545127cf1fbb600(values) {
    return $86aa8bfeeba567b3$export$bdf30dca883ea463(values) || $86aa8bfeeba567b3$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $86aa8bfeeba567b3$export$bf80f5f8f4dc327f(values) {
    return $86aa8bfeeba567b3$var$is2DTranslate(values.x) || $86aa8bfeeba567b3$var$is2DTranslate(values.y);
}
function $86aa8bfeeba567b3$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $9dc03dd4f0a3d153$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $9dc03dd4f0a3d153$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $9dc03dd4f0a3d153$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $9dc03dd4f0a3d153$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $9dc03dd4f0a3d153$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $9dc03dd4f0a3d153$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $9dc03dd4f0a3d153$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $9dc03dd4f0a3d153$export$d80074982803af5c(box, { x: x, y: y }) {
    $9dc03dd4f0a3d153$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $9dc03dd4f0a3d153$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $9dc03dd4f0a3d153$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $9dc03dd4f0a3d153$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $9dc03dd4f0a3d153$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $9dc03dd4f0a3d153$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $9dc03dd4f0a3d153$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(node.latestValues)) $9dc03dd4f0a3d153$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $9dc03dd4f0a3d153$var$TREE_SCALE_SNAP_MAX && treeScale.x > $9dc03dd4f0a3d153$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $9dc03dd4f0a3d153$var$TREE_SCALE_SNAP_MAX && treeScale.y > $9dc03dd4f0a3d153$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $9dc03dd4f0a3d153$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $9dc03dd4f0a3d153$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $9dc03dd4f0a3d153$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $9dc03dd4f0a3d153$export$58b16271041fbfb(box, transform) {
    $9dc03dd4f0a3d153$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $9dc03dd4f0a3d153$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $51e0326f61f3f2db$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $ab8b7504c9f173d4$export$d3955c6a8f65a36b)((0, $ab8b7504c9f173d4$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $51e0326f61f3f2db$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $51e0326f61f3f2db$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $9dc03dd4f0a3d153$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $9dc03dd4f0a3d153$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $868a52dedcabff67$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $298213aadc23fced$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $298213aadc23fced$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $efd86900444fb483$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $2775257601283e84$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $e29f6157615280b5$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $e4d59c87cc7a73b8$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $298213aadc23fced$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $024724f8fbf2e05c$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $868a52dedcabff67$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$298213aadc23fced$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $f088fa1086963306$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $7aa8008e1e27cc21$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $f088fa1086963306$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $f088fa1086963306$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $f088fa1086963306$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $7aa8008e1e27cc21$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $06304b9683179beb$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $51e0326f61f3f2db$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $f088fa1086963306$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $ab8b7504c9f173d4$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $ab8b7504c9f173d4$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            if (!$298213aadc23fced$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $e4d59c87cc7a73b8$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $cbe55c6823b7435d$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$298213aadc23fced$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $7aa8008e1e27cc21$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $f088fa1086963306$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            if (!$298213aadc23fced$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $298213aadc23fced$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $7aa8008e1e27cc21$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $f4b7678cda54e417$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $f088fa1086963306$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $298213aadc23fced$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $298213aadc23fced$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $a0d55596339d9beb$export$5d97dc2872682820 extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
        this.removeListeners = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
        this.controls = new (0, $298213aadc23fced$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $f1a6d4109fd9a31b$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $f1a6d4109fd9a31b$export$b4f8f1ee75ce5859 extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $024724f8fbf2e05c$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $868a52dedcabff67$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $f1a6d4109fd9a31b$var$asyncHandler(onPanSessionStart),
            onStart: $f1a6d4109fd9a31b$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $ajtHG = parcelRequire("ajtHG");

var $ajtHG = parcelRequire("ajtHG");

var $ajtHG = parcelRequire("ajtHG");
"use client";
/**
 * @public
 */ const $e325c24ea0a50a06$export$f224e4635b6f8ce2 = (0, $ajtHG.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $0461a0d48a628dce$export$2a8c16d82a0a0e26() {
    const context = (0, $ajtHG.useContext)((0, $e325c24ea0a50a06$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $ajtHG.useId)();
    (0, $ajtHG.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $ajtHG.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $0461a0d48a628dce$export$8249053f690ea39a() {
    return $0461a0d48a628dce$export$ee27c052bca048fb((0, $ajtHG.useContext)((0, $e325c24ea0a50a06$export$f224e4635b6f8ce2)));
}
function $0461a0d48a628dce$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $ajtHG = parcelRequire("ajtHG");
"use client";
const $57855d678d276da3$export$a3579ca508007a95 = (0, $ajtHG.createContext)({});



var $ajtHG = parcelRequire("ajtHG");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $ce84c4cc5cb54fdb$export$da5f7b802957459a = (0, $ajtHG.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $a950addc44919b14$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $1c7d5479d05821fe$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $1c7d5479d05821fe$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $1c7d5479d05821fe$export$fafff692be55225d(latest, node.target.x);
        const y = $1c7d5479d05821fe$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $1f0c767a17f9026e$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $cb497529768be9f4$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $cb497529768be9f4$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $e1239f430d6b09ed$export$91ddd985b97788d1 = {};
function $e1239f430d6b09ed$export$de9e7791c71225fd(correctors) {
    Object.assign($e1239f430d6b09ed$export$91ddd985b97788d1, correctors);
}



const { schedule: $9cb14334e6ef22de$export$bb76eed83315504c, cancel: $9cb14334e6ef22de$export$3252729004b8456e } = (0, $7d1c6bfe2b9686d8$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $b0f274fd36dfdab3$var$MeasureLayoutWithContext extends (0, $ajtHG.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $e1239f430d6b09ed$export$de9e7791c71225fd)($b0f274fd36dfdab3$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $a950addc44919b14$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $9cb14334e6ef22de$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $b0f274fd36dfdab3$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $0461a0d48a628dce$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $ajtHG.useContext)((0, $57855d678d276da3$export$a3579ca508007a95));
    return (0, $9b3c114f2ec1a7b9$exports.jsx)($b0f274fd36dfdab3$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $ajtHG.useContext)((0, $ce84c4cc5cb54fdb$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $b0f274fd36dfdab3$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $1c7d5479d05821fe$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $1c7d5479d05821fe$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $1c7d5479d05821fe$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $1c7d5479d05821fe$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $1c7d5479d05821fe$export$5eafb6257a5844c),
    boxShadow: (0, $1f0c767a17f9026e$export$eb0bc629e74dcf8)
};








const $ec59db072cdcf4a8$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $ec59db072cdcf4a8$var$numBorders = $ec59db072cdcf4a8$var$borders.length;
const $ec59db072cdcf4a8$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $ec59db072cdcf4a8$var$isPx = (value)=>typeof value === "number" || (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008).test(value);
function $ec59db072cdcf4a8$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $ec59db072cdcf4a8$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $ec59db072cdcf4a8$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $ec59db072cdcf4a8$var$numBorders; i++){
        const borderLabel = `border${$ec59db072cdcf4a8$var$borders[i]}Radius`;
        let followRadius = $ec59db072cdcf4a8$var$getRadius(follow, borderLabel);
        let leadRadius = $ec59db072cdcf4a8$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $ec59db072cdcf4a8$var$isPx(followRadius) === $ec59db072cdcf4a8$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)($ec59db072cdcf4a8$var$asNumber(followRadius), $ec59db072cdcf4a8$var$asNumber(leadRadius), progress), 0);
            if ((0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de).test(leadRadius) || (0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $ec59db072cdcf4a8$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $ec59db072cdcf4a8$var$easeCrossfadeIn = /*@__PURE__*/ $ec59db072cdcf4a8$var$compress(0, 0.5, (0, $46ff946ce3fc4d37$export$c8d67a19199d1a50));
const $ec59db072cdcf4a8$var$easeCrossfadeOut = /*@__PURE__*/ $ec59db072cdcf4a8$var$compress(0.5, 0.95, (0, $e3cb7a0786fb85a0$export$8793edee2d425525));
function $ec59db072cdcf4a8$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a184539f25437722$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a184539f25437722$export$c53fd88f45d77e4b(box, originBox) {
    $a184539f25437722$export$a0230ae482601ae8(box.x, originBox.x);
    $a184539f25437722$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $a184539f25437722$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $7aae8a0f60af362d$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $9dc03dd4f0a3d153$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $9dc03dd4f0a3d153$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $7aae8a0f60af362d$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $8fbba1dc9f16e9ad$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $7aae8a0f60af362d$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $7aae8a0f60af362d$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $7aae8a0f60af362d$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $7aae8a0f60af362d$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $7aae8a0f60af362d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $7aae8a0f60af362d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $7aae8a0f60af362d$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $7aae8a0f60af362d$export$42b76f1d0d16d5b(box.x, transforms, $7aae8a0f60af362d$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $7aae8a0f60af362d$export$42b76f1d0d16d5b(box.y, transforms, $7aae8a0f60af362d$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $8670616d513a5fa1$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $8670616d513a5fa1$export$a7ec7642fe550fb6(delta) {
    return $8670616d513a5fa1$var$isAxisDeltaZero(delta.x) && $8670616d513a5fa1$var$isAxisDeltaZero(delta.y);
}
function $8670616d513a5fa1$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $8670616d513a5fa1$export$8d5cf76bb7daff09(a, b) {
    return $8670616d513a5fa1$export$7a9a6f114ddd0fdb(a.x, b.x) && $8670616d513a5fa1$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $8670616d513a5fa1$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $8670616d513a5fa1$export$ef641b782d85522(a, b) {
    return $8670616d513a5fa1$export$22adf28bfca1c186(a.x, b.x) && $8670616d513a5fa1$export$22adf28bfca1c186(a.y, b.y);
}
function $8670616d513a5fa1$export$c5706146bc63213(box) {
    return (0, $e29f6157615280b5$export$c1c127004b72a37)(box.x) / (0, $e29f6157615280b5$export$c1c127004b72a37)(box.y);
}
function $8670616d513a5fa1$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $0851c0f8bc801c59$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $45a95db56da9af08$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $45a95db56da9af08$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $c36d5a4a75822e78$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $fed0c2aff88c093b$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $3e60fa5060f820e3$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $45a95db56da9af08$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $45a95db56da9af08$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $fed0c2aff88c093b$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $3a1664cf67d64e40$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $a02270f55ca51f0b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






/**
 * Timeout defined in ms
 */ function $57081f9dd7b05b28$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $f4b7678cda54e417$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(checkElapsed);
}
function $57081f9dd7b05b28$export$fcd451ca460f8a2a(callback, timeout) {
    return $57081f9dd7b05b28$export$1391212d75b2ee65(callback, (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(timeout));
}



function $9acf87a958f1e041$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $b4eb7f7f0fb66ba3$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(value) ? value : (0, $bd3a97a3202cbe66$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $cbe55c6823b7435d$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $5b53e6253258fd84$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $5b53e6253258fd84$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $5b53e6253258fd84$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $5b53e6253258fd84$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $5b53e6253258fd84$var$animationTarget = 1000;
let $5b53e6253258fd84$var$id = 0;
function $5b53e6253258fd84$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $5b53e6253258fd84$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $0dd174e75ffa479a$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $f4b7678cda54e417$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $5b53e6253258fd84$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $5b53e6253258fd84$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $5b53e6253258fd84$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($5b53e6253258fd84$var$isDebug) $5b53e6253258fd84$var$metrics.totalNodes = $5b53e6253258fd84$var$metrics.resolvedTargetDeltas = $5b53e6253258fd84$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($5b53e6253258fd84$export$131f2f0cc5fe9609);
                this.nodes.forEach($5b53e6253258fd84$var$resolveTargetDelta);
                this.nodes.forEach($5b53e6253258fd84$var$calcProjection);
                this.nodes.forEach($5b53e6253258fd84$export$c2664f37bc951031);
                if ($5b53e6253258fd84$var$isDebug) window.MotionDebug.record($5b53e6253258fd84$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $3e60fa5060f820e3$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $e9341638631146bc$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $9acf87a958f1e041$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $57081f9dd7b05b28$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $a950addc44919b14$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $a950addc44919b14$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($5b53e6253258fd84$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $5b53e6253258fd84$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $8670616d513a5fa1$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $1475c271f914e0a2$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $5b53e6253258fd84$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($5b53e6253258fd84$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $5b53e6253258fd84$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($5b53e6253258fd84$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($5b53e6253258fd84$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($5b53e6253258fd84$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($5b53e6253258fd84$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($5b53e6253258fd84$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
            (0, $f4b7678cda54e417$export$fff89137e9e818ce).delta = (0, $c632ef8d0c8afa2e$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp);
            (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp = now;
            (0, $f4b7678cda54e417$export$fff89137e9e818ce).isProcessing = true;
            (0, $f4b7678cda54e417$export$1811c3a7e3af92f0).update.process((0, $f4b7678cda54e417$export$fff89137e9e818ce));
            (0, $f4b7678cda54e417$export$1811c3a7e3af92f0).preRender.process((0, $f4b7678cda54e417$export$fff89137e9e818ce));
            (0, $f4b7678cda54e417$export$1811c3a7e3af92f0).render.process((0, $f4b7678cda54e417$export$fff89137e9e818ce));
            (0, $f4b7678cda54e417$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $9cb14334e6ef22de$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($5b53e6253258fd84$var$clearSnapshot);
            this.sharedNodes.forEach($5b53e6253258fd84$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $f4b7678cda54e417$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $8670616d513a5fa1$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $5b53e6253258fd84$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($5b53e6253258fd84$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $9dc03dd4f0a3d153$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $9dc03dd4f0a3d153$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            (0, $a184539f25437722$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $a184539f25437722$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $9dc03dd4f0a3d153$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $9dc03dd4f0a3d153$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            (0, $a184539f25437722$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $9dc03dd4f0a3d153$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $9dc03dd4f0a3d153$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(this.latestValues)) (0, $9dc03dd4f0a3d153$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            (0, $a184539f25437722$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $86aa8bfeeba567b3$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $a184539f25437722$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $7aae8a0f60af362d$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(this.latestValues)) (0, $7aae8a0f60af362d$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    (0, $e29f6157615280b5$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $a184539f25437722$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $e29f6157615280b5$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $a184539f25437722$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $9dc03dd4f0a3d153$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $a184539f25437722$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    (0, $e29f6157615280b5$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $a184539f25437722$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($5b53e6253258fd84$var$isDebug) $5b53e6253258fd84$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $86aa8bfeeba567b3$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $86aa8bfeeba567b3$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $f4b7678cda54e417$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $a184539f25437722$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $9dc03dd4f0a3d153$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $a184539f25437722$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $a184539f25437722$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $e29f6157615280b5$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $8670616d513a5fa1$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $8670616d513a5fa1$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($5b53e6253258fd84$var$isDebug) $5b53e6253258fd84$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $9f7f517a75b835d9$export$3d227df54007d73a)();
            this.projectionDelta = (0, $9f7f517a75b835d9$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $9f7f517a75b835d9$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $9f7f517a75b835d9$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($5b53e6253258fd84$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $5b53e6253258fd84$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $5b53e6253258fd84$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $e29f6157615280b5$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $5b53e6253258fd84$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $8670616d513a5fa1$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    (0, $a184539f25437722$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $ec59db072cdcf4a8$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $f4b7678cda54e417$export$2cef06c20297c17d).update(()=>{
                (0, $a950addc44919b14$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $b4eb7f7f0fb66ba3$export$335a17c977067b99)(0, $5b53e6253258fd84$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($5b53e6253258fd84$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $5b53e6253258fd84$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                const xLength = (0, $e29f6157615280b5$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $e29f6157615280b5$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $a184539f25437722$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $9dc03dd4f0a3d153$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $e29f6157615280b5$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $0851c0f8bc801c59$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $5b53e6253258fd84$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $5b53e6253258fd84$var$transformAxes.length; i++){
                $5b53e6253258fd84$var$resetDistortingTransform(`rotate${$5b53e6253258fd84$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $5b53e6253258fd84$var$resetDistortingTransform(`skew${$5b53e6253258fd84$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $5b53e6253258fd84$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $3a1664cf67d64e40$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $3a1664cf67d64e40$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $86aa8bfeeba567b3$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $c36d5a4a75822e78$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $e1239f430d6b09ed$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $e1239f430d6b09ed$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $3a1664cf67d64e40$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($5b53e6253258fd84$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $5b53e6253258fd84$var$updateLayout(node) {
    node.updateLayout();
}
function $5b53e6253258fd84$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $e29f6157615280b5$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($5b53e6253258fd84$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $ea8be9af2a8e54ff$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $e29f6157615280b5$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $9f7f517a75b835d9$export$3d227df54007d73a)();
        (0, $e29f6157615280b5$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $9f7f517a75b835d9$export$3d227df54007d73a)();
        if (isShared) (0, $e29f6157615280b5$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $e29f6157615280b5$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $8670616d513a5fa1$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    (0, $e29f6157615280b5$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
                    (0, $e29f6157615280b5$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $8670616d513a5fa1$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $5b53e6253258fd84$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($5b53e6253258fd84$var$isDebug) $5b53e6253258fd84$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $5b53e6253258fd84$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $5b53e6253258fd84$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $5b53e6253258fd84$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $5b53e6253258fd84$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $5b53e6253258fd84$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $5b53e6253258fd84$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $5b53e6253258fd84$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $5b53e6253258fd84$var$calcProjection(node) {
    node.calcProjection();
}
function $5b53e6253258fd84$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $5b53e6253258fd84$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $5b53e6253258fd84$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $5b53e6253258fd84$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $5b53e6253258fd84$export$6ffd3e6ae339a132(output, from, to, p) {
    $5b53e6253258fd84$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $5b53e6253258fd84$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $5b53e6253258fd84$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $5b53e6253258fd84$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $5b53e6253258fd84$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $5b53e6253258fd84$var$roundPoint = $5b53e6253258fd84$var$userAgentContains("applewebkit/") && !$5b53e6253258fd84$var$userAgentContains("chrome/") ? Math.round : (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
function $5b53e6253258fd84$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $5b53e6253258fd84$var$roundPoint(axis.min);
    axis.max = $5b53e6253258fd84$var$roundPoint(axis.max);
}
function $5b53e6253258fd84$var$roundBox(box) {
    $5b53e6253258fd84$var$roundAxis(box.x);
    $5b53e6253258fd84$var$roundAxis(box.y);
}
function $5b53e6253258fd84$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $e29f6157615280b5$export$28d0384c4b79bde2)((0, $8670616d513a5fa1$export$c5706146bc63213)(snapshot), (0, $8670616d513a5fa1$export$c5706146bc63213)(layout), 0.2);
}
function $5b53e6253258fd84$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $fc34352c049ee571$export$2d029a49a09b6177 = (0, $5b53e6253258fd84$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $6d85dc00779a51c6$export$b91509fcf893b648 = {
    current: undefined
};
const $6d85dc00779a51c6$export$b61a9eb3dbde8858 = (0, $5b53e6253258fd84$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$6d85dc00779a51c6$export$b91509fcf893b648.current) {
            const documentNode = new (0, $fc34352c049ee571$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $6d85dc00779a51c6$export$b91509fcf893b648.current = documentNode;
        }
        return $6d85dc00779a51c6$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $5d18248758ce4b19$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $f1a6d4109fd9a31b$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $a0d55596339d9beb$export$5d97dc2872682820),
        ProjectionNode: (0, $6d85dc00779a51c6$export$b61a9eb3dbde8858),
        MeasureLayout: $b0f274fd36dfdab3$export$779f5fb01ad751cd
    }
};







function $7e1c5fb1c002f1a8$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $2775257601283e84$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $7e1c5fb1c002f1a8$export$93a81ea037eac456 extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $47eb4902933aeeba$export$a4627e546088548d)($7e1c5fb1c002f1a8$var$addHoverEvent(this.node, true), $7e1c5fb1c002f1a8$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $381633fec04b0a84$export$d4826db40d47595b extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $47eb4902933aeeba$export$a4627e546088548d)((0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $e144c31312bc3a9c$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $e144c31312bc3a9c$export$e841ada32ff745b(parent, child.parentElement);
};




function $3da1313efa2c4646$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $efd86900444fb483$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $3da1313efa2c4646$export$f026abdbba7f0c9e extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
        this.removeEndListeners = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $e3cb7a0786fb85a0$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $e144c31312bc3a9c$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $f4b7678cda54e417$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $47eb4902933aeeba$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $3da1313efa2c4646$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $3da1313efa2c4646$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $3da1313efa2c4646$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $47eb4902933aeeba$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $2775257601283e84$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $f4b7678cda54e417$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $d1e5d1e0a68a11c6$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $0a1ac4f0361f34ba$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $47eb4902933aeeba$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $ceed08f8b860b35d$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $ceed08f8b860b35d$var$observers = new WeakMap();
const $ceed08f8b860b35d$var$fireObserverCallback = (entry)=>{
    const callback = $ceed08f8b860b35d$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $ceed08f8b860b35d$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($ceed08f8b860b35d$var$fireObserverCallback);
};
function $ceed08f8b860b35d$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$ceed08f8b860b35d$var$observers.has(lookupRoot)) $ceed08f8b860b35d$var$observers.set(lookupRoot, {});
    const rootObservers = $ceed08f8b860b35d$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($ceed08f8b860b35d$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $ceed08f8b860b35d$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $ceed08f8b860b35d$var$initIntersectionObserver(options);
    $ceed08f8b860b35d$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $ceed08f8b860b35d$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $a82424444bb19a00$var$thresholdNames = {
    some: 0,
    all: 1
};
class $a82424444bb19a00$export$150851c8cc2f0c72 extends (0, $82475d8a5717da4f$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $a82424444bb19a00$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $ceed08f8b860b35d$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($a82424444bb19a00$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $a82424444bb19a00$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $65d5f5268fa118c9$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $a82424444bb19a00$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $3da1313efa2c4646$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $381633fec04b0a84$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $7e1c5fb1c002f1a8$export$93a81ea037eac456)
    }
};




const $9d0ad75fcf62702c$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $6d85dc00779a51c6$export$b61a9eb3dbde8858),
        MeasureLayout: $b0f274fd36dfdab3$export$779f5fb01ad751cd
    }
};




var $ajtHG = parcelRequire("ajtHG");

var $ajtHG = parcelRequire("ajtHG");
"use client";
/**
 * @public
 */ const $ae991a58cddf687f$export$22a697fb29aac98d = (0, $ajtHG.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $ajtHG = parcelRequire("ajtHG");
"use client";
const $dce7a09533ada423$export$2285bbca2c666415 = (0, $ajtHG.createContext)({});



var $ajtHG = parcelRequire("ajtHG");



var $ajtHG = parcelRequire("ajtHG");
const $bcd55e478a15cc19$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $d5749960abfed972$export$700979bc83e7db82 = (0, $bcd55e478a15cc19$export$4e09c449d6c407f7) ? (0, $ajtHG.useLayoutEffect) : (0, $ajtHG.useEffect);



var $ajtHG = parcelRequire("ajtHG");
"use client";
const $d0718a87e1fcb0e8$export$40f10139ecf1f171 = (0, $ajtHG.createContext)({
    strict: false
});







function $e6fd333702ec7348$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $ajtHG.useContext)((0, $dce7a09533ada423$export$2285bbca2c666415));
    const lazyContext = (0, $ajtHG.useContext)((0, $d0718a87e1fcb0e8$export$40f10139ecf1f171));
    const presenceContext = (0, $ajtHG.useContext)((0, $e325c24ea0a50a06$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $ajtHG.useContext)((0, $ae991a58cddf687f$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $ajtHG.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $ajtHG.useContext)((0, $ce84c4cc5cb54fdb$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $e6fd333702ec7348$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $ajtHG.useRef)(false);
    (0, $ajtHG.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $7bb4541a74605791$export$8592e1c077c890a6];
    const wantsHandoff = (0, $ajtHG.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $d5749960abfed972$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $9cb14334e6ef22de$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $ajtHG.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $e6fd333702ec7348$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $e6fd333702ec7348$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $7aa8008e1e27cc21$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $e6fd333702ec7348$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $e6fd333702ec7348$var$getClosestProjectingNode(visualElement.parent);
}



var $ajtHG = parcelRequire("ajtHG");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $96d171966b4406e4$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $ajtHG.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $7aa8008e1e27cc21$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $ajtHG = parcelRequire("ajtHG");





function $39824dc970dd0fd4$export$4b3c3bd8d910d78d(props) {
    return (0, $3d98cdcd9e935c82$export$aa71198ceeaf53ce)(props.animate) || (0, $4d383567546b00bb$export$1405a65085f40b9).some((name)=>(0, $5df4f1e8f75ff142$export$720b90e312cea233)(props[name]));
}
function $39824dc970dd0fd4$export$ce46fa4165cdec40(props) {
    return Boolean($39824dc970dd0fd4$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $0a177963a80d9388$export$12fc32fc096a04a3(props, context) {
    if ((0, $39824dc970dd0fd4$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $5df4f1e8f75ff142$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $5df4f1e8f75ff142$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $607dd3aa68006649$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $0a177963a80d9388$export$12fc32fc096a04a3)(props, (0, $ajtHG.useContext)((0, $dce7a09533ada423$export$2285bbca2c666415)));
    return (0, $ajtHG.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $607dd3aa68006649$var$variantLabelsAsDependency(initial),
        $607dd3aa68006649$var$variantLabelsAsDependency(animate)
    ]);
}
function $607dd3aa68006649$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $bb666c2df4217c04$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $bb666c2df4217c04$export$65570e08d843624d = {};
for(const key in $bb666c2df4217c04$var$featureProps)$bb666c2df4217c04$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$bb666c2df4217c04$var$featureProps[key].some((name)=>!!props[name])
};


function $5ede3bd778807442$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $bb666c2df4217c04$export$65570e08d843624d)[key] = {
        ...(0, $bb666c2df4217c04$export$65570e08d843624d)[key],
        ...features[key]
    };
}





const $804c56bbf325b6fa$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $7f97ec6e28d6ff4e$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $5ede3bd778807442$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $ajtHG.useContext)((0, $ae991a58cddf687f$export$22a697fb29aac98d)),
            ...props,
            layoutId: $7f97ec6e28d6ff4e$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $607dd3aa68006649$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $bcd55e478a15cc19$export$4e09c449d6c407f7)) {
            $7f97ec6e28d6ff4e$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $7f97ec6e28d6ff4e$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $e6fd333702ec7348$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $dce7a09533ada423$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $9b3c114f2ec1a7b9$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $96d171966b4406e4$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $ajtHG.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $804c56bbf325b6fa$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $7f97ec6e28d6ff4e$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $ajtHG.useContext)((0, $57855d678d276da3$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $7f97ec6e28d6ff4e$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $ajtHG.useContext)((0, $d0718a87e1fcb0e8$export$40f10139ecf1f171)).strict;
}
function $7f97ec6e28d6ff4e$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $bb666c2df4217c04$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c9452c0413157d1a$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $eccdacb84459fbfa$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c9452c0413157d1a$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



function $b547c29abaea737d$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $6b9e63cc1f7e80ba$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $7e8eaeff81aae570$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $b547c29abaea737d$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $6b9e63cc1f7e80ba$export$28931db5d57958e5).has(key) ? (0, $9b74efc8ade54cc6$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $ba4fd0cbf18530d7$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $7a2459a153995169$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $e1239f430d6b09ed$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $27126a61b5dbaca5$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(prevProps.style[key]) || (0, $ba4fd0cbf18530d7$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $bc5f331b856be38f$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $27126a61b5dbaca5$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(props[key]) || (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $7a2459a153995169$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $ajtHG = parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $82955f1cf14099ed$export$fe4300aa8eebea86(init) {
    const ref = (0, $ajtHG.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}





function $757d59e065c9b647$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $757d59e065c9b647$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $757d59e065c9b647$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $ajtHG.useContext)((0, $dce7a09533ada423$export$2285bbca2c666415));
        const presenceContext = (0, $ajtHG.useContext)((0, $e325c24ea0a50a06$export$f224e4635b6f8ce2));
        const make = ()=>$757d59e065c9b647$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $82955f1cf14099ed$export$fe4300aa8eebea86)(make);
    };
function $757d59e065c9b647$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $3a1664cf67d64e40$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $39824dc970dd0fd4$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $39824dc970dd0fd4$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $3d98cdcd9e935c82$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $362c01d2b30f63d8$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}


const $db292dc08e4b9a70$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $26072570f021be33$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $db292dc08e4b9a70$export$8940b483cf52eeda)(),
        attrs: {}
    });



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $36b8dcb096ba47bf$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $dda1b5387cdf9fb0$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $dda1b5387cdf9fb0$var$numTransforms = (0, $7a2459a153995169$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $dda1b5387cdf9fb0$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $dda1b5387cdf9fb0$var$numTransforms; i++){
        const key = (0, $7a2459a153995169$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $36b8dcb096ba47bf$export$453ef540a9a1bd6b)(value, (0, $3cf7ecb9cf9566a1$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $dda1b5387cdf9fb0$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $76dbabc3f676c59a$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $7a2459a153995169$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $eca7cd7daa2f203d$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $36b8dcb096ba47bf$export$453ef540a9a1bd6b)(value, (0, $3cf7ecb9cf9566a1$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $dda1b5387cdf9fb0$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $9a1b98f48cecc684$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $9a1b98f48cecc684$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $9a1b98f48cecc684$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $9a1b98f48cecc684$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $bdd95f14aea55ce2$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $bdd95f14aea55ce2$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $bdd95f14aea55ce2$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $bdd95f14aea55ce2$var$dashKeys : $bdd95f14aea55ce2$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $8fbba1dc9f16e9ad$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $7ee2f88cd47b5739$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $76dbabc3f676c59a$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $9a1b98f48cecc684$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $bdd95f14aea55ce2$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $0951b18afd805c1b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $ead5a88aebda873e$export$44dabd3fae512e85 = {
    useVisualState: (0, $757d59e065c9b647$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $bc5f331b856be38f$export$16da615486abaa45),
        createRenderState: (0, $26072570f021be33$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $f4b7678cda54e417$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $f4b7678cda54e417$export$2cef06c20297c17d).render(()=>{
                (0, $7ee2f88cd47b5739$export$5475d24f125d7053)(renderState, latestValues, (0, $0951b18afd805c1b$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $7e8eaeff81aae570$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $038fd7fb560c715d$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $757d59e065c9b647$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $27126a61b5dbaca5$export$16da615486abaa45,
        createRenderState: (0, $db292dc08e4b9a70$export$8940b483cf52eeda)
    })
};



var $ajtHG = parcelRequire("ajtHG");

var $ajtHG = parcelRequire("ajtHG");




function $3362705cc2274fdf$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(source[key]) && !(0, $ba4fd0cbf18530d7$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $3362705cc2274fdf$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $ajtHG.useMemo)(()=>{
        const state = (0, $db292dc08e4b9a70$export$8940b483cf52eeda)();
        (0, $76dbabc3f676c59a$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $3362705cc2274fdf$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $3362705cc2274fdf$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $3362705cc2274fdf$var$useInitialMotionValues(props, visualState));
    return style;
}
function $3362705cc2274fdf$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $3362705cc2274fdf$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $0c0f5535423172be$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $0c0f5535423172be$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $0c0f5535423172be$var$validMotionProps.has(key);
}


let $baf48f4266421dd1$var$shouldForward = (key)=>!(0, $0c0f5535423172be$export$2f9c46555243bf04)(key);
function $baf48f4266421dd1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $baf48f4266421dd1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $0c0f5535423172be$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $baf48f4266421dd1$export$59d6962c470509a5($baf48f4266421dd1$import$e0ecd9be0ad60761$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $baf48f4266421dd1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($baf48f4266421dd1$var$shouldForward(key) || forwardMotionProps === true && (0, $0c0f5535423172be$export$2f9c46555243bf04)(key) || !isDom && !(0, $0c0f5535423172be$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $ajtHG = parcelRequire("ajtHG");




function $175b612ce7c44b02$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $ajtHG.useMemo)(()=>{
        const state = (0, $26072570f021be33$export$41be8b43e1c4d4f9)();
        (0, $7ee2f88cd47b5739$export$5475d24f125d7053)(state, visualState, (0, $0951b18afd805c1b$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $3362705cc2274fdf$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $fcc982e47521014e$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $eccdacb84459fbfa$export$88f3fc2fd3766989)(Component) ? (0, $175b612ce7c44b02$export$84309c4f53cb1bd5) : (0, $3362705cc2274fdf$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $baf48f4266421dd1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $ajtHG.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $ajtHG.useMemo)(()=>(0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $ajtHG.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $29988ede2f733fea$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $eccdacb84459fbfa$export$88f3fc2fd3766989)(Component) ? (0, $ead5a88aebda873e$export$44dabd3fae512e85) : (0, $038fd7fb560c715d$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $fcc982e47521014e$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $7f97ec6e28d6ff4e$export$c3ad4a902bccc2d8)(config);
    };
}



var $ajtHG = parcelRequire("ajtHG");








// Does this device prefer reduced motion? Returns `null` server-side.
const $d65a53c256c079df$export$ff7706047246b98b = {
    current: null
};
const $d65a53c256c079df$export$6476d16e2fd2d0db = {
    current: false
};


function $b457e18c64818c25$export$ca9f41fb23dded3d() {
    (0, $d65a53c256c079df$export$6476d16e2fd2d0db).current = true;
    if (!(0, $bcd55e478a15cc19$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $d65a53c256c079df$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $d65a53c256c079df$export$ff7706047246b98b).current = false;
}











function $233ea06d3959fce0$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $bd3a97a3202cbe66$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $bd3a97a3202cbe66$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}





const $73382c2f2cbf6910$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $3ed262525495fdbb$var$valueTypes = [
    ...(0, $1f8533aa7b5b7539$export$d176691c1998a1f5),
    (0, $a58c15eb6a659bc0$export$35e9368ef982300f),
    (0, $cb497529768be9f4$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $3ed262525495fdbb$export$950e7e59ea1ffed7 = (v)=>$3ed262525495fdbb$var$valueTypes.find((0, $0e1fbeaeea9ea565$export$6eae4d0a6a7ca7cd)(v));







const $97ef7e04c1fa6c32$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $97ef7e04c1fa6c32$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $2e1a8a256a2f4570$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $39e3972fc0251128$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $f4b7678cda54e417$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $39824dc970dd0fd4$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $39824dc970dd0fd4$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $73382c2f2cbf6910$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $d65a53c256c079df$export$6476d16e2fd2d0db).current) (0, $b457e18c64818c25$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $d65a53c256c079df$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $73382c2f2cbf6910$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $f4b7678cda54e417$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $7a2459a153995169$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $f4b7678cda54e417$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $bb666c2df4217c04$export$65570e08d843624d){
            const featureDefinition = (0, $bb666c2df4217c04$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $97ef7e04c1fa6c32$var$propEventHandlers.length; i++){
            const key = $97ef7e04c1fa6c32$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $233ea06d3959fce0$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $bd3a97a3202cbe66$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $a9cd1239fa048fdb$export$65583ed5a868f2d9)(value) || (0, $c4ff2e8e36e938d2$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $3ed262525495fdbb$export$950e7e59ea1ffed7)(value) && (0, $cb497529768be9f4$export$83a0e34f1302825b).test(target)) value = (0, $24e5be6a11176d21$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $362c01d2b30f63d8$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $e9341638631146bc$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $62a5055264b3de12$export$e49735c2a366bdc7 extends (0, $97ef7e04c1fa6c32$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $1bb5103377bd9ff4$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $7900947fbb990cbc$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $7900947fbb990cbc$export$23fea75b03ac16b3 extends (0, $62a5055264b3de12$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $b547c29abaea737d$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $7a2459a153995169$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $1d10ecb8b84625e9$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $7900947fbb990cbc$export$3735103072e4a80(instance);
            const value = ((0, $eca7cd7daa2f203d$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $51e0326f61f3f2db$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $76dbabc3f676c59a$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $27126a61b5dbaca5$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}












class $c2fb788c010dbfc3$export$86bcdffbaf733d84 extends (0, $62a5055264b3de12$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $9f7f517a75b835d9$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $7a2459a153995169$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $1d10ecb8b84625e9$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $6b9e63cc1f7e80ba$export$28931db5d57958e5).has(key) ? (0, $9b74efc8ade54cc6$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $bc5f331b856be38f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $7ee2f88cd47b5739$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $7e8eaeff81aae570$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $0951b18afd805c1b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2076e563469a4625$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $eccdacb84459fbfa$export$88f3fc2fd3766989)(Component) ? new (0, $c2fb788c010dbfc3$export$86bcdffbaf733d84)(options) : new (0, $7900947fbb990cbc$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $ajtHG.Fragment)
    });
};


const $212780b655effc27$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $29988ede2f733fea$export$d86feac869a7f0d5)({
    ...(0, $dac8efd164150afe$export$7f9953c70dacfd7f),
    ...(0, $65d5f5268fa118c9$export$e5b72898e5a201f1),
    ...(0, $5d18248758ce4b19$export$d7d5d435647ed5a0),
    ...(0, $9d0ad75fcf62702c$export$b3219800bda33a1f)
}, (0, $2076e563469a4625$export$56ba0183203348f5));


const $b421c655783740a4$export$e25e478948902b8b = /*@__PURE__*/ (0, $f5d380161b2d224d$export$3af29c0efb268f04)((0, $212780b655effc27$export$46b7e4b9dc6110c3));



parcelRequire("ajtHG");
const $9cd772bad9dc8d45$var$StoryProgressBar = ({ className: className, totalPages: totalPages, currentPage: currentPage, duration: duration })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: className,
        style: $9cd772bad9dc8d45$var$styles.container,
        children: [
            Array.from({
                length: totalPages
            }).map((_, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                    style: {
                        ...$9cd772bad9dc8d45$var$styles.segment,
                        backgroundColor: index < currentPage ? "white" // Completed pages
                         : "grey" // Pending pages
                    },
                    children: index === currentPage && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        style: {
                            ...$9cd772bad9dc8d45$var$styles.activeProgress,
                            animation: `${duration}s 1 linear progress forwards`
                        }
                    })
                }, index)),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("style", {
                children: `
          @keyframes progress {
            from {
              width: 0%;
            }
            to {
              width: 100%;
            }
          }
        `
            })
        ]
    });
};
var $9cd772bad9dc8d45$export$2e2bcd8739ae039 = $9cd772bad9dc8d45$var$StoryProgressBar;
const $9cd772bad9dc8d45$var$styles = {
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "calc(100% - 32px)",
        height: "5px",
        margin: "16px 16px 0px 16px",
        gap: "5px"
    },
    segment: {
        flex: 1,
        height: "3px",
        position: "relative",
        backgroundColor: "grey",
        borderRadius: "2.5px",
        overflow: "hidden"
    },
    activeProgress: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        backgroundColor: "white",
        animationFillMode: "forwards"
    }
};




var $ajtHG = parcelRequire("ajtHG");





parcelRequire("ajtHG");

const $be2bc40674a284e0$export$70a41ccc5091e7ef = ({ data: data })=>{
    const topArtistUrl = data.artist_id.artwork;
    const topArtistName = data.artist_id.name;
    const topArtistRank = data.rank;
    const trackPlayed = data.play_count;
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "top-artist-card",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "top-artist-card-header",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                        children: "Your top artist"
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                        className: "",
                        children: topArtistName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "artist-cover-container",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        referrerPolicy: "no-referrer",
                        src: topArtistUrl,
                        alt: "airbuds yearly recap",
                        className: "artist-capsule top-artist-cover "
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        src: (parcelRequire("1VBZS")),
                        alt: "top badge",
                        className: "top-artist-badge"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "track-played-container",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                        className: "track-played",
                        children: trackPlayed
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "track-played-subtitle",
                        children: "tracks played"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "track-rank-container",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                        className: "track-rank",
                        children: [
                            "You're ranked #",
                            topArtistRank
                        ]
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "track-rank-subtitle",
                        children: "of all airbuds users"
                    })
                ]
            })
        ]
    });
};



parcelRequire("ajtHG");


var $ajtHG = parcelRequire("ajtHG");


var $ajtHG = parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");

"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $2bead9dc1a0f11b3$var$PopChildMeasure extends $ajtHG.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $2bead9dc1a0f11b3$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $ajtHG.useId)();
    const ref = (0, $ajtHG.useRef)(null);
    const size = (0, $ajtHG.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $ajtHG.useContext)((0, $ae991a58cddf687f$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $ajtHG.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $9b3c114f2ec1a7b9$exports.jsx)($2bead9dc1a0f11b3$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $ajtHG.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $77ab7856ef167724$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $82955f1cf14099ed$export$fe4300aa8eebea86)($77ab7856ef167724$var$newChildrenMap);
    const id = (0, $ajtHG.useId)();
    const memoizedOnExitComplete = (0, $ajtHG.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $ajtHG.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $ajtHG.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $ajtHG.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $2bead9dc1a0f11b3$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $e325c24ea0a50a06$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $77ab7856ef167724$var$newChildrenMap() {
    return new Map();
}






var $ajtHG = parcelRequire("ajtHG");
const $c4524f57a474bbcf$export$10e61aed958678dd = (child)=>child.key || "";
function $c4524f57a474bbcf$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $ajtHG.Children).forEach(children, (child)=>{
        if ((0, $ajtHG.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $8553df5161f06c53$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $06304b9683179beb$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $ajtHG.useMemo)(()=>(0, $c4524f57a474bbcf$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $c4524f57a474bbcf$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $ajtHG.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $ajtHG.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $82955f1cf14099ed$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $ajtHG.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $ajtHG.useState)(presentChildren);
    (0, $d5749960abfed972$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $c4524f57a474bbcf$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $c4524f57a474bbcf$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $c4524f57a474bbcf$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $ajtHG.useContext)((0, $57855d678d276da3$export$a3579ca508007a95));
    return (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9b3c114f2ec1a7b9$exports.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $c4524f57a474bbcf$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $77ab7856ef167724$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};


const $23d7a5ff2dfcbd7c$var$WordByWordAnimation = ({ text: text })=>{
    // Split the texts into words
    const textA = text.split(" ");
    // Animation Variants
    const wordVariants = {
        hidden: {
            opacity: 0,
            y: 50
        },
        // Words start off-screen
        visible: {
            opacity: 1,
            y: 0
        },
        // Animate to visible
        exit: {
            opacity: 0,
            y: -50
        } // Words exit off-screen
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "text-animation-container",
        style: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
            style: {
                position: "relative"
            },
            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $8553df5161f06c53$export$3ae376d12526dd6f), {
                mode: "wait",
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "compat-text-headline light-headline",
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        gap: "8px"
                    },
                    children: textA.map((word, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).span, {
                            variants: wordVariants,
                            initial: "hidden",
                            animate: "visible",
                            exit: "exit",
                            transition: {
                                duration: 0.5,
                                delay: index * 0.2 // Delay each word animation
                            },
                            style: {
                                display: "inline-block"
                            },
                            children: word
                        }, word + index))
                }, "textA")
            })
        })
    });
};
var $23d7a5ff2dfcbd7c$export$2e2bcd8739ae039 = $23d7a5ff2dfcbd7c$var$WordByWordAnimation;







/**
 * Create a progress => progress easing function from a generator.
 */ function $d12a8b1b37ca9cfe$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $d6cc8f88fab19b6e$export$cbdd6b3d40ea54e2)(generator), (0, $d6cc8f88fab19b6e$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $715687867bb13e2f$export$f64c3bfbc58eec0f)(duration)
    };
}








function $1ef97ad4a4163e67$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $06304b9683179beb$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


function $a246f3320c3718e8$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}


function $03abff189bfc7be1$export$92b2aefc56600400(subject, keyframes, scope, selectorCache) {
    if (typeof subject === "string" && (0, $a246f3320c3718e8$export$d276bfce3b1077ca)(keyframes)) return (0, $1ef97ad4a4163e67$export$90ceba2564a894f8)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject;
    else return [
        subject
    ];
}



/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $6180b6d746713c62$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $c206db39e5d478c7$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $2c88858b012a7d69$export$41c5e731255a462(easing, i) {
    return (0, $e1b1f19bb68401bb$export$216948827bbdc797)(easing) ? easing[(0, $c206db39e5d478c7$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $b64194782581163b$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $45a95db56da9af08$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $b64194782581163b$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $b64194782581163b$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $0245bb99118c6d08$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $2c88858b012a7d69$export$41c5e731255a462)(easing, i)
    });
}


function $54dc9621b3e74ad7$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $041d57a39ebc62a8$var$defaultSegmentEasing = "easeInOut";
function $041d57a39ebc62a8$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $6180b6d746713c62$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $6180b6d746713c62$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0)=>{
            const valueKeyframesAsList = $041d57a39ebc62a8$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $2eee6ddf3c7f5b25$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = (0, $daeac1d30f06680c$export$6ab7812f1bac68be)(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $041d57a39ebc62a8$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $715687867bb13e2f$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $d12a8b1b37ca9cfe$export$7f1511d09ee75a99)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $952e38f368131131$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $b64194782581163b$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $041d57a39ebc62a8$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $041d57a39ebc62a8$var$getValueSequence("default", subjectSequence));
        } else {
            const subjects = (0, $03abff189bfc7be1$export$92b2aefc56600400)(subject, keyframes, scope, elementCache);
            const numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const thisSubject = subjects[subjectIndex];
                const subjectSequence = $041d57a39ebc62a8$var$getSubjectSequence(thisSubject, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $041d57a39ebc62a8$export$7c1391340308742e(transition, key), $041d57a39ebc62a8$var$getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $54dc9621b3e74ad7$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $d640842db8ae7ecd$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($041d57a39ebc62a8$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $041d57a39ebc62a8$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $041d57a39ebc62a8$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $041d57a39ebc62a8$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $041d57a39ebc62a8$export$7c1391340308742e(transition, key) {
    return transition && transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $041d57a39ebc62a8$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $041d57a39ebc62a8$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($041d57a39ebc62a8$var$isNumber);












function $90be24ef0ea05517$var$isObjectKey(key, object) {
    return key in object;
}
class $90be24ef0ea05517$export$fe67a5eca4e986d6 extends (0, $97ef7e04c1fa6c32$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if ($90be24ef0ea05517$var$isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, $9f7f517a75b835d9$export$6459fc9e86be362e)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output: output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}


function $a79cbe061a322d08$export$602bd1946a6d1d47(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $9acf87a958f1e041$export$17eda790a720ec57)(element) ? new (0, $c2fb788c010dbfc3$export$86bcdffbaf733d84)(options) : new (0, $7900947fbb990cbc$export$23fea75b03ac16b3)(options);
    node.mount(element);
    (0, $73382c2f2cbf6910$export$bc2a978a17abfdde).set(element, node);
}
function $a79cbe061a322d08$export$69c3b8be1812d4ee(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    const node = new (0, $90be24ef0ea05517$export$fe67a5eca4e986d6)(options);
    node.mount(subject);
    (0, $73382c2f2cbf6910$export$bc2a978a17abfdde).set(subject, node);
}





function $dbb65bd7d3cb896e$var$isSingleValue(subject, keyframes) {
    return (0, $ae4ea0ff5eccee3a$export$605d60a2578142d3)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, $a246f3320c3718e8$export$d276bfce3b1077ca)(keyframes);
}
/**
 * Implementation
 */ function $dbb65bd7d3cb896e$export$7f91f5969506fd92(subject, keyframes, options, scope) {
    const animations = [];
    if ($dbb65bd7d3cb896e$var$isSingleValue(subject, keyframes)) animations.push((0, $b4eb7f7f0fb66ba3$export$335a17c977067b99)(subject, (0, $a246f3320c3718e8$export$d276bfce3b1077ca)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        const subjects = (0, $03abff189bfc7be1$export$92b2aefc56600400)(subject, keyframes, scope);
        const numSubjects = subjects.length;
        (0, $06304b9683179beb$export$f5708dca728d7177)(Boolean(numSubjects), "No valid elements provided.");
        for(let i = 0; i < numSubjects; i++){
            const thisSubject = subjects[i];
            const createVisualElement = thisSubject instanceof Element ? (0, $a79cbe061a322d08$export$602bd1946a6d1d47) : (0, $a79cbe061a322d08$export$69c3b8be1812d4ee);
            if (!(0, $73382c2f2cbf6910$export$bc2a978a17abfdde).has(thisSubject)) createVisualElement(thisSubject);
            const visualElement = (0, $73382c2f2cbf6910$export$bc2a978a17abfdde).get(thisSubject);
            const transition = {
                ...options
            };
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            animations.push(...(0, $783a78e7c86840b7$export$68cacfeee78d98d2)(visualElement, {
                ...keyframes,
                transition: transition
            }, {}));
        }
    }
    return animations;
}


function $aee8b1e1b70cc566$export$82a013c5b12ef57f(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $041d57a39ebc62a8$export$1f0f44b51a4b2f73)(sequence, options, scope, {
        spring: $213f6b9aaf6a36bc$export$b36281d89752ae66
    });
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        animations.push(...(0, $dbb65bd7d3cb896e$export$7f91f5969506fd92)(subject, keyframes, transition));
    });
    return animations;
}



function $bc6b2f94450725a7$var$isSequence(value) {
    return Array.isArray(value) && Array.isArray(value[0]);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function $bc6b2f94450725a7$export$c17e592002be9b90(scope) {
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        let animations = [];
        if ($bc6b2f94450725a7$var$isSequence(subjectOrSequence)) animations = (0, $aee8b1e1b70cc566$export$82a013c5b12ef57f)(subjectOrSequence, optionsOrKeyframes, scope);
        else animations = (0, $dbb65bd7d3cb896e$export$7f91f5969506fd92)(subjectOrSequence, optionsOrKeyframes, options, scope);
        const animation = new (0, $1db1b0191f772c6d$export$c1e41718f71efe41)(animations);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
}
const $bc6b2f94450725a7$export$e3607ec2d7a891c4 = $bc6b2f94450725a7$export$c17e592002be9b90();



var $ajtHG = parcelRequire("ajtHG");
const $a0401e570a895d71$export$1b74141c5fe63a28 = ({ className: className, from: from, to: to, duration: duration })=>{
    const nodeRef = (0, $ajtHG.useRef)();
    (0, $ajtHG.useEffect)(()=>{
        const node = nodeRef.current;
        const controls = (0, $bc6b2f94450725a7$export$e3607ec2d7a891c4)(from, to, {
            duration: duration ? duration : 1,
            onUpdate (value) {
                node.textContent = value.toFixed(0);
            }
        });
        return ()=>controls.stop();
    }, [
        from,
        to
    ]);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
        className: className ? className : "counter headline",
        ref: nodeRef
    });
};




var $ajtHG = parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");

const $b22b634b64676940$export$68fb1297e1fdf33e = [
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83D\uDC96",
    "\uD83C\uDF1F",
    "\uD83D\uDD25",
    "\uD83D\uDC8E",
    "\uD83C\uDF55",
    "\uD83C\uDFB5",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDC96",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83D\uDC96",
    "\uD83C\uDF1F",
    "\uD83D\uDD25",
    "\uD83D\uDC8E",
    "\uD83C\uDF55",
    "\uD83C\uDFB5"
];
const $b22b634b64676940$export$d75782c74c541dbb = [
    "\u2753",
    "\uD83C\uDFA7",
    "\uD83C\uDFA4",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83C\uDFB5",
    "\u2753",
    "\uD83C\uDFA7",
    "\uD83C\uDFA4",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83C\uDFB5",
    "\u2753",
    "\uD83C\uDFA7",
    "\uD83C\uDFA4",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83C\uDFB5",
    "\u2753",
    "\uD83C\uDFA7",
    "\uD83C\uDFA4",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83C\uDFB5",
    "\u2753",
    "\uD83C\uDFA7",
    "\uD83C\uDFA4",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83C\uDFB5",
    "\u2753",
    "\uD83C\uDFA7",
    "\uD83C\uDFA4",
    "\uD83D\uDE00",
    "\uD83C\uDF89",
    "\uD83C\uDFB5"
];
const $b22b634b64676940$export$af3ad78f66a47b37 = ({ emojis: emojis, next: next })=>{
    (0, $ajtHG.useEffect)(()=>{
        //Implementing the setInterval method
        const interval = setTimeout(()=>{
            if (next) next();
        }, 2000);
        //Clearing the interval
        return ()=>clearTimeout(interval);
    }, []);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        style: {
            position: "relative",
            width: "100vw",
            height: "100vh",
            overflow: "hidden"
        },
        children: emojis.map((emoji, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                style: {
                    position: "absolute",
                    fontSize: `${Math.floor(Math.random() * 6)}em`,
                    left: `${Math.random() * 100}%` // Random horizontal position
                },
                initial: {
                    y: "100vh",
                    bottom: "-100vh"
                },
                animate: {
                    y: "0px",
                    bottom: "100vh"
                },
                transition: {
                    duration: emojis.length * 0.1,
                    // Animate in 1 second
                    type: "spring",
                    bounce: 0.25,
                    delay: index * 0.1 // Stagger the emojis for a wave effect
                },
                children: emoji
            }, index))
    });
};
var $b22b634b64676940$export$2e2bcd8739ae039 = $b22b634b64676940$export$af3ad78f66a47b37;



const $6ac075d0e0717380$export$b8b909caae7de950 = ({ user: user, me: me, score: score })=>{
    const [step, setStep] = (0, $ajtHG.useState)(0);
    const [avatarSmall, setAvatarsSmall] = (0, $ajtHG.useState)(false);
    const { playMusic: playMusic } = (0, $e1bd9c9bc4ba88d5$export$8be4c01406f592a)();
    const nextStep = ()=>{
        if (step == 2) setStep(0);
        else setStep(step + 1);
    };
    (0, $ajtHG.useEffect)(()=>{
        playMusic();
    });
    (0, $ajtHG.useEffect)(()=>{
        //Implementing the setInterval method
        const interval = setInterval(()=>{
            var newStep = step + 1;
            if (newStep == 1) setAvatarsSmall(true);
            nextStep();
        }, 2000);
        //Clearing the interval
        return ()=>clearInterval(interval);
    }, []);
    const renderState = (state)=>{
        switch(state){
            case 1:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$fc87e6186064b3b3), {
                    top: score
                });
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {});
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "compat-avatar-animation",
        children: [
            step == 0 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("span", {
                className: "compat-text-headline",
                children: [
                    " ",
                    "most compatible",
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("br", {}),
                    " friend"
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                className: "compat-content",
                initial: {
                    backgroundSize: "70%"
                },
                animate: avatarSmall ? {
                    backgroundSize: "0%"
                } // Second animation state
                 : {
                    backgroundSize: "80%"
                } // First animation state
                ,
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: "compat-door-container",
                        children: renderState(step)
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "compat-avatars",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                                className: "compat-avatar-container compat-avatar-container-left",
                                initial: {
                                    x: "-50%",
                                    y: "3%",
                                    rotate: 0,
                                    scale: 1
                                },
                                animate: avatarSmall ? {
                                    x: "10%",
                                    y: "-60%",
                                    rotate: -9,
                                    scale: 0.4
                                } // Second animation state
                                 : {
                                    x: "5%",
                                    y: "0%",
                                    rotate: -9,
                                    scale: 1
                                } // First animation state
                                ,
                                transition: {
                                    duration: 0.8,
                                    delay: 0.0,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                children: me && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "compat-avatar compat-avatar-left",
                                    src: me.image
                                })
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                                className: "compat-avatar-container compat-avatar-container-right",
                                initial: {
                                    x: "150%",
                                    rotate: 0,
                                    scale: 1
                                },
                                animate: avatarSmall ? {
                                    x: "75%",
                                    y: "50%",
                                    rotate: 20,
                                    scale: 0.5
                                } // Second animation state
                                 : {
                                    x: "75%",
                                    y: "10%",
                                    rotate: 20,
                                    scale: 1
                                } // First animation state
                                ,
                                transition: {
                                    duration: 0.8,
                                    delay: 0.0,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                children: user && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "compat-avatar compat-avatar-right",
                                    src: user.image
                                })
                            })
                        ]
                    })
                ]
            }),
            user && user.name && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("h1", {
                className: "compat-title headline",
                children: [
                    user.name,
                    " ",
                    step == 1 && "& you"
                ]
            })
        ]
    });
};




parcelRequire("ajtHG");


const $a6b7e7fb6b25e3f1$export$fbe15cc8315f3e9e = ({ emojis: emojis, me: me, user: user, count: count })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "compat-reaction",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "compat-reactions-avatars",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                                className: "compat-avatar-container compat-avatar-container-left",
                                initial: {
                                    x: "-50%",
                                    y: "3%",
                                    rotate: 0,
                                    scale: 1
                                },
                                animate: {
                                    x: "5%",
                                    y: "0%",
                                    rotate: -9,
                                    scale: 1
                                },
                                transition: {
                                    duration: 0.8,
                                    delay: 0.0,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "compat-avatar compat-avatar-left",
                                    src: me.image
                                })
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                                className: "compat-avatar-container compat-avatar-container-right",
                                initial: {
                                    x: "150%",
                                    rotate: 0,
                                    scale: 1
                                },
                                animate: {
                                    x: "75%",
                                    y: "10%",
                                    rotate: 20,
                                    scale: 1.0
                                },
                                transition: {
                                    duration: 0.8,
                                    delay: 0.0,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "compat-avatar compat-avatar-right",
                                    src: user.image
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "compat-reaction-title-container",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("h4", {
                                className: "compat-reaction-title",
                                children: [
                                    "You\u2019ve sent ",
                                    count
                                ]
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                                className: "compat-reaction-subtitle",
                                children: "reactions to each other"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                emojis: emojis
            })
        ]
    });
};



parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");


var $ajtHG = parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");

const $247b426d82c0e2c6$var$HorizontalPager = ({ data: data, showArtist: showArtist })=>{
    const containerRef = (0, $ajtHG.useRef)(null);
    (0, $ajtHG.useEffect)(()=>{
        if (containerRef.current) {
            // Scroll to the second item (index 1)
            const secondItem = containerRef.current.children[1];
            secondItem.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "scroll-snap-container",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "spacer"
            }, "space1"),
            data && data.top_artists && data.top_artists.map((item, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                    className: "artist-item",
                    onClick: ()=>showArtist(item),
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6830037506aa62af$export$1af6141b823fcdc3), {
                        data: item
                    }, index)
                }, "arist-" + index)),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "spacer"
            }, "space2")
        ]
    });
};
var $247b426d82c0e2c6$export$2e2bcd8739ae039 = $247b426d82c0e2c6$var$HorizontalPager;



parcelRequire("ajtHG");

const $17fc925e4b927833$export$3b0a3a1406f56aea = ({ title: title })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "cta-button-full",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
            className: "cta-button-full-content",
            children: title
        })
    });
};
const $17fc925e4b927833$export$cfc7921d29ef7b80 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "cta-button",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
            className: "cta-button-content",
            children: title
        })
    });
};








var $ajtHG = parcelRequire("ajtHG");


var $ajtHG = parcelRequire("ajtHG");
function $f96b51fe7975cd75$var$i(e, t, r, n) {
    return new (r || (r = Promise))(function(o, a) {
        function i(e) {
            try {
                c(n.next(e));
            } catch (e) {
                a(e);
            }
        }
        function u(e) {
            try {
                c(n.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function c(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, u);
        }
        c((n = n.apply(e, t || [])).next());
    });
}
function $f96b51fe7975cd75$var$u(e, t) {
    var r, n, o, a, i = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function u(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; i;)try {
                    if (r = 1, n && (o = 2 & a[0] ? n.return : a[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, a[1])).done) return o;
                    switch(n = 0, o && (a = [
                        2 & a[0],
                        o.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            o = a;
                            break;
                        case 4:
                            return i.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            i.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(o = i.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                                i.label = a[1];
                                break;
                            }
                            if (6 === a[0] && i.label < o[1]) {
                                i.label = o[1], o = a;
                                break;
                            }
                            if (o && i.label < o[2]) {
                                i.label = o[2], i.ops.push(a);
                                break;
                            }
                            o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    a = t.call(e, i);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
function $f96b51fe7975cd75$var$c(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
    if (r) return r.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && n >= e.length && (e = void 0), {
                value: e && e[n++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f96b51fe7975cd75$var$l(e, t) {
    var r = "function" == typeof Symbol && e[Symbol.iterator];
    if (!r) return e;
    var n, o, a = r.call(e), i = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(n = a.next()).done;)i.push(n.value);
    } catch (e) {
        o = {
            error: e
        };
    } finally{
        try {
            n && !n.done && (r = a.return) && r.call(a);
        } finally{
            if (o) throw o.error;
        }
    }
    return i;
}
function $f96b51fe7975cd75$var$s(e, t, r) {
    if (r || 2 === arguments.length) for(var n, o = 0, a = t.length; o < a; o++)!n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
    return e.concat(n || Array.prototype.slice.call(t));
}
function $f96b51fe7975cd75$var$f(e, t, r, n, o) {
    for(var a = [], f = 5; f < arguments.length; f++)a[f - 5] = arguments[f];
    return $f96b51fe7975cd75$var$i(this, void 0, void 0, function() {
        var i, f, h, y, v, b;
        return $f96b51fe7975cd75$var$u(this, function(u) {
            switch(u.label){
                case 0:
                    u.trys.push([
                        0,
                        12,
                        13,
                        14
                    ]), i = $f96b51fe7975cd75$var$c(a), f = i.next(), u.label = 1;
                case 1:
                    if (f.done) return [
                        3,
                        11
                    ];
                    switch(h = f.value, typeof h){
                        case "string":
                            return [
                                3,
                                2
                            ];
                        case "number":
                            return [
                                3,
                                4
                            ];
                        case "function":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        $f96b51fe7975cd75$var$d(e, t, h, r, n, o)
                    ];
                case 3:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 4:
                    return [
                        4,
                        $f96b51fe7975cd75$var$p(h)
                    ];
                case 5:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 6:
                    return [
                        4,
                        h.apply(void 0, $f96b51fe7975cd75$var$s([
                            e,
                            t,
                            r,
                            n,
                            o
                        ], $f96b51fe7975cd75$var$l(a), !1))
                    ];
                case 7:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 8:
                    return [
                        4,
                        h
                    ];
                case 9:
                    u.sent(), u.label = 10;
                case 10:
                    return f = i.next(), [
                        3,
                        1
                    ];
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    return y = u.sent(), v = {
                        error: y
                    }, [
                        3,
                        14
                    ];
                case 13:
                    try {
                        f && !f.done && (b = i.return) && b.call(i);
                    } finally{
                        if (v) throw v.error;
                    }
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
}
function $f96b51fe7975cd75$var$d(e, t, r, n, o, a) {
    return $f96b51fe7975cd75$var$i(this, void 0, void 0, function() {
        var i, c;
        return $f96b51fe7975cd75$var$u(this, function(u) {
            switch(u.label){
                case 0:
                    return i = e.textContent || "", c = function(e, t) {
                        var r = $f96b51fe7975cd75$var$l(t).slice(0);
                        return $f96b51fe7975cd75$var$s($f96b51fe7975cd75$var$s([], $f96b51fe7975cd75$var$l(e), !1), [
                            NaN
                        ], !1).findIndex(function(e, t) {
                            return r[t] !== e;
                        });
                    }(i, r), [
                        4,
                        $f96b51fe7975cd75$var$h(e, $f96b51fe7975cd75$var$s($f96b51fe7975cd75$var$s([], $f96b51fe7975cd75$var$l($f96b51fe7975cd75$var$v(i, t, c)), !1), $f96b51fe7975cd75$var$l($f96b51fe7975cd75$var$y(r, t, c)), !1), n, o, a)
                    ];
                case 1:
                    return u.sent(), [
                        2
                    ];
            }
        });
    });
}
function $f96b51fe7975cd75$var$p(e) {
    return $f96b51fe7975cd75$var$i(this, void 0, void 0, function() {
        return $f96b51fe7975cd75$var$u(this, function(t) {
            switch(t.label){
                case 0:
                    return [
                        4,
                        new Promise(function(t) {
                            return setTimeout(t, e);
                        })
                    ];
                case 1:
                    return t.sent(), [
                        2
                    ];
            }
        });
    });
}
function $f96b51fe7975cd75$var$h(e, t, r, n, o) {
    return $f96b51fe7975cd75$var$i(this, void 0, void 0, function() {
        var a, i, s, f, d, h, y, v, b, m, w, g, x;
        return $f96b51fe7975cd75$var$u(this, function(S) {
            switch(S.label){
                case 0:
                    if (a = t, o) {
                        for(i = 0, s = 1; s < t.length; s++)if (f = $f96b51fe7975cd75$var$l([
                            t[s - 1],
                            t[s]
                        ], 2), d = f[0], (h = f[1]).length > d.length || "" === h) {
                            i = s;
                            break;
                        }
                        a = t.slice(i, t.length);
                    }
                    S.label = 1;
                case 1:
                    S.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]), y = $f96b51fe7975cd75$var$c(function(e) {
                        var t, r, n, o, a, i, l;
                        return $f96b51fe7975cd75$var$u(this, function(s) {
                            switch(s.label){
                                case 0:
                                    t = function(e) {
                                        return $f96b51fe7975cd75$var$u(this, function(t) {
                                            switch(t.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        {
                                                            op: function(t) {
                                                                return requestAnimationFrame(function() {
                                                                    return t.textContent = e;
                                                                });
                                                            },
                                                            opCode: function(t) {
                                                                var r = t.textContent || "";
                                                                return "" === e || r.length > e.length ? "DELETE" : "WRITING";
                                                            }
                                                        }
                                                    ];
                                                case 1:
                                                    return t.sent(), [
                                                        2
                                                    ];
                                            }
                                        });
                                    }, s.label = 1;
                                case 1:
                                    s.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), r = $f96b51fe7975cd75$var$c(e), n = r.next(), s.label = 2;
                                case 2:
                                    return n.done ? [
                                        3,
                                        5
                                    ] : (o = n.value, [
                                        5,
                                        t(o)
                                    ]);
                                case 3:
                                    s.sent(), s.label = 4;
                                case 4:
                                    return n = r.next(), [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return a = s.sent(), i = {
                                        error: a
                                    }, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        n && !n.done && (l = r.return) && l.call(r);
                                    } finally{
                                        if (i) throw i.error;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }(a)), v = y.next(), S.label = 2;
                case 2:
                    return v.done ? [
                        3,
                        5
                    ] : (b = v.value, m = "WRITING" === b.opCode(e) ? r + r * (Math.random() - .5) : n + n * (Math.random() - .5), b.op(e), [
                        4,
                        $f96b51fe7975cd75$var$p(m)
                    ]);
                case 3:
                    S.sent(), S.label = 4;
                case 4:
                    return v = y.next(), [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    return w = S.sent(), g = {
                        error: w
                    }, [
                        3,
                        8
                    ];
                case 7:
                    try {
                        v && !v.done && (x = y.return) && x.call(y);
                    } finally{
                        if (g) throw g.error;
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
}
function $f96b51fe7975cd75$var$y(e, t, r) {
    var n, o;
    return void 0 === r && (r = 0), $f96b51fe7975cd75$var$u(this, function(a) {
        switch(a.label){
            case 0:
                n = t(e), o = n.length, a.label = 1;
            case 1:
                return r < o ? [
                    4,
                    n.slice(0, ++r).join("")
                ] : [
                    3,
                    3
                ];
            case 2:
                return a.sent(), [
                    3,
                    1
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
function $f96b51fe7975cd75$var$v(e, t, r) {
    var n, o;
    return void 0 === r && (r = 0), $f96b51fe7975cd75$var$u(this, function(a) {
        switch(a.label){
            case 0:
                n = t(e), o = n.length, a.label = 1;
            case 1:
                return o > r ? [
                    4,
                    n.slice(0, --o).join("")
                ] : [
                    3,
                    3
                ];
            case 2:
                return a.sent(), [
                    3,
                    1
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
var $f96b51fe7975cd75$var$b = "index-module_type__E-SaG";
!function(e, t) {
    void 0 === t && (t = {});
    var r = t.insertAt;
    if (e && "undefined" != typeof document) {
        var n = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
        o.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(o, n.firstChild) : n.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
    }
}(".index-module_type__E-SaG::after {\n  content: '|';\n  animation: index-module_cursor__PQg0P 1.1s infinite step-start;\n}\n\n@keyframes index-module_cursor__PQg0P {\n  50% {\n    opacity: 0;\n  }\n}\n");
var $f96b51fe7975cd75$export$9ccb4d0b6557995c = (0, $ajtHG.memo)((0, $ajtHG.forwardRef)(function(o, a) {
    var i = o.sequence, u = o.repeat, c = o.className, d = o.speed, p = void 0 === d ? 40 : d, h = o.deletionSpeed, y = o.omitDeletionAnimation, v = void 0 !== y && y, m = o.preRenderFirstString, w = void 0 !== m && m, g = o.wrapper, x = void 0 === g ? "span" : g, S = o.splitter, E = void 0 === S ? function(e) {
        return $f96b51fe7975cd75$var$s([], $f96b51fe7975cd75$var$l(e), !1);
    } : S, _ = o.cursor, k = void 0 === _ || _, O = o.style, T = function(e, t) {
        var r = {};
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
        }
        return r;
    }(o, [
        "sequence",
        "repeat",
        "className",
        "speed",
        "deletionSpeed",
        "omitDeletionAnimation",
        "preRenderFirstString",
        "wrapper",
        "splitter",
        "cursor",
        "style"
    ]), A = T["aria-label"], C = T["aria-hidden"], N = T.role;
    h || (h = p);
    var P = new Array(2).fill(40);
    [
        p,
        h
    ].forEach(function(e, t) {
        switch(typeof e){
            case "number":
                P[t] = Math.abs(e - 100);
                break;
            case "object":
                var r = e.type, n = e.value;
                if ("number" != typeof n) break;
                if ("keyStrokeDelayInMs" === r) P[t] = n;
        }
    });
    var j, I, G, D, M, R, q = P[0], F = P[1], B = function(e, r) {
        void 0 === r && (r = null);
        var o = (0, $ajtHG.useRef)(r);
        return (0, $ajtHG.useEffect)(function() {
            e && ("function" == typeof e ? e(o.current) : e.current = o.current);
        }, [
            e
        ]), o;
    }(a), Q = $f96b51fe7975cd75$var$b;
    j = c ? "".concat(k ? Q + " " : "").concat(c) : k ? Q : "", I = (0, $ajtHG.useRef)(function() {
        var e, t = i;
        u === 1 / 0 ? e = $f96b51fe7975cd75$var$f : "number" == typeof u && (t = Array(1 + u).fill(i).flat());
        var r = e ? $f96b51fe7975cd75$var$s($f96b51fe7975cd75$var$s([], $f96b51fe7975cd75$var$l(t), !1), [
            e
        ], !1) : $f96b51fe7975cd75$var$s([], $f96b51fe7975cd75$var$l(t), !1);
        return $f96b51fe7975cd75$var$f.apply(void 0, $f96b51fe7975cd75$var$s([
            B.current,
            E,
            q,
            F,
            v
        ], $f96b51fe7975cd75$var$l(r), !1)), function() {
            B.current;
        };
    }), G = (0, $ajtHG.useRef)(), D = (0, $ajtHG.useRef)(!1), M = (0, $ajtHG.useRef)(!1), R = $f96b51fe7975cd75$var$l((0, $ajtHG.useState)(0), 2)[1], D.current && (M.current = !0), (0, $ajtHG.useEffect)(function() {
        return D.current || (G.current = I.current(), D.current = !0), R(function(e) {
            return e + 1;
        }), function() {
            M.current && G.current && G.current();
        };
    }, []);
    var W = x, L = w ? i.find(function(e) {
        return "string" == typeof e;
    }) || "" : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ajtHG))).createElement(W, {
        "aria-hidden": C,
        "aria-label": A,
        role: N,
        style: O,
        className: j,
        children: A ? (0, (/*@__PURE__*/$parcel$interopDefault($ajtHG))).createElement("span", {
            "aria-hidden": "true",
            ref: B,
            children: L
        }) : L,
        ref: A ? void 0 : B
    });
}), function(e, t) {
    return !0;
});




function $ae2586eaae775944$var$useStateAndRef(initial) {
    const [value, setValue] = (0, $ajtHG.useState)(initial);
    const valueRef = (0, $ajtHG.useRef)(value);
    valueRef.current = value;
    return [
        value,
        setValue,
        valueRef
    ];
}
const $ae2586eaae775944$export$6feb0569e282a70e = ({ featureText: featureText, next: next })=>{
    const [step, setStep, refStep] = $ae2586eaae775944$var$useStateAndRef(0);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-stats-container thanks-gradient-background message-container ",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                className: "app-stats-content",
                initial: {
                    opacity: 0,
                    y: "100%"
                },
                animate: {
                    opacity: 1,
                    y: "0%"
                },
                exit: {
                    opacity: 0,
                    y: "-100%"
                },
                transition: {
                    duration: 1.0,
                    delay: 0.5,
                    ease: [
                        0,
                        0.71,
                        0.2,
                        1.01
                    ]
                },
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                    className: "headline-light message-container",
                    sequence: [
                        200,
                        "That's it for today",
                        1000,
                        featureText,
                        2000,
                        ()=>{
                            next();
                        }
                    ],
                    style: {
                        fontSize: "2em"
                    },
                    typeSpeed: 620
                })
            }, "step-0"),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                }
            })
        ]
    });
};



parcelRequire("ajtHG");


parcelRequire("ajtHG");









const $fc54defa952189da$export$9a6806e3f49705c5 = ({ showFloatingItems: showFloatingItems })=>{
    // Floating animation configuration
    const floatingAnimation = {
        x: [
            0,
            10,
            0
        ],
        y: [
            0,
            -10,
            0
        ],
        // Move up by 20px, then back to original
        transition: {
            duration: 10,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        }
    };
    const cloudAnimation = {
        x: [
            0,
            500,
            0
        ],
        transition: {
            duration: 100,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "validation-background",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            style: {
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "Img",
                    style: {
                        width: 1724,
                        height: 941,
                        left: -380,
                        top: "40%",
                        position: "absolute"
                    },
                    src: (parcelRequire("dDAK1")),
                    animate: cloudAnimation
                }),
                showFloatingItems && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                            className: "Bubble",
                            style: {
                                width: 120,
                                height: 120,
                                left: -86,
                                top: 141,
                                position: "absolute"
                            },
                            src: (parcelRequire("l4f2z")),
                            animate: floatingAnimation
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                            className: "Bubble",
                            style: {
                                width: 50,
                                height: 50,
                                left: 358,
                                top: 151,
                                position: "absolute",
                                transform: "rotate(180deg)",
                                transformOrigin: "0 0"
                            },
                            src: (parcelRequire("l4f2z")),
                            animate: floatingAnimation
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                            className: "Bubble",
                            style: {
                                width: 174,
                                height: 174,
                                left: -104,
                                top: 786,
                                position: "absolute"
                            },
                            src: (parcelRequire("l4f2z")),
                            animate: floatingAnimation
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                            className: "Img",
                            style: {
                                width: 1046,
                                height: 747,
                                left: 128,
                                top: 206,
                                position: "absolute"
                            },
                            src: (parcelRequire("dDAK1")),
                            animate: cloudAnimation
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                            className: "Bubble",
                            style: {
                                width: 249,
                                height: 249,
                                left: 321,
                                top: 489,
                                position: "absolute"
                            },
                            src: (parcelRequire("dDAK1")),
                            animate: cloudAnimation
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "Heart3d",
                    style: {
                        width: 72,
                        height: 72,
                        left: 51,
                        top: 515.93,
                        position: "absolute",
                        transform: "rotate(-11.16deg)",
                        transformOrigin: "0 0",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "inline-flex"
                    },
                    animate: floatingAnimation,
                    children: showFloatingItems && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                        className: "Image110",
                        style: {
                            width: 58.79,
                            height: 58.79,
                            left: 0,
                            top: 15.22,
                            position: "absolute",
                            transform: "rotate(-15deg)",
                            transformOrigin: "0 0"
                        },
                        src: (parcelRequire("8xFeJ")),
                        animate: floatingAnimation
                    })
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "Smiley3d",
                    style: {
                        width: 138,
                        height: 138,
                        paddingTop: 5,
                        paddingBottom: 5.55,
                        paddingLeft: 3,
                        paddingRight: 3.51,
                        left: 162,
                        top: 221.72,
                        position: "absolute",
                        transform: "rotate(-15deg)",
                        transformOrigin: "0 0",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "inline-flex"
                    },
                    animate: floatingAnimation,
                    children: showFloatingItems && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                        className: "Image109",
                        style: {
                            width: 131.49,
                            height: 127.45,
                            left: 0,
                            top: 0,
                            position: "absolute"
                        },
                        src: (parcelRequire("avBLG")),
                        animate: floatingAnimation
                    })
                })
            ]
        })
    });
};











const $71adacfbe7bbc045$var$validationList = [
    "You're ending 2024 proud of all the tracks you listened to! I know you and your music taste brings the life to every party, and I'm sure in 2025 you will keep being authentically you.",
    "You're ending 2024 knowing you played banger after banger the entire year. In 2025, evvvvvveryone is going to want you on aux (if they didn't already).",
    "You're ending 2024 in perfect harmony. You're all about balance, and that is reflected in your music taste. I hope 2025 brings you great peace!",
    "You're ending 2024 shamelessly you. Having niche music taste AND being on a music sharing app is just so cool of you. We will continue to be in awe of you all of 2025 and beyond!",
    "You're ending 2024 being unmistakably you. Your music taste is unique just like you. Don't forget that in 2025 and keep listening to the tracks you hold near to your heart, and no one elses."
];
const $71adacfbe7bbc045$var$validationGenre = [
    "BASIC",
    "POPULAR",
    "INTERESTING",
    "NICHE",
    "OBSCURE"
];
const $71adacfbe7bbc045$export$d15bb912fa4ed6cf = ({ text: text, closeAction: closeAction })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "content column-layout",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                children: text ? text : "This section is empty"
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                hideMenuBanner: true,
                closeAction: closeAction
            })
        ]
    });
};







const $71adacfbe7bbc045$export$794e892580855985 = ({})=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const [validationStep, setValidationStep, refStep] = (0, $82844ddb31b5eeae$export$d0ca4085b9a132e2)(0);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($71adacfbe7bbc045$export$d15bb912fa4ed6cf, {
        text: "no validation",
        closeAction: ()=>navigate("/menu")
    });
    const validationCategory = data.validation ? data.validation.category : 0;
    const genre = data.validation ? data.validation.genre : null;
    const genreCategory = $71adacfbe7bbc045$var$validationGenre[validationCategory];
    const validationText = $71adacfbe7bbc045$var$validationList[validationCategory];
    const badgeImage = function() {
        switch(validationCategory){
            case 1:
                return (parcelRequire("ixFFQ"));
            case 2:
                return (parcelRequire("9bOGD"));
            case 3:
                return (parcelRequire("bauHv"));
            case 4:
                return (parcelRequire("6BQXg"));
            case 5:
                return (parcelRequire("i1JUM"));
            default:
                return (parcelRequire("ixFFQ"));
        }
    }();
    const STEP_COUNT = 5;
    const previous = ()=>{
        setValidationStep(Math.max(validationStep - 1, 0));
    };
    const next = ()=>{
        if (validationStep == STEP_COUNT - 1) navigate("/menu");
        else setValidationStep(Math.min(validationStep + 1, STEP_COUNT));
    };
    const renderState = (state)=>{
        switch(state){
            case 0:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-validation-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                        className: "validation-display",
                        sequence: [
                            1000,
                            "\uD83D\uDC4B",
                            1000,
                            "You know",
                            //  Continuing previous Text
                            750,
                            "You know how it goes.",
                            1000,
                            "Let's stop at the station.",
                            1000,
                            "What station you may ask?",
                            2000,
                            ()=>{
                                if (refStep.currentPage == 0) setValidationStep(1);
                            }
                        ],
                        style: {
                            fontSize: "2em"
                        },
                        typeSpeed: 220
                    })
                }, "step-0");
            case 1:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-validation-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                            className: "validation-title",
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                alt: "validation",
                                src: (parcelRequire("hdM8F"))
                            })
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                            onClick: ()=>setValidationStep(2),
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$3b0a3a1406f56aea), {
                                title: "tell me about me"
                            })
                        })
                    ]
                }, "step-1");
            case 2:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-validation-content app-validation-result",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                        className: "validation-display",
                        sequence: [
                            1000,
                            validationText,
                            3000,
                            ()=>{
                                if (refStep.currentPage == 2) setValidationStep(3);
                            }
                        ],
                        style: {
                            fontSize: "2em"
                        },
                        typeSpeed: 220
                    })
                }, "step-2");
            case 3:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-validation-content app-validation-result",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        genre && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "column-layout validation-header",
                            children: [
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    alt: "validation",
                                    src: badgeImage
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                    className: "headline",
                                    children: genre
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                                    className: "caption",
                                    children: [
                                        "Your top ",
                                        genreCategory,
                                        " genre"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                            className: "validation-text",
                            children: validationText
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                            onClick: ()=>setValidationStep(4),
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                                title: "Next"
                            })
                        })
                    ]
                }, "step-3");
            case 4:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $ae2586eaae775944$export$6feb0569e282a70e), {
                    featureText: " Come back tomorrow to unlock your next stat: Ghosted & Opposite Artists",
                    next: ()=>{}
                });
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {});
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-validation-container validation-gradient-background",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $fc54defa952189da$export$9a6806e3f49705c5), {
                showFloatingItems: validationStep < 2
            }),
            renderState(validationStep),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$cb5eab83e584f566), {
                prev: previous,
                next: next
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                }
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9cd772bad9dc8d45$export$2e2bcd8739ae039), {
                className: "story-bar",
                totalPages: STEP_COUNT,
                currentPage: validationStep,
                duration: 0
            })
        ]
    });
};



const $6830037506aa62af$export$1af6141b823fcdc3 = ({ data: data })=>{
    var title = "";
    var artwork = "";
    var isTop = false;
    if (data.artist_id) {
        title = data.artist_id.name;
        artwork = data.artist_id.artwork;
        isTop = data.rank < 10;
    }
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "artist-item-container",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                children: [
                    artwork && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        referrerPolicy: "no-referrer",
                        src: artwork,
                        alt: title,
                        className: "artist-item-cover artist-capsule"
                    }),
                    isTop && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        src: (parcelRequire("1VBZS")),
                        alt: "top badge",
                        className: "artist-item-badge"
                    })
                ]
            }),
            title && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                className: "artist-item-title",
                children: title
            })
        ]
    });
};
const $6830037506aa62af$export$600f06439232a5ee = ({})=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const [selectedArtist, setSelectedArtist] = (0, $ajtHG.useState)(null);
    const [showLastMessage, setShowLastMessage] = (0, $ajtHG.useState)(false);
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "loading...",
        closeAction: ()=>navigate("/menu")
    });
    if (showLastMessage) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $ae2586eaae775944$export$6feb0569e282a70e), {
        featureText: "Come back tomorrow to unlock your next stat: Music Match of the year",
        next: ()=>{}
    });
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-top-artist-list-container",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "app-artist-top",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "app-top-artist-list",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h4", {
                                className: "top-artist-list-instruction",
                                children: "Select from your most played artists to discover your ranking"
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $247b426d82c0e2c6$export$2e2bcd8739ae039), {
                                data: data,
                                showArtist: (item)=>{
                                    setSelectedArtist(item);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: "buttons",
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("button", {
                            onClick: ()=>setShowLastMessage(true),
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                                    title: "next"
                                })
                            ]
                        })
                    })
                ]
            }),
            selectedArtist && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                className: "app-artist-modal",
                initial: {
                    opacity: 0,
                    scale: 0
                },
                animate: {
                    opacity: 1,
                    scale: 1.0
                },
                exit: {
                    opacity: 1,
                    scale: 0
                },
                transition: {
                    duration: 0.5,
                    delay: 0.0,
                    ease: [
                        0,
                        0.71,
                        0.2,
                        1.01
                    ]
                },
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $be2bc40674a284e0$export$70a41ccc5091e7ef), {
                        data: selectedArtist
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                        onClick: ()=>setSelectedArtist(null),
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                            title: "close"
                        })
                    })
                ]
            }, "step-1"),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                }
            })
        ]
    });
};


const $95cbd25eaf8c5e1d$export$8a38918016142bff = ({ data: data })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "track-item",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                src: data.artwork,
                alt: data.name,
                className: "track-item-cover"
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "track-item-title",
                        children: data.name
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "track-item-artist",
                        children: data.artistName
                    })
                ]
            })
        ]
    });
};
const $95cbd25eaf8c5e1d$export$6fc5b9a4d7987406 = ({ songs: songs })=>{
    const containerRef = (0, $ajtHG.useRef)(null);
    (0, $ajtHG.useEffect)(()=>{
        if (containerRef.current) {
            // Scroll to the second item (index 1)
            const secondItem = containerRef.current.children[0];
            secondItem.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "scroll-snap-container track-container",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "spacer-small"
            }),
            songs && songs.map((item, index)=>item ? /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($95cbd25eaf8c5e1d$export$8a38918016142bff, {
                    data: item
                }, index) : /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {})),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "spacer-small"
            })
        ]
    });
};




const $e2b6aa817d4342ad$export$d012e56bc4aa99d2 = ({ me: me, user: user, songs: songs, songCount: songCount, next: next })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "compat-reaction",
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    className: "compat-reactions-avatars",
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "compat-avatar-container compat-avatar-container-left",
                            initial: {
                                x: "-50%",
                                y: "3%",
                                rotate: 0,
                                scale: 1
                            },
                            animate: {
                                x: "15%",
                                y: "0%",
                                rotate: -9,
                                scale: 0.7
                            },
                            transition: {
                                duration: 0.8,
                                delay: 0.0,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: user && user.image && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                className: "compat-avatar compat-avatar-left",
                                src: user.image
                            })
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "compat-avatar-container compat-avatar-container-right",
                            initial: {
                                x: "150%",
                                rotate: 0,
                                scale: 1
                            },
                            animate: {
                                x: "65%",
                                y: "10%",
                                rotate: 20,
                                scale: 0.7
                            },
                            transition: {
                                duration: 0.8,
                                delay: 0.0,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: me && me.image && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                className: "compat-avatar compat-avatar-right",
                                src: me.image
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    className: "compat-result-title-container",
                    children: [
                        user && user.name && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("h1", {
                            className: "compat-title headline",
                            children: [
                                user.name,
                                " & you"
                            ]
                        }),
                        songs && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                            className: "compat-reaction-subtitle",
                            children: [
                                songCount,
                                " tracks in common"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "song-list-container",
                    initial: {
                        scale: 1.2
                    },
                    animate: {
                        scale: 1.0
                    },
                    transition: {
                        duration: 0.8,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $95cbd25eaf8c5e1d$export$6fc5b9a4d7987406), {
                        songs: songs
                    })
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                    className: "buttons",
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                        onClick: ()=>{
                            next();
                        },
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                            title: "next"
                        })
                    })
                })
            ]
        })
    });
};









const $962f8d1f1055734c$export$fc87e6186064b3b3 = ({ top: top })=>{
    const [showCounter, setShowCounter] = (0, $ajtHG.useState)(false);
    (0, $ajtHG.useEffect)(()=>{
        //Implementing the setInterval method
        const interval = setTimeout(()=>{
            setShowCounter(true);
        }, 1000);
        //Clearing the interval
        return ()=>clearTimeout(interval);
    }, [
        showCounter
    ]);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "doorAnimation",
        initial: {
            opacity: 0,
            scale: 0.5
        },
        animate: {
            opacity: 1,
            scale: 1
        },
        transition: {
            duration: 0.8,
            delay: 0.0,
            ease: [
                0,
                0.71,
                0.2,
                1.01
            ]
        },
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                src: (parcelRequire("2pf9y")),
                alt: "airbuds yearly recap",
                className: "door"
            }),
            showCounter && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a0401e570a895d71$export$1b74141c5fe63a28), {
                from: 0,
                to: top
            })
        ]
    });
};
const $962f8d1f1055734c$export$10255bda2baf681 = ()=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const [stepp, setStepe] = (0, $ajtHG.useState)(0);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const { setMusicURL: setMusicURL } = (0, $e1bd9c9bc4ba88d5$export$8be4c01406f592a)();
    const [showMusic, setShowMusic] = (0, $ajtHG.useState)(false);
    const [currentSongIndex, setCurrentSongIndex, refCurrentSong] = (0, $82844ddb31b5eeae$export$d0ca4085b9a132e2)(0);
    (0, $ajtHG.useEffect)(()=>{
        if (data && data.compatible_friends && data.compatible_friends.length > 0 && data.compatible_friends[0].song_ids && data.compatible_friends[0].song_ids[0].preview) {
            setShowMusic(true);
            setMusicURL(data.compatible_friends[0].song_ids[0].preview);
        }
        return ()=>{
            setMusicURL(null);
        };
    }, [
        data
    ]);
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "loading...",
        closeAction: ()=>navigate("/menu")
    });
    if (!data.compatible_friends && !data.compatible_friends.length <= 0) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "no compat",
        closeAction: ()=>navigate("/menu")
    });
    const rank = data.compatible_friends[0].rank;
    const score = data.compatible_friends[0].score;
    const song_count = data.compatible_friends[0].song_count;
    const reactions_count = data.compatible_friends[0].reactions_count;
    const songs = data.compatible_friends[0].song_ids;
    const user = data.compatible_friends[0].user_id;
    const me = data.user;
    const emojis = data.compatible_friends[0].top_reactions ? data.compatible_friends[0].top_reactions.filter((reaction)=>reaction.kind === "emoji") // Filter only emojis
    .map((reaction)=>reaction.body) // Extract the "body" field
     : (0, $b22b634b64676940$export$68fb1297e1fdf33e);
    const STEP_COUNT = 7;
    const previous = ()=>{
        setStepe(Math.max(stepp - 1, 0));
    };
    const next = ()=>{
        if (stepp == STEP_COUNT) navigate("/menu");
        else setStepe(Math.min(stepp + 1, STEP_COUNT));
    };
    const renderState = (state)=>{
        switch(state){
            case 0:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $23d7a5ff2dfcbd7c$export$2e2bcd8739ae039), {
                    text: "Let's maybe spare your dating life this year and focus on friends, shall we?"
                });
            case 1:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $23d7a5ff2dfcbd7c$export$2e2bcd8739ae039), {
                    text: "Among all your friends on Airbuds"
                });
            case 2:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $23d7a5ff2dfcbd7c$export$2e2bcd8739ae039), {
                    text: "There is one that matches your freak (musically)"
                });
            case 3:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6ac075d0e0717380$export$b8b909caae7de950), {
                    me: me,
                    user: user,
                    score: Math.round(score)
                });
            case 4:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                    emojis: emojis,
                    next: ()=>setStepe(5)
                });
            case 5:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a6b7e7fb6b25e3f1$export$fbe15cc8315f3e9e), {
                    emojis: emojis.concat(emojis),
                    me: me,
                    user: user,
                    count: reactions_count
                });
            case 6:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $e2b6aa817d4342ad$export$d012e56bc4aa99d2), {
                    me: me,
                    user: user,
                    songs: songs,
                    songCount: song_count,
                    next: ()=>setStepe(7)
                });
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $ae2586eaae775944$export$6feb0569e282a70e), {
                    featureText: "Come back tomorrow to unlock your next stat: Get validated for your Top Genre",
                    next: ()=>{}
                });
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-compat-container ",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "compat-gradient-background"
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "app-compat-content",
                children: renderState(stepp)
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($962f8d1f1055734c$export$cb5eab83e584f566, {
                className: stepp == 6 ? "not-clickable" : "",
                prev: previous,
                next: next
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                },
                showMusic: showMusic
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9cd772bad9dc8d45$export$2e2bcd8739ae039), {
                className: "story-bar",
                totalPages: STEP_COUNT,
                currentPage: stepp,
                duration: 0
            })
        ]
    });
};
const $962f8d1f1055734c$export$cb5eab83e584f566 = ({ className: className, prev: prev, next: next })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "story-overlay " + className,
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                className: "prev",
                onClick: prev,
                children: " "
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                className: "next",
                onClick: next,
                children: " "
            })
        ]
    });
};


function $82844ddb31b5eeae$export$d0ca4085b9a132e2(initial) {
    const [value, setValue] = (0, $ajtHG.useState)(initial);
    const valueRef = (0, $ajtHG.useRef)(value);
    valueRef.current = value;
    return [
        value,
        setValue,
        valueRef
    ];
}

const $82844ddb31b5eeae$export$b3c44ac484b3c461 = ({ data: data })=>{
    const [step, setStep, refStep] = $82844ddb31b5eeae$export$d0ca4085b9a132e2(0);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const previous = ()=>{
        setStep(Math.max(step - 1, 0));
    };
    const next = ()=>{
        if (step == 3) navigate("/menu");
        else setStep(Math.min(step + 1, 8));
    };
    const renderState = (state)=>{
        switch(state){
            case 0:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-stats-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                            className: "title",
                            children: "Welcome to your"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                            src: (parcelRequire("2KSlU")),
                            alt: "airbuds yearly recap",
                            class: "full-centered-img"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h1", {
                            className: "title subtile-stats",
                            children: "2024 airbuds recap"
                        })
                    ]
                }, "step-1");
            case 1:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-thanks-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).p, {
                        className: "type-text",
                        initial: {
                            opacity: 0,
                            y: "100%"
                        },
                        animate: {
                            opacity: 1,
                            y: "0%"
                        },
                        exit: {
                            opacity: 1,
                            y: "-100%"
                        },
                        transition: {
                            duration: 1.0,
                            delay: 0.0,
                            ease: [
                                0,
                                0.71,
                                0.2,
                                1.01
                            ]
                        },
                        children: "we\u2019re doing things a little differently this year\u2026"
                    })
                }, "step-1");
            case 2:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-thanks-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h3, {
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 1,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.0,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            className: "headline-light",
                            children: "Meet your Airbuds Advent Calendar."
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).p, {
                            className: "type-text",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 1,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: "Open a new stat each day and your full recap will be available the last day\u2013 December 20th."
                        })
                    ]
                }, "step-2");
            case 3:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-thanks-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                        className: "big-headline",
                        initial: {
                            opacity: 0,
                            y: "100%"
                        },
                        animate: {
                            opacity: 1,
                            y: "0%"
                        },
                        exit: {
                            opacity: 1,
                            y: "-100%"
                        },
                        transition: {
                            duration: 1.0,
                            delay: 0.0,
                            ease: [
                                0,
                                0.71,
                                0.2,
                                1.01
                            ]
                        },
                        children: "Let\u2019s begin\u2026"
                    })
                }, "step-4");
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {});
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-stats-container thanks-gradient-background ",
        children: [
            renderState(step),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$cb5eab83e584f566), {
                prev: previous,
                next: next
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                }
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9cd772bad9dc8d45$export$2e2bcd8739ae039), {
                className: "story-bar",
                totalPages: 4,
                currentPage: step,
                duration: 0
            })
        ]
    });
};


const $e1bd9c9bc4ba88d5$var$MusicPlayerContext = /*#__PURE__*/ (0, $ajtHG.createContext)();
const $e1bd9c9bc4ba88d5$export$11b4a88f8f4bdfe8 = ({ children: children })=>{
    const audioRef = (0, $ajtHG.useRef)(new Audio());
    const [isPlaying, setIsPlaying, isPlayingRef] = (0, $82844ddb31b5eeae$export$d0ca4085b9a132e2)(false);
    const [hasMusic, setHasMusic, hasMusicRef] = (0, $82844ddb31b5eeae$export$d0ca4085b9a132e2)(false);
    (0, $ajtHG.useEffect)(()=>{
        function resetPlayback() {
            audioRef.current.currentTime = 0;
            audioRef.current.play();
        }
        audioRef.current.addEventListener("ended", ()=>resetPlayback());
        return ()=>{
            audioRef.current.removeEventListener("ended", ()=>resetPlayback());
        };
    }, []);
    const playMusic = ()=>{
        if (!hasMusicRef.current) return;
        audioRef.current.play();
        setIsPlaying(true);
    };
    const pauseMusic = ()=>{
        audioRef.current.pause();
        setIsPlaying(false);
    };
    const toggleMusic = ()=>{
        isPlayingRef.current ? pauseMusic() : playMusic();
    };
    const setMusicURL = (url)=>{
        if (audioRef.current.src === url) return;
        var autoPlay = false;
        if (isPlayingRef.current) {
            pauseMusic();
            autoPlay = true;
        }
        audioRef.current.src = url;
        const hasSrc = url !== undefined && url !== null && url !== "";
        setHasMusic(hasSrc);
        if (autoPlay && hasSrc) playMusic();
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($e1bd9c9bc4ba88d5$var$MusicPlayerContext.Provider, {
        value: {
            hasMusic: hasMusic,
            playMusic: playMusic,
            pauseMusic: pauseMusic,
            toggleMusic: toggleMusic,
            setMusicURL: setMusicURL,
            isPlaying: isPlaying
        },
        children: children
    });
};
const $e1bd9c9bc4ba88d5$export$8be4c01406f592a = ()=>(0, $ajtHG.useContext)($e1bd9c9bc4ba88d5$var$MusicPlayerContext);




const $0c85b84cc280df52$var$MusicButton = ()=>{
    const { hasMusic: hasMusic, toggleMusic: toggleMusic, isPlaying: isPlaying } = (0, $e1bd9c9bc4ba88d5$export$8be4c01406f592a)();
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "music-player-button",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
            className: hasMusic ? "" : "inactive",
            onClick: toggleMusic,
            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                src: isPlaying ? (parcelRequire("9m2sy")) : (parcelRequire("1eOKT")),
                alt: isPlaying ? "mute" : "unmute"
            })
        })
    });
};
var $0c85b84cc280df52$export$2e2bcd8739ae039 = $0c85b84cc280df52$var$MusicButton;





const $891bbbacc5f56989$export$e3106ce591b86aaa = ({ hideMenuBanner: hideMenuBanner, showMusic: showMusic, closeAction: closeAction })=>{
    const { pauseMusic: pauseMusic } = (0, $e1bd9c9bc4ba88d5$export$8be4c01406f592a)();
    const close = async ()=>{
        if (closeAction) closeAction();
        else if (typeof webkit !== "undefined") {
            pauseMusic();
            webkit.messageHandlers.airbudsBridge.postMessage('{"close": {}}');
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "header",
        children: [
            !hideMenuBanner && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "header-title",
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$a6c7ac8248d6e38a), {
                    to: "/menu",
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        src: (parcelRequire("jKhdP")),
                        alt: "airbuds yearly recap"
                    })
                })
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "header-actions",
                children: [
                    showMusic && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $0c85b84cc280df52$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: "close-button",
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                            onClick: close,
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                src: (parcelRequire("5IObX")),
                                alt: "close"
                            })
                        })
                    })
                ]
            })
        ]
    });
};





const $1cb9c0fd0ce5cecc$export$b94310965bed44e6 = ({})=>{
    let navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: "image-background",
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {})
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "intro-title-content",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "intro-title",
                                children: [
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                        children: "your"
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                        src: (parcelRequire("2KSlU")),
                                        alt: "airbuds yearly recap"
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("h1", {
                                        children: [
                                            "Music Recap",
                                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("br", {}),
                                            "is Ready"
                                        ]
                                    })
                                ]
                            }),
                            data && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                className: "full-width-content",
                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                                    onClick: ()=>{
                                        if (localStorage.getItem("hasOnboard")) navigate("/menu");
                                        else {
                                            localStorage.setItem("hasOnboard", true);
                                            navigate("/intro");
                                        }
                                    },
                                    className: "big-cta-button",
                                    children: "Discover now"
                                })
                            })
                        ]
                    }),
                    !data && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        children: "Loading..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                hideMenuBanner: true
            })
        ]
    });
};


const $f87038cacdd3bc62$var$App = ()=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $1cb9c0fd0ce5cecc$export$b94310965bed44e6), {});
};
var $f87038cacdd3bc62$export$2e2bcd8739ae039 = $f87038cacdd3bc62$var$App;





var $ajtHG = parcelRequire("ajtHG");
var $6319d2413f564773$exports = {};
/*!
 * html2canvas 1.4.3 <https://html2canvas.hertzen.com>
 * Copyright (c) 2023 wtto00 <https://github.com/wtto00>
 * Released under MIT License
 */ (function(global, factory) {
    $6319d2413f564773$exports = factory();
})($6319d2413f564773$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue$1(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue$1 = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var objectFit = {
        name: 'objectFit',
        initialValue: 'fill',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* FILL */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'contain':
                return 2 /* CONTAIN */ ;
            case 'cover':
                return 4 /* COVER */ ;
            case 'none':
                return 8 /* NONE */ ;
            case 'scale-down':
                return 16 /* SCALE_DOWN */ ;
        }
        return 0 /* FILL */ ;
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
            this.objectFit = parse(context, objectFit, declaration.objectFit);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            var intrinsicWidth = image.naturalWidth || container.intrinsicWidth;
            var intrinsicHeight = image.naturalHeight || container.intrinsicHeight;
            if (image && intrinsicWidth > 0 && intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                var sx = 0, sy = 0, sw = intrinsicWidth, sh = intrinsicHeight, dx = box.left, dy = box.top, dw = box.width, dh = box.height;
                var objectFit = container.styles.objectFit;
                var boxRatio = dw / dh;
                var imgRatio = sw / sh;
                if (objectFit === 2 /* CONTAIN */ ) {
                    if (imgRatio > boxRatio) {
                        dh = dw / imgRatio;
                        dy += (box.height - dh) / 2;
                    } else {
                        dw = dh * imgRatio;
                        dx += (box.width - dw) / 2;
                    }
                } else if (objectFit === 4 /* COVER */ ) {
                    if (imgRatio > boxRatio) {
                        sw = sh * boxRatio;
                        sx += (intrinsicWidth - sw) / 2;
                    } else {
                        sh = sw / boxRatio;
                        sy += (intrinsicHeight - sh) / 2;
                    }
                } else if (objectFit === 8 /* NONE */ ) {
                    if (sw > dw) {
                        sx += (sw - dw) / 2;
                        sw = dw;
                    } else {
                        dx += (dw - sw) / 2;
                        dw = sw;
                    }
                    if (sh > dh) {
                        sy += (sh - dh) / 2;
                        sh = dh;
                    } else {
                        dy += (dh - sh) / 2;
                        dh = sh;
                    }
                } else if (objectFit === 16 /* SCALE_DOWN */ ) {
                    var containW = imgRatio > boxRatio ? dw : dh * imgRatio;
                    var noneW = sw > dw ? sw : dw;
                    if (containW < noneW) {
                        if (imgRatio > boxRatio) {
                            dh = dw / imgRatio;
                            dy += (box.height - dh) / 2;
                        } else {
                            dw = dh * imgRatio;
                            dx += (box.width - dw) / 2;
                        }
                    } else {
                        if (sw > dw) {
                            sx += (sw - dw) / 2;
                            sw = dw;
                        } else {
                            dx += (dw - sw) / 2;
                            dw = sw;
                        }
                        if (sh > dh) {
                            sy += (sh - dh) / 2;
                            sh = dh;
                        } else {
                            dy += (dh - sh) / 2;
                            dh = sh;
                        }
                    }
                }
                this.ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});







var $ajtHG = parcelRequire("ajtHG");
const $60b9ec92eb38ae95$var$useIsIOS = ()=>{
    const [isIOS, setIsIOS] = (0, $ajtHG.useState)(false);
    (0, $ajtHG.useEffect)(()=>{
        const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        // Check for iOS
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) setIsIOS(true);
        else setIsIOS(false);
    }, []);
    return isIOS;
};
var $60b9ec92eb38ae95$export$2e2bcd8739ae039 = $60b9ec92eb38ae95$var$useIsIOS;



var $ajtHG = parcelRequire("ajtHG");
const $8fb9c8fab9f69cde$var$useIsAirbudsClient = ()=>{
    const [isAirbudsClient, setIsAirbudsClient] = (0, $ajtHG.useState)(false);
    (0, $ajtHG.useEffect)(()=>{
        setIsAirbudsClient(!(typeof webkit === "undefined"));
    }, []);
    return isAirbudsClient;
};
var $8fb9c8fab9f69cde$export$2e2bcd8739ae039 = $8fb9c8fab9f69cde$var$useIsAirbudsClient;





const $949ad98624b47189$export$393157a251c5a813 = ({ className: className, variant: variant, url: url })=>{
    const shape = function() {
        switch(variant){
            case 1:
                return "artist-share-shape-1";
            case 2:
                return "artist-share-shape-2";
            case 3:
                return "artist-share-shape-3";
            default:
                return "artist-share-shape-4";
        }
    }();
    const badgeShape = function() {
        switch(variant){
            case 1:
                return "artist-shape-badge-1";
            case 2:
                return "artist-shape-badge-2";
            case 3:
                return "artist-shape-badge-3";
            default:
                return "artist-shap-badge-4";
        }
    }();
    const badgeName = function() {
        switch(variant){
            case 1:
                return (parcelRequire("haq60"));
            case 2:
                return null;
            case 3:
                return (parcelRequire("bOkMY"));
            default:
                return (parcelRequire("cZAZL"));
        }
    }();
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                className: "artist-share-shape " + shape,
                src: url
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                className: badgeShape,
                style: {
                    right: 0,
                    bottom: 0,
                    position: "absolute"
                },
                src: badgeName
            })
        ]
    });
};





const $949ad98624b47189$var$ShareableCard = ({ data: data })=>{
    var artistList = [];
    var songList = [];
    var albumList = [];
    var genre = null;
    if (data.top_artists) artistList = data.top_artists ? data.top_artists.slice(0, 5) : [];
    if (data.top_albums) albumList = data.top_albums ? data.top_albums.slice(0, 5) : [];
    if (data.top_songs) songList = data.top_songs ? data.top_songs.slice(0, 5) : [];
    genre = data.top_genres ? data.top_genres[0].genre : null;
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "igStoriesImage",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "IgShareV2",
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                    className: "top-images",
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: "share-top-artists-images",
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "Group1812",
                            children: [
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "floating-badge-3",
                                    src: (parcelRequire("koCUj"))
                                }),
                                data && data.top_artists && data.top_artists[0] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "BodyBackground BodyBackground--small",
                                    src: data.top_artists[0].artist_id.artwork,
                                    alt: "Small Circle"
                                }),
                                data && data.top_artists && data.top_artists[1] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "BodyBackground BodyBackground--medium",
                                    src: data.top_artists[1].artist_id.artwork,
                                    alt: "Medium Circle"
                                }),
                                data && data.top_artists && data.top_artists[2] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "BodyBackground BodyBackground--tiny",
                                    src: data.top_artists[2].artist_id.artwork,
                                    alt: "Tiny Circle"
                                }),
                                data && data.top_artists && data.top_artists[3] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "BodyBackground BodyBackground--large",
                                    src: data.top_artists[3].artist_id.artwork,
                                    alt: "Large Circle"
                                }),
                                data && data.top_artists && data.top_artists[4] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "BodyBackground BodyBackground--xl",
                                    src: data.top_artists[4].artist_id.artwork,
                                    alt: "XL Circle"
                                }),
                                data && data.top_artists && data.top_artists[5] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "BodyBackground BodyBackground--mediumAlt",
                                    src: data.top_artists[5].artist_id.artwork,
                                    alt: "Medium Alternate Circle"
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    referrerPolicy: "no-referrer",
                                    className: "central-avatar",
                                    src: data.user.image,
                                    alt: "Central Image"
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "floating-badge",
                                    src: (parcelRequire("cZAZL"))
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    className: "floating-badge-2",
                                    src: (parcelRequire("haq60"))
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    src: (parcelRequire("2KSlU")),
                                    alt: "Airbuds Yearly Recap",
                                    className: "chrome2024"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    className: "top-texts",
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "top-lists",
                            children: [
                                artistList && artistList.length > 0 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                    className: "top-list-container top-artist-container",
                                    children: [
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-artist-title",
                                            children: "Top Artists"
                                        }),
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-list",
                                            children: artistList.map((item, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                                    className: "top-line",
                                                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                                                        children: [
                                                            index + 1,
                                                            " . ",
                                                            item.artist_id.name
                                                        ]
                                                    })
                                                }, "top-line-artist-" + index))
                                        })
                                    ]
                                }),
                                songList && songList.length > 0 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                    className: "top-list-container  top-songs-container",
                                    children: [
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-songs-title",
                                            children: "Top Songs"
                                        }),
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-list",
                                            children: songList.map((item, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                                    className: "top-line",
                                                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                                                        children: [
                                                            index + 1,
                                                            " . ",
                                                            item.song_id.name
                                                        ]
                                                    })
                                                }, "top-line-song-" + index))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "top-lists",
                            children: [
                                data && data.play_count && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                    className: "top-list-container top-artist-container",
                                    children: [
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-artist-title",
                                            children: "Tracks listened"
                                        }),
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-list",
                                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                                className: "top-line top-line-big",
                                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                                                    children: data && data.play_count ? data.play_count : 0
                                                })
                                            })
                                        })
                                    ]
                                }),
                                genre && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                    className: "top-list-container  top-songs-container",
                                    children: [
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-songs-title",
                                            children: "Top Genre"
                                        }),
                                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                            className: "top-list",
                                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                                className: "top-line top-line-big",
                                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                                                    children: genre
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                            className: "top-lists top-lists-footer",
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                                className: "top-list-container top-artist-container",
                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                    src: (parcelRequire("4zSMw")),
                                    alt: "airbuds yearly recap",
                                    className: "airbuds-yearly-logo"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $949ad98624b47189$var$ShareableComponent = ()=>{
    const isIOS = (0, $60b9ec92eb38ae95$export$2e2bcd8739ae039)();
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const captureRef = (0, $ajtHG.useRef)(null);
    const containerRef = (0, $ajtHG.useRef)(null);
    const [canvas, setCanvas] = (0, $ajtHG.useState)(null);
    const [loading, setLoading] = (0, $ajtHG.useState)(false);
    const [sharing, setSharing] = (0, $ajtHG.useState)(false);
    const close = async ()=>{
        webkit.messageHandlers.airbudsBridge.postMessage('{"close": {}}');
    };
    (0, $ajtHG.useEffect)(()=>{
        // declare the data fetching function
        const computeImage = async ()=>{
            setLoading(true);
            var options = {};
            if (isIOS) options = {
                scale: 1,
                useCORS: true,
                allowTaint: true,
                backgroundColor: null
            };
            else options = {
                scale: 1,
                useCORS: true,
                allowTaint: true
            };
            const c = await (0, (/*@__PURE__*/$parcel$interopDefault($6319d2413f564773$exports)))(captureRef.current, options);
            setCanvas(c.toDataURL(isIOS ? "image/png" : "image/jpg"));
            setLoading(false);
        };
        // call the function
        computeImage()// make sure to catch any error
        .catch(console.error);
    }, [
        data,
        isIOS
    ]);
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "loading..."
    });
    const handleCapture = async ()=>{
        if (typeof webkit === "undefined") {
            if (navigator.share) {
                const response = await fetch(canvas);
                const blob = await response.blob();
                // Convert dataURL to Blob
                try {
                    await navigator.share({
                        files: [
                            new File([
                                blob
                            ], "music-recap.png", {
                                type: blob.type
                            })
                        ]
                    });
                } catch (error) {
                    console.error("Error sharing:", error);
                }
            } else alert("Sharing is not supported in your browser!");
        } else {
            const base64Img = canvas.split(",")[1];
            // to receive messages from native
            window.airbudsMessage = function(data) {};
            webkit.messageHandlers.airbudsBridge.postMessage('{"share": {"editable":true,"image": "' + base64Img + '"}}');
        }
        setSharing(false);
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "content sharing-content",
            children: [
                canvas && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                    className: "recap-image",
                    src: canvas
                }),
                !canvas && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    className: "sharingCardContainer",
                    ref: containerRef,
                    children: [
                        !canvas && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                            className: "imageOverlay",
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
                                text: "loading your card..."
                            })
                        }),
                        !canvas && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                            ref: captureRef,
                            className: isIOS ? "sharingCard" : "sharingCardBackground",
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($949ad98624b47189$var$ShareableCard, {
                                data: data
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    className: "sharing-actions",
                    children: [
                        !sharing && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                            className: "big-cta-button",
                            onClick: ()=>{
                                setSharing(true);
                                setTimeout(()=>{
                                    handleCapture();
                                }, 500);
                            },
                            children: "Share your recap"
                        }),
                        sharing && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                            children: "Prepare for sharing..."
                        })
                    ]
                })
            ]
        })
    });
};
var $949ad98624b47189$export$2e2bcd8739ae039 = $949ad98624b47189$var$ShareableComponent;




var $ajtHG = parcelRequire("ajtHG");




function $0e747dcf3025c85b$export$f880c09bcc72f33e(targetDateString) {
    const date = new Date(targetDateString);
    if (!(date instanceof Date)) throw new Error("Invalid input: Parameter must be a Date object.");
    // Get the current date in the user's local time
    const now = new Date();
    // Adjust the input date to a pure local day comparison
    const localInputDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    // Get today's date in local time (midnight start)
    const localToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // Compare if the input date is before today
    return localInputDate.getTime() <= localToday.getTime();
}




const $dcedd9fcf24415e9$var$MenuItem = ({ category: category, locked: locked })=>{
    var lockedClassName = "locked";
    if (locked) lockedClassName = "unlocked";
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: `menu-item ${lockedClassName}`,
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "menu-item-top",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "menu-item-day",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h4", {
                                children: category.weekDay
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                                children: [
                                    category.day,
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("sup", {
                                        children: category.sub
                                    })
                                ]
                            })
                        ]
                    }, category.id),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: `locker ${lockedClassName}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                className: "menu-item-category",
                children: category.title
            })
        ]
    });
};

const $dcedd9fcf24415e9$export$d9b273488cd8ce6f = ({})=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const [showBlocked, setShowBlocked] = (0, $ajtHG.useState)(false);
    const [daysCategories, setDaysCategories] = (0, $ajtHG.useState)([]);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    (0, $ajtHG.useEffect)(()=>{
        if (data == null) return;
        if (!data.top_artists && !data.yingyang && !data.weird_artist && !data.compatible_friends) navigate("/stats");
    }, [
        data
    ]);
    (0, $ajtHG.useEffect)(()=>{
        var categories = [];
        if (!data) return;
        if (data.top_artists && data.top_artists.length > 0) categories.push({
            id: "top-artist",
            weekDay: "Monday",
            day: "16",
            sub: "th",
            title: "Top Artist",
            route: "/artist",
            unlockDate: "2024-12-16T23:00:00"
        });
        if (data.compatible_friends && data.compatible_friends.length >= 1) categories.push({
            id: "most-compatible-friend",
            weekDay: "Tuesday",
            day: "17",
            sub: "th",
            title: "Music Match",
            route: "/compat",
            unlockDate: "2024-12-17T23:00:00"
        });
        categories.push({
            id: "genre-validation",
            weekDay: "Wednesday",
            day: "18",
            sub: "th",
            title: "Get validated",
            route: "/validation",
            unlockDate: "2024-12-18T23:00:00"
        });
        if (data.yingyang || data.weird_artist) categories.push({
            id: "artist-ranking",
            weekDay: "Thursday",
            day: "19",
            sub: "th",
            title: "Ghosted & Opposite Artists",
            unlockDate: "2024-12-19T23:00:00",
            route: "/curiosity"
        });
        categories.push({
            id: "stats",
            weekDay: "Friday",
            day: "20",
            sub: "th",
            title: "All Stats",
            route: "/stats",
            unlockDate: "2024-12-20T23:00:00"
        });
        categories.push({
            id: "recomputed",
            weekDay: "January",
            day: "1",
            sub: "st",
            title: "Recomputed Recap",
            route: "/stats",
            unlockDate: "2025-01-01T23:00:00"
        });
        setDaysCategories(categories);
    }, [
        data
    ]);
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "loading..."
    });
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app menu-app",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "content menu-content",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "menu-header",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                                src: (parcelRequire("2KSlU")),
                                alt: "airbuds yearly recap"
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h1", {
                                children: "Airbuds"
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                children: "Yearly Recap"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                        className: "menu",
                        children: daysCategories.map((category, index)=>{
                            const unlocked = true;
                            var lockedClassName = "locked";
                            if (unlocked) lockedClassName = "unlocked";
                            return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                                className: `menu-item-container ${lockedClassName}`,
                                onClick: ()=>{
                                    if (!unlocked) setShowBlocked(true);
                                    else navigate(category.route);
                                },
                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($dcedd9fcf24415e9$var$MenuItem, {
                                    category: category,
                                    locked: unlocked
                                })
                            }, category.id);
                        })
                    })
                ]
            }),
            showBlocked && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                onClick: ()=>setShowBlocked(false),
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "lock-modal",
                    initial: {
                        opacity: 0,
                        y: "200%"
                    },
                    animate: {
                        opacity: 1,
                        y: "50vh"
                    },
                    exit: {
                        opacity: 1,
                        y: "200%"
                    },
                    transition: {
                        duration: 0.5,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                            class: "locker",
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                                children: " "
                            })
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h1", {
                            children: "Locked"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                            children: "Come back tomorrow to get a new Yearly stat!"
                        })
                    ]
                }, "step-1")
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                hideMenuBanner: true
            })
        ]
    });
};




var $ajtHG = parcelRequire("ajtHG");

var $9cdd1c4e81076dfa$exports = {};
$9cdd1c4e81076dfa$exports = new URL("scratch.148ced95.jpg", import.meta.url).toString();



var $ajtHG = parcelRequire("ajtHG");
function $e0837b7d9dd71c0f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e0837b7d9dd71c0f$var$_setPrototypeOf(subClass, superClass);
}
function $e0837b7d9dd71c0f$var$_setPrototypeOf(o, p) {
    $e0837b7d9dd71c0f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0837b7d9dd71c0f$var$_setPrototypeOf(o, p);
}
var $e0837b7d9dd71c0f$var$Scratch = /*#__PURE__*/ function(_Component) {
    $e0837b7d9dd71c0f$var$_inheritsLoose(Scratch, _Component);
    function Scratch(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.isDrawing = false;
        _this.lastPoint = null;
        _this.isFinished = false;
        _this.reset = function() {
            _this.canvas.style.opacity = '1';
            _this.ctx.globalCompositeOperation = 'source-over';
            _this.ctx.drawImage(_this.image, 0, 0, _this.props.width, _this.props.height);
            _this.isFinished = false;
        };
        _this.handleMouseDown = function(e) {
            _this.isDrawing = true;
            _this.lastPoint = _this.getMouse(e, _this.canvas);
        };
        _this.handleMouseMove = function(e) {
            if (!_this.isDrawing) return;
            e.preventDefault();
            var currentPoint = _this.getMouse(e, _this.canvas);
            var distance = _this.distanceBetween(_this.lastPoint, currentPoint);
            var angle = _this.angleBetween(_this.lastPoint, currentPoint);
            var x, y;
            for(var i = 0; i < distance; i++){
                x = _this.lastPoint ? _this.lastPoint.x + Math.sin(angle) * i : 0;
                y = _this.lastPoint ? _this.lastPoint.y + Math.cos(angle) * i : 0;
                _this.ctx.globalCompositeOperation = 'destination-out';
                if (_this.brushImage && _this.props.customBrush) _this.ctx.drawImage(_this.brushImage, x, y, _this.props.customBrush.width, _this.props.customBrush.height);
                else {
                    _this.ctx.beginPath();
                    _this.ctx.arc(x, y, _this.props.brushSize || 20, 0, 2 * Math.PI, false);
                    _this.ctx.fill();
                }
            }
            _this.lastPoint = currentPoint;
            _this.handlePercentage(_this.getFilledInPixels(32));
        };
        _this.handleMouseUp = function() {
            _this.isDrawing = false;
        };
        _this.state = {
            loaded: false,
            finished: false
        };
        return _this;
    }
    var _proto = Scratch.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this.isDrawing = false;
        this.lastPoint = null;
        this.ctx = this.canvas.getContext('2d');
        this.image = new Image();
        this.image.crossOrigin = 'Anonymous';
        this.image.onload = function() {
            _this2.ctx.drawImage(_this2.image, 0, 0, _this2.props.width, _this2.props.height);
            _this2.setState({
                loaded: true
            });
        };
        this.image.src = this.props.image;
        if (this.props.customBrush) {
            this.brushImage = new Image(this.props.customBrush.width, this.props.customBrush.height);
            this.brushImage.src = this.props.customBrush.image;
        }
    };
    _proto.getFilledInPixels = function getFilledInPixels(stride) {
        if (!stride || stride < 1) stride = 1;
        var x = 0;
        var y = 0;
        var width = this.canvas.width;
        var height = this.canvas.height;
        if (this.props.customCheckZone) {
            x = this.props.customCheckZone.x;
            y = this.props.customCheckZone.y;
            width = this.props.customCheckZone.width;
            height = this.props.customCheckZone.height;
        }
        var pixels = this.ctx.getImageData(x, y, width, height);
        var total = pixels.data.length / stride;
        var count = 0;
        for(var i = 0; i < pixels.data.length; i += stride)if (parseInt(pixels.data[i], 10) === 0) count++;
        return Math.round(count / total * 100);
    };
    _proto.getMouse = function getMouse(e, canvas) {
        var _canvas$getBoundingCl = canvas.getBoundingClientRect(), top = _canvas$getBoundingCl.top, left = _canvas$getBoundingCl.left;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        var x = 0;
        var y = 0;
        if (e && e.pageX && e.pageY) {
            x = e.pageX - left - scrollLeft;
            y = e.pageY - top - scrollTop;
        } else if (e && e.touches) {
            x = e.touches[0].clientX - left - scrollLeft;
            y = e.touches[0].clientY - top - scrollTop;
        }
        return {
            x: x,
            y: y
        };
    };
    _proto.distanceBetween = function distanceBetween(point1, point2) {
        if (point1 && point2) return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
        return 0;
    };
    _proto.angleBetween = function angleBetween(point1, point2) {
        if (point1 && point2) return Math.atan2(point2.x - point1.x, point2.y - point1.y);
        return 0;
    };
    _proto.handlePercentage = function handlePercentage(filledInPixels) {
        if (filledInPixels === void 0) filledInPixels = 0;
        if (this.isFinished) return;
        var finishPercent = 70;
        if (this.props.finishPercent !== undefined) finishPercent = this.props.finishPercent;
        if (filledInPixels > finishPercent) {
            if (this.props.fadeOutOnComplete !== false) {
                this.canvas.style.transition = '1s';
                this.canvas.style.opacity = '0';
            }
            this.setState({
                finished: true
            });
            if (this.props.onComplete) this.props.onComplete();
            this.isFinished = true;
        }
    };
    _proto.render = function render() {
        var _this3 = this;
        var containerStyle = {
            width: this.props.width + 'px',
            height: this.props.height + 'px',
            position: 'relative',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none'
        };
        var canvasStyle = {
            position: 'absolute',
            top: 0,
            zIndex: 1
        };
        var resultStyle = {
            visibility: this.state.loaded ? 'visible' : 'hidden',
            width: '100%',
            height: '100%'
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($ajtHG))).createElement("div", {
            className: 'ScratchCard__Container',
            style: containerStyle
        }, (0, (/*@__PURE__*/$parcel$interopDefault($ajtHG))).createElement("canvas", {
            ref: function ref(_ref) {
                _this3.canvas = _ref;
            },
            className: 'ScratchCard__Canvas',
            style: canvasStyle,
            width: this.props.width,
            height: this.props.height,
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleMouseDown,
            onMouseMove: this.handleMouseMove,
            onTouchMove: this.handleMouseMove,
            onMouseUp: this.handleMouseUp,
            onTouchEnd: this.handleMouseUp
        }), (0, (/*@__PURE__*/$parcel$interopDefault($ajtHG))).createElement("div", {
            className: 'ScratchCard__Result',
            style: resultStyle
        }, this.props.children));
    };
    return Scratch;
}((0, $ajtHG.Component));
var $e0837b7d9dd71c0f$export$b9edca389c4d699a = {
    image: 'data:image/png;base64,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',
    width: 30,
    height: 30
};
var $e0837b7d9dd71c0f$export$2e2bcd8739ae039 = $e0837b7d9dd71c0f$var$Scratch;



var $ajtHG = parcelRequire("ajtHG");

var $2a37c9fd7c8f6baf$var$__defProp = Object.defineProperty;
var $2a37c9fd7c8f6baf$var$__defProps = Object.defineProperties;
var $2a37c9fd7c8f6baf$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2a37c9fd7c8f6baf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2a37c9fd7c8f6baf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2a37c9fd7c8f6baf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2a37c9fd7c8f6baf$var$__defNormalProp = (obj, key, value)=>key in obj ? $2a37c9fd7c8f6baf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2a37c9fd7c8f6baf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2a37c9fd7c8f6baf$var$__hasOwnProp.call(b, prop)) $2a37c9fd7c8f6baf$var$__defNormalProp(a, prop, b[prop]);
    if ($2a37c9fd7c8f6baf$var$__getOwnPropSymbols) {
        for (var prop of $2a37c9fd7c8f6baf$var$__getOwnPropSymbols(b))if ($2a37c9fd7c8f6baf$var$__propIsEnum.call(b, prop)) $2a37c9fd7c8f6baf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2a37c9fd7c8f6baf$var$__spreadProps = (a, b)=>$2a37c9fd7c8f6baf$var$__defProps(a, $2a37c9fd7c8f6baf$var$__getOwnPropDescs(b));
var $2a37c9fd7c8f6baf$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2a37c9fd7c8f6baf$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2a37c9fd7c8f6baf$var$__getOwnPropSymbols) {
        for (var prop of $2a37c9fd7c8f6baf$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2a37c9fd7c8f6baf$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// ../web/dist/index.js
var $2a37c9fd7c8f6baf$var$t0 = Object.defineProperty;
var $2a37c9fd7c8f6baf$var$n0 = Object.defineProperties;
var $2a37c9fd7c8f6baf$var$i0 = Object.getOwnPropertyDescriptors;
var $2a37c9fd7c8f6baf$var$k1 = Object.getOwnPropertySymbols;
var $2a37c9fd7c8f6baf$var$e3 = Object.prototype.hasOwnProperty;
var $2a37c9fd7c8f6baf$var$t3 = Object.prototype.propertyIsEnumerable;
var $2a37c9fd7c8f6baf$var$u2 = (c, n, i)=>n in c ? $2a37c9fd7c8f6baf$var$t0(c, n, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: i
    }) : c[n] = i;
var $2a37c9fd7c8f6baf$var$F = (c, n)=>{
    for(var i in n || (n = {}))$2a37c9fd7c8f6baf$var$e3.call(n, i) && $2a37c9fd7c8f6baf$var$u2(c, i, n[i]);
    if ($2a37c9fd7c8f6baf$var$k1) for (var i of $2a37c9fd7c8f6baf$var$k1(n))$2a37c9fd7c8f6baf$var$t3.call(n, i) && $2a37c9fd7c8f6baf$var$u2(c, i, n[i]);
    return c;
};
var $2a37c9fd7c8f6baf$var$k = (c, n)=>$2a37c9fd7c8f6baf$var$n0(c, $2a37c9fd7c8f6baf$var$i0(n));
var $2a37c9fd7c8f6baf$var$O1 = (c, n)=>{
    var i = {};
    for(var s in c)$2a37c9fd7c8f6baf$var$e3.call(c, s) && n.indexOf(s) < 0 && (i[s] = c[s]);
    if (c != null && $2a37c9fd7c8f6baf$var$k1) for (var s of $2a37c9fd7c8f6baf$var$k1(c))n.indexOf(s) < 0 && $2a37c9fd7c8f6baf$var$t3.call(c, s) && (i[s] = c[s]);
    return i;
};
var $2a37c9fd7c8f6baf$var$_ = (c, n, i)=>$2a37c9fd7c8f6baf$var$u2(c, typeof n != "symbol" ? n + "" : n, i);
var $2a37c9fd7c8f6baf$var$g = (c, n, i)=>new Promise((s, d)=>{
        var m = (P)=>{
            try {
                M(i.next(P));
            } catch (R) {
                d(R);
            }
        }, b = (P)=>{
            try {
                M(i.throw(P));
            } catch (R) {
                d(R);
            }
        }, M = (P)=>P.done ? s(P.value) : Promise.resolve(P.value).then(m, b);
        M((i = i.apply(c, n)).next());
    });
var $2a37c9fd7c8f6baf$var$l2 = class {
    requestAnimationFrame(n) {
        return requestAnimationFrame(n);
    }
    cancelAnimationFrame(n) {
        cancelAnimationFrame(n);
    }
};
var $2a37c9fd7c8f6baf$var$h2 = class {
    constructor(){
        $2a37c9fd7c8f6baf$var$_(this, "_lastHandleId", 0);
        $2a37c9fd7c8f6baf$var$_(this, "_lastImmediate", null);
    }
    requestAnimationFrame(n) {
        return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(()=>{
            n(Date.now());
        }), this._lastHandleId;
    }
    cancelAnimationFrame(n) {
        this._lastImmediate && clearImmediate(this._lastImmediate);
    }
};
var $2a37c9fd7c8f6baf$var$z1 = class {
    constructor(){
        $2a37c9fd7c8f6baf$var$_(this, "_strategy");
        this._strategy = typeof requestAnimationFrame == "function" ? new $2a37c9fd7c8f6baf$var$l2() : new $2a37c9fd7c8f6baf$var$h2();
    }
    requestAnimationFrame(n) {
        return this._strategy.requestAnimationFrame(n);
    }
    cancelAnimationFrame(n) {
        this._strategy.cancelAnimationFrame(n);
    }
};
var $2a37c9fd7c8f6baf$var$A = typeof window != "undefined" && typeof window.document != "undefined";
var $2a37c9fd7c8f6baf$var$W1 = new Uint8Array([
    80,
    75,
    3,
    4
]);
var $2a37c9fd7c8f6baf$var$n3 = [
    "v",
    "ip",
    "op",
    "layers",
    "fr",
    "w",
    "h"
];
var $2a37c9fd7c8f6baf$var$c2 = "0.38.2";
var $2a37c9fd7c8f6baf$var$p2 = "@lottiefiles/dotlottie-web";
var $2a37c9fd7c8f6baf$var$i3 = 0.75;
var $2a37c9fd7c8f6baf$var$r0 = (()=>{
    var n;
    var c = typeof document != "undefined" ? (n = document.currentScript) == null ? void 0 : n.src : void 0;
    return function(i = {}) {
        var s, d = i, m, b, M = new Promise((e, t)=>{
            m = e, b = t;
        }), P = Object.assign({}, d), R = "./this.program", O = "", d1;
        typeof document != "undefined" && document.currentScript && (O = document.currentScript.src), c && (O = c), O.startsWith("blob:") ? O = "" : O = O.substr(0, O.replace(/[?#].*/, "").lastIndexOf("/") + 1), d1 = (e)=>fetch(e, {
                credentials: "same-origin"
            }).then((t)=>t.ok ? t.arrayBuffer() : Promise.reject(Error(t.status + " : " + t.url)));
        var L1 = d.print || console.log.bind(console), K = d.printErr || console.error.bind(console);
        Object.assign(d, P), P = null, d.thisProgram && (R = d.thisProgram);
        var C1 = d.wasmBinary, M1, E1 = false, B1, r1, x, a1, u1, e1, E, b2, L2;
        function C22() {
            var e = M1.buffer;
            d.HEAP8 = r1 = new Int8Array(e), d.HEAP16 = a1 = new Int16Array(e), d.HEAPU8 = x = new Uint8Array(e), d.HEAPU16 = u1 = new Uint16Array(e), d.HEAP32 = e1 = new Int32Array(e), d.HEAPU32 = E = new Uint32Array(e), d.HEAPF32 = b2 = new Float32Array(e), d.HEAPF64 = L2 = new Float64Array(e);
        }
        var M2 = [], E2 = [], P2 = [];
        function c3() {
            var e = d.preRun.shift();
            M2.unshift(e);
        }
        var t1 = 0, l1 = null;
        function P1(e) {
            var t;
            throw (t = d.onAbort) == null || t.call(d, e), e = "Aborted(" + e + ")", K(e), E1 = true, e = new WebAssembly.RuntimeError(e + ". Build with -sASSERTIONS for more info."), b(e), e;
        }
        var I2 = (e)=>e.startsWith("data:application/octet-stream;base64,"), h1;
        function S2(e) {
            if (e == h1 && C1) return new Uint8Array(C1);
            throw "both async and sync fetching of the wasm failed";
        }
        function p3(e) {
            return C1 ? Promise.resolve().then(()=>S2(e)) : d1(e).then((t)=>new Uint8Array(t), ()=>S2(e));
        }
        function T2(e, t, r) {
            return p3(e).then((a)=>WebAssembly.instantiate(a, t)).then(r, (a)=>{
                K(`failed to asynchronously prepare wasm: ${a}`), P1(a);
            });
        }
        function v3(e, t) {
            var r = h1;
            return C1 || typeof WebAssembly.instantiateStreaming != "function" || I2(r) || typeof fetch != "function" ? T2(r, e, t) : fetch(r, {
                credentials: "same-origin"
            }).then((a)=>WebAssembly.instantiateStreaming(a, e).then(t, function(o) {
                    return K(`wasm streaming compile failed: ${o}`), K("falling back to ArrayBuffer instantiation"), T2(r, e, t);
                }));
        }
        class x2 {
            constructor(t){
                $2a37c9fd7c8f6baf$var$_(this, "name", "ExitStatus");
                this.message = `Program terminated with exit(${t})`, this.status = t;
            }
        }
        var H1 = (e)=>{
            for(; 0 < e.length;)e.shift()(d);
        }, N1 = d.noExitRuntime || true, F2 = typeof TextDecoder != "undefined" ? new TextDecoder() : void 0, c1 = (e, t = 0, r = NaN)=>{
            var a = t + r;
            for(r = t; e[r] && !(r >= a);)++r;
            if (16 < r - t && e.buffer && F2) return F2.decode(e.subarray(t, r));
            for(a = ""; t < r;){
                var o = e[t++];
                if (o & 128) {
                    var u = e[t++] & 63;
                    if ((o & 224) == 192) a += String.fromCharCode((o & 31) << 6 | u);
                    else {
                        var h = e[t++] & 63;
                        o = (o & 240) == 224 ? (o & 15) << 12 | u << 6 | h : (o & 7) << 18 | u << 12 | h << 6 | e[t++] & 63, 65536 > o ? a += String.fromCharCode(o) : (o -= 65536, a += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023));
                    }
                } else a += String.fromCharCode(o);
            }
            return a;
        };
        class f3 {
            constructor(t){
                this.wa = t - 24;
            }
        }
        var A2 = 0, p1 = (e, t, r)=>{
            var a = x;
            if (0 < r) {
                r = t + r - 1;
                for(var o = 0; o < e.length; ++o){
                    var u = e.charCodeAt(o);
                    if (55296 <= u && 57343 >= u) {
                        var h = e.charCodeAt(++o);
                        u = 65536 + ((u & 1023) << 10) | h & 1023;
                    }
                    if (127 >= u) {
                        if (t >= r) break;
                        a[t++] = u;
                    } else {
                        if (2047 >= u) {
                            if (t + 1 >= r) break;
                            a[t++] = 192 | u >> 6;
                        } else {
                            if (65535 >= u) {
                                if (t + 2 >= r) break;
                                a[t++] = 224 | u >> 12;
                            } else {
                                if (t + 3 >= r) break;
                                a[t++] = 240 | u >> 18, a[t++] = 128 | u >> 12 & 63;
                            }
                            a[t++] = 128 | u >> 6 & 63;
                        }
                        a[t++] = 128 | u & 63;
                    }
                }
                a[t] = 0;
            }
        }, I1 = {}, V1 = (e)=>{
            for(; e.length;){
                var t = e.pop();
                e.pop()(t);
            }
        };
        function v1(e) {
            return this.fromWireType(E[e >> 2]);
        }
        var o1 = {}, n1 = {}, S1 = {}, f1, Q = (e, t, r)=>{
            function a(l) {
                if (l = r(l), l.length !== e.length) throw new f1("Mismatched type converter count");
                for(var p = 0; p < e.length; ++p)H(e[p], l[p]);
            }
            e.forEach((l)=>S1[l] = t);
            var o = Array(t.length), u = [], h = 0;
            t.forEach((l, p)=>{
                n1.hasOwnProperty(l) ? o[p] = n1[l] : (u.push(l), o1.hasOwnProperty(l) || (o1[l] = []), o1[l].push(()=>{
                    o[p] = n1[l], ++h, h === u.length && a(o);
                }));
            }), u.length === 0 && a(o);
        }, R2, D = (e)=>{
            for(var t = ""; x[e];)t += R2[x[e++]];
            return t;
        }, y;
        function _3(e, t, r = {}) {
            var a = t.name;
            if (!e) throw new y(`type "${a}" must have a positive integer typeid pointer`);
            if (n1.hasOwnProperty(e)) {
                if (r.ab) return;
                throw new y(`Cannot register type '${a}' twice`);
            }
            n1[e] = t, delete S1[e], o1.hasOwnProperty(e) && (t = o1[e], delete o1[e], t.forEach((o)=>o()));
        }
        function H(e, t, r = {}) {
            return _3(e, t, r);
        }
        var J1 = (e)=>{
            throw new y(e.ua.xa.va.name + " instance already deleted");
        }, G1 = false, D2 = ()=>{}, k2 = (e, t, r)=>t === r ? e : r.Aa === void 0 ? null : (e = k2(e, t, r.Aa), e === null ? null : r.Ua(e)), O2 = {}, g3 = {}, y3 = (e, t)=>{
            if (t === void 0) throw new y("ptr should not be undefined");
            for(; e.Aa;)t = e.Ka(t), e = e.Aa;
            return g3[t];
        }, T1 = (e, t)=>{
            if (!t.xa || !t.wa) throw new f1("makeClassHandle requires ptr and ptrType");
            if (!!t.Ba != !!t.za) throw new f1("Both smartPtrType and smartPtr must be specified");
            return t.count = {
                value: 1
            }, m1(Object.create(e, {
                ua: {
                    value: t,
                    writable: true
                }
            }));
        }, m1 = (e)=>typeof FinalizationRegistry == "undefined" ? (m1 = (t)=>t, e) : (G1 = new FinalizationRegistry((t)=>{
                t = t.ua, --t.count.value, t.count.value === 0 && (t.za ? t.Ba.Ea(t.za) : t.xa.va.Ea(t.wa));
            }), m1 = (t)=>{
                var r = t.ua;
                return r.za && G1.register(t, {
                    ua: r
                }, t), t;
            }, D2 = (t)=>{
                G1.unregister(t);
            }, m1(e));
        function x1() {}
        var _1 = (e, t)=>Object.defineProperty(t, "name", {
                value: e
            }), z2 = (e, t, r)=>{
            if (e[t].ya === void 0) {
                var a = e[t];
                e[t] = function(...o) {
                    if (!e[t].ya.hasOwnProperty(o.length)) throw new y(`Function '${r}' called with an invalid number of arguments (${o.length}) - expects one of (${e[t].ya})!`);
                    return e[t].ya[o.length].apply(this, o);
                }, e[t].ya = [], e[t].ya[a.Ha] = a;
            }
        }, q1 = (e, t, r)=>{
            if (d.hasOwnProperty(e)) {
                if (r === void 0 || d[e].ya !== void 0 && d[e].ya[r] !== void 0) throw new y(`Cannot register public name '${e}' twice`);
                if (z2(d, e, e), d[e].ya.hasOwnProperty(r)) throw new y(`Cannot register multiple overloads of a function with the same number of arguments (${r})!`);
                d[e].ya[r] = t;
            } else d[e] = t, d[e].Ha = r;
        }, b3 = (e)=>{
            e = e.replace(/[^a-zA-Z0-9_]/g, "$");
            var t = e.charCodeAt(0);
            return 48 <= t && 57 >= t ? `_${e}` : e;
        };
        function L3(e, t, r, a, o, u, h, l) {
            this.name = e, this.constructor = t, this.Ga = r, this.Ea = a, this.Aa = o, this.Wa = u, this.Ka = h, this.Ua = l, this.cb = [];
        }
        var K1 = (e, t, r)=>{
            for(; t !== r;){
                if (!t.Ka) throw new y(`Expected null or instance of ${r.name}, got an instance of ${t.name}`);
                e = t.Ka(e), t = t.Aa;
            }
            return e;
        };
        function C3(e, t) {
            if (t === null) {
                if (this.Na) throw new y(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!t.ua) throw new y(`Cannot pass "${n2(t)}" as a ${this.name}`);
            if (!t.ua.wa) throw new y(`Cannot pass deleted object as a pointer of type ${this.name}`);
            return K1(t.ua.wa, t.ua.xa.va, this.va);
        }
        function M3(e, t) {
            if (t === null) {
                if (this.Na) throw new y(`null is not a valid ${this.name}`);
                if (this.Ma) {
                    var r = this.Oa();
                    return e !== null && e.push(this.Ea, r), r;
                }
                return 0;
            }
            if (!t || !t.ua) throw new y(`Cannot pass "${n2(t)}" as a ${this.name}`);
            if (!t.ua.wa) throw new y(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (!this.La && t.ua.xa.La) throw new y(`Cannot convert argument of type ${t.ua.Ba ? t.ua.Ba.name : t.ua.xa.name} to parameter type ${this.name}`);
            if (r = K1(t.ua.wa, t.ua.xa.va, this.va), this.Ma) {
                if (t.ua.za === void 0) throw new y("Passing raw pointer to smart pointer is illegal");
                switch(this.ib){
                    case 0:
                        if (t.ua.Ba === this) r = t.ua.za;
                        else throw new y(`Cannot convert argument of type ${t.ua.Ba ? t.ua.Ba.name : t.ua.xa.name} to parameter type ${this.name}`);
                        break;
                    case 1:
                        r = t.ua.za;
                        break;
                    case 2:
                        if (t.ua.Ba === this) r = t.ua.za;
                        else {
                            var a = t.clone();
                            r = this.eb(r, A1(()=>a.delete())), e !== null && e.push(this.Ea, r);
                        }
                        break;
                    default:
                        throw new y("Unsupporting sharing policy");
                }
            }
            return r;
        }
        function E3(e, t) {
            if (t === null) {
                if (this.Na) throw new y(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!t.ua) throw new y(`Cannot pass "${n2(t)}" as a ${this.name}`);
            if (!t.ua.wa) throw new y(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (t.ua.xa.La) throw new y(`Cannot convert argument of type ${t.ua.xa.name} to parameter type ${this.name}`);
            return K1(t.ua.wa, t.ua.xa.va, this.va);
        }
        function g1(e, t, r, a, o, u, h, l, p, v, f) {
            this.name = e, this.va = t, this.Na = r, this.La = a, this.Ma = o, this.bb = u, this.ib = h, this.Sa = l, this.Oa = p, this.eb = v, this.Ea = f, o || t.Aa !== void 0 ? this.toWireType = M3 : (this.toWireType = a ? C3 : E3, this.Da = null);
        }
        var W2 = (e, t, r)=>{
            if (!d.hasOwnProperty(e)) throw new f1("Replacing nonexistent public symbol");
            d[e].ya !== void 0 && r !== void 0 ? d[e].ya[r] = t : (d[e] = t, d[e].Ha = r);
        }, j, P3 = (e, t, r = [])=>(e.includes("j") ? (e = e.replace(/p/g, "i"), t = (0, d["dynCall_" + e])(t, ...r)) : t = j.get(t)(...r), t), I3 = (e, t)=>(...r)=>P3(e, t, r), z = (e, t)=>{
            e = D(e);
            var r = e.includes("j") ? I3(e, t) : j.get(t);
            if (typeof r != "function") throw new y(`unknown function pointer with signature ${e}: ${t}`);
            return r;
        }, $2, U2 = (e)=>{
            e = K2(e);
            var t = D(e);
            return X(e), t;
        }, F1 = (e, t)=>{
            function r(u) {
                o[u] || n1[u] || (S1[u] ? S1[u].forEach(r) : (a.push(u), o[u] = true));
            }
            var a = [], o = {};
            throw t.forEach(r), new $2(`${e}: ` + a.map(U2).join([
                ", "
            ]));
        }, Y1 = (e, t)=>{
            for(var r = [], a = 0; a < e; a++)r.push(E[t + 4 * a >> 2]);
            return r;
        };
        function S3(e) {
            for(var t = 1; t < e.length; ++t)if (e[t] !== null && e[t].Da === void 0) return true;
            return false;
        }
        function X1(e, t, r, a, o) {
            var u = t.length;
            if (2 > u) throw new y("argTypes array size mismatch! Must at least get return value and 'this' types!");
            var h = t[1] !== null && r !== null, l = S3(t), p = t[0].name !== "void", v = u - 2, f = Array(v), w = [], L = [];
            return _1(e, function(...U) {
                if (L.length = 0, w.length = h ? 2 : 1, w[0] = o, h) {
                    var I = t[1].toWireType(L, this);
                    w[1] = I;
                }
                for(var T = 0; T < v; ++T)f[T] = t[T + 2].toWireType(L, U[T]), w.push(f[T]);
                if (U = a(...w), l) V1(L);
                else for(T = h ? 1 : 2; T < t.length; T++){
                    var N = T === 1 ? I : f[T - 2];
                    t[T].Da !== null && t[T].Da(N);
                }
                return I = p ? t[0].fromWireType(U) : void 0, I;
            });
        }
        var B2 = (e)=>{
            e = e.trim();
            let t = e.indexOf("(");
            return t !== -1 ? e.substr(0, t) : e;
        }, Z1 = [], Y = [], Q1 = (e)=>{
            9 < e && --Y[e + 1] === 0 && (Y[e] = void 0, Z1.push(e));
        }, e2 = (e)=>{
            if (!e) throw new y("Cannot use deleted val. handle = " + e);
            return Y[e];
        }, A1 = (e)=>{
            switch(e){
                case void 0:
                    return 2;
                case null:
                    return 4;
                case true:
                    return 6;
                case false:
                    return 8;
                default:
                    let t = Z1.pop() || Y.length;
                    return Y[t] = e, Y[t + 1] = 1, t;
            }
        }, j2 = {
            name: "emscripten::val",
            fromWireType: (e)=>{
                var t = e2(e);
                return Q1(e), t;
            },
            toWireType: (e, t)=>A1(t),
            Ca: 8,
            readValueFromPointer: v1,
            Da: null
        }, T3 = (e, t, r)=>{
            switch(t){
                case 1:
                    return r ? function(a) {
                        return this.fromWireType(r1[a]);
                    } : function(a) {
                        return this.fromWireType(x[a]);
                    };
                case 2:
                    return r ? function(a) {
                        return this.fromWireType(a1[a >> 1]);
                    } : function(a) {
                        return this.fromWireType(u1[a >> 1]);
                    };
                case 4:
                    return r ? function(a) {
                        return this.fromWireType(e1[a >> 2]);
                    } : function(a) {
                        return this.fromWireType(E[a >> 2]);
                    };
                default:
                    throw new TypeError(`invalid integer width (${t}): ${e}`);
            }
        }, t2 = (e, t)=>{
            var r = n1[e];
            if (r === void 0) throw e = `${t} has unknown type ${U2(e)}`, new y(e);
            return r;
        }, n2 = (e)=>{
            if (e === null) return "null";
            var t = typeof e;
            return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
        }, x3 = (e, t)=>{
            switch(t){
                case 4:
                    return function(r) {
                        return this.fromWireType(b2[r >> 2]);
                    };
                case 8:
                    return function(r) {
                        return this.fromWireType(L2[r >> 3]);
                    };
                default:
                    throw new TypeError(`invalid float width (${t}): ${e}`);
            }
        }, F3 = (e, t, r)=>{
            switch(t){
                case 1:
                    return r ? (a)=>r1[a] : (a)=>x[a];
                case 2:
                    return r ? (a)=>a1[a >> 1] : (a)=>u1[a >> 1];
                case 4:
                    return r ? (a)=>e1[a >> 2] : (a)=>E[a >> 2];
                default:
                    throw new TypeError(`invalid integer width (${t}): ${e}`);
            }
        }, A3 = Object.assign({
            optional: true
        }, j2), H2 = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, R3 = (e, t)=>{
            for(var r = e >> 1, a = r + t / 2; !(r >= a) && u1[r];)++r;
            if (r <<= 1, 32 < r - e && H2) return H2.decode(x.subarray(e, r));
            for(r = "", a = 0; !(a >= t / 2); ++a){
                var o = a1[e + 2 * a >> 1];
                if (o == 0) break;
                r += String.fromCharCode(o);
            }
            return r;
        }, D3 = (e, t, r)=>{
            if (r != null || (r = 2147483647), 2 > r) return 0;
            r -= 2;
            var a = t;
            r = r < 2 * e.length ? r / 2 : e.length;
            for(var o = 0; o < r; ++o)a1[t >> 1] = e.charCodeAt(o), t += 2;
            return a1[t >> 1] = 0, t - a;
        }, k3 = (e)=>2 * e.length, O3 = (e, t)=>{
            for(var r = 0, a = ""; !(r >= t / 4);){
                var o = e1[e + 4 * r >> 2];
                if (o == 0) break;
                ++r, 65536 <= o ? (o -= 65536, a += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023)) : a += String.fromCharCode(o);
            }
            return a;
        }, z3 = (e, t, r)=>{
            if (r != null || (r = 2147483647), 4 > r) return 0;
            var a = t;
            r = a + r - 4;
            for(var o = 0; o < e.length; ++o){
                var u = e.charCodeAt(o);
                if (55296 <= u && 57343 >= u) {
                    var h = e.charCodeAt(++o);
                    u = 65536 + ((u & 1023) << 10) | h & 1023;
                }
                if (e1[t >> 2] = u, t += 4, t + 4 > r) break;
            }
            return e1[t >> 2] = 0, t - a;
        }, W3 = (e)=>{
            for(var t = 0, r = 0; r < e.length; ++r){
                var a = e.charCodeAt(r);
                55296 <= a && 57343 >= a && ++r, t += 4;
            }
            return t;
        }, i2 = 0, r2 = [], $3 = (e)=>{
            var t = r2.length;
            return r2.push(e), t;
        }, U3 = (e, t)=>{
            for(var r = Array(e), a = 0; a < e; ++a)r[a] = t2(E[t + 4 * a >> 2], "parameter " + a);
            return r;
        }, B3 = Reflect.construct, y1 = {}, N2 = (e)=>{
            if (!(e instanceof x2 || e == "unwind")) throw e;
        }, V2 = (e)=>{
            var t;
            throw B1 = e, N1 || 0 < i2 || ((t = d.onExit) == null || t.call(d, e), E1 = true), new x2(e);
        }, j3 = (e)=>{
            if (!E1) try {
                if (e(), !(N1 || 0 < i2)) try {
                    B1 = e = B1, V2(e);
                } catch (t) {
                    N2(t);
                }
            } catch (t) {
                N2(t);
            }
        }, a2 = {}, J2 = ()=>{
            if (!o2) {
                var e = {
                    USER: "web_user",
                    LOGNAME: "web_user",
                    PATH: "/",
                    PWD: "/",
                    HOME: "/home/web_user",
                    LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                    _: R || "./this.program"
                }, t;
                for(t in a2)a2[t] === void 0 ? delete e[t] : e[t] = a2[t];
                var r = [];
                for(t in e)r.push(`${t}=${e[t]}`);
                o2 = r;
            }
            return o2;
        }, o2, H3 = [
            null,
            [],
            []
        ], N3 = ()=>{
            if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (e)=>crypto.getRandomValues(e);
            P1("initRandomDevice");
        }, G2 = (e)=>(G2 = N3())(e);
        f1 = d.InternalError = class extends Error {
            constructor(e){
                super(e), this.name = "InternalError";
            }
        };
        for(var q22 = Array(256), R1 = 0; 256 > R1; ++R1)q22[R1] = String.fromCharCode(R1);
        R2 = q22, y = d.BindingError = class extends Error {
            constructor(e){
                super(e), this.name = "BindingError";
            }
        }, Object.assign(x1.prototype, {
            isAliasOf: function(e) {
                if (!(this instanceof x1 && e instanceof x1)) return false;
                var t = this.ua.xa.va, r = this.ua.wa;
                e.ua = e.ua;
                var a = e.ua.xa.va;
                for(e = e.ua.wa; t.Aa;)r = t.Ka(r), t = t.Aa;
                for(; a.Aa;)e = a.Ka(e), a = a.Aa;
                return t === a && r === e;
            },
            clone: function() {
                if (this.ua.wa || J1(this), this.ua.Ja) return this.ua.count.value += 1, this;
                var e = m1, t = Object, r = t.create, a = Object.getPrototypeOf(this), o = this.ua;
                return e = e(r.call(t, a, {
                    ua: {
                        value: {
                            count: o.count,
                            Ia: o.Ia,
                            Ja: o.Ja,
                            wa: o.wa,
                            xa: o.xa,
                            za: o.za,
                            Ba: o.Ba
                        }
                    }
                })), e.ua.count.value += 1, e.ua.Ia = false, e;
            },
            delete () {
                if (this.ua.wa || J1(this), this.ua.Ia && !this.ua.Ja) throw new y("Object already scheduled for deletion");
                D2(this);
                var e = this.ua;
                --e.count.value, e.count.value === 0 && (e.za ? e.Ba.Ea(e.za) : e.xa.va.Ea(e.wa)), this.ua.Ja || (this.ua.za = void 0, this.ua.wa = void 0);
            },
            isDeleted: function() {
                return !this.ua.wa;
            },
            deleteLater: function() {
                if (this.ua.wa || J1(this), this.ua.Ia && !this.ua.Ja) throw new y("Object already scheduled for deletion");
                return this.ua.Ia = true, this;
            }
        }), Object.assign(g1.prototype, {
            Xa (e) {
                return this.Sa && (e = this.Sa(e)), e;
            },
            Qa (e) {
                var t;
                (t = this.Ea) == null || t.call(this, e);
            },
            Ca: 8,
            readValueFromPointer: v1,
            fromWireType: function(e) {
                function t() {
                    return this.Ma ? T1(this.va.Ga, {
                        xa: this.bb,
                        wa: r,
                        Ba: this,
                        za: e
                    }) : T1(this.va.Ga, {
                        xa: this,
                        wa: e
                    });
                }
                var r = this.Xa(e);
                if (!r) return this.Qa(e), null;
                var a = y3(this.va, r);
                if (a !== void 0) return a.ua.count.value === 0 ? (a.ua.wa = r, a.ua.za = e, a.clone()) : (a = a.clone(), this.Qa(e), a);
                if (a = this.va.Wa(r), a = O2[a], !a) return t.call(this);
                a = this.La ? a.Ta : a.pointerType;
                var o = k2(r, this.va, a.va);
                return o === null ? t.call(this) : this.Ma ? T1(a.va.Ga, {
                    xa: a,
                    wa: o,
                    Ba: this,
                    za: e
                }) : T1(a.va.Ga, {
                    xa: a,
                    wa: o
                });
            }
        }), $2 = d.UnboundTypeError = ((e, t)=>{
            var r = _1(t, function(a) {
                this.name = t, this.message = a, a = Error(a).stack, a !== void 0 && (this.stack = this.toString() + `
` + a.replace(/^Error(:[^\n]*)?\n/, ""));
            });
            return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function() {
                return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
            }, r;
        })(Error, "UnboundTypeError"), Y.push(0, 1, void 0, 1, null, 1, true, 1, false, 1), d.count_emval_handles = ()=>Y.length / 2 - 5 - Z1.length;
        var V3 = {
            c: (e, t, r, a)=>P1(`Assertion failed: ${e ? c1(x, e) : ""}, at: ` + [
                    t ? t ? c1(x, t) : "" : "unknown filename",
                    r,
                    a ? a ? c1(x, a) : "" : "unknown function"
                ]),
            m: (e, t, r)=>{
                var a = new f3(e);
                throw E[a.wa + 16 >> 2] = 0, E[a.wa + 4 >> 2] = t, E[a.wa + 8 >> 2] = r, A2 = e, A2;
            },
            M: ()=>{},
            J: ()=>{},
            K: ()=>{},
            P: function() {},
            L: ()=>{},
            R: ()=>P1(""),
            v: (e)=>{
                var t = I1[e];
                delete I1[e];
                var r = t.Oa, a = t.Ea, o = t.Ra, u = o.map((h)=>h.$a).concat(o.map((h)=>h.gb));
                Q([
                    e
                ], u, (h)=>{
                    var l = {};
                    return o.forEach((p, v)=>{
                        var f = h[v], w = p.Ya, L = p.Za, U = h[v + o.length], I = p.fb, T = p.hb;
                        l[p.Va] = {
                            read: (N)=>f.fromWireType(w(L, N)),
                            write: (N, w1)=>{
                                var B = [];
                                I(T, N, U.toWireType(B, w1)), V1(B);
                            }
                        };
                    }), [
                        {
                            name: t.name,
                            fromWireType: (p)=>{
                                var v = {}, f;
                                for(f in l)v[f] = l[f].read(p);
                                return a(p), v;
                            },
                            toWireType: (p, v)=>{
                                for(var f in l)if (!(f in v)) throw new TypeError(`Missing field: "${f}"`);
                                var w = r();
                                for(f in l)l[f].write(w, v[f]);
                                return p !== null && p.push(a, w), w;
                            },
                            Ca: 8,
                            readValueFromPointer: v1,
                            Da: a
                        }
                    ];
                });
            },
            C: ()=>{},
            W: (e, t, r, a)=>{
                t = D(t), H(e, {
                    name: t,
                    fromWireType: function(o) {
                        return !!o;
                    },
                    toWireType: function(o, u) {
                        return u ? r : a;
                    },
                    Ca: 8,
                    readValueFromPointer: function(o) {
                        return this.fromWireType(x[o]);
                    },
                    Da: null
                });
            },
            r: (e, t, r, a, o, u, h, l, p, v, f, w, L)=>{
                f = D(f), u = z(o, u), l && (l = z(h, l)), v && (v = z(p, v)), L = z(w, L);
                var U = b3(f);
                q1(U, function() {
                    F1(`Cannot construct ${f} due to unbound types`, [
                        a
                    ]);
                }), Q([
                    e,
                    t,
                    r
                ], a ? [
                    a
                ] : [], (I)=>{
                    if (I = I[0], a) var T = I.va, N = T.Ga;
                    else N = x1.prototype;
                    I = _1(f, function(...d2) {
                        if (Object.getPrototypeOf(this) !== w1) throw new y("Use 'new' to construct " + f);
                        if (B.Fa === void 0) throw new y(f + " has no accessible constructor");
                        var Q2 = B.Fa[d2.length];
                        if (Q2 === void 0) throw new y(`Tried to invoke ctor of ${f} with invalid number of parameters (${d2.length}) - expected (${Object.keys(B.Fa).toString()}) parameters instead!`);
                        return Q2.apply(this, d2);
                    });
                    var w1 = Object.create(N, {
                        constructor: {
                            value: I
                        }
                    });
                    I.prototype = w1;
                    var B = new L3(f, I, w1, L, T, u, l, v);
                    if (B.Aa) {
                        var b1;
                        (b1 = B.Aa).Pa != null || (b1.Pa = []), B.Aa.Pa.push(B);
                    }
                    return T = new g1(f, B, true, false, false), b1 = new g1(f + "*", B, false, false, false), N = new g1(f + " const*", B, false, true, false), O2[e] = {
                        pointerType: b1,
                        Ta: N
                    }, W2(U, I), [
                        T,
                        b1,
                        N
                    ];
                });
            },
            q: (e, t, r, a, o, u)=>{
                var h = Y1(t, r);
                o = z(a, o), Q([], [
                    e
                ], (l)=>{
                    l = l[0];
                    var p = `constructor ${l.name}`;
                    if (l.va.Fa === void 0 && (l.va.Fa = []), l.va.Fa[t - 1] !== void 0) throw new y(`Cannot register multiple constructors with identical number of parameters (${t - 1}) for class '${l.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                    return l.va.Fa[t - 1] = ()=>{
                        F1(`Cannot construct ${l.name} due to unbound types`, h);
                    }, Q([], h, (v)=>(v.splice(1, 0, null), l.va.Fa[t - 1] = X1(p, v, null, o, u), [])), [];
                });
            },
            f: (e, t, r, a, o, u, h, l)=>{
                var p = Y1(r, a);
                t = D(t), t = B2(t), u = z(o, u), Q([], [
                    e
                ], (v)=>{
                    function f() {
                        F1(`Cannot call ${w} due to unbound types`, p);
                    }
                    v = v[0];
                    var w = `${v.name}.${t}`;
                    t.startsWith("@@") && (t = Symbol[t.substring(2)]), l && v.va.cb.push(t);
                    var L = v.va.Ga, U = L[t];
                    return U === void 0 || U.ya === void 0 && U.className !== v.name && U.Ha === r - 2 ? (f.Ha = r - 2, f.className = v.name, L[t] = f) : (z2(L, t, w), L[t].ya[r - 2] = f), Q([], p, (I)=>(I = X1(w, I, v, u, h), L[t].ya === void 0 ? (I.Ha = r - 2, L[t] = I) : L[t].ya[r - 2] = I, [])), [];
                });
            },
            V: (e)=>H(e, j2),
            x: (e, t, r, a)=>{
                function o() {}
                t = D(t), o.values = {}, H(e, {
                    name: t,
                    constructor: o,
                    fromWireType: function(u) {
                        return this.constructor.values[u];
                    },
                    toWireType: (u, h)=>h.value,
                    Ca: 8,
                    readValueFromPointer: T3(t, r, a),
                    Da: null
                }), q1(t, o);
            },
            k: (e, t, r)=>{
                var a = t2(e, "enum");
                t = D(t), e = a.constructor, a = Object.create(a.constructor.prototype, {
                    value: {
                        value: r
                    },
                    constructor: {
                        value: _1(`${a.name}_${t}`, function() {})
                    }
                }), e.values[r] = a, e[t] = a;
            },
            z: (e, t, r)=>{
                t = D(t), H(e, {
                    name: t,
                    fromWireType: (a)=>a,
                    toWireType: (a, o)=>o,
                    Ca: 8,
                    readValueFromPointer: x3(t, r),
                    Da: null
                });
            },
            u: (e, t, r, a, o, u)=>{
                var h = Y1(t, r);
                e = D(e), e = B2(e), o = z(a, o), q1(e, function() {
                    F1(`Cannot call ${e} due to unbound types`, h);
                }, t - 1), Q([], h, (l)=>(W2(e, X1(e, [
                        l[0],
                        null
                    ].concat(l.slice(1)), null, o, u), t - 1), []));
            },
            l: (e, t, r, a, o)=>{
                if (t = D(t), o === -1 && (o = 4294967295), o = (l)=>l, a === 0) {
                    var u = 32 - 8 * r;
                    o = (l)=>l << u >>> u;
                }
                var h = t.includes("unsigned") ? function(l, p) {
                    return p >>> 0;
                } : function(l, p) {
                    return p;
                };
                H(e, {
                    name: t,
                    fromWireType: o,
                    toWireType: h,
                    Ca: 8,
                    readValueFromPointer: F3(t, r, a !== 0),
                    Da: null
                });
            },
            h: (e, t, r)=>{
                function a(u) {
                    return new o(r1.buffer, E[u + 4 >> 2], E[u >> 2]);
                }
                var o = [
                    Int8Array,
                    Uint8Array,
                    Int16Array,
                    Uint16Array,
                    Int32Array,
                    Uint32Array,
                    Float32Array,
                    Float64Array
                ][t];
                r = D(r), H(e, {
                    name: r,
                    fromWireType: a,
                    Ca: 8,
                    readValueFromPointer: a
                }, {
                    ab: true
                });
            },
            t: (e)=>{
                H(e, A3);
            },
            aa: (e, t, r, a, o, u, h, l, p, v, f, w)=>{
                r = D(r), u = z(o, u), l = z(h, l), v = z(p, v), w = z(f, w), Q([
                    e
                ], [
                    t
                ], (L)=>(L = L[0], [
                        new g1(r, L.va, false, false, true, L, a, u, l, v, w)
                    ]));
            },
            A: (e, t)=>{
                t = D(t);
                var r = t === "std::string";
                H(e, {
                    name: t,
                    fromWireType: function(a) {
                        var o = E[a >> 2], u = a + 4;
                        if (r) for(var h = u, l = 0; l <= o; ++l){
                            var p = u + l;
                            if (l == o || x[p] == 0) {
                                if (h = h ? c1(x, h, p - h) : "", v === void 0) var v = h;
                                else v += "\0", v += h;
                                h = p + 1;
                            }
                        }
                        else {
                            for(v = Array(o), l = 0; l < o; ++l)v[l] = String.fromCharCode(x[u + l]);
                            v = v.join("");
                        }
                        return X(a), v;
                    },
                    toWireType: function(a, o) {
                        o instanceof ArrayBuffer && (o = new Uint8Array(o));
                        var u, h = typeof o == "string";
                        if (!(h || o instanceof Uint8Array || o instanceof Uint8ClampedArray || o instanceof Int8Array)) throw new y("Cannot pass non-string to std::string");
                        if (r && h) for(var l = u = 0; l < o.length; ++l){
                            var p = o.charCodeAt(l);
                            127 >= p ? u++ : 2047 >= p ? u += 2 : 55296 <= p && 57343 >= p ? (u += 4, ++l) : u += 3;
                        }
                        else u = o.length;
                        if (l = s2(4 + u + 1), p = l + 4, E[l >> 2] = u, r && h) p1(o, p, u + 1);
                        else if (h) for(h = 0; h < u; ++h){
                            var v = o.charCodeAt(h);
                            if (255 < v) throw X(p), new y("String has UTF-16 code units that do not fit in 8 bits");
                            x[p + h] = v;
                        }
                        else for(h = 0; h < u; ++h)x[p + h] = o[h];
                        return a !== null && a.push(X, l), l;
                    },
                    Ca: 8,
                    readValueFromPointer: v1,
                    Da (a) {
                        X(a);
                    }
                });
            },
            s: (e, t, r)=>{
                if (r = D(r), t === 2) var a = R3, o = D3, u = k3, h = (l)=>u1[l >> 1];
                else t === 4 && (a = O3, o = z3, u = W3, h = (l)=>E[l >> 2]);
                H(e, {
                    name: r,
                    fromWireType: (l)=>{
                        for(var p = E[l >> 2], v, f = l + 4, w = 0; w <= p; ++w){
                            var L = l + 4 + w * t;
                            (w == p || h(L) == 0) && (f = a(f, L - f), v === void 0 ? v = f : (v += "\0", v += f), f = L + t);
                        }
                        return X(l), v;
                    },
                    toWireType: (l, p)=>{
                        if (typeof p != "string") throw new y(`Cannot pass non-string to C++ string type ${r}`);
                        var v = u(p), f = s2(4 + v + t);
                        return E[f >> 2] = v / t, o(p, f + 4, v + t), l !== null && l.push(X, f), f;
                    },
                    Ca: 8,
                    readValueFromPointer: v1,
                    Da (l) {
                        X(l);
                    }
                });
            },
            w: (e, t, r, a, o, u)=>{
                I1[e] = {
                    name: D(t),
                    Oa: z(r, a),
                    Ea: z(o, u),
                    Ra: []
                };
            },
            j: (e, t, r, a, o, u, h, l, p, v)=>{
                I1[e].Ra.push({
                    Va: D(t),
                    $a: r,
                    Ya: z(a, o),
                    Za: u,
                    gb: h,
                    fb: z(l, p),
                    hb: v
                });
            },
            X: (e, t)=>{
                t = D(t), H(e, {
                    jb: true,
                    name: t,
                    Ca: 0,
                    fromWireType: ()=>{},
                    toWireType: ()=>{}
                });
            },
            H: ()=>{
                N1 = false, i2 = 0;
            },
            D: ()=>{
                throw 1 / 0;
            },
            _: (e, t, r, a)=>(e = r2[e], t = e2(t), e(null, t, r, a)),
            B: Q1,
            Z: (e, t, r)=>{
                var a = U3(e, t), o = a.shift();
                e--;
                var u = Array(e);
                return t = `methodCaller<(${a.map((h)=>h.name).join(", ")}) => ${o.name}>`, $3(_1(t, (h, l, p, v)=>{
                    for(var f = 0, w = 0; w < e; ++w)u[w] = a[w].readValueFromPointer(v + f), f += a[w].Ca;
                    return l = r === 1 ? B3(l, u) : l.apply(h, u), h = [], l = o.toWireType(h, l), h.length && (E[p >> 2] = A1(h)), l;
                }));
            },
            $: (e)=>{
                9 < e && (Y[e + 1] += 1);
            },
            Y: (e)=>{
                var t = e2(e);
                V1(t), Q1(e);
            },
            o: (e, t)=>(e = t2(e, "_emval_take_value"), e = e.readValueFromPointer(t), A1(e)),
            E: (e, t)=>{
                if (y1[e] && (clearTimeout(y1[e].id), delete y1[e]), !t) return 0;
                var r = setTimeout(()=>{
                    delete y1[e], j3(()=>Y2(e, performance.now()));
                }, t);
                return y1[e] = {
                    id: r,
                    kb: t
                }, 0;
            },
            F: (e, t, r, a)=>{
                var o = /* @__PURE__ */ new Date().getFullYear(), u = new Date(o, 0, 1).getTimezoneOffset();
                o = new Date(o, 6, 1).getTimezoneOffset(), E[e >> 2] = 60 * Math.max(u, o), e1[t >> 2] = +(u != o), t = (h)=>{
                    var l = Math.abs(h);
                    return `UTC${0 <= h ? "-" : "+"}${String(Math.floor(l / 60)).padStart(2, "0")}${String(l % 60).padStart(2, "0")}`;
                }, e = t(u), t = t(o), o < u ? (p1(e, r, 17), p1(t, a, 17)) : (p1(e, a, 17), p1(t, r, 17));
            },
            ba: ()=>performance.now(),
            G: (e)=>{
                var t = x.length;
                if (e >>>= 0, 2147483648 < e) return false;
                for(var r = 1; 4 >= r; r *= 2){
                    var a = t * (1 + 0.2 / r);
                    a = Math.min(a, e + 100663296);
                    e: {
                        a = (Math.min(2147483648, 65536 * Math.ceil(Math.max(e, a) / 65536)) - M1.buffer.byteLength + 65535) / 65536 | 0;
                        try {
                            M1.grow(a), C22();
                            var o = 1;
                            break e;
                        } catch (u) {}
                        o = void 0;
                    }
                    if (o) return true;
                }
                return false;
            },
            T: (e, t)=>{
                var r = 0;
                return J2().forEach((a, o)=>{
                    var u = t + r;
                    for(o = E[e + 4 * o >> 2] = u, u = 0; u < a.length; ++u)r1[o++] = a.charCodeAt(u);
                    r1[o] = 0, r += a.length + 1;
                }), 0;
            },
            U: (e, t)=>{
                var r = J2();
                E[e >> 2] = r.length;
                var a = 0;
                return r.forEach((o)=>a += o.length + 1), E[t >> 2] = a, 0;
            },
            Q: ()=>52,
            O: ()=>52,
            N: (e, t, r, a)=>{
                for(var o = 0, u = 0; u < r; u++){
                    var h = E[t >> 2], l = E[t + 4 >> 2];
                    t += 8;
                    for(var p = 0; p < l; p++){
                        var v = e, f = x[h + p], w = H3[v];
                        f === 0 || f === 10 ? ((v === 1 ? L1 : K)(c1(w)), w.length = 0) : w.push(f);
                    }
                    o += l;
                }
                return E[a >> 2] = o, 0;
            },
            i: Y3,
            d: K3,
            e: q3,
            p: X3,
            y: e0,
            b: G3,
            a: J3,
            g: Q3,
            n: Z3,
            S: V2,
            I: (e, t)=>(G2(x.subarray(e, e + t)), 0)
        }, S = function() {
            var r;
            function e(a) {
                var o;
                return S = a.exports, M1 = S.ca, C22(), j = S.ga, E2.unshift(S.da), t1--, (o = d.monitorRunDependencies) == null || o.call(d, t1), t1 == 0 && l1 && (a = l1, l1 = null, a()), S;
            }
            t1++, (r = d.monitorRunDependencies) == null || r.call(d, t1);
            var t = {
                a: V3
            };
            if (d.instantiateWasm) try {
                return d.instantiateWasm(t, e);
            } catch (a) {
                K(`Module.instantiateWasm callback failed with error: ${a}`), b(a);
            }
            return h1 != null || (h1 = I2("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : d.locateFile ? d.locateFile("DotLottiePlayer.wasm", O) : O + "DotLottiePlayer.wasm"), v3(t, function(a) {
                e(a.instance);
            }).catch(b), {};
        }(), s2 = (e)=>(s2 = S.ea)(e), K2 = (e)=>(K2 = S.fa)(e), X = (e)=>(X = S.ha)(e), Y2 = (e, t)=>(Y2 = S.ia)(e, t), V = (e, t)=>(V = S.ja)(e, t), J = (e)=>(J = S.ka)(e), G = ()=>(G = S.la)();
        d.dynCall_iijj = (e, t, r, a, o, u)=>(d.dynCall_iijj = S.ma)(e, t, r, a, o, u), d.dynCall_vijj = (e, t, r, a, o, u)=>(d.dynCall_vijj = S.na)(e, t, r, a, o, u), d.dynCall_jiii = (e, t, r, a)=>(d.dynCall_jiii = S.oa)(e, t, r, a), d.dynCall_jii = (e, t, r)=>(d.dynCall_jii = S.pa)(e, t, r), d.dynCall_viijii = (e, t, r, a, o, u, h)=>(d.dynCall_viijii = S.qa)(e, t, r, a, o, u, h), d.dynCall_iiiiij = (e, t, r, a, o, u, h)=>(d.dynCall_iiiiij = S.ra)(e, t, r, a, o, u, h), d.dynCall_iiiiijj = (e, t, r, a, o, u, h, l, p)=>(d.dynCall_iiiiijj = S.sa)(e, t, r, a, o, u, h, l, p), d.dynCall_iiiiiijj = (e, t, r, a, o, u, h, l, p, v)=>(d.dynCall_iiiiiijj = S.ta)(e, t, r, a, o, u, h, l, p, v);
        function J3(e, t, r) {
            var a = G();
            try {
                j.get(e)(t, r);
            } catch (o) {
                if (J(a), o !== o + 0) throw o;
                V(1, 0);
            }
        }
        function G3(e, t) {
            var r = G();
            try {
                j.get(e)(t);
            } catch (a) {
                if (J(r), a !== a + 0) throw a;
                V(1, 0);
            }
        }
        function q3(e, t, r, a) {
            var o = G();
            try {
                return j.get(e)(t, r, a);
            } catch (u) {
                if (J(o), u !== u + 0) throw u;
                V(1, 0);
            }
        }
        function K3(e, t, r) {
            var a = G();
            try {
                return j.get(e)(t, r);
            } catch (o) {
                if (J(a), o !== o + 0) throw o;
                V(1, 0);
            }
        }
        function Y3(e, t) {
            var r = G();
            try {
                return j.get(e)(t);
            } catch (a) {
                if (J(r), a !== a + 0) throw a;
                V(1, 0);
            }
        }
        function X3(e, t, r, a, o, u) {
            var h = G();
            try {
                return j.get(e)(t, r, a, o, u);
            } catch (l) {
                if (J(h), l !== l + 0) throw l;
                V(1, 0);
            }
        }
        function Z3(e, t, r, a, o) {
            var u = G();
            try {
                j.get(e)(t, r, a, o);
            } catch (h) {
                if (J(u), h !== h + 0) throw h;
                V(1, 0);
            }
        }
        function Q3(e, t, r, a) {
            var o = G();
            try {
                j.get(e)(t, r, a);
            } catch (u) {
                if (J(o), u !== u + 0) throw u;
                V(1, 0);
            }
        }
        function e0(e) {
            var t = G();
            try {
                j.get(e)();
            } catch (r) {
                if (J(t), r !== r + 0) throw r;
                V(1, 0);
            }
        }
        var D1;
        l1 = function e() {
            D1 || X2(), D1 || (l1 = e);
        };
        function X2() {
            function e() {
                var r;
                if (!D1 && (D1 = true, d.calledRun = true, !E1)) {
                    if (H1(E2), m(d), (r = d.onRuntimeInitialized) == null || r.call(d), d.postRun) for(typeof d.postRun == "function" && (d.postRun = [
                        d.postRun
                    ]); d.postRun.length;){
                        var t = d.postRun.shift();
                        P2.unshift(t);
                    }
                    H1(P2);
                }
            }
            if (!(0 < t1)) {
                if (d.preRun) for(typeof d.preRun == "function" && (d.preRun = [
                    d.preRun
                ]); d.preRun.length;)c3();
                H1(M2), 0 < t1 || (d.setStatus ? (d.setStatus("Running..."), setTimeout(()=>{
                    setTimeout(()=>d.setStatus(""), 1), e();
                }, 1)) : e());
            }
        }
        if (d.preInit) for(typeof d.preInit == "function" && (d.preInit = [
            d.preInit
        ]); 0 < d.preInit.length;)d.preInit.pop()();
        return X2(), s = M, s;
    };
})();
var $2a37c9fd7c8f6baf$var$r3 = $2a37c9fd7c8f6baf$var$r0;
var $2a37c9fd7c8f6baf$var$i1 = class {
    constructor(){
        throw new Error("RendererLoader is a static class and cannot be instantiated.");
    }
    static _tryLoad(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            return yield $2a37c9fd7c8f6baf$var$r3({
                locateFile: ()=>n
            });
        });
    }
    static _loadWithBackup() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch((n)=>$2a37c9fd7c8f6baf$var$g(this, null, function*() {
                    let i = `https://unpkg.com/${$2a37c9fd7c8f6baf$var$p2}@${$2a37c9fd7c8f6baf$var$c2}/dist/dotlottie-player.wasm`;
                    console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${n.message}`), console.warn(`Attempting to load WASM from backup URL: ${i}`);
                    try {
                        return yield this._tryLoad(i);
                    } catch (s) {
                        throw console.error(`Primary WASM URL failed: ${n.message}`), console.error(`Backup WASM URL failed: ${s.message}`), new Error("WASM loading failed from all sources.");
                    }
                }))), this._ModulePromise;
        });
    }
    static load() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            return this._loadWithBackup();
        });
    }
    static setWasmUrl(n) {
        n !== this._wasmURL && (this._wasmURL = n, this._ModulePromise = null);
    }
};
$2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$i1, "_ModulePromise", null), $2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$i1, "_wasmURL", `https://cdn.jsdelivr.net/npm/${$2a37c9fd7c8f6baf$var$p2}@${$2a37c9fd7c8f6baf$var$c2}/dist/dotlottie-player.wasm`);
var $2a37c9fd7c8f6baf$var$s1 = class {
    constructor(){
        $2a37c9fd7c8f6baf$var$_(this, "_eventListeners", /* @__PURE__ */ new Map());
    }
    addEventListener(n, i) {
        let s = this._eventListeners.get(n);
        s || (s = /* @__PURE__ */ new Set(), this._eventListeners.set(n, s)), s.add(i);
    }
    removeEventListener(n, i) {
        let s = this._eventListeners.get(n);
        s && (i ? (s.delete(i), s.size === 0 && this._eventListeners.delete(n)) : this._eventListeners.delete(n));
    }
    dispatch(n) {
        let i = this._eventListeners.get(n.type);
        i == null || i.forEach((s)=>s(n));
    }
    removeAllEventListeners() {
        this._eventListeners.clear();
    }
};
var $2a37c9fd7c8f6baf$var$W = class {
    static _initializeObserver() {
        if (this._observer) return;
        let n = (i)=>{
            i.forEach((s)=>{
                let d = this._observedCanvases.get(s.target);
                d && (s.isIntersecting ? d.unfreeze() : d.freeze());
            });
        };
        this._observer = new IntersectionObserver(n, {
            threshold: 0
        });
    }
    static observe(n, i) {
        var s;
        this._initializeObserver(), !this._observedCanvases.has(n) && (this._observedCanvases.set(n, i), (s = this._observer) == null || s.observe(n));
    }
    static unobserve(n) {
        var i, s;
        (i = this._observer) == null || i.unobserve(n), this._observedCanvases.delete(n), this._observedCanvases.size === 0 && ((s = this._observer) == null || s.disconnect(), this._observer = null);
    }
};
$2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$W, "_observer", null), $2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$W, "_observedCanvases", /* @__PURE__ */ new Map());
var $2a37c9fd7c8f6baf$var$$ = class {
    static _initializeObserver() {
        if (this._observer) return;
        let n = (i)=>{
            i.forEach((s)=>{
                let d = this._observedCanvases.get(s.target);
                if (!d) return;
                let [m, b] = d;
                clearTimeout(b);
                let M = setTimeout(()=>{
                    m.resize();
                }, 100);
                this._observedCanvases.set(s.target, [
                    m,
                    M
                ]);
            });
        };
        this._observer = new ResizeObserver(n);
    }
    static observe(n, i) {
        var s;
        this._initializeObserver(), !this._observedCanvases.has(n) && (this._observedCanvases.set(n, [
            i,
            0
        ]), (s = this._observer) == null || s.observe(n));
    }
    static unobserve(n) {
        var i, s;
        (i = this._observer) == null || i.unobserve(n), this._observedCanvases.delete(n), this._observedCanvases.size === 0 && ((s = this._observer) == null || s.disconnect(), this._observer = null);
    }
};
$2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$$, "_observer", null), $2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$$, "_observedCanvases", /* @__PURE__ */ new Map());
function $2a37c9fd7c8f6baf$var$a0(c) {
    return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(c);
}
function $2a37c9fd7c8f6baf$var$o3(c) {
    if (!$2a37c9fd7c8f6baf$var$a0(c)) return 0;
    let n = c.replace("#", "");
    return n = n.length === 6 ? `${n}ff` : n, parseInt(n, 16);
}
function $2a37c9fd7c8f6baf$var$v2(c) {
    if (c.byteLength < 4) return false;
    let n = new Uint8Array(c.slice(0, $2a37c9fd7c8f6baf$var$W1.byteLength));
    for(let i = 0; i < $2a37c9fd7c8f6baf$var$W1.length; i += 1)if ($2a37c9fd7c8f6baf$var$W1[i] !== n[i]) return false;
    return true;
}
function $2a37c9fd7c8f6baf$var$a3(c) {
    return $2a37c9fd7c8f6baf$var$n3.every((n)=>Object.prototype.hasOwnProperty.call(c, n));
}
function $2a37c9fd7c8f6baf$var$f2(c) {
    if (typeof c == "string") try {
        return $2a37c9fd7c8f6baf$var$a3(JSON.parse(c));
    } catch (n) {
        return false;
    }
    else return $2a37c9fd7c8f6baf$var$a3(c);
}
function $2a37c9fd7c8f6baf$var$Z() {
    return 1 + (($2a37c9fd7c8f6baf$var$A ? window.devicePixelRatio : 1) - 1) * $2a37c9fd7c8f6baf$var$i3;
}
function $2a37c9fd7c8f6baf$var$$1(c) {
    let n = c.getBoundingClientRect();
    return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var $2a37c9fd7c8f6baf$var$m2 = (c, n)=>c === "reverse" ? n.Mode.Reverse : c === "bounce" ? n.Mode.Bounce : c === "reverse-bounce" ? n.Mode.ReverseBounce : n.Mode.Forward;
var $2a37c9fd7c8f6baf$var$_2 = (c, n)=>c === "contain" ? n.Fit.Contain : c === "cover" ? n.Fit.Cover : c === "fill" ? n.Fit.Fill : c === "fit-height" ? n.Fit.FitHeight : c === "fit-width" ? n.Fit.FitWidth : n.Fit.None;
var $2a37c9fd7c8f6baf$var$g2 = (c, n)=>{
    let i = new n.VectorFloat();
    return i.push_back(c[0]), i.push_back(c[1]), i;
};
var $2a37c9fd7c8f6baf$var$y2 = (c, n)=>{
    let i = new n.VectorFloat();
    return c.length !== 2 || (i.push_back(c[0]), i.push_back(c[1])), i;
};
var $2a37c9fd7c8f6baf$var$C = class C2 {
    constructor(n){
        $2a37c9fd7c8f6baf$var$_(this, "_canvas");
        $2a37c9fd7c8f6baf$var$_(this, "_context", null);
        $2a37c9fd7c8f6baf$var$_(this, "_eventManager");
        $2a37c9fd7c8f6baf$var$_(this, "_animationFrameId", null);
        $2a37c9fd7c8f6baf$var$_(this, "_frameManager");
        $2a37c9fd7c8f6baf$var$_(this, "_dotLottieCore", null);
        $2a37c9fd7c8f6baf$var$_(this, "_renderConfig", {});
        $2a37c9fd7c8f6baf$var$_(this, "_isFrozen", false);
        $2a37c9fd7c8f6baf$var$_(this, "_backgroundColor", null);
        $2a37c9fd7c8f6baf$var$_(this, "_pointerUpMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerDownMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerMoveMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerEnterMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerExitMethod");
        var i, s, d;
        this._canvas = n.canvas, this._context = this._canvas.getContext("2d"), this._eventManager = new $2a37c9fd7c8f6baf$var$s1(), this._frameManager = new $2a37c9fd7c8f6baf$var$z1(), this._renderConfig = $2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, n.renderConfig), {
            devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || $2a37c9fd7c8f6baf$var$Z(),
            freezeOnOffscreen: (d = (s = n.renderConfig) == null ? void 0 : s.freezeOnOffscreen) != null ? d : true
        }), $2a37c9fd7c8f6baf$var$i1.load().then((m)=>{
            var b, M, P, R, O, d1, L1, K;
            C2._wasmModule = m, this._dotLottieCore = new m.DotLottiePlayer({
                themeId: (b = n.themeId) != null ? b : "",
                autoplay: (M = n.autoplay) != null ? M : false,
                backgroundColor: 0,
                loopAnimation: (P = n.loop) != null ? P : false,
                mode: $2a37c9fd7c8f6baf$var$m2((R = n.mode) != null ? R : "forward", m),
                segment: $2a37c9fd7c8f6baf$var$y2((O = n.segment) != null ? O : [], m),
                speed: (d1 = n.speed) != null ? d1 : 1,
                useFrameInterpolation: (L1 = n.useFrameInterpolation) != null ? L1 : true,
                marker: (K = n.marker) != null ? K : "",
                layout: n.layout ? {
                    align: $2a37c9fd7c8f6baf$var$g2(n.layout.align, m),
                    fit: $2a37c9fd7c8f6baf$var$_2(n.layout.fit, m)
                } : m.createDefaultLayout()
            }), this._eventManager.dispatch({
                type: "ready"
            }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), n.backgroundColor && this.setBackgroundColor(n.backgroundColor);
        }).catch((m)=>{
            this._eventManager.dispatch({
                type: "loadError",
                error: new Error(`Failed to load wasm module: ${m}`)
            });
        }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    _dispatchError(n) {
        console.error(n), this._eventManager.dispatch({
            type: "loadError",
            error: new Error(n)
        });
    }
    _fetchData(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            let i = yield fetch(n);
            if (!i.ok) throw new Error(`Failed to fetch animation data from URL: ${n}. ${i.status}: ${i.statusText}`);
            let s = yield i.arrayBuffer();
            return $2a37c9fd7c8f6baf$var$v2(s) ? s : new TextDecoder().decode(s);
        });
    }
    _loadFromData(n) {
        if (this._dotLottieCore === null) return;
        let i = this._canvas.width, s = this._canvas.height, d = false;
        if (typeof n == "string") {
            if (!$2a37c9fd7c8f6baf$var$f2(n)) {
                this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
                return;
            }
            d = this._dotLottieCore.loadAnimationData(n, i, s);
        } else if (n instanceof ArrayBuffer) {
            if (!$2a37c9fd7c8f6baf$var$v2(n)) {
                this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
                return;
            }
            d = this._dotLottieCore.loadDotLottieData(n, i, s);
        } else if (typeof n == "object") {
            if (!$2a37c9fd7c8f6baf$var$f2(n)) {
                this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
                return;
            }
            d = this._dotLottieCore.loadAnimationData(JSON.stringify(n), i, s);
        } else {
            this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof n}`);
            return;
        }
        d ? (this._eventManager.dispatch({
            type: "load"
        }), $2a37c9fd7c8f6baf$var$A && this.resize(), this._eventManager.dispatch({
            type: "frame",
            currentFrame: this._dotLottieCore.currentFrame()
        }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({
            type: "play"
        }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && $2a37c9fd7c8f6baf$var$W.observe(this._canvas, this), this._renderConfig.autoResize && $2a37c9fd7c8f6baf$var$$.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
    }
    _loadFromSrc(n) {
        this._fetchData(n).then((i)=>this._loadFromData(i)).catch((i)=>this._dispatchError(`Failed to load animation data from URL: ${n}. ${i}`));
    }
    get activeAnimationId() {
        var n;
        return (n = this._dotLottieCore) == null ? void 0 : n.activeAnimationId();
    }
    get activeThemeId() {
        var n;
        return (n = this._dotLottieCore) == null ? void 0 : n.activeThemeId();
    }
    get layout() {
        var i;
        let n = (i = this._dotLottieCore) == null ? void 0 : i.config().layout;
        if (n) return {
            align: [
                n.align.get(0),
                n.align.get(1)
            ],
            fit: (()=>{
                var s, d, m, b, M, P;
                switch(n.fit){
                    case (s = C2._wasmModule) == null ? void 0 : s.Fit.Contain:
                        return "contain";
                    case (d = C2._wasmModule) == null ? void 0 : d.Fit.Cover:
                        return "cover";
                    case (m = C2._wasmModule) == null ? void 0 : m.Fit.Fill:
                        return "fill";
                    case (b = C2._wasmModule) == null ? void 0 : b.Fit.FitHeight:
                        return "fit-height";
                    case (M = C2._wasmModule) == null ? void 0 : M.Fit.FitWidth:
                        return "fit-width";
                    case (P = C2._wasmModule) == null ? void 0 : P.Fit.None:
                        return "none";
                    default:
                        return "contain";
                }
            })()
        };
    }
    get marker() {
        var i;
        return (i = this._dotLottieCore) == null ? void 0 : i.config().marker;
    }
    get manifest() {
        var n;
        try {
            let i = (n = this._dotLottieCore) == null ? void 0 : n.manifestString();
            if (this._dotLottieCore === null || !i) return null;
            let s = JSON.parse(i);
            return Object.keys(s).length === 0 ? null : s;
        } catch (i) {
            return null;
        }
    }
    get renderConfig() {
        return this._renderConfig;
    }
    get segment() {
        var i;
        let n = (i = this._dotLottieCore) == null ? void 0 : i.config().segment;
        if (n && n.size() === 2) return [
            n.get(0),
            n.get(1)
        ];
    }
    get loop() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().loopAnimation) != null ? i : false;
    }
    get mode() {
        var i, s, d, m;
        let n = (i = this._dotLottieCore) == null ? void 0 : i.config().mode;
        return n === ((s = C2._wasmModule) == null ? void 0 : s.Mode.Reverse) ? "reverse" : n === ((d = C2._wasmModule) == null ? void 0 : d.Mode.Bounce) ? "bounce" : n === ((m = C2._wasmModule) == null ? void 0 : m.Mode.ReverseBounce) ? "reverse-bounce" : "forward";
    }
    get isFrozen() {
        return this._isFrozen;
    }
    get backgroundColor() {
        var n;
        return (n = this._backgroundColor) != null ? n : "";
    }
    get autoplay() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().autoplay) != null ? i : false;
    }
    get useFrameInterpolation() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().useFrameInterpolation) != null ? i : false;
    }
    get speed() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().speed) != null ? i : 0;
    }
    get isReady() {
        return this._dotLottieCore !== null;
    }
    get isLoaded() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.isLoaded()) != null ? i : false;
    }
    get isPlaying() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPlaying()) != null ? i : false;
    }
    get isPaused() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPaused()) != null ? i : false;
    }
    get isStopped() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.isStopped()) != null ? i : false;
    }
    get currentFrame() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.currentFrame()) != null ? i : 0;
    }
    get loopCount() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.loopCount()) != null ? i : 0;
    }
    get totalFrames() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.totalFrames()) != null ? i : 0;
    }
    get duration() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.duration()) != null ? i : 0;
    }
    get segmentDuration() {
        var n, i;
        return (i = (n = this._dotLottieCore) == null ? void 0 : n.segmentDuration()) != null ? i : 0;
    }
    get canvas() {
        return this._canvas;
    }
    load(n) {
        var i, s, d, m, b, M, P, R, O;
        this._dotLottieCore === null || C2._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._dotLottieCore.setConfig({
            themeId: (i = n.themeId) != null ? i : "",
            autoplay: (s = n.autoplay) != null ? s : false,
            backgroundColor: 0,
            loopAnimation: (d = n.loop) != null ? d : false,
            mode: $2a37c9fd7c8f6baf$var$m2((m = n.mode) != null ? m : "forward", C2._wasmModule),
            segment: $2a37c9fd7c8f6baf$var$y2((b = n.segment) != null ? b : [], C2._wasmModule),
            speed: (M = n.speed) != null ? M : 1,
            useFrameInterpolation: (P = n.useFrameInterpolation) != null ? P : true,
            marker: (R = n.marker) != null ? R : "",
            layout: n.layout ? {
                align: $2a37c9fd7c8f6baf$var$g2(n.layout.align, C2._wasmModule),
                fit: $2a37c9fd7c8f6baf$var$_2(n.layout.fit, C2._wasmModule)
            } : C2._wasmModule.createDefaultLayout()
        }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), this.setBackgroundColor((O = n.backgroundColor) != null ? O : ""));
    }
    _render() {
        if (this._dotLottieCore === null || this._context === null) return false;
        if (this._dotLottieCore.render()) {
            let i = this._dotLottieCore.buffer(), s = new Uint8ClampedArray(i, 0, this._canvas.width * this._canvas.height * 4), d = null;
            return typeof ImageData == "undefined" ? (d = this._context.createImageData(this._canvas.width, this._canvas.height), d.data.set(s)) : d = new ImageData(s, this._canvas.width, this._canvas.height), this._context.putImageData(d, 0, 0), this._eventManager.dispatch({
                type: "render",
                currentFrame: this._dotLottieCore.currentFrame()
            }), true;
        }
        return false;
    }
    _draw() {
        if (this._dotLottieCore === null || this._context === null || !this._dotLottieCore.isPlaying()) return;
        let n = this._dotLottieCore.requestFrame();
        this._dotLottieCore.setFrame(n) && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this._dotLottieCore.currentFrame()
        }), this._render() && this._dotLottieCore.isComplete() && (this._dotLottieCore.config().loopAnimation ? this._eventManager.dispatch({
            type: "loop",
            loopCount: this._dotLottieCore.loopCount()
        }) : this._eventManager.dispatch({
            type: "complete"
        }))), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
    }
    play() {
        if (this._dotLottieCore === null) return;
        (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = false, this._eventManager.dispatch({
            type: "play"
        }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !$2a37c9fd7c8f6baf$var$$1(this._canvas) && this.freeze();
    }
    pause() {
        if (this._dotLottieCore === null) return;
        (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({
            type: "pause"
        });
    }
    stop() {
        if (this._dotLottieCore === null) return;
        this._dotLottieCore.stop() && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this._dotLottieCore.currentFrame()
        }), this._render(), this._eventManager.dispatch({
            type: "stop"
        }));
    }
    setFrame(n) {
        if (this._dotLottieCore === null || n < 0 || n > this._dotLottieCore.totalFrames()) return;
        this._dotLottieCore.seek(n) && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this._dotLottieCore.currentFrame()
        }), this._render());
    }
    setSpeed(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            speed: n
        }));
    }
    setBackgroundColor(n) {
        this._dotLottieCore !== null && ($2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = n : this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            backgroundColor: $2a37c9fd7c8f6baf$var$o3(n)
        })), this._backgroundColor = n);
    }
    setLoop(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            loopAnimation: n
        }));
    }
    setUseFrameInterpolation(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            useFrameInterpolation: n
        }));
    }
    addEventListener(n, i) {
        this._eventManager.addEventListener(n, i);
    }
    removeEventListener(n, i) {
        this._eventManager.removeEventListener(n, i);
    }
    destroy() {
        var n;
        $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && ($2a37c9fd7c8f6baf$var$W.unobserve(this._canvas), $2a37c9fd7c8f6baf$var$$.unobserve(this._canvas)), (n = this._dotLottieCore) == null || n.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({
            type: "destroy"
        }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
    }
    freeze() {
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = true, this._eventManager.dispatch({
            type: "freeze"
        }));
    }
    unfreeze() {
        this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = false, this._eventManager.dispatch({
            type: "unfreeze"
        }));
    }
    resize() {
        if (!this._dotLottieCore || !this.isLoaded) return;
        if ($2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement) {
            let i = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: s, width: d } = this._canvas.getBoundingClientRect();
            this._canvas.width = d * i, this._canvas.height = s * i;
        }
        this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
    }
    setSegment(n, i) {
        this._dotLottieCore === null || C2._wasmModule === null || this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            segment: $2a37c9fd7c8f6baf$var$y2([
                n,
                i
            ], C2._wasmModule)
        }));
    }
    setMode(n) {
        this._dotLottieCore === null || C2._wasmModule === null || this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            mode: $2a37c9fd7c8f6baf$var$m2(n, C2._wasmModule)
        }));
    }
    setRenderConfig(n) {
        let m = n, { devicePixelRatio: i, freezeOnOffscreen: s } = m, d = $2a37c9fd7c8f6baf$var$O1(m, [
            "devicePixelRatio",
            "freezeOnOffscreen"
        ]);
        this._renderConfig = $2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F($2a37c9fd7c8f6baf$var$F({}, this._renderConfig), d), {
            devicePixelRatio: i || $2a37c9fd7c8f6baf$var$Z(),
            freezeOnOffscreen: s != null ? s : true
        }), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? $2a37c9fd7c8f6baf$var$$.observe(this._canvas, this) : $2a37c9fd7c8f6baf$var$$.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? $2a37c9fd7c8f6baf$var$W.observe(this._canvas, this) : ($2a37c9fd7c8f6baf$var$W.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
    }
    loadAnimation(n) {
        if (this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === n) return;
        this._dotLottieCore.loadAnimation(n, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({
            type: "load"
        }), this.resize()) : this._eventManager.dispatch({
            type: "loadError",
            error: new Error(`Failed to animation :${n}`)
        });
    }
    setMarker(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            marker: n
        }));
    }
    markers() {
        var i;
        let n = (i = this._dotLottieCore) == null ? void 0 : i.markers();
        if (n) {
            let s = [];
            for(let d = 0; d < n.size(); d += 1){
                let m = n.get(d);
                s.push({
                    name: m.name,
                    time: m.time,
                    duration: m.duration
                });
            }
            return s;
        }
        return [];
    }
    setTheme(n) {
        if (this._dotLottieCore === null) return false;
        let i = this._dotLottieCore.setTheme(n);
        return this._render(), i;
    }
    resetTheme() {
        return this._dotLottieCore === null ? false : this._dotLottieCore.resetTheme();
    }
    setThemeData(n) {
        if (this._dotLottieCore === null) return false;
        let i = this._dotLottieCore.setThemeData(n);
        return this._render(), i;
    }
    setSlots(n) {
        this._dotLottieCore !== null && this._dotLottieCore.setSlots(n);
    }
    setLayout(n) {
        this._dotLottieCore === null || C2._wasmModule === null || this._dotLottieCore.setConfig($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, this._dotLottieCore.config()), {
            layout: {
                align: $2a37c9fd7c8f6baf$var$g2(n.align, C2._wasmModule),
                fit: $2a37c9fd7c8f6baf$var$_2(n.fit, C2._wasmModule)
            }
        }));
    }
    setViewport(n, i, s, d) {
        return this._dotLottieCore === null ? false : this._dotLottieCore.setViewport(n, i, s, d);
    }
    static setWasmUrl(n) {
        $2a37c9fd7c8f6baf$var$i1.setWasmUrl(n);
    }
    loadStateMachine(n) {
        var i, s;
        return (s = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachine(n)) != null ? s : false;
    }
    startStateMachine() {
        var i, s;
        let n = (s = (i = this._dotLottieCore) == null ? void 0 : i.startStateMachine()) != null ? s : false;
        return n && this._setupStateMachineListeners(), n;
    }
    stopStateMachine() {
        var i, s;
        let n = (s = (i = this._dotLottieCore) == null ? void 0 : i.stopStateMachine()) != null ? s : false;
        return n && this._cleanupStateMachineListeners(), n;
    }
    _getPointerPosition(n) {
        let i = this._canvas.getBoundingClientRect(), s = this._canvas.width / i.width, d = this._canvas.height / i.height, m = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, b = (n.clientX - i.left) * s / m, M = (n.clientY - i.top) * d / m;
        return {
            x: b,
            y: M
        };
    }
    _onPointerUp(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this.postPointerUpEvent(i, s);
    }
    _onPointerDown(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this.postPointerDownEvent(i, s);
    }
    _onPointerMove(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this.postPointerMoveEvent(i, s);
    }
    _onPointerEnter(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this.postPointerEnterEvent(i, s);
    }
    _onPointerLeave(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this.postPointerExitEvent(i, s);
    }
    postPointerUpEvent(n, i) {
        var s;
        return (s = this._dotLottieCore) == null ? void 0 : s.postPointerUpEvent(n, i);
    }
    postPointerDownEvent(n, i) {
        var s;
        return (s = this._dotLottieCore) == null ? void 0 : s.postPointerDownEvent(n, i);
    }
    postPointerMoveEvent(n, i) {
        var s;
        return (s = this._dotLottieCore) == null ? void 0 : s.postPointerMoveEvent(n, i);
    }
    postPointerEnterEvent(n, i) {
        var s;
        return (s = this._dotLottieCore) == null ? void 0 : s.postPointerEnterEvent(n, i);
    }
    postPointerExitEvent(n, i) {
        var s;
        return (s = this._dotLottieCore) == null ? void 0 : s.postPointerExitEvent(n, i);
    }
    getStateMachineListeners() {
        if (!this._dotLottieCore) return [];
        let n = this._dotLottieCore.stateMachineFrameworkSetup(), i = [];
        for(let s = 0; s < n.size(); s += 1)i.push(n.get(s));
        return i;
    }
    _setupStateMachineListeners() {
        if ($2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
            let n = this.getStateMachineListeners();
            n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
        }
    }
    _cleanupStateMachineListeners() {
        $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
    }
    loadStateMachineData(n) {
        var i, s;
        return (s = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachineData(n)) != null ? s : false;
    }
    animationSize() {
        var s, d, m, b;
        let n = (d = (s = this._dotLottieCore) == null ? void 0 : s.animationSize().get(0)) != null ? d : 0, i = (b = (m = this._dotLottieCore) == null ? void 0 : m.animationSize().get(1)) != null ? b : 0;
        return {
            width: n,
            height: i
        };
    }
    setStateMachineBooleanContext(n, i) {
        var s, d;
        return (d = (s = this._dotLottieCore) == null ? void 0 : s.setStateMachineBooleanContext(n, i)) != null ? d : false;
    }
    setStateMachineNumericContext(n, i) {
        var s, d;
        return (d = (s = this._dotLottieCore) == null ? void 0 : s.setStateMachineNumericContext(n, i)) != null ? d : false;
    }
    setStateMachineStringContext(n, i) {
        var s, d;
        return (d = (s = this._dotLottieCore) == null ? void 0 : s.setStateMachineStringContext(n, i)) != null ? d : false;
    }
    getLayerBoundingBox(n) {
        var M;
        let i = (M = this._dotLottieCore) == null ? void 0 : M.getLayerBounds(n);
        if (!i || i.size() !== 4) return;
        let s = i.get(0), d = i.get(1), m = i.get(2), b = i.get(3);
        return {
            x: s,
            y: d,
            width: m,
            height: b
        };
    }
    static transformThemeToLottieSlots(n, i) {
        var s, d;
        return (d = (s = C2._wasmModule) == null ? void 0 : s.transformThemeToLottieSlots(n, i)) != null ? d : "";
    }
};
$2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$C, "_wasmModule", null);
var $2a37c9fd7c8f6baf$var$s3 = $2a37c9fd7c8f6baf$var$C;
var $2a37c9fd7c8f6baf$var$w2 = class {
    constructor(){
        if (typeof Worker == "undefined") throw new Error("Worker is not supported in this environment.");
        let n = new Blob([
            new Uint8Array([
                34,
                117,
                115,
                101,
                32,
                115,
                116,
                114,
                105,
                99,
                116,
                34,
                59,
                10,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                115,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                105,
                101,
                115,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                68,
                101,
                115,
                99,
                115,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                68,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                111,
                114,
                115,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                83,
                121,
                109,
                98,
                111,
                108,
                115,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                83,
                121,
                109,
                98,
                111,
                108,
                115,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                112,
                114,
                111,
                112,
                73,
                115,
                69,
                110,
                117,
                109,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                112,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                73,
                115,
                69,
                110,
                117,
                109,
                101,
                114,
                97,
                98,
                108,
                101,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                107,
                101,
                121,
                32,
                105,
                110,
                32,
                111,
                98,
                106,
                32,
                63,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                123,
                32,
                101,
                110,
                117,
                109,
                101,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                117,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                32,
                58,
                32,
                111,
                98,
                106,
                91,
                107,
                101,
                121,
                93,
                32,
                61,
                32,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                112,
                114,
                111,
                112,
                32,
                105,
                110,
                32,
                98,
                32,
                124,
                124,
                32,
                40,
                98,
                32,
                61,
                32,
                123,
                125,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                95,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                46,
                99,
                97,
                108,
                108,
                40,
                98,
                44,
                32,
                112,
                114,
                111,
                112,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                40,
                97,
                44,
                32,
                112,
                114,
                111,
                112,
                44,
                32,
                98,
                91,
                112,
                114,
                111,
                112,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                83,
                121,
                109,
                98,
                111,
                108,
                115,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                112,
                114,
                111,
                112,
                32,
                111,
                102,
                32,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                83,
                121,
                109,
                98,
                111,
                108,
                115,
                40,
                98,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                95,
                112,
                114,
                111,
                112,
                73,
                115,
                69,
                110,
                117,
                109,
                46,
                99,
                97,
                108,
                108,
                40,
                98,
                44,
                32,
                112,
                114,
                111,
                112,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                40,
                97,
                44,
                32,
                112,
                114,
                111,
                112,
                44,
                32,
                98,
                91,
                112,
                114,
                111,
                112,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                115,
                40,
                97,
                44,
                32,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                68,
                101,
                115,
                99,
                115,
                40,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                111,
                98,
                106,
                82,
                101,
                115,
                116,
                32,
                61,
                32,
                40,
                115,
                111,
                117,
                114,
                99,
                101,
                44,
                32,
                101,
                120,
                99,
                108,
                117,
                100,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                112,
                114,
                111,
                112,
                32,
                105,
                110,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                95,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                46,
                99,
                97,
                108,
                108,
                40,
                115,
                111,
                117,
                114,
                99,
                101,
                44,
                32,
                112,
                114,
                111,
                112,
                41,
                32,
                38,
                38,
                32,
                101,
                120,
                99,
                108,
                117,
                100,
                101,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                112,
                114,
                111,
                112,
                41,
                32,
                60,
                32,
                48,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                91,
                112,
                114,
                111,
                112,
                93,
                32,
                61,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                91,
                112,
                114,
                111,
                112,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                111,
                117,
                114,
                99,
                101,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                38,
                38,
                32,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                83,
                121,
                109,
                98,
                111,
                108,
                115,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                112,
                114,
                111,
                112,
                32,
                111,
                102,
                32,
                95,
                95,
                103,
                101,
                116,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                83,
                121,
                109,
                98,
                111,
                108,
                115,
                40,
                115,
                111,
                117,
                114,
                99,
                101,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                120,
                99,
                108,
                117,
                100,
                101,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                112,
                114,
                111,
                112,
                41,
                32,
                60,
                32,
                48,
                32,
                38,
                38,
                32,
                95,
                95,
                112,
                114,
                111,
                112,
                73,
                115,
                69,
                110,
                117,
                109,
                46,
                99,
                97,
                108,
                108,
                40,
                115,
                111,
                117,
                114,
                99,
                101,
                44,
                32,
                112,
                114,
                111,
                112,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                91,
                112,
                114,
                111,
                112,
                93,
                32,
                61,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                91,
                112,
                114,
                111,
                112,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                101,
                121,
                32,
                33,
                61,
                61,
                32,
                34,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                32,
                63,
                32,
                107,
                101,
                121,
                32,
                43,
                32,
                34,
                34,
                32,
                58,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                97,
                115,
                121,
                110,
                99,
                32,
                61,
                32,
                40,
                95,
                95,
                116,
                104,
                105,
                115,
                44,
                32,
                95,
                95,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                44,
                32,
                103,
                101,
                110,
                101,
                114,
                97,
                116,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                40,
                40,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                44,
                32,
                114,
                101,
                106,
                101,
                99,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                117,
                108,
                102,
                105,
                108,
                108,
                101,
                100,
                32,
                61,
                32,
                40,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                101,
                112,
                40,
                103,
                101,
                110,
                101,
                114,
                97,
                116,
                111,
                114,
                46,
                110,
                101,
                120,
                116,
                40,
                118,
                97,
                108,
                117,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                106,
                101,
                99,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                101,
                106,
                101,
                99,
                116,
                101,
                100,
                32,
                61,
                32,
                40,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                101,
                112,
                40,
                103,
                101,
                110,
                101,
                114,
                97,
                116,
                111,
                114,
                46,
                116,
                104,
                114,
                111,
                119,
                40,
                118,
                97,
                108,
                117,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                106,
                101,
                99,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                115,
                116,
                101,
                112,
                32,
                61,
                32,
                40,
                120,
                41,
                32,
                61,
                62,
                32,
                120,
                46,
                100,
                111,
                110,
                101,
                32,
                63,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                40,
                120,
                46,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                58,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                40,
                120,
                46,
                118,
                97,
                108,
                117,
                101,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                102,
                117,
                108,
                102,
                105,
                108,
                108,
                101,
                100,
                44,
                32,
                114,
                101,
                106,
                101,
                99,
                116,
                101,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                101,
                112,
                40,
                40,
                103,
                101,
                110,
                101,
                114,
                97,
                116,
                111,
                114,
                32,
                61,
                32,
                103,
                101,
                110,
                101,
                114,
                97,
                116,
                111,
                114,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                95,
                95,
                116,
                104,
                105,
                115,
                44,
                32,
                95,
                95,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                41,
                41,
                46,
                110,
                101,
                120,
                116,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                45,
                102,
                114,
                97,
                109,
                101,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                34,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                62,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                77,
                65,
                88,
                95,
                83,
                65,
                70,
                69,
                95,
                73,
                78,
                84,
                69,
                71,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                61,
                32,
                115,
                101,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                40,
                68,
                97,
                116,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                95,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                32,
                58,
                32,
                110,
                101,
                119,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                110,
                115,
                116,
                97,
                110,
                116,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                91,
                56,
                48,
                44,
                32,
                55,
                53,
                44,
                32,
                51,
                44,
                32,
                52,
                93,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                32,
                61,
                32,
                91,
                34,
                118,
                34,
                44,
                32,
                34,
                105,
                112,
                34,
                44,
                32,
                34,
                111,
                112,
                34,
                44,
                32,
                34,
                108,
                97,
                121,
                101,
                114,
                115,
                34,
                44,
                32,
                34,
                102,
                114,
                34,
                44,
                32,
                34,
                119,
                34,
                44,
                32,
                34,
                104,
                34,
                93,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                32,
                61,
                32,
                34,
                48,
                46,
                51,
                56,
                46,
                50,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                32,
                61,
                32,
                34,
                64,
                108,
                111,
                116,
                116,
                105,
                101,
                102,
                105,
                108,
                101,
                115,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                101,
                98,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                32,
                61,
                32,
                48,
                46,
                55,
                53,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                106,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                63,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                114,
                99,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                44,
                32,
                97,
                97,
                44,
                32,
                98,
                97,
                44,
                32,
                99,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                44,
                32,
                102,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                125,
                44,
                32,
                107,
                41,
                44,
                32,
                104,
                97,
                32,
                61,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                44,
                32,
                112,
                32,
                61,
                32,
                34,
                34,
                44,
                32,
                105,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                32,
                38,
                38,
                32,
                40,
                112,
                32,
                61,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                40,
                112,
                32,
                61,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                98,
                108,
                111,
                98,
                58,
                34,
                41,
                32,
                63,
                32,
                112,
                32,
                61,
                32,
                34,
                34,
                32,
                58,
                32,
                112,
                32,
                61,
                32,
                112,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                112,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                63,
                35,
                93,
                46,
                42,
                47,
                44,
                32,
                34,
                34,
                41,
                46,
                108,
                97,
                115,
                116,
                73,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                47,
                34,
                41,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                97,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                98,
                46,
                111,
                107,
                32,
                63,
                32,
                98,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                32,
                58,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                114,
                101,
                106,
                101,
                99,
                116,
                40,
                69,
                114,
                114,
                111,
                114,
                40,
                98,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                43,
                32,
                34,
                32,
                58,
                32,
                34,
                32,
                43,
                32,
                98,
                46,
                117,
                114,
                108,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                106,
                97,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                105,
                110,
                116,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                108,
                111,
                103,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                44,
                32,
                116,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                105,
                110,
                116,
                69,
                114,
                114,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                107,
                44,
                32,
                102,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                38,
                38,
                32,
                40,
                104,
                97,
                32,
                61,
                32,
                107,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                97,
                32,
                61,
                32,
                107,
                46,
                119,
                97,
                115,
                109,
                66,
                105,
                110,
                97,
                114,
                121,
                44,
                32,
                108,
                97,
                44,
                32,
                109,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                110,
                97,
                44,
                32,
                119,
                44,
                32,
                120,
                44,
                32,
                121,
                44,
                32,
                122,
                44,
                32,
                67,
                44,
                32,
                68,
                44,
                32,
                111,
                97,
                44,
                32,
                112,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                113,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                108,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                56,
                32,
                61,
                32,
                119,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                49,
                54,
                32,
                61,
                32,
                121,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                56,
                32,
                61,
                32,
                120,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                49,
                54,
                32,
                61,
                32,
                122,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                51,
                50,
                32,
                61,
                32,
                67,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                85,
                51,
                50,
                32,
                61,
                32,
                68,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                70,
                51,
                50,
                32,
                61,
                32,
                111,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                72,
                69,
                65,
                80,
                70,
                54,
                52,
                32,
                61,
                32,
                112,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                115,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                116,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                70,
                32,
                61,
                32,
                48,
                44,
                32,
                118,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                71,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                107,
                46,
                111,
                110,
                65,
                98,
                111,
                114,
                116,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                50,
                46,
                99,
                97,
                108,
                108,
                40,
                107,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                34,
                65,
                98,
                111,
                114,
                116,
                101,
                100,
                40,
                34,
                32,
                43,
                32,
                97,
                32,
                43,
                32,
                34,
                41,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                32,
                43,
                32,
                34,
                46,
                32,
                66,
                117,
                105,
                108,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                45,
                115,
                65,
                83,
                83,
                69,
                82,
                84,
                73,
                79,
                78,
                83,
                32,
                102,
                111,
                114,
                32,
                109,
                111,
                114,
                101,
                32,
                105,
                110,
                102,
                111,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                120,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                97,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                100,
                97,
                116,
                97,
                58,
                97,
                112,
                112,
                108,
                105,
                99,
                97,
                116,
                105,
                111,
                110,
                47,
                111,
                99,
                116,
                101,
                116,
                45,
                115,
                116,
                114,
                101,
                97,
                109,
                59,
                98,
                97,
                115,
                101,
                54,
                52,
                44,
                34,
                41,
                44,
                32,
                121,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                122,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                32,
                61,
                61,
                32,
                121,
                97,
                32,
                38,
                38,
                32,
                107,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                107,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                34,
                98,
                111,
                116,
                104,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                97,
                110,
                100,
                32,
                115,
                121,
                110,
                99,
                32,
                102,
                101,
                116,
                99,
                104,
                105,
                110,
                103,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                119,
                97,
                115,
                109,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                65,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                107,
                97,
                32,
                63,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                40,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                122,
                97,
                40,
                97,
                41,
                41,
                32,
                58,
                32,
                105,
                97,
                40,
                97,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                122,
                97,
                40,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                66,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                65,
                97,
                40,
                97,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                40,
                100,
                44,
                32,
                98,
                41,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                99,
                44,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                96,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                115,
                121,
                110,
                99,
                104,
                114,
                111,
                110,
                111,
                117,
                115,
                108,
                121,
                32,
                112,
                114,
                101,
                112,
                97,
                114,
                101,
                32,
                119,
                97,
                115,
                109,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                67,
                97,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                121,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                107,
                97,
                32,
                124,
                124,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                124,
                124,
                32,
                120,
                97,
                40,
                99,
                41,
                32,
                124,
                124,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                101,
                116,
                99,
                104,
                32,
                63,
                32,
                66,
                97,
                40,
                99,
                44,
                32,
                97,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                99,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                40,
                100,
                44,
                32,
                97,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                98,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                96,
                119,
                97,
                115,
                109,
                32,
                115,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                99,
                111,
                109,
                112,
                105,
                108,
                101,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                34,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                66,
                97,
                40,
                99,
                44,
                32,
                97,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                68,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                34,
                69,
                120,
                105,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                96,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                116,
                101,
                114,
                109,
                105,
                110,
                97,
                116,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                120,
                105,
                116,
                40,
                36,
                123,
                97,
                125,
                41,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                48,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                97,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                70,
                97,
                32,
                61,
                32,
                107,
                46,
                110,
                111,
                69,
                120,
                105,
                116,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                32,
                124,
                124,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                71,
                97,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                72,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                78,
                97,
                78,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                99,
                32,
                61,
                32,
                98,
                59,
                32,
                97,
                91,
                99,
                93,
                32,
                38,
                38,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                54,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                98,
                32,
                38,
                38,
                32,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                71,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                71,
                97,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                97,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                98,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                98,
                32,
                60,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                50,
                56,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                57,
                50,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                50,
                52,
                41,
                41,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                40,
                101,
                32,
                38,
                32,
                51,
                49,
                41,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                52,
                48,
                41,
                32,
                63,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                53,
                41,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                104,
                32,
                58,
                32,
                40,
                101,
                32,
                38,
                32,
                55,
                41,
                32,
                60,
                60,
                32,
                49,
                56,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                104,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                97,
                91,
                98,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                62,
                32,
                101,
                32,
                63,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                32,
                58,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                72,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                119,
                97,
                32,
                61,
                32,
                97,
                32,
                45,
                32,
                50,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                73,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                74,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                73,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                60,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                104,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                49,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                57,
                50,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                54,
                53,
                53,
                51,
                53,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                50,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                51,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                52,
                48,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                75,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                76,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                74,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                68,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                75,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                76,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                77,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                77,
                44,
                32,
                79,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                99,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                40,
                34,
                77,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                101,
                100,
                32,
                116,
                121,
                112,
                101,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                108,
                41,
                32,
                78,
                40,
                97,
                91,
                108,
                93,
                44,
                32,
                103,
                91,
                108,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                77,
                97,
                91,
                103,
                93,
                32,
                61,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                63,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                76,
                91,
                103,
                93,
                32,
                58,
                32,
                40,
                102,
                46,
                112,
                117,
                115,
                104,
                40,
                103,
                41,
                44,
                32,
                75,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                124,
                124,
                32,
                40,
                75,
                91,
                103,
                93,
                32,
                61,
                32,
                91,
                93,
                41,
                44,
                32,
                75,
                91,
                103,
                93,
                46,
                112,
                117,
                115,
                104,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                76,
                91,
                103,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                78,
                97,
                44,
                32,
                80,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                120,
                91,
                97,
                93,
                59,
                32,
                41,
                32,
                98,
                32,
                43,
                61,
                32,
                78,
                97,
                91,
                120,
                91,
                97,
                43,
                43,
                93,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                81,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                80,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                116,
                121,
                112,
                101,
                32,
                34,
                36,
                123,
                100,
                125,
                34,
                32,
                109,
                117,
                115,
                116,
                32,
                104,
                97,
                118,
                101,
                32,
                97,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                118,
                101,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                105,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                76,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                46,
                97,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                39,
                36,
                123,
                100,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                77,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                75,
                91,
                97,
                93,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                75,
                91,
                97,
                93,
                44,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                78,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                80,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                81,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                97,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                43,
                32,
                34,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                83,
                97,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                84,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                46,
                65,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                84,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                46,
                65,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                32,
                63,
                32,
                110,
                117,
                108,
                108,
                32,
                58,
                32,
                99,
                46,
                85,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                85,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                86,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                87,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                112,
                116,
                114,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                65,
                97,
                59,
                32,
                41,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                75,
                97,
                40,
                98,
                41,
                44,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                88,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                120,
                97,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                119,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                40,
                34,
                109,
                97,
                107,
                101,
                67,
                108,
                97,
                115,
                115,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                115,
                32,
                112,
                116,
                114,
                32,
                97,
                110,
                100,
                32,
                112,
                116,
                114,
                84,
                121,
                112,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                33,
                98,
                46,
                66,
                97,
                32,
                33,
                61,
                61,
                32,
                33,
                33,
                98,
                46,
                122,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                40,
                34,
                66,
                111,
                116,
                104,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                84,
                121,
                112,
                101,
                32,
                97,
                110,
                100,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                32,
                109,
                117,
                115,
                116,
                32,
                98,
                101,
                32,
                115,
                112,
                101,
                99,
                105,
                102,
                105,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                32,
                61,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                49,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                44,
                32,
                123,
                32,
                117,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                98,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                61,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                98,
                44,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                40,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                117,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                98,
                46,
                122,
                97,
                32,
                63,
                32,
                98,
                46,
                66,
                97,
                46,
                69,
                97,
                40,
                98,
                46,
                122,
                97,
                41,
                32,
                58,
                32,
                98,
                46,
                120,
                97,
                46,
                118,
                97,
                46,
                69,
                97,
                40,
                98,
                46,
                119,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                117,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                122,
                97,
                32,
                38,
                38,
                32,
                82,
                97,
                46,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                44,
                32,
                123,
                32,
                117,
                97,
                58,
                32,
                99,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                97,
                46,
                117,
                110,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                89,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                90,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                36,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                98,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                97,
                32,
                125,
                41,
                44,
                32,
                97,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                121,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                91,
                98,
                93,
                46,
                121,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                70,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                39,
                36,
                123,
                99,
                125,
                39,
                32,
                99,
                97,
                108,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                97,
                110,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                115,
                32,
                111,
                110,
                101,
                32,
                111,
                102,
                32,
                40,
                36,
                123,
                97,
                91,
                98,
                93,
                46,
                121,
                97,
                125,
                41,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                91,
                98,
                93,
                46,
                121,
                97,
                91,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                121,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                121,
                97,
                91,
                100,
                46,
                72,
                97,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                121,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                121,
                97,
                91,
                99,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                110,
                97,
                109,
                101,
                32,
                39,
                36,
                123,
                97,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                98,
                40,
                107,
                44,
                32,
                97,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                91,
                97,
                93,
                46,
                121,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                99,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                111,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                105,
                116,
                104,
                32,
                116,
                104,
                101,
                32,
                115,
                97,
                109,
                101,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                99,
                125,
                41,
                33,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                91,
                97,
                93,
                46,
                121,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                107,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                107,
                91,
                97,
                93,
                46,
                72,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                99,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                94,
                97,
                45,
                122,
                65,
                45,
                90,
                48,
                45,
                57,
                95,
                93,
                47,
                103,
                44,
                32,
                34,
                36,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                56,
                32,
                60,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                53,
                55,
                32,
                62,
                61,
                32,
                98,
                32,
                63,
                32,
                96,
                95,
                36,
                123,
                97,
                125,
                96,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                71,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                69,
                97,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                87,
                97,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                75,
                97,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                85,
                97,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                98,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                98,
                32,
                33,
                61,
                61,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                75,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                110,
                117,
                108,
                108,
                32,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                99,
                46,
                110,
                97,
                109,
                101,
                125,
                44,
                32,
                103,
                111,
                116,
                32,
                97,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                98,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                46,
                75,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                102,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                78,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                117,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                103,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                117,
                97,
                46,
                119,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                101,
                98,
                40,
                98,
                46,
                117,
                97,
                46,
                119,
                97,
                44,
                32,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                78,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                77,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                69,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                117,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                103,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                117,
                97,
                46,
                119,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                76,
                97,
                32,
                38,
                38,
                32,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                76,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                117,
                97,
                46,
                66,
                97,
                32,
                63,
                32,
                98,
                46,
                117,
                97,
                46,
                66,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                101,
                98,
                40,
                98,
                46,
                117,
                97,
                46,
                119,
                97,
                44,
                32,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                77,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                117,
                97,
                46,
                122,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                80,
                97,
                115,
                115,
                105,
                110,
                103,
                32,
                114,
                97,
                119,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                116,
                111,
                32,
                115,
                109,
                97,
                114,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                105,
                115,
                32,
                105,
                108,
                108,
                101,
                103,
                97,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                117,
                97,
                46,
                66,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                117,
                97,
                46,
                122,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                117,
                97,
                46,
                66,
                97,
                32,
                63,
                32,
                98,
                46,
                117,
                97,
                46,
                66,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                117,
                97,
                46,
                122,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                117,
                97,
                46,
                66,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                117,
                97,
                46,
                122,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                101,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                100,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                69,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                105,
                110,
                103,
                32,
                115,
                104,
                97,
                114,
                105,
                110,
                103,
                32,
                112,
                111,
                108,
                105,
                99,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                106,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                78,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                117,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                103,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                117,
                97,
                46,
                119,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                76,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                101,
                98,
                40,
                98,
                46,
                117,
                97,
                46,
                119,
                97,
                44,
                32,
                98,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                78,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                76,
                97,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                77,
                97,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                98,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                79,
                97,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                101,
                98,
                32,
                61,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                69,
                97,
                32,
                61,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                98,
                46,
                65,
                97,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                104,
                98,
                32,
                58,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                100,
                32,
                63,
                32,
                102,
                98,
                32,
                58,
                32,
                106,
                98,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                68,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                107,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                77,
                40,
                34,
                82,
                101,
                112,
                108,
                97,
                99,
                105,
                110,
                103,
                32,
                110,
                111,
                110,
                101,
                120,
                105,
                115,
                116,
                101,
                110,
                116,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                107,
                91,
                97,
                93,
                46,
                121,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                107,
                91,
                97,
                93,
                46,
                121,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                32,
                58,
                32,
                40,
                107,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                107,
                91,
                97,
                93,
                46,
                72,
                97,
                32,
                61,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                44,
                32,
                109,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                112,
                47,
                103,
                44,
                32,
                34,
                105,
                34,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                40,
                48,
                44,
                32,
                107,
                91,
                34,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                34,
                32,
                43,
                32,
                97,
                93,
                41,
                40,
                98,
                44,
                32,
                46,
                46,
                46,
                99,
                41,
                41,
                32,
                58,
                32,
                98,
                32,
                61,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                40,
                46,
                46,
                46,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                110,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                46,
                46,
                46,
                99,
                41,
                32,
                61,
                62,
                32,
                109,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                44,
                32,
                84,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                80,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                110,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                119,
                105,
                116,
                104,
                32,
                115,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                36,
                123,
                97,
                125,
                58,
                32,
                36,
                123,
                98,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                111,
                98,
                44,
                32,
                113,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                112,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                114,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                99,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                76,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                40,
                77,
                97,
                91,
                102,
                93,
                32,
                63,
                32,
                77,
                97,
                91,
                102,
                93,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                32,
                58,
                32,
                40,
                100,
                46,
                112,
                117,
                115,
                104,
                40,
                102,
                41,
                44,
                32,
                101,
                91,
                102,
                93,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                111,
                98,
                40,
                96,
                36,
                123,
                97,
                125,
                58,
                32,
                96,
                32,
                43,
                32,
                100,
                46,
                109,
                97,
                112,
                40,
                113,
                98,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                91,
                34,
                44,
                32,
                34,
                93,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                115,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                100,
                43,
                43,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                68,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                116,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                49,
                59,
                32,
                98,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                98,
                41,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                68,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                102,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                97,
                114,
                103,
                84,
                121,
                112,
                101,
                115,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                33,
                32,
                77,
                117,
                115,
                116,
                32,
                97,
                116,
                32,
                108,
                101,
                97,
                115,
                116,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                97,
                110,
                100,
                32,
                39,
                116,
                104,
                105,
                115,
                39,
                32,
                116,
                121,
                112,
                101,
                115,
                33,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                49,
                93,
                32,
                38,
                38,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                44,
                32,
                103,
                32,
                61,
                32,
                116,
                98,
                40,
                98,
                41,
                44,
                32,
                108,
                32,
                61,
                32,
                34,
                118,
                111,
                105,
                100,
                34,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                48,
                93,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                109,
                32,
                61,
                32,
                102,
                32,
                45,
                32,
                50,
                44,
                32,
                110,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                109,
                41,
                44,
                32,
                113,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                114,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                36,
                97,
                40,
                97,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                65,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                50,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                91,
                48,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                117,
                32,
                61,
                32,
                98,
                91,
                49,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                114,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                91,
                49,
                93,
                32,
                61,
                32,
                117,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                118,
                32,
                61,
                32,
                48,
                59,
                32,
                118,
                32,
                60,
                32,
                109,
                59,
                32,
                43,
                43,
                118,
                41,
                32,
                110,
                91,
                118,
                93,
                32,
                61,
                32,
                98,
                91,
                118,
                32,
                43,
                32,
                50,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                114,
                44,
                32,
                65,
                91,
                118,
                93,
                41,
                44,
                32,
                113,
                46,
                112,
                117,
                115,
                104,
                40,
                110,
                91,
                118,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                32,
                61,
                32,
                100,
                40,
                46,
                46,
                46,
                113,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                41,
                32,
                76,
                97,
                40,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                49,
                32,
                58,
                32,
                50,
                59,
                32,
                118,
                32,
                60,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                118,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                118,
                32,
                63,
                32,
                117,
                32,
                58,
                32,
                110,
                91,
                118,
                32,
                45,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                118,
                93,
                46,
                68,
                97,
                32,
                38,
                38,
                32,
                98,
                91,
                118,
                93,
                46,
                68,
                97,
                40,
                69,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                32,
                61,
                32,
                108,
                32,
                63,
                32,
                98,
                91,
                48,
                93,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                65,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                117,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                118,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                114,
                105,
                109,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                40,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                45,
                49,
                32,
                33,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                120,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                86,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                121,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                45,
                45,
                86,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                38,
                38,
                32,
                40,
                86,
                91,
                97,
                93,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                120,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                122,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                117,
                115,
                101,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                118,
                97,
                108,
                46,
                32,
                104,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                34,
                32,
                43,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                105,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                110,
                117,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                116,
                114,
                117,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                102,
                97,
                108,
                115,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                120,
                98,
                46,
                112,
                111,
                112,
                40,
                41,
                32,
                124,
                124,
                32,
                86,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                91,
                98,
                93,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                91,
                98,
                32,
                43,
                32,
                49,
                93,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                65,
                98,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                34,
                101,
                109,
                115,
                99,
                114,
                105,
                112,
                116,
                101,
                110,
                58,
                58,
                118,
                97,
                108,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                122,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                105,
                98,
                40,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                74,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                66,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                119,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                67,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                68,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                67,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                76,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                32,
                61,
                32,
                96,
                36,
                123,
                98,
                125,
                32,
                104,
                97,
                115,
                32,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                113,
                98,
                40,
                97,
                41,
                125,
                96,
                44,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                103,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                117,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                97,
                114,
                114,
                97,
                121,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                43,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                68,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                111,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                56,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                112,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                51,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                102,
                108,
                111,
                97,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                69,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                119,
                91,
                100,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                120,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                67,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                68,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                70,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                32,
                111,
                112,
                116,
                105,
                111,
                110,
                97,
                108,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                44,
                32,
                65,
                98,
                41,
                44,
                32,
                71,
                98,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                34,
                117,
                116,
                102,
                45,
                49,
                54,
                108,
                101,
                34,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                72,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                32,
                62,
                62,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                98,
                32,
                47,
                32,
                50,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                32,
                38,
                38,
                32,
                122,
                91,
                99,
                93,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                60,
                60,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                51,
                50,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                97,
                32,
                38,
                38,
                32,
                71,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                71,
                98,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                33,
                40,
                100,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                50,
                41,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                121,
                91,
                97,
                32,
                43,
                32,
                50,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                99,
                32,
                58,
                32,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                45,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                99,
                32,
                60,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                63,
                32,
                99,
                32,
                47,
                32,
                50,
                32,
                58,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                99,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                44,
                32,
                98,
                32,
                43,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                74,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                44,
                32,
                75,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                44,
                32,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                52,
                41,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                67,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                60,
                61,
                32,
                101,
                32,
                63,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                32,
                58,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                76,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                99,
                32,
                58,
                32,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                100,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                104,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                77,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                99,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                78,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                79,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                80,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                79,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                81,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                99,
                91,
                100,
                93,
                32,
                61,
                32,
                67,
                98,
                40,
                68,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                34,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                34,
                32,
                43,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                98,
                32,
                61,
                32,
                82,
                101,
                102,
                108,
                101,
                99,
                116,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                44,
                32,
                83,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                84,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                68,
                97,
                32,
                124,
                124,
                32,
                34,
                117,
                110,
                119,
                105,
                110,
                100,
                34,
                32,
                61,
                61,
                32,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                85,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                78,
                98,
                32,
                124,
                124,
                32,
                40,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                107,
                46,
                111,
                110,
                69,
                120,
                105,
                116,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                50,
                46,
                99,
                97,
                108,
                108,
                40,
                107,
                44,
                32,
                97,
                41,
                44,
                32,
                109,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                86,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                109,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                40,
                41,
                44,
                32,
                33,
                40,
                70,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                78,
                98,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                32,
                61,
                32,
                97,
                32,
                61,
                32,
                110,
                97,
                44,
                32,
                85,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                89,
                98,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                88,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                83,
                69,
                82,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                79,
                71,
                78,
                65,
                77,
                69,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                65,
                84,
                72,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                87,
                68,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                79,
                77,
                69,
                58,
                32,
                34,
                47,
                104,
                111,
                109,
                101,
                47,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                65,
                78,
                71,
                58,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                91,
                48,
                93,
                32,
                124,
                124,
                32,
                34,
                67,
                34,
                41,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                45,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                95,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                32,
                43,
                32,
                34,
                46,
                85,
                84,
                70,
                45,
                56,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                104,
                97,
                32,
                124,
                124,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                87,
                98,
                41,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                87,
                98,
                91,
                98,
                93,
                32,
                63,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                97,
                91,
                98,
                93,
                32,
                58,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                87,
                98,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                97,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                96,
                36,
                123,
                98,
                125,
                61,
                36,
                123,
                97,
                91,
                98,
                93,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                88,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                88,
                98,
                44,
                32,
                90,
                98,
                32,
                61,
                32,
                91,
                110,
                117,
                108,
                108,
                44,
                32,
                91,
                93,
                44,
                32,
                91,
                93,
                93,
                44,
                32,
                36,
                98,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                97,
                40,
                34,
                105,
                110,
                105,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                68,
                101,
                118,
                105,
                99,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                97,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                97,
                99,
                32,
                61,
                32,
                36,
                98,
                40,
                41,
                41,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                32,
                61,
                32,
                107,
                46,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                50,
                53,
                54,
                41,
                44,
                32,
                99,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                50,
                53,
                54,
                32,
                62,
                32,
                99,
                99,
                59,
                32,
                43,
                43,
                99,
                99,
                41,
                32,
                98,
                99,
                91,
                99,
                99,
                93,
                32,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                99,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                97,
                32,
                61,
                32,
                98,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                32,
                61,
                32,
                107,
                46,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                90,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                65,
                108,
                105,
                97,
                115,
                79,
                102,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                116,
                104,
                105,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                90,
                97,
                32,
                38,
                38,
                32,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                90,
                97,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                44,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                119,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                117,
                97,
                32,
                61,
                32,
                97,
                46,
                117,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                117,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                117,
                97,
                46,
                119,
                97,
                59,
                32,
                98,
                46,
                65,
                97,
                59,
                32,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                75,
                97,
                40,
                99,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                100,
                46,
                65,
                97,
                59,
                32,
                41,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                75,
                97,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                61,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                99,
                32,
                61,
                61,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                111,
                110,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                119,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                74,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                44,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                82,
                44,
                32,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                44,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                44,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                99,
                97,
                108,
                108,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                99,
                111,
                117,
                110,
                116,
                58,
                32,
                101,
                46,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                73,
                97,
                58,
                32,
                101,
                46,
                73,
                97,
                44,
                32,
                74,
                97,
                58,
                32,
                101,
                46,
                74,
                97,
                44,
                32,
                119,
                97,
                58,
                32,
                101,
                46,
                119,
                97,
                44,
                32,
                120,
                97,
                58,
                32,
                101,
                46,
                120,
                97,
                44,
                32,
                122,
                97,
                58,
                32,
                101,
                46,
                122,
                97,
                44,
                32,
                66,
                97,
                58,
                32,
                101,
                46,
                66,
                97,
                32,
                125,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                117,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                117,
                97,
                46,
                73,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                119,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                73,
                97,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                74,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                97,
                46,
                122,
                97,
                32,
                63,
                32,
                97,
                46,
                66,
                97,
                46,
                69,
                97,
                40,
                97,
                46,
                122,
                97,
                41,
                32,
                58,
                32,
                97,
                46,
                120,
                97,
                46,
                118,
                97,
                46,
                69,
                97,
                40,
                97,
                46,
                119,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                74,
                97,
                32,
                124,
                124,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                122,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                119,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                68,
                101,
                108,
                101,
                116,
                101,
                100,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                119,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                76,
                97,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                119,
                97,
                32,
                124,
                124,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                73,
                97,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                74,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                97,
                46,
                73,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                107,
                98,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                32,
                38,
                38,
                32,
                40,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                69,
                97,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                50,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                74,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                98,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                77,
                97,
                32,
                63,
                32,
                88,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                46,
                71,
                97,
                44,
                32,
                123,
                32,
                120,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                98,
                98,
                44,
                32,
                119,
                97,
                58,
                32,
                99,
                44,
                32,
                66,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                122,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                88,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                46,
                71,
                97,
                44,
                32,
                123,
                32,
                120,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                119,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                88,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                40,
                97,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                87,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                46,
                117,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                46,
                117,
                97,
                46,
                119,
                97,
                32,
                61,
                32,
                99,
                44,
                32,
                100,
                46,
                117,
                97,
                46,
                122,
                97,
                32,
                61,
                32,
                97,
                44,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                46,
                87,
                97,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                85,
                97,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                76,
                97,
                32,
                63,
                32,
                100,
                46,
                84,
                97,
                32,
                58,
                32,
                100,
                46,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                84,
                97,
                40,
                99,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                118,
                97,
                44,
                32,
                100,
                46,
                118,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                63,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                77,
                97,
                32,
                63,
                32,
                88,
                97,
                40,
                100,
                46,
                118,
                97,
                46,
                71,
                97,
                44,
                32,
                123,
                32,
                120,
                97,
                58,
                32,
                100,
                44,
                32,
                119,
                97,
                58,
                32,
                101,
                44,
                32,
                66,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                122,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                88,
                97,
                40,
                100,
                46,
                118,
                97,
                46,
                71,
                97,
                44,
                32,
                123,
                32,
                120,
                97,
                58,
                32,
                100,
                44,
                32,
                119,
                97,
                58,
                32,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                111,
                98,
                32,
                61,
                32,
                107,
                46,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                36,
                97,
                40,
                98,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                100,
                41,
                46,
                115,
                116,
                97,
                99,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                99,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                43,
                32,
                34,
                92,
                110,
                34,
                32,
                43,
                32,
                100,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                94,
                69,
                114,
                114,
                111,
                114,
                40,
                58,
                91,
                94,
                92,
                110,
                93,
                42,
                41,
                63,
                92,
                110,
                47,
                44,
                32,
                34,
                34,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                96,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                58,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                69,
                114,
                114,
                111,
                114,
                44,
                32,
                34,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                46,
                112,
                117,
                115,
                104,
                40,
                48,
                44,
                32,
                49,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                49,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                49,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                49,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                99,
                111,
                117,
                110,
                116,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                104,
                97,
                110,
                100,
                108,
                101,
                115,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                86,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                47,
                32,
                50,
                32,
                45,
                32,
                53,
                32,
                45,
                32,
                120,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                111,
                99,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                119,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                65,
                115,
                115,
                101,
                114,
                116,
                105,
                111,
                110,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                97,
                32,
                63,
                32,
                72,
                40,
                120,
                44,
                32,
                97,
                41,
                32,
                58,
                32,
                34,
                34,
                125,
                44,
                32,
                97,
                116,
                58,
                32,
                96,
                32,
                43,
                32,
                91,
                98,
                32,
                63,
                32,
                98,
                32,
                63,
                32,
                72,
                40,
                120,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                105,
                108,
                101,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                44,
                32,
                100,
                32,
                63,
                32,
                100,
                32,
                63,
                32,
                72,
                40,
                120,
                44,
                32,
                100,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                72,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                46,
                119,
                97,
                32,
                43,
                32,
                49,
                54,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                46,
                119,
                97,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                46,
                119,
                97,
                32,
                43,
                32,
                56,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                119,
                97,
                40,
                34,
                34,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                75,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                75,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                79,
                97,
                44,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                69,
                97,
                44,
                32,
                101,
                32,
                61,
                32,
                98,
                46,
                82,
                97,
                44,
                32,
                102,
                32,
                61,
                32,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                36,
                97,
                41,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                103,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                97,
                93,
                44,
                32,
                102,
                44,
                32,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                104,
                91,
                109,
                93,
                44,
                32,
                113,
                32,
                61,
                32,
                108,
                46,
                89,
                97,
                44,
                32,
                114,
                32,
                61,
                32,
                108,
                46,
                90,
                97,
                44,
                32,
                65,
                32,
                61,
                32,
                104,
                91,
                109,
                32,
                43,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                44,
                32,
                117,
                32,
                61,
                32,
                108,
                46,
                102,
                98,
                44,
                32,
                118,
                32,
                61,
                32,
                108,
                46,
                104,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                91,
                108,
                46,
                86,
                97,
                93,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                58,
                32,
                40,
                69,
                41,
                32,
                61,
                62,
                32,
                110,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                113,
                40,
                114,
                44,
                32,
                69,
                41,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                114,
                105,
                116,
                101,
                58,
                32,
                40,
                69,
                44,
                32,
                100,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                40,
                118,
                44,
                32,
                69,
                44,
                32,
                65,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                66,
                44,
                32,
                100,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                97,
                40,
                66,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                109,
                91,
                110,
                93,
                32,
                61,
                32,
                103,
                91,
                110,
                93,
                46,
                114,
                101,
                97,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                110,
                32,
                105,
                110,
                32,
                109,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                105,
                115,
                115,
                105,
                110,
                103,
                32,
                102,
                105,
                101,
                108,
                100,
                58,
                32,
                34,
                36,
                123,
                110,
                125,
                34,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                113,
                32,
                61,
                32,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                110,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                103,
                91,
                110,
                93,
                46,
                119,
                114,
                105,
                116,
                101,
                40,
                113,
                44,
                32,
                109,
                91,
                110,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                108,
                32,
                38,
                38,
                32,
                108,
                46,
                112,
                117,
                115,
                104,
                40,
                100,
                44,
                32,
                113,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                113,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                74,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                58,
                32,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                33,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                32,
                63,
                32,
                99,
                32,
                58,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                101,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                44,
                32,
                113,
                44,
                32,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                80,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                40,
                103,
                32,
                61,
                32,
                84,
                40,
                104,
                44,
                32,
                103,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                38,
                38,
                32,
                40,
                109,
                32,
                61,
                32,
                84,
                40,
                108,
                44,
                32,
                109,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                32,
                61,
                32,
                84,
                40,
                113,
                44,
                32,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                65,
                32,
                61,
                32,
                99,
                98,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                98,
                40,
                65,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                110,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                93,
                44,
                32,
                100,
                32,
                63,
                32,
                91,
                100,
                93,
                32,
                58,
                32,
                91,
                93,
                44,
                32,
                40,
                117,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                32,
                61,
                32,
                117,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                118,
                32,
                61,
                32,
                117,
                46,
                118,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                32,
                61,
                32,
                118,
                46,
                71,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                69,
                32,
                61,
                32,
                90,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                32,
                61,
                32,
                36,
                97,
                40,
                110,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                79,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                33,
                61,
                61,
                32,
                100,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                85,
                115,
                101,
                32,
                39,
                110,
                101,
                119,
                39,
                32,
                116,
                111,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                34,
                32,
                43,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                66,
                46,
                70,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                110,
                32,
                43,
                32,
                34,
                32,
                104,
                97,
                115,
                32,
                110,
                111,
                32,
                97,
                99,
                99,
                101,
                115,
                115,
                105,
                98,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                98,
                32,
                61,
                32,
                66,
                46,
                70,
                97,
                91,
                79,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                119,
                98,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                84,
                114,
                105,
                101,
                100,
                32,
                116,
                111,
                32,
                105,
                110,
                118,
                111,
                107,
                101,
                32,
                99,
                116,
                111,
                114,
                32,
                111,
                102,
                32,
                36,
                123,
                110,
                125,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                79,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                40,
                36,
                123,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                66,
                46,
                70,
                97,
                41,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                125,
                41,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                105,
                110,
                115,
                116,
                101,
                97,
                100,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                119,
                98,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                79,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                69,
                44,
                32,
                123,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                117,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                100,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                100,
                98,
                40,
                110,
                44,
                32,
                117,
                44,
                32,
                100,
                97,
                44,
                32,
                114,
                44,
                32,
                118,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                66,
                46,
                65,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                40,
                101,
                97,
                32,
                61,
                32,
                66,
                46,
                65,
                97,
                41,
                46,
                80,
                97,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                97,
                50,
                32,
                58,
                32,
                101,
                97,
                46,
                80,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                46,
                65,
                97,
                46,
                80,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                66,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                107,
                98,
                40,
                110,
                44,
                32,
                66,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                107,
                98,
                40,
                110,
                32,
                43,
                32,
                34,
                42,
                34,
                44,
                32,
                66,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                107,
                98,
                40,
                110,
                32,
                43,
                32,
                34,
                32,
                99,
                111,
                110,
                115,
                116,
                42,
                34,
                44,
                32,
                66,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                58,
                32,
                101,
                97,
                44,
                32,
                84,
                97,
                58,
                32,
                69,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                98,
                40,
                65,
                44,
                32,
                117,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                118,
                44,
                32,
                101,
                97,
                44,
                32,
                69,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                115,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                103,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                96,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                103,
                46,
                118,
                97,
                46,
                70,
                97,
                32,
                38,
                38,
                32,
                40,
                103,
                46,
                118,
                97,
                46,
                70,
                97,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                103,
                46,
                118,
                97,
                46,
                70,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                115,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                101,
                110,
                116,
                105,
                99,
                97,
                108,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                98,
                32,
                45,
                32,
                49,
                125,
                41,
                32,
                102,
                111,
                114,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                39,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                39,
                33,
                32,
                79,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                32,
                114,
                101,
                115,
                111,
                108,
                117,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                108,
                121,
                32,
                111,
                110,
                108,
                121,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                116,
                104,
                101,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                110,
                111,
                116,
                32,
                97,
                99,
                116,
                117,
                97,
                108,
                32,
                116,
                121,
                112,
                101,
                32,
                105,
                110,
                102,
                111,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                118,
                97,
                46,
                70,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                93,
                44,
                32,
                104,
                44,
                32,
                40,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                46,
                115,
                112,
                108,
                105,
                99,
                101,
                40,
                49,
                44,
                32,
                48,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                118,
                97,
                46,
                70,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                117,
                98,
                40,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                115,
                98,
                40,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                118,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                113,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                109,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                113,
                32,
                61,
                32,
                96,
                36,
                123,
                109,
                46,
                110,
                97,
                109,
                101,
                125,
                46,
                36,
                123,
                98,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                64,
                64,
                34,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                83,
                121,
                109,
                98,
                111,
                108,
                91,
                98,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                105,
                110,
                103,
                40,
                50,
                41,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                109,
                46,
                118,
                97,
                46,
                99,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                32,
                61,
                32,
                109,
                46,
                118,
                97,
                46,
                71,
                97,
                44,
                32,
                65,
                32,
                61,
                32,
                114,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                65,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                65,
                46,
                121,
                97,
                32,
                38,
                38,
                32,
                65,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                33,
                61,
                61,
                32,
                109,
                46,
                110,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                65,
                46,
                72,
                97,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                32,
                63,
                32,
                40,
                110,
                46,
                72,
                97,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                110,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                109,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                114,
                91,
                98,
                93,
                32,
                61,
                32,
                110,
                41,
                32,
                58,
                32,
                40,
                97,
                98,
                40,
                114,
                44,
                32,
                98,
                44,
                32,
                113,
                41,
                44,
                32,
                114,
                91,
                98,
                93,
                46,
                121,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                93,
                44,
                32,
                108,
                44,
                32,
                40,
                117,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                32,
                61,
                32,
                117,
                98,
                40,
                113,
                44,
                32,
                117,
                44,
                32,
                109,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                114,
                91,
                98,
                93,
                46,
                121,
                97,
                32,
                63,
                32,
                40,
                117,
                46,
                72,
                97,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                114,
                91,
                98,
                93,
                32,
                61,
                32,
                117,
                41,
                32,
                58,
                32,
                114,
                91,
                98,
                93,
                46,
                121,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                117,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                78,
                40,
                97,
                44,
                32,
                65,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                118,
                97,
                108,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                66,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                98,
                40,
                98,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                67,
                98,
                40,
                97,
                44,
                32,
                34,
                101,
                110,
                117,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                99,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                36,
                97,
                40,
                96,
                36,
                123,
                100,
                46,
                110,
                97,
                109,
                101,
                125,
                95,
                36,
                123,
                98,
                125,
                96,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                99,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                68,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                115,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                80,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                118,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                97,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                45,
                32,
                49,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                93,
                44,
                32,
                104,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                98,
                40,
                97,
                44,
                32,
                117,
                98,
                40,
                97,
                44,
                32,
                91,
                103,
                91,
                48,
                93,
                44,
                32,
                110,
                117,
                108,
                108,
                93,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                103,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                49,
                41,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                98,
                32,
                45,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                49,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                38,
                38,
                32,
                40,
                101,
                32,
                61,
                32,
                52,
                50,
                57,
                52,
                57,
                54,
                55,
                50,
                57,
                53,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                51,
                50,
                32,
                45,
                32,
                56,
                32,
                42,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                32,
                60,
                60,
                32,
                102,
                32,
                62,
                62,
                62,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                98,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                117,
                110,
                115,
                105,
                103,
                110,
                101,
                100,
                34,
                41,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                32,
                62,
                62,
                62,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                101,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                104,
                44,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                69,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                44,
                32,
                68,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                101,
                40,
                119,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                68,
                91,
                102,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                68,
                91,
                102,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                91,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                93,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                80,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                100,
                44,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                100,
                32,
                125,
                44,
                32,
                123,
                32,
                97,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                70,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                44,
                32,
                110,
                44,
                32,
                113,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                80,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                84,
                40,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                84,
                40,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                32,
                61,
                32,
                84,
                40,
                110,
                44,
                32,
                113,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                40,
                91,
                97,
                93,
                44,
                32,
                91,
                98,
                93,
                44,
                32,
                40,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                32,
                61,
                32,
                114,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                110,
                101,
                119,
                32,
                107,
                98,
                40,
                99,
                44,
                32,
                114,
                46,
                118,
                97,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                114,
                44,
                32,
                100,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                109,
                44,
                32,
                113,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                34,
                115,
                116,
                100,
                58,
                58,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                68,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                102,
                32,
                61,
                32,
                100,
                32,
                43,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                102,
                44,
                32,
                103,
                32,
                61,
                32,
                48,
                59,
                32,
                103,
                32,
                60,
                61,
                32,
                101,
                59,
                32,
                43,
                43,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                102,
                32,
                43,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                61,
                61,
                32,
                101,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                120,
                91,
                108,
                93,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                104,
                32,
                63,
                32,
                72,
                40,
                120,
                44,
                32,
                104,
                44,
                32,
                108,
                32,
                45,
                32,
                104,
                41,
                32,
                58,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                109,
                41,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                109,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                109,
                32,
                43,
                61,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                108,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                103,
                32,
                61,
                32,
                48,
                59,
                32,
                103,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                103,
                41,
                32,
                109,
                91,
                103,
                93,
                32,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                120,
                91,
                102,
                32,
                43,
                32,
                103,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                109,
                46,
                106,
                111,
                105,
                110,
                40,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                40,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                44,
                32,
                104,
                32,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                104,
                32,
                124,
                124,
                32,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                115,
                116,
                100,
                58,
                58,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                32,
                38,
                38,
                32,
                104,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                103,
                32,
                60,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                101,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                108,
                32,
                63,
                32,
                102,
                43,
                43,
                32,
                58,
                32,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                108,
                32,
                63,
                32,
                102,
                32,
                43,
                61,
                32,
                50,
                32,
                58,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                108,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                108,
                32,
                63,
                32,
                40,
                102,
                32,
                43,
                61,
                32,
                52,
                44,
                32,
                43,
                43,
                103,
                41,
                32,
                58,
                32,
                102,
                32,
                43,
                61,
                32,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                102,
                32,
                61,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                100,
                99,
                40,
                52,
                32,
                43,
                32,
                102,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                32,
                38,
                38,
                32,
                104,
                41,
                32,
                73,
                40,
                101,
                44,
                32,
                108,
                44,
                32,
                102,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                104,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                104,
                32,
                61,
                32,
                48,
                59,
                32,
                104,
                32,
                60,
                32,
                102,
                59,
                32,
                43,
                43,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                101,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                53,
                53,
                32,
                60,
                32,
                109,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                85,
                40,
                108,
                41,
                44,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                34,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                104,
                97,
                115,
                32,
                85,
                84,
                70,
                45,
                49,
                54,
                32,
                99,
                111,
                100,
                101,
                32,
                117,
                110,
                105,
                116,
                115,
                32,
                116,
                104,
                97,
                116,
                32,
                100,
                111,
                32,
                110,
                111,
                116,
                32,
                102,
                105,
                116,
                32,
                105,
                110,
                32,
                56,
                32,
                98,
                105,
                116,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                91,
                108,
                32,
                43,
                32,
                104,
                93,
                32,
                61,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                102,
                111,
                114,
                32,
                40,
                104,
                32,
                61,
                32,
                48,
                59,
                32,
                104,
                32,
                60,
                32,
                102,
                59,
                32,
                43,
                43,
                104,
                41,
                32,
                120,
                91,
                108,
                32,
                43,
                32,
                104,
                93,
                32,
                61,
                32,
                101,
                91,
                104,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                100,
                46,
                112,
                117,
                115,
                104,
                40,
                85,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                74,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                80,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                72,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                73,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                74,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                103,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                52,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                75,
                98,
                44,
                32,
                101,
                32,
                61,
                32,
                76,
                98,
                44,
                32,
                102,
                32,
                61,
                32,
                77,
                98,
                44,
                32,
                104,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                68,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                68,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                109,
                44,
                32,
                110,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                44,
                32,
                113,
                32,
                61,
                32,
                48,
                59,
                32,
                113,
                32,
                60,
                61,
                32,
                108,
                59,
                32,
                43,
                43,
                113,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                32,
                43,
                32,
                113,
                32,
                42,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                113,
                32,
                61,
                61,
                32,
                108,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                104,
                40,
                114,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                100,
                40,
                110,
                44,
                32,
                114,
                32,
                45,
                32,
                110,
                41,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                109,
                32,
                63,
                32,
                109,
                32,
                61,
                32,
                110,
                32,
                58,
                32,
                40,
                109,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                109,
                32,
                43,
                61,
                32,
                110,
                41,
                44,
                32,
                110,
                32,
                61,
                32,
                114,
                32,
                43,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                81,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                67,
                43,
                43,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                99,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                102,
                40,
                108,
                41,
                44,
                32,
                110,
                32,
                61,
                32,
                100,
                99,
                40,
                52,
                32,
                43,
                32,
                109,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                110,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                109,
                32,
                47,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                40,
                108,
                44,
                32,
                110,
                32,
                43,
                32,
                52,
                44,
                32,
                109,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                103,
                46,
                112,
                117,
                115,
                104,
                40,
                85,
                44,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                74,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                97,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                80,
                40,
                98,
                41,
                44,
                32,
                79,
                97,
                58,
                32,
                84,
                40,
                99,
                44,
                32,
                100,
                41,
                44,
                32,
                69,
                97,
                58,
                32,
                84,
                40,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                82,
                97,
                58,
                32,
                91,
                93,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                97,
                91,
                97,
                93,
                46,
                82,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                32,
                86,
                97,
                58,
                32,
                80,
                40,
                98,
                41,
                44,
                32,
                36,
                97,
                58,
                32,
                99,
                44,
                32,
                89,
                97,
                58,
                32,
                84,
                40,
                100,
                44,
                32,
                101,
                41,
                44,
                32,
                90,
                97,
                58,
                32,
                102,
                44,
                32,
                103,
                98,
                58,
                32,
                104,
                44,
                32,
                102,
                98,
                58,
                32,
                84,
                40,
                103,
                44,
                32,
                108,
                41,
                44,
                32,
                104,
                98,
                58,
                32,
                109,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                80,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                97,
                44,
                32,
                123,
                32,
                106,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                67,
                97,
                58,
                32,
                48,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                98,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                110,
                102,
                105,
                110,
                105,
                116,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                79,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                122,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                40,
                110,
                117,
                108,
                108,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                58,
                32,
                121,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                81,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                96,
                109,
                101,
                116,
                104,
                111,
                100,
                67,
                97,
                108,
                108,
                101,
                114,
                60,
                40,
                36,
                123,
                100,
                46,
                109,
                97,
                112,
                40,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                110,
                97,
                109,
                101,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                34,
                44,
                32,
                34,
                41,
                125,
                41,
                32,
                61,
                62,
                32,
                36,
                123,
                101,
                46,
                110,
                97,
                109,
                101,
                125,
                62,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                80,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                97,
                40,
                98,
                44,
                32,
                40,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                48,
                44,
                32,
                113,
                32,
                61,
                32,
                48,
                59,
                32,
                113,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                113,
                41,
                32,
                102,
                91,
                113,
                93,
                32,
                61,
                32,
                100,
                91,
                113,
                93,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                109,
                32,
                43,
                32,
                110,
                41,
                44,
                32,
                110,
                32,
                43,
                61,
                32,
                100,
                91,
                113,
                93,
                46,
                67,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                82,
                98,
                40,
                103,
                44,
                32,
                102,
                41,
                32,
                58,
                32,
                103,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                104,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                101,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                104,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                40,
                68,
                91,
                108,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                105,
                98,
                40,
                104,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                40,
                86,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                43,
                61,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                122,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                111,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                67,
                98,
                40,
                97,
                44,
                32,
                34,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                116,
                97,
                107,
                101,
                95,
                118,
                97,
                108,
                117,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                98,
                91,
                97,
                93,
                32,
                38,
                38,
                32,
                40,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                83,
                98,
                91,
                97,
                93,
                46,
                105,
                100,
                41,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                83,
                98,
                91,
                97,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                83,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                101,
                99,
                40,
                97,
                44,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                98,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                105,
                100,
                58,
                32,
                99,
                44,
                32,
                107,
                98,
                58,
                32,
                98,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                40,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                41,
                41,
                46,
                103,
                101,
                116,
                70,
                117,
                108,
                108,
                89,
                101,
                97,
                114,
                40,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                48,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                54,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                54,
                48,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                102,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                40,
                102,
                32,
                33,
                61,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                40,
                104,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                97,
                98,
                115,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                96,
                85,
                84,
                67,
                36,
                123,
                48,
                32,
                60,
                61,
                32,
                104,
                32,
                63,
                32,
                34,
                45,
                34,
                32,
                58,
                32,
                34,
                43,
                34,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                77,
                97,
                116,
                104,
                46,
                102,
                108,
                111,
                111,
                114,
                40,
                103,
                32,
                47,
                32,
                54,
                48,
                41,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                50,
                44,
                32,
                34,
                48,
                34,
                41,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                103,
                32,
                37,
                32,
                54,
                48,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                48,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                60,
                32,
                102,
                32,
                63,
                32,
                40,
                73,
                40,
                97,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                73,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                41,
                32,
                58,
                32,
                40,
                73,
                40,
                97,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                73,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                62,
                62,
                62,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                32,
                60,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                49,
                59,
                32,
                52,
                32,
                62,
                61,
                32,
                99,
                59,
                32,
                99,
                32,
                42,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                42,
                32,
                40,
                49,
                32,
                43,
                32,
                48,
                46,
                50,
                32,
                47,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                100,
                44,
                32,
                97,
                32,
                43,
                32,
                49,
                48,
                48,
                54,
                54,
                51,
                50,
                57,
                54,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                44,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                99,
                101,
                105,
                108,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                97,
                44,
                32,
                100,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                41,
                41,
                32,
                45,
                32,
                108,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                54,
                53,
                53,
                51,
                53,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                124,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                46,
                103,
                114,
                111,
                119,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                98,
                40,
                41,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                68,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                101,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                119,
                91,
                101,
                43,
                43,
                93,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                91,
                101,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                89,
                98,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                100,
                32,
                43,
                61,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                44,
                32,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                99,
                59,
                32,
                102,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                68,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                103,
                32,
                61,
                32,
                68,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                103,
                59,
                32,
                108,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                97,
                44,
                32,
                110,
                32,
                61,
                32,
                120,
                91,
                104,
                32,
                43,
                32,
                108,
                93,
                44,
                32,
                113,
                32,
                61,
                32,
                90,
                98,
                91,
                109,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                124,
                124,
                32,
                49,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                63,
                32,
                40,
                40,
                49,
                32,
                61,
                61,
                61,
                32,
                109,
                32,
                63,
                32,
                106,
                97,
                32,
                58,
                32,
                116,
                41,
                40,
                72,
                40,
                113,
                41,
                41,
                44,
                32,
                113,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                41,
                32,
                58,
                32,
                113,
                46,
                112,
                117,
                115,
                104,
                40,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                43,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                58,
                32,
                102,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                58,
                32,
                103,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                58,
                32,
                104,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                58,
                32,
                105,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                58,
                32,
                106,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                58,
                32,
                107,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                108,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                58,
                32,
                109,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                58,
                32,
                110,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                58,
                32,
                85,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                97,
                32,
                43,
                32,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                32,
                61,
                32,
                99,
                46,
                101,
                120,
                112,
                111,
                114,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                32,
                61,
                32,
                87,
                46,
                99,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                32,
                61,
                32,
                87,
                46,
                103,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                87,
                46,
                100,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                51,
                32,
                61,
                32,
                107,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                51,
                46,
                99,
                97,
                108,
                108,
                40,
                107,
                44,
                32,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                32,
                70,
                32,
                38,
                38,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                118,
                97,
                32,
                38,
                38,
                32,
                40,
                99,
                108,
                101,
                97,
                114,
                73,
                110,
                116,
                101,
                114,
                118,
                97,
                108,
                40,
                118,
                97,
                41,
                44,
                32,
                118,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                44,
                32,
                71,
                32,
                38,
                38,
                32,
                40,
                99,
                32,
                61,
                32,
                71,
                44,
                32,
                71,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                99,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                107,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                50,
                46,
                99,
                97,
                108,
                108,
                40,
                107,
                44,
                32,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                123,
                32,
                97,
                58,
                32,
                111,
                99,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                107,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                96,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                99,
                125,
                96,
                41,
                44,
                32,
                98,
                97,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                97,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                121,
                97,
                32,
                58,
                32,
                121,
                97,
                32,
                61,
                32,
                120,
                97,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                32,
                63,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                32,
                58,
                32,
                107,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                32,
                63,
                32,
                107,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                44,
                32,
                112,
                41,
                32,
                58,
                32,
                112,
                32,
                43,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                40,
                98,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                99,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                98,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                40,
                41,
                44,
                32,
                100,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                100,
                99,
                32,
                61,
                32,
                87,
                46,
                101,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                112,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                112,
                98,
                32,
                61,
                32,
                87,
                46,
                102,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                85,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                85,
                32,
                61,
                32,
                87,
                46,
                104,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                101,
                99,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                99,
                32,
                61,
                32,
                87,
                46,
                105,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                88,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                88,
                32,
                61,
                32,
                87,
                46,
                106,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                89,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                89,
                32,
                61,
                32,
                87,
                46,
                107,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                90,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                40,
                90,
                32,
                61,
                32,
                87,
                46,
                108,
                97,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                109,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                110,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                111,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                112,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                113,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                87,
                46,
                114,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                115,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                32,
                61,
                62,
                32,
                40,
                107,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                116,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                104,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                108,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                102,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                32,
                33,
                61,
                61,
                32,
                104,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                109,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                106,
                99,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                112,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                113,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                99,
                32,
                124,
                124,
                32,
                114,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                99,
                32,
                124,
                124,
                32,
                40,
                71,
                32,
                61,
                32,
                113,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                114,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                112,
                99,
                32,
                38,
                38,
                32,
                40,
                112,
                99,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                107,
                46,
                99,
                97,
                108,
                108,
                101,
                100,
                82,
                117,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                33,
                109,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                97,
                40,
                115,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                107,
                46,
                111,
                110,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                73,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                100,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                50,
                46,
                99,
                97,
                108,
                108,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                107,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                97,
                40,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                48,
                32,
                60,
                32,
                70,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                41,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                107,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                117,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                97,
                40,
                114,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                60,
                32,
                70,
                32,
                124,
                124,
                32,
                40,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                32,
                63,
                32,
                40,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                46,
                46,
                46,
                34,
                41,
                44,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                34,
                41,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                49,
                41,
                41,
                32,
                58,
                32,
                97,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                38,
                38,
                32,
                40,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                61,
                32,
                91,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                93,
                41,
                59,
                32,
                48,
                32,
                60,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                107,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                32,
                61,
                32,
                99,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                97,
                115,
                109,
                45,
                108,
                111,
                97,
                100,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                82,
                101,
                110,
                100,
                101,
                114,
                101,
                114,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                97,
                110,
                100,
                32,
                99,
                97,
                110,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                100,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                95,
                97,
                115,
                121,
                110,
                99,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                42,
                32,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                121,
                105,
                101,
                108,
                100,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                40,
                123,
                32,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                117,
                114,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                114,
                105,
                101,
                115,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                85,
                82,
                76,
                44,
                32,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                97,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                105,
                102,
                32,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                104,
                114,
                111,
                119,
                115,
                32,
                97,
                110,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                102,
                32,
                98,
                111,
                116,
                104,
                32,
                85,
                82,
                76,
                115,
                32,
                102,
                97,
                105,
                108,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                95,
                97,
                115,
                121,
                110,
                99,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                42,
                32,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                95,
                95,
                97,
                115,
                121,
                110,
                99,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                42,
                32,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                32,
                61,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                117,
                110,
                112,
                107,
                103,
                46,
                99,
                111,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                125,
                46,
                32,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                65,
                116,
                116,
                101,
                109,
                112,
                116,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                114,
                111,
                109,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                121,
                105,
                101,
                108,
                100,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                66,
                97,
                99,
                107,
                117,
                112,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                105,
                110,
                103,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                97,
                108,
                108,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                115,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                117,
                98,
                108,
                105,
                99,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                85,
                116,
                105,
                108,
                105,
                122,
                101,
                115,
                32,
                97,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                97,
                110,
                100,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                114,
                111,
                98,
                117,
                115,
                116,
                110,
                101,
                115,
                115,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                108,
                111,
                97,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                95,
                97,
                115,
                121,
                110,
                99,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                42,
                32,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                115,
                32,
                97,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                32,
                97,
                110,
                100,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                97,
                116,
                101,
                115,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                45,
                32,
                32,
                84,
                104,
                101,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                114,
                108,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                32,
                61,
                32,
                117,
                114,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                101,
                115,
                108,
                105,
                110,
                116,
                45,
                100,
                105,
                115,
                97,
                98,
                108,
                101,
                45,
                110,
                101,
                120,
                116,
                45,
                108,
                105,
                110,
                101,
                32,
                64,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                45,
                101,
                115,
                108,
                105,
                110,
                116,
                47,
                110,
                97,
                109,
                105,
                110,
                103,
                45,
                99,
                111,
                110,
                118,
                101,
                110,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                44,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                112,
                97,
                99,
                107,
                97,
                103,
                101,
                32,
                105,
                110,
                102,
                111,
                114,
                109,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                34,
                44,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                99,
                100,
                110,
                46,
                106,
                115,
                100,
                101,
                108,
                105,
                118,
                114,
                46,
                110,
                101,
                116,
                47,
                110,
                112,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                101,
                118,
                101,
                110,
                116,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                83,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                97,
                100,
                100,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                61,
                62,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                99,
                108,
                101,
                97,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                105,
                115,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                101,
                115,
                104,
                111,
                108,
                100,
                58,
                32,
                48,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                98,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                114,
                101,
                115,
                105,
                122,
                101,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                32,
                61,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                98,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                117,
                116,
                105,
                108,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                47,
                94,
                35,
                40,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                54,
                125,
                124,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                56,
                125,
                41,
                36,
                47,
                105,
                117,
                46,
                116,
                101,
                115,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                34,
                35,
                34,
                44,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                104,
                101,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                54,
                32,
                63,
                32,
                96,
                36,
                123,
                104,
                101,
                120,
                125,
                102,
                102,
                96,
                32,
                58,
                32,
                104,
                101,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                97,
                114,
                115,
                101,
                73,
                110,
                116,
                40,
                104,
                101,
                120,
                44,
                32,
                49,
                54,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                60,
                32,
                52,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                48,
                44,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                91,
                105,
                93,
                32,
                33,
                61,
                61,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                91,
                105,
                93,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                106,
                115,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                46,
                101,
                118,
                101,
                114,
                121,
                40,
                40,
                102,
                105,
                101,
                108,
                100,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                46,
                99,
                97,
                108,
                108,
                40,
                106,
                115,
                111,
                110,
                44,
                32,
                102,
                105,
                101,
                108,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                63,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                49,
                32,
                43,
                32,
                40,
                100,
                112,
                114,
                32,
                45,
                32,
                49,
                41,
                32,
                42,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                32,
                62,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                32,
                62,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                98,
                111,
                116,
                116,
                111,
                109,
                32,
                60,
                61,
                32,
                40,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                38,
                38,
                32,
                114,
                101,
                99,
                116,
                46,
                114,
                105,
                103,
                104,
                116,
                32,
                60,
                61,
                32,
                40,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                87,
                105,
                100,
                116,
                104,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                32,
                61,
                32,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                70,
                111,
                114,
                119,
                97,
                114,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                32,
                61,
                32,
                40,
                102,
                105,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                40,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                50,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                34,
                44,
                32,
                123,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                34,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                44,
                32,
                95,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                34,
                50,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                40,
                40,
                95,
                97,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                41,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                105,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                98,
                121,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                116,
                111,
                32,
                112,
                114,
                101,
                118,
                101,
                110,
                116,
                32,
                117,
                110,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                105,
                110,
                103,
                32,
                119,
                104,
                101,
                110,
                32,
                116,
                104,
                101,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                115,
                32,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                40,
                95,
                99,
                32,
                61,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                98,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                99,
                32,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                108,
                111,
                97,
                100,
                40,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                44,
                32,
                95,
                98,
                50,
                44,
                32,
                95,
                99,
                50,
                44,
                32,
                95,
                100,
                44,
                32,
                95,
                101,
                44,
                32,
                95,
                102,
                44,
                32,
                95,
                103,
                44,
                32,
                95,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                97,
                50,
                32,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                95,
                98,
                50,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                50,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                95,
                99,
                50,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                99,
                50,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                40,
                95,
                100,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                100,
                32,
                58,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                40,
                95,
                101,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                101,
                32,
                58,
                32,
                91,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                40,
                95,
                102,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                102,
                32,
                58,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                95,
                103,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                103,
                32,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                40,
                95,
                104,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                104,
                32,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                63,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                119,
                97,
                115,
                109,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                58,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                95,
                97,
                115,
                121,
                110,
                99,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                42,
                32,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                121,
                105,
                101,
                108,
                100,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                102,
                101,
                116,
                99,
                104,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                125,
                58,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                84,
                101,
                120,
                116,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                32,
                121,
                105,
                101,
                108,
                100,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                100,
                97,
                116,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                74,
                83,
                79,
                78,
                46,
                115,
                116,
                114,
                105,
                110,
                103,
                105,
                102,
                121,
                40,
                100,
                97,
                116,
                97,
                41,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                101,
                100,
                32,
                100,
                97,
                116,
                97,
                32,
                116,
                121,
                112,
                101,
                32,
                102,
                111,
                114,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                46,
                32,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                58,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                40,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                46,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                101,
                99,
                101,
                105,
                118,
                101,
                100,
                58,
                32,
                36,
                123,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                34,
                115,
                111,
                109,
                101,
                116,
                104,
                105,
                110,
                103,
                32,
                119,
                101,
                110,
                116,
                32,
                119,
                114,
                111,
                110,
                103,
                44,
                32,
                116,
                104,
                101,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                119,
                97,
                115,
                32,
                115,
                117,
                112,
                112,
                111,
                115,
                101,
                32,
                116,
                111,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                91,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                50,
                44,
                32,
                95,
                98,
                44,
                32,
                95,
                99,
                44,
                32,
                95,
                100,
                44,
                32,
                95,
                101,
                44,
                32,
                95,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                40,
                40,
                95,
                97,
                50,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                50,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                41,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                40,
                40,
                95,
                98,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                98,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                41,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                40,
                40,
                95,
                99,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                99,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                41,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                40,
                40,
                95,
                100,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                100,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                41,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                40,
                40,
                95,
                101,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                41,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                40,
                40,
                95,
                102,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                102,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                41,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                111,
                110,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                32,
                61,
                32,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                41,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                114,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                111,
                100,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                44,
                32,
                95,
                99,
                44,
                32,
                95,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                40,
                40,
                95,
                98,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                98,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                40,
                40,
                95,
                99,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                99,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                40,
                40,
                95,
                100,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                100,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                97,
                32,
                58,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                44,
                32,
                95,
                99,
                44,
                32,
                95,
                100,
                44,
                32,
                95,
                101,
                44,
                32,
                95,
                102,
                44,
                32,
                95,
                103,
                44,
                32,
                95,
                104,
                44,
                32,
                95,
                105,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                97,
                32,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                95,
                99,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                99,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                40,
                95,
                100,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                100,
                32,
                58,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                40,
                95,
                101,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                101,
                32,
                58,
                32,
                91,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                40,
                95,
                102,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                102,
                32,
                58,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                95,
                103,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                103,
                32,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                40,
                95,
                104,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                104,
                32,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                63,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                40,
                95,
                105,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                105,
                32,
                58,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                48,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                52,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                46,
                100,
                97,
                116,
                97,
                46,
                115,
                101,
                116,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                112,
                117,
                116,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                44,
                32,
                48,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                120,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                112,
                100,
                97,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                110,
                101,
                120,
                116,
                70,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                112,
                100,
                97,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                38,
                38,
                32,
                33,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                114,
                97,
                109,
                101,
                32,
                60,
                32,
                48,
                32,
                124,
                124,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                101,
                107,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                115,
                116,
                121,
                108,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                108,
                111,
                111,
                112,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                91,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                95,
                97,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                44,
                32,
                123,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                44,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                125,
                32,
                61,
                32,
                95,
                97,
                44,
                32,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                95,
                95,
                111,
                98,
                106,
                82,
                101,
                115,
                116,
                40,
                95,
                97,
                44,
                32,
                91,
                34,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                34,
                44,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                34,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                44,
                32,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                112,
                101,
                99,
                105,
                97,
                108,
                32,
                99,
                97,
                115,
                101,
                44,
                32,
                105,
                116,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                98,
                101,
                32,
                115,
                101,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                105,
                102,
                32,
                105,
                116,
                39,
                115,
                32,
                110,
                111,
                116,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                58,
                36,
                123,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                105,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                116,
                105,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                80,
                114,
                111,
                112,
                115,
                40,
                95,
                95,
                115,
                112,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                123,
                125,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                41,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                61,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                32,
                61,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                88,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                89,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                114,
                97,
                109,
                101,
                119,
                111,
                114,
                107,
                83,
                101,
                116,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                77,
                101,
                116,
                104,
                111,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                44,
                32,
                95,
                99,
                44,
                32,
                95,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                40,
                95,
                100,
                32,
                61,
                32,
                40,
                95,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                99,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                100,
                32,
                58,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                98,
                121,
                32,
                105,
                116,
                115,
                32,
                110,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                97,
                109,
                112,
                108,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                47,
                47,
                32,
                68,
                114,
                97,
                119,
                32,
                97,
                32,
                114,
                101,
                99,
                116,
                97,
                110,
                103,
                108,
                101,
                32,
                97,
                114,
                111,
                117,
                110,
                100,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                39,
                114,
                101,
                110,
                100,
                101,
                114,
                39,
                44,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                32,
                61,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                125,
                32,
                61,
                32,
                98,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                115,
                116,
                114,
                111,
                107,
                101,
                82,
                101,
                99,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                115,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                111,
                117,
                110,
                100,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                33,
                61,
                61,
                32,
                52,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                50,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                51,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                97,
                44,
                32,
                95,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                95,
                98,
                32,
                61,
                32,
                40,
                95,
                97,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                58,
                32,
                95,
                97,
                46,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                41,
                32,
                33,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                63,
                32,
                95,
                98,
                32,
                58,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                119,
                111,
                114,
                107,
                101,
                114,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                119,
                111,
                114,
                107,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                97,
                100,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                85,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                68,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                83,
                116,
                97,
                116,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                111,
                100,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                112,
                101,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                114,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                104,
                97,
                115,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                101,
                120,
                105,
                115,
                116,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                115,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                44,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                91,
                101,
                118,
                101,
                110,
                116,
                93,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                102,
                114,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                112,
                101,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                111,
                111,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                36,
                123,
                109,
                101,
                116,
                104,
                111,
                100,
                125,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                105,
                109,
                112,
                108,
                101,
                109,
                101,
                110,
                116,
                101,
                100,
                32,
                105,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                111,
                110,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                101,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                117,
                109,
                109,
                121,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                119,
                111,
                114,
                107,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                100,
                117,
                109,
                109,
                121,
                59,
                10,
                125,
                41,
                40,
                41,
                59,
                10
            ])
        ], {
            type: "application/javascript"
        }), i = URL.createObjectURL(n), s = new Worker(i);
        return URL.revokeObjectURL(i), s;
    }
};
var $2a37c9fd7c8f6baf$var$d3 = $2a37c9fd7c8f6baf$var$w2;
var $2a37c9fd7c8f6baf$var$U1 = class {
    constructor(){
        $2a37c9fd7c8f6baf$var$_(this, "_workers", /* @__PURE__ */ new Map());
        $2a37c9fd7c8f6baf$var$_(this, "_animationWorkerMap", /* @__PURE__ */ new Map());
    }
    getWorker(n) {
        return this._workers.has(n) || this._workers.set(n, new $2a37c9fd7c8f6baf$var$d3()), this._workers.get(n);
    }
    assignAnimationToWorker(n, i) {
        this._animationWorkerMap.set(n, i);
    }
    unassignAnimationFromWorker(n) {
        this._animationWorkerMap.delete(n);
    }
    sendMessage(n, i, s) {
        this.getWorker(n).postMessage(i, s || []);
    }
    terminateWorker(n) {
        let i = this._workers.get(n);
        i && (i.terminate(), this._workers.delete(n));
    }
};
function $2a37c9fd7c8f6baf$var$u3(c, n) {
    if (c instanceof OffscreenCanvas) return {
        width: c.width,
        height: c.height
    };
    let { height: i, width: s } = c.getBoundingClientRect();
    return {
        width: s * n,
        height: i * n
    };
}
function $2a37c9fd7c8f6baf$var$l3() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var $2a37c9fd7c8f6baf$var$q = class q2 {
    constructor(n){
        $2a37c9fd7c8f6baf$var$_(this, "_eventManager", new $2a37c9fd7c8f6baf$var$s1());
        $2a37c9fd7c8f6baf$var$_(this, "_id");
        $2a37c9fd7c8f6baf$var$_(this, "_worker");
        $2a37c9fd7c8f6baf$var$_(this, "_canvas");
        $2a37c9fd7c8f6baf$var$_(this, "_dotLottieInstanceState", {
            markers: [],
            autoplay: false,
            backgroundColor: "",
            currentFrame: 0,
            duration: 0,
            loop: false,
            mode: "forward",
            segment: [
                0,
                0
            ],
            segmentDuration: 0,
            speed: 1,
            totalFrames: 0,
            isLoaded: false,
            isPlaying: false,
            isPaused: false,
            isStopped: true,
            isFrozen: false,
            useFrameInterpolation: false,
            renderConfig: {
                devicePixelRatio: $2a37c9fd7c8f6baf$var$Z()
            },
            activeAnimationId: "",
            activeThemeId: "",
            layout: void 0,
            marker: void 0,
            isReady: false,
            manifest: null
        });
        $2a37c9fd7c8f6baf$var$_(this, "_created", false);
        $2a37c9fd7c8f6baf$var$_(this, "_pointerUpMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerDownMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerMoveMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerEnterMethod");
        $2a37c9fd7c8f6baf$var$_(this, "_pointerExitMethod");
        var s, d, m;
        this._canvas = n.canvas, this._id = `dotlottie-${$2a37c9fd7c8f6baf$var$l3()}`;
        let i = n.workerId || "defaultWorker";
        this._worker = q2._workerManager.getWorker(i), q2._workerManager.assignAnimationToWorker(this._id, i), q2._wasmUrl && this._sendMessage("setWasmUrl", {
            url: q2._wasmUrl
        }), this._create($2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, n), {
            renderConfig: $2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, n.renderConfig), {
                devicePixelRatio: ((s = n.renderConfig) == null ? void 0 : s.devicePixelRatio) || $2a37c9fd7c8f6baf$var$Z(),
                freezeOnOffscreen: (m = (d = n.renderConfig) == null ? void 0 : d.freezeOnOffscreen) != null ? m : true
            })
        })), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    _handleWorkerEvent(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            let i = n.data;
            i.id || (i.method === "onLoad" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && $2a37c9fd7c8f6baf$var$W.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && $2a37c9fd7c8f6baf$var$$.observe(this._canvas, this))), i.method === "onComplete" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onDestroy" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onUnfreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = false, this._eventManager.dispatch(i.result.event)), i.method === "onFrame" && i.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = i.result.event.currentFrame, this._eventManager.dispatch(i.result.event)), i.method === "onRender" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onFreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPause" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPlay" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStop" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onLoadError" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onReady" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)));
        });
    }
    _create(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            var d;
            let i;
            this._canvas instanceof HTMLCanvasElement ? i = this._canvas.transferControlToOffscreen() : i = this._canvas;
            let { instanceId: s } = yield this._sendMessage("create", $2a37c9fd7c8f6baf$var$F({
                instanceId: this._id,
                config: $2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F({}, n), {
                    canvas: i
                })
            }, $2a37c9fd7c8f6baf$var$u3(this._canvas, ((d = n.renderConfig) == null ? void 0 : d.devicePixelRatio) || $2a37c9fd7c8f6baf$var$Z())), [
                i
            ]);
            if (s !== this._id) throw new Error("Instance ID mismatch");
            this._created = true, yield this._updateDotLottieInstanceState();
        });
    }
    get isLoaded() {
        return this._dotLottieInstanceState.isLoaded;
    }
    get isPlaying() {
        return this._dotLottieInstanceState.isPlaying;
    }
    get isPaused() {
        return this._dotLottieInstanceState.isPaused;
    }
    get isStopped() {
        return this._dotLottieInstanceState.isStopped;
    }
    get currentFrame() {
        return this._dotLottieInstanceState.currentFrame;
    }
    get isFrozen() {
        return this._dotLottieInstanceState.isFrozen;
    }
    get segmentDuration() {
        return this._dotLottieInstanceState.segmentDuration;
    }
    get totalFrames() {
        return this._dotLottieInstanceState.totalFrames;
    }
    get segment() {
        return this._dotLottieInstanceState.segment;
    }
    get speed() {
        return this._dotLottieInstanceState.speed;
    }
    get duration() {
        return this._dotLottieInstanceState.duration;
    }
    get isReady() {
        return this._dotLottieInstanceState.isReady;
    }
    get mode() {
        return this._dotLottieInstanceState.mode;
    }
    get canvas() {
        return this._canvas;
    }
    get autoplay() {
        return this._dotLottieInstanceState.autoplay;
    }
    get backgroundColor() {
        return this._dotLottieInstanceState.backgroundColor;
    }
    get loop() {
        return this._dotLottieInstanceState.loop;
    }
    get useFrameInterpolation() {
        return this._dotLottieInstanceState.useFrameInterpolation;
    }
    get renderConfig() {
        return this._dotLottieInstanceState.renderConfig;
    }
    get manifest() {
        return this._dotLottieInstanceState.manifest;
    }
    get activeAnimationId() {
        return this._dotLottieInstanceState.activeAnimationId;
    }
    get marker() {
        return this._dotLottieInstanceState.marker;
    }
    get activeThemeId() {
        return this._dotLottieInstanceState.activeThemeId;
    }
    get layout() {
        return this._dotLottieInstanceState.layout;
    }
    play() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("play", {
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState(), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !$2a37c9fd7c8f6baf$var$$1(this._canvas) && (yield this.freeze()));
        });
    }
    pause() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("pause", {
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    stop() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("stop", {
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setSpeed(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setSpeed", {
                instanceId: this._id,
                speed: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setMode(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setMode", {
                instanceId: this._id,
                mode: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setFrame(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setFrame", {
                frame: n,
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setSegment(n, i) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setSegment", {
                instanceId: this._id,
                segment: [
                    n,
                    i
                ]
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setRenderConfig(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return;
            let m = n, { devicePixelRatio: i, freezeOnOffscreen: s } = m, d = $2a37c9fd7c8f6baf$var$O1(m, [
                "devicePixelRatio",
                "freezeOnOffscreen"
            ]);
            yield this._sendMessage("setRenderConfig", {
                instanceId: this._id,
                renderConfig: $2a37c9fd7c8f6baf$var$k($2a37c9fd7c8f6baf$var$F($2a37c9fd7c8f6baf$var$F({}, this._dotLottieInstanceState.renderConfig), d), {
                    devicePixelRatio: i || $2a37c9fd7c8f6baf$var$Z(),
                    freezeOnOffscreen: s != null ? s : true
                })
            }), yield this._updateDotLottieInstanceState(), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? $2a37c9fd7c8f6baf$var$$.observe(this._canvas, this) : $2a37c9fd7c8f6baf$var$$.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? $2a37c9fd7c8f6baf$var$W.observe(this._canvas, this) : ($2a37c9fd7c8f6baf$var$W.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && (yield this.unfreeze())));
        });
    }
    setUseFrameInterpolation(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setUseFrameInterpolation", {
                instanceId: this._id,
                useFrameInterpolation: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setTheme(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return false;
            let i = this._sendMessage("setTheme", {
                instanceId: this._id,
                themeId: n
            });
            return yield this._updateDotLottieInstanceState(), i;
        });
    }
    load(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("load", {
                config: n,
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setLoop(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setLoop", {
                instanceId: this._id,
                loop: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    resize() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return;
            let { height: n, width: i } = $2a37c9fd7c8f6baf$var$u3(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || $2a37c9fd7c8f6baf$var$Z());
            yield this._sendMessage("resize", {
                height: n,
                instanceId: this._id,
                width: i
            }), yield this._updateDotLottieInstanceState();
        });
    }
    destroy() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (this._created = false, yield this._sendMessage("destroy", {
                instanceId: this._id
            }), this._cleanupStateMachineListeners(), q2._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && ($2a37c9fd7c8f6baf$var$W.unobserve(this._canvas), $2a37c9fd7c8f6baf$var$$.unobserve(this._canvas)));
        });
    }
    freeze() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("freeze", {
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    unfreeze() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("unfreeze", {
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setBackgroundColor(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setBackgroundColor", {
                instanceId: this._id,
                backgroundColor: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    loadAnimation(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("loadAnimation", {
                animationId: n,
                instanceId: this._id
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setLayout(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setLayout", {
                instanceId: this._id,
                layout: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    _updateDotLottieInstanceState() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return;
            let n = yield this._sendMessage("getDotLottieInstanceState", {
                instanceId: this._id
            });
            this._dotLottieInstanceState = n.state;
        });
    }
    markers() {
        return this._dotLottieInstanceState.markers;
    }
    setMarker(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            this._created && (yield this._sendMessage("setMarker", {
                instanceId: this._id,
                marker: n
            }), yield this._updateDotLottieInstanceState());
        });
    }
    setThemeData(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return false;
            let i = yield this._sendMessage("setThemeData", {
                instanceId: this._id,
                themeData: n
            });
            return yield this._updateDotLottieInstanceState(), i;
        });
    }
    setViewport(n, i, s, d) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            return this._created ? this._sendMessage("setViewport", {
                x: n,
                y: i,
                width: s,
                height: d,
                instanceId: this._id
            }) : false;
        });
    }
    _sendMessage(n, i, s) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            let d = {
                id: `dotlottie-request-${$2a37c9fd7c8f6baf$var$l3()}`,
                method: n,
                params: i
            };
            return this._worker.postMessage(d, s || []), new Promise((m, b)=>{
                let M = (P)=>{
                    let R = P.data;
                    R.id === d.id && (this._worker.removeEventListener("message", M), R.error ? b(new Error(`Failed to execute method ${n}: ${R.error}`)) : m(R.result));
                };
                this._worker.addEventListener("message", M);
            });
        });
    }
    addEventListener(n, i) {
        this._eventManager.addEventListener(n, i);
    }
    removeEventListener(n, i) {
        this._eventManager.removeEventListener(n, i);
    }
    static setWasmUrl(n) {
        q2._wasmUrl = n;
    }
    loadStateMachine(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return false;
            let i = yield this._sendMessage("loadStateMachine", {
                instanceId: this._id,
                stateMachineId: n
            });
            return yield this._updateDotLottieInstanceState(), i;
        });
    }
    loadStateMachineData(n) {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return false;
            let i = yield this._sendMessage("loadStateMachineData", {
                instanceId: this._id,
                stateMachineData: n
            });
            return yield this._updateDotLottieInstanceState(), i;
        });
    }
    startStateMachine() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if (!this._created) return false;
            this._setupStateMachineListeners();
            let n = yield this._sendMessage("startStateMachine", {
                instanceId: this._id
            });
            return yield this._updateDotLottieInstanceState(), n;
        });
    }
    stopStateMachine() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", {
                instanceId: this._id
            })) : false;
        });
    }
    getStateMachineListeners() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            return this._created ? this._sendMessage("getStateMachineListeners", {
                instanceId: this._id
            }) : [];
        });
    }
    _getPointerPosition(n) {
        let i = this._canvas.getBoundingClientRect(), s = this._canvas.width / i.width, d = this._canvas.height / i.height, m = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, b = (n.clientX - i.left) * s / m, M = (n.clientY - i.top) * d / m;
        return {
            x: b,
            y: M
        };
    }
    _onPointerUp(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerUpEvent", {
            instanceId: this._id,
            x: i,
            y: s
        });
    }
    _onPointerDown(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerDownEvent", {
            instanceId: this._id,
            x: i,
            y: s
        });
    }
    _onPointerMove(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerMoveEvent", {
            instanceId: this._id,
            x: i,
            y: s
        });
    }
    _onPointerEnter(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerEnterEvent", {
            instanceId: this._id,
            x: i,
            y: s
        });
    }
    _onPointerLeave(n) {
        let { x: i, y: s } = this._getPointerPosition(n);
        this._sendMessage("postPointerExitEvent", {
            instanceId: this._id,
            x: i,
            y: s
        });
    }
    _setupStateMachineListeners() {
        return $2a37c9fd7c8f6baf$var$g(this, null, function*() {
            if ($2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
                let n = yield this._sendMessage("getStateMachineListeners", {
                    instanceId: this._id
                });
                n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
            }
        });
    }
    _cleanupStateMachineListeners() {
        $2a37c9fd7c8f6baf$var$A && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
    }
};
$2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$q, "_workerManager", new $2a37c9fd7c8f6baf$var$U1()), $2a37c9fd7c8f6baf$var$_($2a37c9fd7c8f6baf$var$q, "_wasmUrl", "");
var $2a37c9fd7c8f6baf$var$h3 = $2a37c9fd7c8f6baf$var$q;
function $2a37c9fd7c8f6baf$var$DotLottieComponent(_a) {
    var _b = _a, { children: children, className: className = "", setCanvasRef: setCanvasRef, setContainerRef: setContainerRef, style: style } = _b, rest = $2a37c9fd7c8f6baf$var$__objRest(_b, [
        "children",
        "className",
        "setCanvasRef",
        "setContainerRef",
        "style"
    ]);
    const containerStyle = $2a37c9fd7c8f6baf$var$__spreadValues({
        width: "100%",
        height: "100%",
        lineHeight: 0
    }, style);
    return /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", $2a37c9fd7c8f6baf$var$__spreadProps($2a37c9fd7c8f6baf$var$__spreadValues({
        ref: setContainerRef,
        className: className
    }, !className && {
        style: containerStyle
    }), {
        children: /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)("canvas", $2a37c9fd7c8f6baf$var$__spreadProps($2a37c9fd7c8f6baf$var$__spreadValues({
            ref: setCanvasRef,
            style: {
                width: "100%",
                height: "100%"
            }
        }, rest), {
            children: children
        }))
    }));
}
var $2a37c9fd7c8f6baf$export$bc8b8ec26ea46445 = (config)=>{
    const [dotLottie, setDotLottie] = (0, $ajtHG.useState)(null);
    const dotLottieRef = (0, $ajtHG.useRef)(null);
    const configRef = (0, $ajtHG.useRef)(config);
    const canvasRef = (0, $ajtHG.useRef)(null);
    const containerRef = (0, $ajtHG.useRef)(null);
    dotLottieRef.current = dotLottie;
    configRef.current = config;
    const hoverHandler = (0, $ajtHG.useCallback)((event)=>{
        var _a, _b;
        if (!((_a = configRef.current) == null ? void 0 : _a.playOnHover) || !((_b = dotLottieRef.current) == null ? void 0 : _b.isLoaded)) return;
        if (event.type === "mouseenter") dotLottieRef.current.play();
        else if (event.type === "mouseleave") dotLottieRef.current.pause();
    }, []);
    const setCanvasRef = (0, $ajtHG.useCallback)((canvas)=>{
        canvasRef.current = canvas;
    }, []);
    const setContainerRef = (0, $ajtHG.useCallback)((container)=>{
        containerRef.current = container;
    }, []);
    const Component = (0, $ajtHG.useCallback)((props)=>{
        return /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)($2a37c9fd7c8f6baf$var$DotLottieComponent, $2a37c9fd7c8f6baf$var$__spreadValues({
            setContainerRef: setContainerRef,
            setCanvasRef: setCanvasRef
        }, props));
    }, [
        setCanvasRef,
        setContainerRef
    ]);
    (0, $ajtHG.useEffect)(()=>{
        const canvas = canvasRef.current;
        let dotLottieInstance = null;
        if (canvas) {
            dotLottieInstance = new $2a37c9fd7c8f6baf$var$s3($2a37c9fd7c8f6baf$var$__spreadProps($2a37c9fd7c8f6baf$var$__spreadValues({}, configRef.current), {
                canvas: canvas
            }));
            canvas.addEventListener("mouseenter", hoverHandler);
            canvas.addEventListener("mouseleave", hoverHandler);
            setDotLottie(dotLottieInstance);
        }
        return ()=>{
            dotLottieInstance == null || dotLottieInstance.destroy();
            setDotLottie(null);
            canvas == null || canvas.removeEventListener("mouseenter", hoverHandler);
            canvas == null || canvas.removeEventListener("mouseleave", hoverHandler);
        };
    }, [
        hoverHandler
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.speed) === "number" && config.speed !== dotLottieRef.current.speed) dotLottieRef.current.setSpeed(config.speed);
    }, [
        config == null ? void 0 : config.speed
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.mode) === "string" && config.mode !== dotLottieRef.current.mode) dotLottieRef.current.setMode(config.mode);
    }, [
        config == null ? void 0 : config.mode
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.loop) === "boolean" && config.loop !== dotLottieRef.current.loop) dotLottieRef.current.setLoop(config.loop);
    }, [
        config == null ? void 0 : config.loop
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.useFrameInterpolation) === "boolean" && config.useFrameInterpolation !== dotLottieRef.current.useFrameInterpolation) dotLottieRef.current.setUseFrameInterpolation(config.useFrameInterpolation);
    }, [
        config == null ? void 0 : config.useFrameInterpolation
    ]);
    (0, $ajtHG.useEffect)(()=>{
        var _a, _b;
        if (!dotLottieRef.current) return;
        const startFrame = (_a = config == null ? void 0 : config.segment) == null ? void 0 : _a[0];
        const endFrame = (_b = config == null ? void 0 : config.segment) == null ? void 0 : _b[1];
        if (typeof startFrame === "number" && typeof endFrame === "number") dotLottieRef.current.setSegment(startFrame, endFrame);
    }, [
        config == null ? void 0 : config.segment
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.backgroundColor) === "string" && config.backgroundColor !== dotLottieRef.current.backgroundColor) dotLottieRef.current.setBackgroundColor(config.backgroundColor);
    }, [
        config == null ? void 0 : config.backgroundColor
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.renderConfig) === "object") dotLottieRef.current.setRenderConfig(config.renderConfig);
    }, [
        JSON.stringify(config == null ? void 0 : config.renderConfig)
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.data) === "string" || (config == null ? void 0 : config.data) instanceof ArrayBuffer) dotLottieRef.current.load($2a37c9fd7c8f6baf$var$__spreadValues({
            data: config.data
        }, configRef.current || {}));
    }, [
        config == null ? void 0 : config.data
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.src) === "string") dotLottieRef.current.load($2a37c9fd7c8f6baf$var$__spreadValues({
            src: config.src
        }, configRef.current || {}));
    }, [
        config == null ? void 0 : config.src
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.marker) === "string") dotLottieRef.current.setMarker(config.marker);
    }, [
        config == null ? void 0 : config.marker
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (dotLottieRef.current.isLoaded && (config == null ? void 0 : config.animationId) && dotLottieRef.current.activeAnimationId !== config.animationId) dotLottieRef.current.loadAnimation(config.animationId);
    }, [
        config == null ? void 0 : config.animationId
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (dotLottieRef.current.isLoaded && dotLottieRef.current.activeThemeId !== (config == null ? void 0 : config.themeId)) dotLottieRef.current.setTheme((config == null ? void 0 : config.themeId) || "");
    }, [
        config == null ? void 0 : config.themeId
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (dotLottieRef.current.isLoaded) dotLottieRef.current.setThemeData((config == null ? void 0 : config.themeData) || "");
    }, [
        config == null ? void 0 : config.themeData
    ]);
    return {
        dotLottie: dotLottie,
        setCanvasRef: setCanvasRef,
        setContainerRef: setContainerRef,
        canvas: canvasRef.current,
        container: containerRef.current,
        DotLottieComponent: Component
    };
};
var $2a37c9fd7c8f6baf$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $ajtHG.useLayoutEffect) : (0, $ajtHG.useEffect);
function $2a37c9fd7c8f6baf$var$useStableCallback(callback) {
    const callbackContainer = (0, $ajtHG.useRef)(callback);
    $2a37c9fd7c8f6baf$var$useIsomorphicLayoutEffect(()=>{
        callbackContainer.current = callback;
    });
    return (0, $ajtHG.useCallback)((...args)=>callbackContainer.current(...args), [
        callbackContainer
    ]);
}
var $2a37c9fd7c8f6baf$export$5502e10bdc22dfb3 = (_a)=>{
    var _b = _a, { animationId: animationId, autoplay: autoplay, backgroundColor: backgroundColor, data: data, dotLottieRefCallback: dotLottieRefCallback, loop: loop, marker: marker, mode: mode, playOnHover: playOnHover, renderConfig: renderConfig, segment: segment, speed: speed, src: src, themeData: themeData, themeId: themeId, useFrameInterpolation: useFrameInterpolation } = _b, props = $2a37c9fd7c8f6baf$var$__objRest(_b, [
        "animationId",
        "autoplay",
        "backgroundColor",
        "data",
        "dotLottieRefCallback",
        "loop",
        "marker",
        "mode",
        "playOnHover",
        "renderConfig",
        "segment",
        "speed",
        "src",
        "themeData",
        "themeId",
        "useFrameInterpolation"
    ]);
    const { DotLottieComponent: DotLottieComponent2, dotLottie: dotLottie } = $2a37c9fd7c8f6baf$export$bc8b8ec26ea46445({
        data: data,
        mode: mode,
        speed: speed,
        src: src,
        autoplay: autoplay,
        loop: loop,
        segment: segment,
        renderConfig: renderConfig,
        backgroundColor: backgroundColor,
        useFrameInterpolation: useFrameInterpolation,
        playOnHover: playOnHover,
        marker: marker,
        themeId: themeId,
        animationId: animationId,
        themeData: themeData
    });
    const stableDotLottieRefCallback = typeof dotLottieRefCallback === "function" ? $2a37c9fd7c8f6baf$var$useStableCallback(dotLottieRefCallback) : void 0;
    (0, $ajtHG.useEffect)(()=>{
        if (typeof stableDotLottieRefCallback === "function") stableDotLottieRefCallback(dotLottie);
    }, [
        stableDotLottieRefCallback,
        dotLottie
    ]);
    return /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)(DotLottieComponent2, $2a37c9fd7c8f6baf$var$__spreadValues({}, props));
};
function $2a37c9fd7c8f6baf$var$DotLottieWorkerComponent(_a) {
    var _b = _a, { children: children, className: className = "", setCanvasRef: setCanvasRef, setContainerRef: setContainerRef, style: style } = _b, rest = $2a37c9fd7c8f6baf$var$__objRest(_b, [
        "children",
        "className",
        "setCanvasRef",
        "setContainerRef",
        "style"
    ]);
    const containerStyle = $2a37c9fd7c8f6baf$var$__spreadValues({
        width: "100%",
        height: "100%",
        lineHeight: 0
    }, style);
    return /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", $2a37c9fd7c8f6baf$var$__spreadProps($2a37c9fd7c8f6baf$var$__spreadValues({
        ref: setContainerRef,
        className: className
    }, !className && {
        style: containerStyle
    }), {
        children: /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)("canvas", $2a37c9fd7c8f6baf$var$__spreadProps($2a37c9fd7c8f6baf$var$__spreadValues({
            ref: setCanvasRef,
            style: {
                width: "100%",
                height: "100%"
            }
        }, rest), {
            children: children
        }))
    }));
}
var $2a37c9fd7c8f6baf$export$513d77987c13781f = (config)=>{
    const [dotLottie, setDotLottie] = (0, $ajtHG.useState)(null);
    const dotLottieRef = (0, $ajtHG.useRef)(null);
    const configRef = (0, $ajtHG.useRef)(config);
    const canvasRef = (0, $ajtHG.useRef)(null);
    const containerRef = (0, $ajtHG.useRef)(null);
    dotLottieRef.current = dotLottie;
    configRef.current = config;
    const hoverHandler = (0, $ajtHG.useCallback)((event)=>{
        var _a, _b;
        if (!((_a = configRef.current) == null ? void 0 : _a.playOnHover) || !((_b = dotLottieRef.current) == null ? void 0 : _b.isLoaded)) return;
        if (event.type === "mouseenter") dotLottieRef.current.play();
        else if (event.type === "mouseleave") dotLottieRef.current.pause();
    }, []);
    const setCanvasRef = (0, $ajtHG.useCallback)((canvas)=>{
        canvasRef.current = canvas;
    }, []);
    const setContainerRef = (0, $ajtHG.useCallback)((container)=>{
        containerRef.current = container;
    }, []);
    const Component = (0, $ajtHG.useCallback)((props)=>{
        return /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)($2a37c9fd7c8f6baf$var$DotLottieWorkerComponent, $2a37c9fd7c8f6baf$var$__spreadValues({
            setContainerRef: setContainerRef,
            setCanvasRef: setCanvasRef
        }, props));
    }, [
        setCanvasRef,
        setContainerRef
    ]);
    (0, $ajtHG.useEffect)(()=>{
        const canvas = canvasRef.current;
        let dotLottieInstance = null;
        if (canvas) {
            dotLottieInstance = new $2a37c9fd7c8f6baf$var$h3($2a37c9fd7c8f6baf$var$__spreadProps($2a37c9fd7c8f6baf$var$__spreadValues({}, configRef.current), {
                canvas: canvas
            }));
            canvas.addEventListener("mouseenter", hoverHandler);
            canvas.addEventListener("mouseleave", hoverHandler);
            setDotLottie(dotLottieInstance);
        }
        return ()=>{
            dotLottieInstance == null || dotLottieInstance.destroy();
            setDotLottie(null);
            canvas == null || canvas.removeEventListener("mouseenter", hoverHandler);
            canvas == null || canvas.removeEventListener("mouseleave", hoverHandler);
        };
    }, [
        hoverHandler
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.speed) === "number" && config.speed !== dotLottieRef.current.speed) dotLottieRef.current.setSpeed(config.speed);
    }, [
        config == null ? void 0 : config.speed
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.mode) === "string" && config.mode !== dotLottieRef.current.mode) dotLottieRef.current.setMode(config.mode);
    }, [
        config == null ? void 0 : config.mode
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.loop) === "boolean" && config.loop !== dotLottieRef.current.loop) dotLottieRef.current.setLoop(config.loop);
    }, [
        config == null ? void 0 : config.loop
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.useFrameInterpolation) === "boolean" && config.useFrameInterpolation !== dotLottieRef.current.useFrameInterpolation) dotLottieRef.current.setUseFrameInterpolation(config.useFrameInterpolation);
    }, [
        config == null ? void 0 : config.useFrameInterpolation
    ]);
    (0, $ajtHG.useEffect)(()=>{
        var _a, _b;
        if (!dotLottieRef.current) return;
        const startFrame = (_a = config == null ? void 0 : config.segment) == null ? void 0 : _a[0];
        const endFrame = (_b = config == null ? void 0 : config.segment) == null ? void 0 : _b[1];
        if (typeof startFrame === "number" && typeof endFrame === "number") dotLottieRef.current.setSegment(startFrame, endFrame);
    }, [
        config == null ? void 0 : config.segment
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.backgroundColor) === "string" && config.backgroundColor !== dotLottieRef.current.backgroundColor) dotLottieRef.current.setBackgroundColor(config.backgroundColor);
    }, [
        config == null ? void 0 : config.backgroundColor
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.renderConfig) === "object") dotLottieRef.current.setRenderConfig(config.renderConfig);
    }, [
        JSON.stringify(config == null ? void 0 : config.renderConfig)
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.data) === "string" || (config == null ? void 0 : config.data) instanceof ArrayBuffer) dotLottieRef.current.load($2a37c9fd7c8f6baf$var$__spreadValues({
            data: config.data
        }, configRef.current || {}));
    }, [
        config == null ? void 0 : config.data
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.src) === "string") dotLottieRef.current.load($2a37c9fd7c8f6baf$var$__spreadValues({
            src: config.src
        }, configRef.current || {}));
    }, [
        config == null ? void 0 : config.src
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (typeof (config == null ? void 0 : config.marker) === "string") dotLottieRef.current.setMarker(config.marker);
    }, [
        config == null ? void 0 : config.marker
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (dotLottieRef.current.isLoaded && (config == null ? void 0 : config.animationId) && dotLottieRef.current.activeAnimationId !== config.animationId) dotLottieRef.current.loadAnimation(config.animationId);
    }, [
        config == null ? void 0 : config.animationId
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (dotLottieRef.current.isLoaded && dotLottieRef.current.activeThemeId !== (config == null ? void 0 : config.themeId)) dotLottieRef.current.setTheme((config == null ? void 0 : config.themeId) || "");
    }, [
        config == null ? void 0 : config.themeId
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (!dotLottieRef.current) return;
        if (dotLottieRef.current.isLoaded) dotLottieRef.current.setThemeData((config == null ? void 0 : config.themeData) || "");
    }, [
        config == null ? void 0 : config.themeData
    ]);
    return {
        dotLottie: dotLottie,
        setCanvasRef: setCanvasRef,
        setContainerRef: setContainerRef,
        canvas: canvasRef.current,
        container: containerRef.current,
        DotLottieComponent: Component
    };
};
var $2a37c9fd7c8f6baf$export$bfcb0a2f556afa6b = (_a)=>{
    var _b = _a, { animationId: animationId, autoplay: autoplay, backgroundColor: backgroundColor, data: data, dotLottieRefCallback: dotLottieRefCallback, loop: loop, marker: marker, mode: mode, playOnHover: playOnHover, renderConfig: renderConfig, segment: segment, speed: speed, src: src, themeData: themeData, themeId: themeId, useFrameInterpolation: useFrameInterpolation, workerId: workerId } = _b, props = $2a37c9fd7c8f6baf$var$__objRest(_b, [
        "animationId",
        "autoplay",
        "backgroundColor",
        "data",
        "dotLottieRefCallback",
        "loop",
        "marker",
        "mode",
        "playOnHover",
        "renderConfig",
        "segment",
        "speed",
        "src",
        "themeData",
        "themeId",
        "useFrameInterpolation",
        "workerId"
    ]);
    const { DotLottieComponent: DotLottieComponent2, dotLottie: dotLottie } = $2a37c9fd7c8f6baf$export$513d77987c13781f({
        workerId: workerId,
        data: data,
        mode: mode,
        speed: speed,
        src: src,
        autoplay: autoplay,
        loop: loop,
        segment: segment,
        renderConfig: renderConfig,
        backgroundColor: backgroundColor,
        useFrameInterpolation: useFrameInterpolation,
        playOnHover: playOnHover,
        marker: marker,
        themeId: themeId,
        animationId: animationId,
        themeData: themeData
    });
    const stableDotLottieRefCallback = typeof dotLottieRefCallback === "function" ? $2a37c9fd7c8f6baf$var$useStableCallback(dotLottieRefCallback) : void 0;
    (0, $ajtHG.useEffect)(()=>{
        if (typeof stableDotLottieRefCallback === "function") stableDotLottieRefCallback(dotLottie);
    }, [
        stableDotLottieRefCallback,
        dotLottie
    ]);
    return /* @__PURE__ */ (0, $9b3c114f2ec1a7b9$exports.jsx)(DotLottieComponent2, $2a37c9fd7c8f6baf$var$__spreadValues({}, props));
};
// src/index.ts
var $2a37c9fd7c8f6baf$export$878e2eb5c33b978f = (url)=>{
    $2a37c9fd7c8f6baf$var$h3.setWasmUrl(url);
    $2a37c9fd7c8f6baf$var$s3.setWasmUrl(url);
};





const $91fcc8cfd10476a9$export$1e2322822297ef53 = ()=>{
    const projectVisor = (0, $ajtHG.useRef)();
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const [width, setWidth] = (0, $ajtHG.useState)(0);
    const [height, setHeight] = (0, $ajtHG.useState)(0);
    const [showInstruction, setShowInstruction] = (0, $ajtHG.useState)(true);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    (0, $ajtHG.useEffect)(()=>{
        setWidth(projectVisor.current.offsetWidth);
        setHeight(projectVisor.current.clientHeight);
    }, []);
    const handleScratchComplete = ()=>{
        setShowInstruction(false);
        setTimeout(()=>{
            navigate("/artist-top");
        }, 2000);
    };
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)(EmptyScreen, {
        text: "loading..."
    });
    if (!data.top_artists || data.top_artists.length <= 0) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        ref: projectVisor,
        className: "content app-artist",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
            children: "No artist"
        })
    });
    const topArtistUrl = data.top_artists[0].artist_id.artwork;
    const topArtistName = data.top_artists[0].artist_id.name;
    const topArtistRank = data.top_artists[0].rank;
    const trackPlayed = data.top_artists[0].play_count;
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-artist",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "scratch-container",
                ref: projectVisor,
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $e0837b7d9dd71c0f$export$2e2bcd8739ae039), {
                    className: "scratch-card",
                    width: width,
                    height: height,
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($9cdd1c4e81076dfa$exports))),
                    finishPercent: 50,
                    brushSize: 50,
                    onComplete: handleScratchComplete,
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        referrerPolicy: "no-referrer",
                        src: topArtistUrl,
                        alt: "airbuds yearly recap",
                        className: "scratch-img"
                    })
                })
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "content content-artist no-touch",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                        closeAction: ()=>{
                            navigate("/menu");
                        }
                    }),
                    showInstruction && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($91fcc8cfd10476a9$export$1e1623ab6ebc04f5, {}),
                    !showInstruction && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "scratch-artist",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                                className: "light-headline scratch-title"
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                                className: "headline scratch-name",
                                children: topArtistName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $91fcc8cfd10476a9$export$1e1623ab6ebc04f5 = ()=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "scratch-artist",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                className: "light-headline scratch-title"
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("h2", {
                className: "light-headline scratch-title",
                children: [
                    "Your top artist",
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("br", {}),
                    "of the year"
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                className: "headline scratch-instruction",
                children: [
                    "scratch to",
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("br", {}),
                    "to discover"
                ]
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $2a37c9fd7c8f6baf$export$5502e10bdc22dfb3), {
                className: "scratch-animation",
                src: "https://lottie.host/d10ff161-b4b0-4572-aec8-0c2a4a0dfd5c/HuBBXK4wL8.lottie",
                loop: true,
                autoplay: true
            })
        ]
    });
};



parcelRequire("ajtHG");






const $b003ae56cfd06cfd$export$5f36f579f4cc8202 = ({})=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
        children: "Loading..."
    });
    if (!data.top_artists || data.top_artists.length <= 0) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        ref: projectVisor,
        className: "app-artist",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
            children: "No artist"
        })
    });
    const artist = data.top_artists[0];
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-top-artist-container",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "app-artist-top app-artist-top-single",
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    className: "top-artist-card-container",
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $be2bc40674a284e0$export$70a41ccc5091e7ef), {
                            data: artist
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                            className: "buttons",
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$a6c7ac8248d6e38a), {
                                to: "/artist-top-list",
                                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                                    title: "next"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                }
            })
        ]
    });
};







var $ajtHG = parcelRequire("ajtHG");




var $ajtHG = parcelRequire("ajtHG");


function $7bb3b27772e5daf2$export$19fa182fb736e81a(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}



const $7bb3b27772e5daf2$export$72f7495ee91036ed = ({ className: className, variant: variant, url: url, hide: hide })=>{
    const floatingAnimation = {
        x: [
            0,
            $7bb3b27772e5daf2$export$19fa182fb736e81a(4, 12),
            0
        ],
        y: [
            0,
            $7bb3b27772e5daf2$export$19fa182fb736e81a(5, 9),
            0
        ],
        // Move up by 20px, then back to original
        transition: {
            duration: 10,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        },
        exit: {
            y: "-150%"
        }
    };
    const shape = function() {
        switch(variant){
            case 1:
                return "artist-shape-1";
            case 2:
                return "artist-shape-2";
            case 3:
                return "artist-shape-3";
            default:
                return "artist-shape-4";
        }
    }();
    const badgeShape = function() {
        switch(variant){
            case 1:
                return "artist-shape-badge-1";
            case 2:
                return "artist-shape-badge-2";
            case 3:
                return "artist-shape-badge-3";
            default:
                return "artist-shape-badge-4";
        }
    }();
    const badgeName = function() {
        switch(variant){
            case 1:
                return (parcelRequire("haq60"));
            case 2:
                return null;
            case 3:
                return (parcelRequire("bOkMY"));
            default:
                return (parcelRequire("cZAZL"));
        }
    }();
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $8553df5161f06c53$export$3ae376d12526dd6f), {
        children: !hide && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
            className: className,
            initial: {
                opacity: 0,
                y: "100%"
            },
            animate: {
                opacity: 1,
                y: "0%"
            },
            exit: {
                opacity: 0,
                y: "-400%"
            },
            transition: {
                duration: 1.0,
                delay: 0.5,
                ease: [
                    0,
                    0.71,
                    0.2,
                    1.01
                ]
            },
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "artist-shape " + shape,
                    src: url,
                    animate: floatingAnimation
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: badgeShape,
                    style: {
                        right: 0,
                        bottom: 0,
                        position: "absolute"
                    },
                    src: badgeName
                })
            ]
        })
    });
};
const $7bb3b27772e5daf2$export$4efff457c69209d5 = ({ data: data, hide: hide })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-stats-intro-background",
        children: [
            data && data.top_artists && data.top_artists[0] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($7bb3b27772e5daf2$export$72f7495ee91036ed, {
                url: data.top_artists[0].artist_id.artwork,
                className: "artist-shape-container artist-shape-container-1",
                variant: 1,
                hide: hide
            }),
            data && data.top_artists && data.top_artists[1] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($7bb3b27772e5daf2$export$72f7495ee91036ed, {
                url: data.top_artists[1].artist_id.artwork,
                className: "artist-shape-container artist-shape-container-2",
                variant: 2,
                hide: hide
            }),
            data && data.top_artists && data.top_artists[2] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($7bb3b27772e5daf2$export$72f7495ee91036ed, {
                url: data.top_artists[2].artist_id.artwork,
                className: "artist-shape-container artist-shape-container-3",
                variant: 3,
                hide: hide
            }),
            data && data.top_artists && data.top_artists[3] && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($7bb3b27772e5daf2$export$72f7495ee91036ed, {
                url: data.top_artists[3].artist_id.artwork,
                className: "artist-shape-container artist-shape-container-4",
                variant: 4,
                hide: hide
            })
        ]
    });
};
const $7bb3b27772e5daf2$export$c2ba5b0117c97f27 = ({ data: data, next: next })=>{
    const [hide, setHide] = (0, $ajtHG.useState)(false);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "app-stats-intro-content",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($7bb3b27772e5daf2$export$4efff457c69209d5, {
                data: data,
                hide: hide
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                className: "center-container",
                initial: {
                    opacity: 0,
                    y: "100%"
                },
                animate: {
                    opacity: 1,
                    y: "0%"
                },
                exit: {
                    opacity: 0,
                    y: "-400%"
                },
                transition: {
                    duration: 1.0,
                    delay: 0.5,
                    ease: [
                        0,
                        0.71,
                        0.2,
                        1.01
                    ]
                },
                children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                    className: "stats-typer",
                    sequence: [
                        1000,
                        "\uD83D\uDC4B",
                        1000,
                        "We know",
                        //  Continuing previous Text
                        750,
                        "We know, you love your stats",
                        500,
                        "Stats \u270A",
                        100,
                        "Stats \u270A Stats \u270A",
                        100,
                        ()=>{
                            setHide(true);
                        },
                        "Stats \u270A Stats \u270A Stats \u270A",
                        1000,
                        ()=>{
                            next();
                        }
                    ],
                    style: {
                        fontSize: "2em"
                    },
                    typeSpeed: 420
                })
            })
        ]
    }, "step-0");
};




var $ajtHG = parcelRequire("ajtHG");



const $89b72aa430117ede$export$4b76a080210bd4eb = ({ url: url })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
        referrerPolicy: "no-referrer",
        className: "artist-capsule",
        style: {
            width: 180,
            height: 280,
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.20)"
        },
        src: url
    });
};
const $89b72aa430117ede$export$ff90d8e9170d636c = ({ url: url })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
        referrerPolicy: "no-referrer",
        className: "Image",
        style: {
            width: 280,
            height: 280,
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.20)"
        },
        src: url
    });
};



const $89b72aa430117ede$export$491954ac4807d6a8 = ({ type: type, data: data, next: next })=>{
    const [hide, setHide] = (0, $ajtHG.useState)(false);
    const [showResult, setShowResult] = (0, $ajtHG.useState)(false);
    var title = "";
    var subtitle = "";
    var artwork = "";
    var listenCount = "";
    if (type == "artist" && data.top_artists && data.top_artists.length > 0) {
        title = data.top_artists[0].artist_id.name;
        subtitle = "";
        artwork = data.top_artists[0].artist_id.artwork;
        listenCount = data.top_artists[0].play_count;
    } else if (type == "album" && data.top_albums && data.top_albums.length > 0) {
        title = data.top_albums[0].album_id.name;
        subtitle = data.top_albums[0].album_id.artistName;
        artwork = data.top_albums[0].album_id.artwork;
        listenCount = data.top_albums[0].play_count;
    } else if (type == "song" && data.top_songs && data.top_songs.length > 0) {
        title = data.top_songs[0].song_id.name;
        subtitle = data.top_songs[0].song_id.artistName;
        artwork = data.top_songs[0].song_id.artwork;
        listenCount = data.top_songs[0].play_count;
    }
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "app-stats-intro-content",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "center-container single-most-played-container",
            initial: {
                opacity: 0,
                y: "100%"
            },
            animate: {
                opacity: 1,
                y: "0%"
            },
            exit: {
                opacity: 0,
                y: "-400%"
            },
            transition: {
                duration: 1.0,
                delay: 0.5,
                ease: [
                    0,
                    0.71,
                    0.2,
                    1.01
                ]
            },
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                    className: "stats-typer light-headline header-single",
                    sequence: [
                        "",
                        1000,
                        "most played ",
                        500,
                        "most played " + type,
                        500,
                        ()=>{
                            setShowResult(true);
                        }
                    ],
                    typeSpeed: 420
                }),
                type == "artist" && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "artist-shape-badge-background artist-shape-badge-4",
                    style: {
                        left: "21%",
                        top: "25%",
                        position: "absolute",
                        width: "60%"
                    },
                    src: (parcelRequire("6Lxug")),
                    initial: {
                        opacity: 0,
                        y: "100%",
                        scale: 0.0
                    },
                    animate: {
                        opacity: showResult ? 1 : 0,
                        y: showResult ? "0%" : "100%",
                        scale: showResult ? 1.0 : 0.0
                    },
                    exit: {
                        opacity: 0,
                        y: "-400%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    }
                }),
                type != "artist" && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "artist-shape-badge-background artist-shape-badge-4",
                    style: {
                        left: "0px",
                        top: "18%",
                        position: "absolute",
                        width: "50%"
                    },
                    src: (parcelRequire("99iC1")),
                    initial: {
                        opacity: 0,
                        y: "100%",
                        scale: 0.0
                    },
                    animate: {
                        opacity: showResult ? 1 : 0,
                        y: showResult ? "0%" : "100%",
                        scale: showResult ? 1.0 : 0.0
                    },
                    exit: {
                        opacity: 0,
                        y: "-400%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    }
                }),
                type != "artist" && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "artist-shape-badge-background artist-shape-badge-3",
                    style: {
                        position: "absolute",
                        right: "-6px",
                        bottom: "46%",
                        width: "40%"
                    },
                    src: (parcelRequire("gAHsj")),
                    initial: {
                        opacity: 0,
                        y: "100%",
                        scale: 0.0
                    },
                    animate: {
                        opacity: showResult ? 1 : 0,
                        y: showResult ? "0%" : "100%",
                        scale: showResult ? 1.0 : 0.0
                    },
                    exit: {
                        opacity: 0,
                        y: "-400%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    }
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "column-layout single-most-played ",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: showResult ? 1 : 0,
                        y: showResult ? "0%" : "100%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-400%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        type != "artist" && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($89b72aa430117ede$export$ff90d8e9170d636c, {
                            url: artwork
                        }),
                        type == "artist" && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($89b72aa430117ede$export$4b76a080210bd4eb, {
                            url: artwork
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "column-layout single-most-played-metadata",
                            children: [
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h1", {
                                    className: "headline",
                                    children: title
                                }),
                                type != "artist" && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                    className: "light-headline",
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "column-layout single-most-played-listen",
                            children: [
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                                    children: listenCount
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                                    className: "light-headline",
                                    children: "listens"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                    onClick: ()=>next(),
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                        title: "next"
                    })
                })
            ]
        })
    }, "step-0");
};




var $ajtHG = parcelRequire("ajtHG");




parcelRequire("ajtHG");


parcelRequire("ajtHG");

const $e3bc67b6319315a1$export$ecb9124777ad894c = ({ rank: rank, type: type, data: data })=>{
    var title = "";
    var subtitle = "";
    var artwork = "";
    var listenCount = "";
    if (type == "artists" && data.artist_id) {
        title = data.artist_id.name;
        subtitle = data.play_count + " listens";
        artwork = data.artist_id.artwork;
        listenCount = data.play_count;
    } else if (type == "albums" && data.album_id) {
        title = data.album_id.name;
        subtitle = data.album_id.artistName;
        artwork = data.album_id.artwork;
        listenCount = data.play_count;
    } else if (type == "songs" && data.song_id) {
        title = data.song_id.name;
        subtitle = data.song_id.artistName;
        artwork = data.song_id.artwork;
        listenCount = data.play_count;
    } else if (type == "genres" && data.genre) {
        title = data.genre;
        subtitle = data.minutes + " minutes \xb7 " + data.play_count + " tracks";
        artwork = null;
        listenCount = null;
    }
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "row-layout list-item",
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 1.0,
            delay: 0.5,
            ease: [
                0,
                0.71,
                0.2,
                1.01
            ]
        },
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "cover-and-rank cover-and-rank-" + type,
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "rank-decoration",
                        children: rank
                    }),
                    type != "artists" && artwork && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        className: "list-cover-image",
                        src: artwork
                    }),
                    type == "artists" && artwork && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        referrerPolicy: "no-referrer",
                        className: "artist-capsule list-cover-artist",
                        src: artwork
                    })
                ]
            }),
            type != "artists" && title && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "column-layout",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "list-title list-title-" + type,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "list-subtitle",
                        children: subtitle
                    })
                ]
            }),
            type == "artists" && title && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "column-layout",
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "list-title list-title-" + type,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
                        className: "list-subtitle",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};


const $3c511cdb59ac3f6f$export$e5181479769a7156 = ({ rank: rank, type: type, data: data })=>{
    var list = [];
    if (type == "artists" && data.top_artists) list = data.top_artists ? data.top_artists.slice(0, 5) : [];
    else if (type == "albums" && data.top_albums) list = data.top_albums ? data.top_albums.slice(0, 5) : [];
    else if (type == "songs" && data.top_songs) list = data.top_songs ? data.top_songs.slice(0, 5) : [];
    else if (type == "genres" && data.top_genres) list = data.top_genres ? data.top_genres.slice(0, 5) : [];
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "column-layout stats-list",
        children: list.map((item, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $e3bc67b6319315a1$export$ecb9124777ad894c), {
                rank: "" + (index + 1),
                type: type,
                data: item
            }, "list-item-" + index))
    });
};


const $6b5ffba64286357d$export$8050371a3a9f1610 = ({ type: type, data: data, next: next })=>{
    const [hide, setHide] = (0, $ajtHG.useState)(false);
    const [showResult, setShowResult] = (0, $ajtHG.useState)(false);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "app-stats-intro-content",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "center-container single-most-played-container list-most-played-container",
            initial: {
                opacity: 0,
                y: "100%"
            },
            animate: {
                opacity: 1,
                y: "0%"
            },
            exit: {
                opacity: 0,
                y: "-400%"
            },
            transition: {
                duration: 1.0,
                delay: 0.5,
                ease: [
                    0,
                    0.71,
                    0.2,
                    1.01
                ]
            },
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                    className: "light-headline list-headline",
                    sequence: [
                        "top 5",
                        1000,
                        "top 5 " + type,
                        500,
                        ()=>{
                            setShowResult(true);
                        }
                    ],
                    typeSpeed: 420
                }, type),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "column-layout list-container",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: showResult ? 1 : 0,
                        y: showResult ? "0%" : "100%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-400%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $3c511cdb59ac3f6f$export$e5181479769a7156), {
                            data: data,
                            type: type
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                            className: "bottom-actions",
                            onClick: ()=>next(),
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                                title: "next"
                            })
                        })
                    ]
                })
            ]
        })
    }, "step-" + type);
};




var $ajtHG = parcelRequire("ajtHG");






const $820b7612c9e1ea86$export$65d24b84517fdb13 = ({ data: data })=>{
    const floatingAnimation = {
        x: [
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(4, 12),
            0
        ],
        y: [
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(5, 9),
            0
        ],
        // Move up by 20px, then back to original
        transition: {
            duration: 10,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        },
        exit: {
            y: "-150%"
        }
    };
    const floatingAnimation2 = {
        x: [
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(6, 15),
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(6, 15),
            0
        ],
        y: [
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(0, 9),
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(0, 9),
            0
        ],
        // Move up by 20px, then back to original
        transition: {
            duration: 10,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        },
        exit: {
            y: "-150%"
        }
    };
    if (data.top_songs) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "track-played-background",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "tracks-played-images",
            children: [
                data && data.top_songs && data.top_songs.length > 0 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--small",
                    src: data.top_songs[0].song_id.artwork,
                    alt: data.top_songs[0].song_id.name,
                    animate: floatingAnimation2
                }),
                data && data.top_songs && data.top_songs.length > 1 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--medium",
                    src: data.top_songs[1].song_id.artwork,
                    alt: data.top_songs[1].song_id.name,
                    animate: floatingAnimation
                }),
                data && data.top_songs && data.top_songs.length > 2 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--tiny",
                    src: data.top_songs[2].song_id.artwork,
                    alt: data.top_songs[2].song_id.name,
                    animate: floatingAnimation2
                }),
                data && data.top_songs && data.top_songs.length > 3 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--large",
                    src: data.top_songs[3].song_id.artwork,
                    alt: data.top_songs[3].song_id.name,
                    animate: floatingAnimation
                }),
                data && data.top_songs && data.top_songs.length > 4 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--xl",
                    src: data.top_songs[4].song_id.artwork,
                    alt: data.top_songs[4].song_id.name,
                    animate: floatingAnimation2
                }),
                data && data.top_songs && data.top_songs.length > 5 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--mediumAlt",
                    src: data.top_songs[5].song_id.artwork,
                    alt: data.top_songs[5].song_id.name,
                    animate: floatingAnimation
                }),
                data && data.top_songs && data.top_songs.length > 6 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--mediumAlt2",
                    src: data.top_songs[6].song_id.artwork,
                    alt: data.top_songs[6].song_id.name,
                    animate: floatingAnimation2
                }),
                data && data.top_songs && data.top_songs.length > 7 && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "cover-background cover-background--mediumAlt3",
                    src: data.top_songs[7].song_id.artwork,
                    alt: data.top_songs[7].song_id.name,
                    animate: floatingAnimation
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    referrerPolicy: "no-referrer",
                    className: "floating-badge",
                    src: (parcelRequire("cZAZL"))
                })
            ]
        })
    });
};
const $820b7612c9e1ea86$export$52936a2deb8e0e26 = ({ data: data, next: next })=>{
    const [hide, setHide] = (0, $ajtHG.useState)(false);
    const [showResult, setShowResult] = (0, $ajtHG.useState)(true);
    const minutes = Math.floor(data.minutes / 24 / 60);
    if (!data.play_count) next();
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "app-stats-intro-content",
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($820b7612c9e1ea86$export$65d24b84517fdb13, {
                data: data
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                className: "center-container track-count-container",
                initial: {
                    opacity: 0,
                    y: "100%"
                },
                animate: {
                    opacity: 1,
                    y: "0%"
                },
                exit: {
                    opacity: 0,
                    y: "-400%"
                },
                transition: {
                    duration: 1.0,
                    delay: 0.5,
                    ease: [
                        0,
                        0.71,
                        0.2,
                        1.01
                    ]
                },
                children: [
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                        className: "column-layout ",
                        initial: {
                            opacity: 0,
                            y: "100%"
                        },
                        animate: {
                            opacity: showResult ? 1 : 0,
                            y: showResult ? "0%" : "100%"
                        },
                        exit: {
                            opacity: 0,
                            y: "-400%"
                        },
                        transition: {
                            duration: 1.0,
                            delay: 0.5,
                            ease: [
                                0,
                                0.71,
                                0.2,
                                1.01
                            ]
                        },
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                            className: "column-layout tracks-played",
                            children: [
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a0401e570a895d71$export$1b74141c5fe63a28), {
                                    className: "headline counter-track",
                                    from: 0,
                                    to: data.play_count,
                                    duration: 3
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                    className: "light-headline",
                                    children: "tracks played"
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                                    className: "track-played-description",
                                    sequence: [
                                        "",
                                        3000,
                                        "Listening to " + data.play_count + " songs is like having your own epic music festival that lasts non-stop for about " + minutes + " days!",
                                        500
                                    ],
                                    typeSpeed: 620
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                        onClick: ()=>next(),
                        style: {
                            marginBottom: "32px"
                        },
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$cfc7921d29ef7b80), {
                            title: "next"
                        })
                    })
                ]
            })
        ]
    }, "step-track-played");
};











function $be0bbcaaf28c2eb6$var$useStateAndRef(initial) {
    const [value, setValue] = (0, $ajtHG.useState)(initial);
    const valueRef = (0, $ajtHG.useRef)(value);
    valueRef.current = value;
    return [
        value,
        setValue,
        valueRef
    ];
}

const $be0bbcaaf28c2eb6$export$3cdec2bba15e3523 = ({})=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const [statsStep, setStatsStep, refStep] = $be0bbcaaf28c2eb6$var$useStateAndRef(0);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const [categories, setCategories, refCategories] = $be0bbcaaf28c2eb6$var$useStateAndRef([]);
    const [reactionsList, setReactionsList] = (0, $ajtHG.useState)((0, $b22b634b64676940$export$68fb1297e1fdf33e));
    const { setMusicURL: setMusicURL, playMusic: playMusic } = (0, $e1bd9c9bc4ba88d5$export$8be4c01406f592a)();
    const [showMusic, setShowMusic] = (0, $ajtHG.useState)(false);
    const [currentSongIndex, setCurrentSongIndex, refCurrentSong] = $be0bbcaaf28c2eb6$var$useStateAndRef(0);
    const previous = ()=>{
        setStatsStep(Math.max(statsStep - 1, 0));
    };
    const next = ()=>{
        if (statsStep == categories.length - 1) navigate("/menu");
        else setStatsStep(Math.min(statsStep + 1, categories.length));
    };
    (0, $ajtHG.useEffect)(()=>{
        if (data && data.reactions) {
            const reactions = data.reactions.sample.filter((reaction)=>reaction.kind === "emoji").map((reaction)=>reaction.body);
            setReactionsList(reactions.concat(reactions));
        }
    }, [
        data
    ]);
    (0, $ajtHG.useEffect)(()=>{
        if (data && data.top_songs && data.top_songs.length > 0) {
            setShowMusic(true);
            setMusicURL(data.top_songs[0].song_id.preview);
        }
        return ()=>{
            setMusicURL(null);
        };
    }, [
        data
    ]);
    (0, $ajtHG.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (data && data.top_songs && data.top_songs.length > refCurrentSong.current + 1) {
                const songIndex = refCurrentSong.current + 1;
                setCurrentSongIndex(songIndex);
                setShowMusic(true);
                setMusicURL(data.top_songs[songIndex].song_id.preview);
            } else {
                setCurrentSongIndex(0);
                setShowMusic(false);
                setMusicURL(null);
            }
            return ()=>{
                setMusicURL(null);
            };
        }, 20000);
        //Clearing the interval
        return ()=>clearInterval(interval);
    }, [
        data
    ]);
    (0, $ajtHG.useEffect)(()=>{
        var c = [];
        c.push({
            id: "intro"
        });
        c.push({
            id: "intro-2"
        });
        if (data && data.top_albums && data.top_albums.length > 0) c.push({
            id: "single-album"
        });
        if (data && data.top_albums && data.top_albums.length > 1) c.push({
            id: "list-albums"
        });
        if (data && data.top_artists && data.top_artists.length > 0) c.push({
            id: "single-artist"
        });
        if (data && data.top_artists && data.top_artists.length > 1) c.push({
            id: "list-artists"
        });
        if (data && data.top_songs && data.top_songs.length > 0) c.push({
            id: "single-song"
        });
        if (data && data.top_songs && data.top_songs.length > 1) c.push({
            id: "list-songs"
        });
        if (data && data.top_genres && data.top_genres.length > 0) c.push({
            id: "list-genres"
        });
        if (data && data.play_count) c.push({
            id: "count-tracks"
        });
        if (data && !data.top_genres && !data.top_artists) {
            c.push({
                id: "reactions",
                type: "reactions"
            });
            c.push({
                id: "questions",
                type: "questions"
            });
        }
        c.push({
            id: "share"
        });
        setCategories(c);
    }, [
        data
    ]);
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "loading..."
    });
    const renderState = (ctgs, state)=>{
        if (!ctgs || ctgs.length <= state) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
            text: "loading...",
            closeAction: ()=>navigate("/menu")
        });
        const stepId = ctgs[state].id;
        switch(stepId){
            case "intro":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $7bb3b27772e5daf2$export$c2ba5b0117c97f27), {
                    data: data,
                    next: ()=>{}
                });
            case "intro-2":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-stats-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                            className: "title title-stats",
                            children: "your"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                            src: (parcelRequire("2KSlU")),
                            alt: "airbuds yearly recap",
                            className: "full-centered-img"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h1", {
                            className: "title subtile-stats",
                            children: "Music Recap"
                        })
                    ]
                }, "step-1");
            case "single-album":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-stats-content ",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $89b72aa430117ede$export$491954ac4807d6a8), {
                        type: "album",
                        data: data,
                        next: ()=>setStatsStep(statsStep + 1)
                    })
                }, "step-2");
            case "list-albums":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6b5ffba64286357d$export$8050371a3a9f1610), {
                    type: "albums",
                    data: data,
                    next: ()=>setStatsStep(statsStep + 1)
                });
            case "single-artist":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-stats-content ",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $89b72aa430117ede$export$491954ac4807d6a8), {
                        type: "artist",
                        data: data,
                        next: ()=>setStatsStep(statsStep + 1)
                    })
                }, "step-2");
            case "list-artists":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6b5ffba64286357d$export$8050371a3a9f1610), {
                    type: "artists",
                    data: data,
                    next: ()=>setStatsStep(statsStep + 1)
                });
            case "single-song":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-stats-content ",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 1,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $89b72aa430117ede$export$491954ac4807d6a8), {
                        type: "song",
                        data: data,
                        next: ()=>setStatsStep(statsStep + 1)
                    })
                }, "step-2");
            case "list-songs":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6b5ffba64286357d$export$8050371a3a9f1610), {
                    type: "songs",
                    data: data,
                    next: ()=>setStatsStep(statsStep + 1)
                });
            case "list-genres":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6b5ffba64286357d$export$8050371a3a9f1610), {
                    type: "genres",
                    data: data,
                    next: ()=>setStatsStep(statsStep + 1)
                });
            case "count-tracks":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $820b7612c9e1ea86$export$52936a2deb8e0e26), {
                    data: data,
                    next: ()=>setStatsStep(statsStep + 1)
                });
            case "share":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $949ad98624b47189$export$2e2bcd8739ae039), {
                    data: data
                });
            case "reactions":
                if (!data.reactions) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                            emojis: reactionsList,
                            next: ()=>{}
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "app-curiosity-content",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 0,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "column-layout",
                                children: [
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a0401e570a895d71$export$1b74141c5fe63a28), {
                                        className: "headline counter-big",
                                        from: 0,
                                        to: data.reactions.count,
                                        duration: 3
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                                        children: "Reactions"
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                        className: "light-headline",
                                        children: "Sent & received"
                                    })
                                ]
                            })
                        }, "step-1")
                    ]
                });
            case "questions":
                if (!data.prompt_stats || data.prompt_stats.answers_count == null || data.prompt_stats.prompts_count == null) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                            emojis: (0, $b22b634b64676940$export$d75782c74c541dbb),
                            next: ()=>{}
                        }, "question-emojis"),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "app-curiosity-content",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 0,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "column-layout",
                                children: [
                                    data.prompt_stats && data.prompt_stats.answers_count && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a0401e570a895d71$export$1b74141c5fe63a28), {
                                        className: "headline counter-big",
                                        from: 0,
                                        to: data.prompt_stats.answers_count + data.prompt_stats.prompts_count,
                                        duration: 3
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                                        children: "Questions"
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                        className: "light-headline",
                                        children: "sent & answered"
                                    })
                                ]
                            })
                        }, "step-2")
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $949ad98624b47189$export$2e2bcd8739ae039), {
                    data: data
                });
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-stats-container stats-gradient-background " + (statsStep == categories.length - 1 ? "share-background" : ""),
        children: [
            renderState(categories, statsStep),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$cb5eab83e584f566), {
                className: statsStep == categories.length - 1 ? "not-clickable" : "",
                prev: previous,
                next: next
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/thanks");
                },
                showMusic: showMusic
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9cd772bad9dc8d45$export$2e2bcd8739ae039), {
                className: "story-bar",
                totalPages: categories.length,
                currentPage: statsStep,
                duration: 0
            })
        ]
    });
};




var $ajtHG = parcelRequire("ajtHG");









function $3f2d0f5133e7d55f$var$useStateAndRef(initial) {
    const [value, setValue] = (0, $ajtHG.useState)(initial);
    const valueRef = (0, $ajtHG.useRef)(value);
    valueRef.current = value;
    return [
        value,
        setValue,
        valueRef
    ];
}









const $3f2d0f5133e7d55f$export$d00b6fa144656dc8 = ({ data: data })=>{
    const floatingAnimation = {
        x: [
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(4, 12),
            0
        ],
        y: [
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(5, 9),
            0
        ],
        // Move up by 20px, then back to original
        transition: {
            duration: 10,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        },
        exit: {
            y: "-150%"
        }
    };
    const floatingAnimation2 = {
        x: [
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(6, 15),
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(6, 15),
            0
        ],
        y: [
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(0, 9),
            0,
            (0, $7bb3b27772e5daf2$export$19fa182fb736e81a)(0, 9),
            0
        ],
        // Move up by 20px, then back to original
        transition: {
            duration: 10,
            // Duration of one cycle
            ease: "easeInOut",
            repeat: Infinity // Loop indefinitely
        },
        exit: {
            y: "-150%"
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "track-played-background",
        initial: {
            scale: 0
        },
        animate: {
            scale: 1
        },
        exit: {
            scale: 0
        },
        transition: {
            duration: 1.0,
            delay: 2.5,
            ease: [
                0,
                0.71,
                0.2,
                1.01
            ]
        },
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
            className: "user-played-images",
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--small",
                    src: (parcelRequire("cPrpx")),
                    alt: "Small Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--medium",
                    src: (parcelRequire("gTNGt")),
                    alt: "Medium Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--tiny",
                    src: (parcelRequire("3LZTk")),
                    alt: "Tiny Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--large",
                    src: (parcelRequire("9xsq5")),
                    alt: "Large Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--xl",
                    src: (parcelRequire("3lF1g")),
                    alt: "XL Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--mediumAlt",
                    src: (parcelRequire("lOhS0")),
                    alt: "Medium Alternate Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--mediumAlt2",
                    src: (parcelRequire("9UWO6")),
                    alt: "Medium Alternate Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "user-background cover-background--mediumAlt3",
                    src: (parcelRequire("5EOJX")),
                    alt: "Medium Alternate Circle"
                }),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                    className: "floating-badge",
                    src: (parcelRequire("cZAZL"))
                })
            ]
        })
    });
};
const $3f2d0f5133e7d55f$export$a572bc837d51c193 = ({ data: data })=>{
    const [step, setStep, refStep] = $3f2d0f5133e7d55f$var$useStateAndRef(0);
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const previous = ()=>{
        setStep(Math.max(refStep.current - 1, 0));
    };
    const next = ()=>{
        if (refStep.current == 4) navigate("/menu");
        else setStep(Math.min(refStep.current + 1, 4));
    };
    const renderState = (state)=>{
        switch(state){
            case 0:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-stats-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f96b51fe7975cd75$export$9ccb4d0b6557995c), {
                        className: "headline thanks-headline",
                        sequence: [
                            1000,
                            "what",
                            400,
                            "what a",
                            400,
                            "what a year",
                            400,
                            "what a year",
                            1000
                        ],
                        style: {
                            fontSize: "2em"
                        },
                        typeSpeed: 620
                    })
                }, "step-0");
            case 1:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($3f2d0f5133e7d55f$export$d00b6fa144656dc8, {}),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "app-thanks-content",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 0,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h3, {
                                    initial: {
                                        opacity: 0,
                                        y: "100%"
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: "0%"
                                    },
                                    exit: {
                                        opacity: 1,
                                        y: "-100%"
                                    },
                                    transition: {
                                        duration: 1.0,
                                        delay: 0.0,
                                        ease: [
                                            0,
                                            0.71,
                                            0.2,
                                            1.01
                                        ]
                                    },
                                    className: "headline-light",
                                    children: "in 2024 we hit"
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                                    className: "big-headline",
                                    initial: {
                                        opacity: 0,
                                        y: "100%"
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: "0%"
                                    },
                                    exit: {
                                        opacity: 1,
                                        y: "-100%"
                                    },
                                    transition: {
                                        duration: 1.0,
                                        delay: 1.5,
                                        ease: [
                                            0,
                                            0.71,
                                            0.2,
                                            1.01
                                        ]
                                    },
                                    children: "4 millions airbuddies"
                                }),
                                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).p, {
                                    className: "type-text",
                                    initial: {
                                        opacity: 0,
                                        y: "100%"
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: "0%"
                                    },
                                    exit: {
                                        opacity: 1,
                                        y: "-100%"
                                    },
                                    transition: {
                                        duration: 1.0,
                                        delay: 2.0,
                                        ease: [
                                            0,
                                            0.71,
                                            0.2,
                                            1.01
                                        ]
                                    },
                                    children: "and we are so appreciative of each and every one of you!"
                                })
                            ]
                        }, "step-1")
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-thanks-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h3, {
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 1,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.0,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            className: "headline-light",
                            children: "Sharing your music is an authentic way of"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                            className: "big-headline",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 1,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: "expressing yourself"
                        })
                    ]
                }, "step-2");
            case 3:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-thanks-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                            className: "big-headline",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 1,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.0,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: "\uD83E\uDEF6"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h3, {
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 1,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            className: "light-headline",
                            children: "And we hope you continue to do so in 2025 and beyond"
                        })
                    ]
                }, "step-4");
            case 4:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                            emojis: Array(50).fill("\uD83E\uDE77")
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "app-thanks-content",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 0,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.0,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                                className: "big-headline",
                                initial: {
                                    opacity: 0,
                                    y: "100%"
                                },
                                animate: {
                                    opacity: 1,
                                    y: "0%"
                                },
                                exit: {
                                    opacity: 1,
                                    y: "-100%"
                                },
                                transition: {
                                    duration: 1.0,
                                    delay: 0.0,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                children: "Thank you for everything"
                            })
                        }, "step-5")
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {});
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-stats-container thanks-gradient-background " + (step == 5 ? "share-background" : ""),
        children: [
            renderState(step),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$cb5eab83e584f566), {
                className: step == 5 ? "not-clickable" : "",
                prev: previous,
                next: next
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {}),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9cd772bad9dc8d45$export$2e2bcd8739ae039), {
                className: "story-bar",
                totalPages: 5,
                currentPage: step,
                duration: 0
            })
        ]
    });
};





var $ajtHG = parcelRequire("ajtHG");


const $e306937278b34acb$var$DataFetcher = ()=>{
    const { data: data, setData: setData } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const location = (0, $96c7c697f6acb9e3$export$45d76561a5302f2b)();
    (0, $ajtHG.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                // Get the current URL
                const currentUrl = window.location.search;
                const urlParams = new URLSearchParams(currentUrl);
                const jsonUrl = urlParams.get("data");
                // Check if data is already cached
                const cachedData = localStorage.getItem(jsonUrl);
                if (cachedData) setData(JSON.parse(cachedData));
                // Fetch the JSON data
                const response = await fetch(jsonUrl);
                if (!response.ok) throw new Error("Failed to fetch data");
                const fetchedData = await response.json();
                // Save data to context and localStorage
                setData(fetchedData);
                localStorage.setItem(jsonUrl, JSON.stringify(fetchedData));
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        const pingBackend = async ()=>{
            try {
                // Get the current URL
                const currentUrl = window.location.search;
                const urlParams = new URLSearchParams(currentUrl);
                const jsonUrl = urlParams.get("data");
                const touchUrl = jsonUrl + ".ping";
                // Fetch the JSON data
                const response = await fetch(touchUrl, {
                    method: "POST"
                });
                if (!response.ok) throw new Error("Failed to ping backend");
            } catch (error) {
                console.error("Error pinging backend:", error);
            }
        };
        if (!data) {
            fetchData();
            pingBackend();
        }
    }, [
        location.pathname,
        data,
        setData
    ]);
    return null; // This component doesn't render anything
};
var $e306937278b34acb$export$2e2bcd8739ae039 = $e306937278b34acb$var$DataFetcher;




var $ajtHG = parcelRequire("ajtHG");











var $ajtHG = parcelRequire("ajtHG");


const $6712160ae15d86f7$export$8b3eeabcce2f7847 = ({ text: text })=>{
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
        className: "row-layout list-item",
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 1.0,
            delay: 0.5,
            ease: [
                0,
                0.71,
                0.2,
                1.01
            ]
        },
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
            children: text
        })
    });
};
const $6712160ae15d86f7$var$allMessages = [
    "You gave one artist the Ex Treatment this year",
    "You listened to them once",
    "then #ghosted for the rest of the year...",
    "...",
    "\uD83D\uDC7B\uD83D\uDC7B\uD83D\uDC7B\uD83D\uDC7B"
];

const $6712160ae15d86f7$var$ChatMessages = ({ data: data, next: next })=>{
    const [displayedMessages, setDisplayedMessages] = (0, $ajtHG.useState)([]);
    const [showArtist, setShowArtist] = (0, $ajtHG.useState)(false);
    const [showArtistName, setShowArtistName] = (0, $ajtHG.useState)(false);
    const [showDate, setShowDate] = (0, $ajtHG.useState)(false);
    const [showNextButton, setShowNextButton] = (0, $ajtHG.useState)(false);
    const MESSAGE_DELAY = 1500;
    (0, $ajtHG.useEffect)(()=>{
        // Simulating messages being received dynamically
        $6712160ae15d86f7$var$allMessages.forEach((message, index)=>{
            setTimeout(()=>{
                setDisplayedMessages((prev)=>[
                        ...prev,
                        message
                    ]);
            }, index * MESSAGE_DELAY); // 500ms delay between each message
        });
    }, []);
    (0, $ajtHG.useEffect)(()=>{
        setTimeout(()=>{
            setShowArtist(true);
        }, $6712160ae15d86f7$var$allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY);
    }, [
        showArtist
    ]);
    (0, $ajtHG.useEffect)(()=>{
        setTimeout(()=>{
            setShowArtistName(true);
        }, $6712160ae15d86f7$var$allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY * 2);
    }, [
        showArtistName
    ]);
    (0, $ajtHG.useEffect)(()=>{
        setTimeout(()=>{
            setShowDate(true);
        }, $6712160ae15d86f7$var$allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY * 3);
    }, [
        showDate
    ]);
    (0, $ajtHG.useEffect)(()=>{
        setTimeout(()=>{
            setShowNextButton(true);
        }, $6712160ae15d86f7$var$allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY * 5);
    }, [
        showNextButton
    ]);
    var artistName = null;
    if (data.artist_id && data.artist_id.name) artistName = data.artist_id.name;
    var artwork = null;
    if (data.artist_id && data.artist_id.artwork) artwork = data.artist_id.artwork;
    var dateString = null;
    if (data.played_at_date && data.played_at_date) {
        const date = new Date(data.played_at_date);
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        dateString = date.toLocaleDateString(undefined, options);
    }
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
        className: "chat-container",
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $8553df5161f06c53$export$3ae376d12526dd6f), {
            children: [
                displayedMessages.map((message, index)=>/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                        className: "message-bubble",
                        initial: {
                            opacity: 0,
                            translateY: 20
                        },
                        animate: {
                            opacity: 1,
                            translateY: 0
                        },
                        exit: {
                            opacity: 0
                        },
                        transition: {
                            duration: 0.5
                        },
                        children: message
                    }, message)),
                showArtist && artwork && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "artist-item-container-chat",
                    initial: {
                        opacity: 0,
                        translateY: 20
                    },
                    animate: {
                        opacity: 1,
                        translateY: 0
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                        referrerPolicy: "no-referrer",
                        src: artwork,
                        alt: "",
                        className: "artist-item-chat artist-capsule"
                    })
                }, "artist"),
                showArtistName && artistName && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    style: $6712160ae15d86f7$var$styles.messageBubble,
                    initial: {
                        opacity: 0,
                        translateY: 20
                    },
                    animate: {
                        opacity: 1,
                        translateY: 0
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: artistName
                }, "artist-name"),
                showDate && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "message-bubble message-bubble-date",
                    initial: {
                        opacity: 0,
                        translateY: 20
                    },
                    animate: {
                        opacity: 1,
                        translateY: 0
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("img", {
                            src: (parcelRequire("1QoVJ")),
                            alt: "read"
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("p", {
                            children: [
                                "Read - ",
                                dateString
                            ]
                        })
                    ]
                }, "date"),
                showNextButton && /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "message-bubble message-bubble-nobackground",
                    initial: {
                        opacity: 0,
                        translateY: 20
                    },
                    animate: {
                        opacity: 1,
                        translateY: 0
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.5
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("button", {
                        onClick: ()=>{
                            next();
                        },
                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$3b0a3a1406f56aea), {
                            title: "next"
                        })
                    })
                }, "next")
            ]
        })
    });
};
var $6712160ae15d86f7$export$2e2bcd8739ae039 = $6712160ae15d86f7$var$ChatMessages;
const $6712160ae15d86f7$var$styles = {
    messageBubble: {
        alignSelf: "flex-start",
        backgroundColor: "#007bff",
        color: "white",
        padding: "10px",
        borderRadius: "15px",
        maxWidth: "80%"
    }
};







function $8f79fac4467d0d99$var$useStateAndRef(initial) {
    const [value, setValue] = (0, $ajtHG.useState)(initial);
    const valueRef = (0, $ajtHG.useRef)(value);
    valueRef.current = value;
    return [
        value,
        setValue,
        valueRef
    ];
}
const $8f79fac4467d0d99$export$b084ed8e1ba5627b = ({})=>{
    const { data: data } = (0, $b6c962eba7db6225$export$c1cf1cf4c5d51937)();
    const [step, setStep, refStep] = $8f79fac4467d0d99$var$useStateAndRef(0);
    const [reactionsList, setReactionsList] = (0, $ajtHG.useState)((0, $b22b634b64676940$export$68fb1297e1fdf33e));
    const navigate = (0, $96c7c697f6acb9e3$export$9770f232ac06a008)();
    const [categories, setCategories, refCategories] = $8f79fac4467d0d99$var$useStateAndRef([]);
    (0, $ajtHG.useEffect)(()=>{
        if (data && data.reactions) {
            const reactions = data.reactions.sample.filter((reaction)=>reaction.kind === "emoji").map((reaction)=>reaction.body);
            setReactionsList(reactions.concat(reactions));
        }
    }, [
        data
    ]);
    const previous = ()=>{
        setStep(Math.max(refStep.current - 1, 0));
    };
    const next = ()=>{
        if (refStep.current == refCategories.current.length - 1) navigate("/menu");
        else setStep(Math.min(refStep.current + 1, refCategories.current.length));
    };
    if (!data) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("p", {
        children: "Loading..."
    });
    if (!data.weird_artist && !data.yingyang && !data.reactions) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
        text: "no data",
        closeAction: ()=>navigate("/menu")
    });
    (0, $ajtHG.useEffect)(()=>{
        var c = [];
        if (data.weird_artist && data.weird_artist) c.push({
            id: "weird-artist",
            type: "weird-artist"
        });
        if (data.yingyang && data.yingyang.artist1) {
            c.push({
                id: "ying-yang-1",
                type: "ying-yang-1"
            });
            c.push({
                id: "ying-yang-2",
                type: "ying-yang-2"
            });
        }
        if (c.length == 0) {
            c.push({
                id: "reactions",
                type: "reactions"
            });
            c.push({
                id: "questions",
                type: "questions"
            });
        }
        c.push({
            id: "comeback-message",
            type: "comeback-message"
        });
        setCategories(c);
    }, [
        data
    ]);
    const renderState = (ctgs, state)=>{
        if (!ctgs || ctgs.length <= state) return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$d15bb912fa4ed6cf), {
            text: "loading...",
            closeAction: ()=>navigate("/menu")
        });
        const stepId = ctgs[state].id;
        switch(stepId){
            case "weird-artist":
                if (!data.weird_artist) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-curiosity-content app-curiosity-content-chat",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.0,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6712160ae15d86f7$export$2e2bcd8739ae039), {
                        data: data.weird_artist,
                        next: next
                    })
                }, "step-0");
            case "reactions":
                if (!data.reactions) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                            emojis: reactionsList,
                            next: ()=>{}
                        }),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "app-curiosity-content",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 0,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "column-layout",
                                children: [
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a0401e570a895d71$export$1b74141c5fe63a28), {
                                        className: "headline counter-big",
                                        from: 0,
                                        to: data.reactions.count,
                                        duration: 3
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                                        children: "Reactions"
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                        className: "light-headline",
                                        children: "Sent & received"
                                    })
                                ]
                            })
                        }, "step-1")
                    ]
                });
            case "questions":
                if (!data.prompt_stats || data.prompt_stats.answers_count == null || data.prompt_stats.prompts_count != null) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b22b634b64676940$export$2e2bcd8739ae039), {
                            emojis: (0, $b22b634b64676940$export$d75782c74c541dbb),
                            next: ()=>{}
                        }, "question-emojis"),
                        /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                            className: "app-curiosity-content",
                            initial: {
                                opacity: 0,
                                y: "100%"
                            },
                            animate: {
                                opacity: 1,
                                y: "0%"
                            },
                            exit: {
                                opacity: 0,
                                y: "-100%"
                            },
                            transition: {
                                duration: 1.0,
                                delay: 0.5,
                                ease: [
                                    0,
                                    0.71,
                                    0.2,
                                    1.01
                                ]
                            },
                            children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "column-layout",
                                children: [
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $a0401e570a895d71$export$1b74141c5fe63a28), {
                                        className: "headline counter-big",
                                        from: 0,
                                        to: data.prompt_stats.answers_count + data.prompt_stats.prompts_count,
                                        duration: 3
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h2", {
                                        children: "Questions"
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("h3", {
                                        className: "light-headline",
                                        children: "sent & answered"
                                    })
                                ]
                            })
                        }, "step-2")
                    ]
                });
            case "ying-yang-1":
                if (data.yingyang != null && !data.yingyang && !data.yingyang.artist1) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                    className: "app-curiosity-content",
                    initial: {
                        opacity: 0,
                        y: "100%"
                    },
                    animate: {
                        opacity: 1,
                        y: "0%"
                    },
                    exit: {
                        opacity: 0,
                        y: "-100%"
                    },
                    transition: {
                        duration: 1.0,
                        delay: 0.5,
                        ease: [
                            0,
                            0.71,
                            0.2,
                            1.01
                        ]
                    },
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                        className: "column-layout curiosity-column ",
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).p, {
                                initial: {
                                    opacity: 0,
                                    y: "100%"
                                },
                                animate: {
                                    opacity: 1,
                                    y: "0%"
                                },
                                exit: {
                                    opacity: 1,
                                    y: "-100%"
                                },
                                transition: {
                                    duration: 1.0,
                                    delay: 0.0,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                children: "Out of your top artists"
                            }, "step-3p-key"),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h3, {
                                initial: {
                                    opacity: 0,
                                    y: "100%"
                                },
                                animate: {
                                    opacity: 1,
                                    y: "0%"
                                },
                                exit: {
                                    opacity: 1,
                                    y: "-100%"
                                },
                                transition: {
                                    duration: 1.0,
                                    delay: 1.5,
                                    ease: [
                                        0,
                                        0.71,
                                        0.2,
                                        1.01
                                    ]
                                },
                                className: "headline-light",
                                children: "these two were the most different from each other"
                            }, "step-3h-key")
                        ]
                    })
                }, "step-3");
            case "ying-yang-2":
                if (data.yingyang != null && !data.yingyang && !data.yingyang.artist1) next();
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                        className: "app-curiosity-content app-curiosity-yingyang",
                        initial: {
                            opacity: 0,
                            y: "100%"
                        },
                        animate: {
                            opacity: 1,
                            y: "0%"
                        },
                        exit: {
                            opacity: 0,
                            y: "-100%"
                        },
                        transition: {
                            duration: 1.0,
                            delay: 0.0,
                            ease: [
                                0,
                                0.71,
                                0.2,
                                1.01
                            ]
                        },
                        children: [
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "yy-center-content",
                                children: [
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                                        initial: {
                                            opacity: 0,
                                            y: "100%"
                                        },
                                        animate: {
                                            opacity: 1,
                                            y: "0%"
                                        },
                                        exit: {
                                            opacity: 1,
                                            y: "-100%"
                                        },
                                        transition: {
                                            duration: 1.0,
                                            delay: 1.5,
                                            ease: [
                                                0,
                                                0.71,
                                                0.2,
                                                1.01
                                            ]
                                        },
                                        className: "curiosity-artist-name",
                                        children: data.yingyang.artist1.name
                                    }, "step-4h1-key"),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $b421c655783740a4$export$e25e478948902b8b).div, {
                                        className: "yingyang",
                                        initial: {
                                            rotate: "0deg"
                                        },
                                        animate: {
                                            rotate: "180deg"
                                        },
                                        exit: {
                                            rotate: "360deg"
                                        },
                                        transition: {
                                            repeat: 3,
                                            repeatType: "mirror",
                                            duration: 2.0,
                                            delay: 4.0,
                                            ease: [
                                                0,
                                                0.71,
                                                0.2,
                                                1.01
                                            ]
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                                                initial: {
                                                    opacity: 0,
                                                    x: "-100%"
                                                },
                                                animate: {
                                                    opacity: 1,
                                                    x: "0%"
                                                },
                                                exit: {
                                                    opacity: 1,
                                                    x: "-100%"
                                                },
                                                transition: {
                                                    duration: 1.0,
                                                    delay: 0.5,
                                                    ease: [
                                                        0,
                                                        0.71,
                                                        0.2,
                                                        1.01
                                                    ]
                                                },
                                                className: "ying",
                                                src: data.yingyang.artist1.artwork,
                                                alt: "read"
                                            }, "ying"),
                                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).img, {
                                                initial: {
                                                    opacity: 0,
                                                    x: "-100%"
                                                },
                                                animate: {
                                                    opacity: 1,
                                                    x: "0%"
                                                },
                                                exit: {
                                                    opacity: 1,
                                                    x: "-100%"
                                                },
                                                transition: {
                                                    duration: 1.0,
                                                    delay: 1.5,
                                                    ease: [
                                                        0,
                                                        0.71,
                                                        0.2,
                                                        1.01
                                                    ]
                                                },
                                                className: "yang",
                                                src: data.yingyang.artist2.artwork,
                                                alt: "read"
                                            }, "yang")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).h1, {
                                        initial: {
                                            opacity: 0,
                                            y: "100%"
                                        },
                                        animate: {
                                            opacity: 1,
                                            y: "0%"
                                        },
                                        exit: {
                                            opacity: 1,
                                            y: "-100%"
                                        },
                                        transition: {
                                            duration: 1.0,
                                            delay: 1.5,
                                            ease: [
                                                0,
                                                0.71,
                                                0.2,
                                                1.01
                                            ]
                                        },
                                        className: "curiosity-artist-name",
                                        children: data.yingyang.artist2.name
                                    }, "step-4h2-key")
                                ]
                            }),
                            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
                                className: "column-layout yy-bottom-content",
                                children: [
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).p, {
                                        initial: {
                                            opacity: 0,
                                            y: "100%"
                                        },
                                        animate: {
                                            opacity: 1,
                                            y: "0%"
                                        },
                                        exit: {
                                            opacity: 1,
                                            y: "-100%"
                                        },
                                        transition: {
                                            duration: 1.0,
                                            delay: 4.5,
                                            ease: [
                                                0,
                                                0.71,
                                                0.2,
                                                1.01
                                            ]
                                        },
                                        children: "ok... eclectic music taste!!"
                                    }, "step-4ht-key"),
                                    /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b421c655783740a4$export$e25e478948902b8b).button, {
                                        initial: {
                                            opacity: 0,
                                            y: "100%"
                                        },
                                        animate: {
                                            opacity: 1,
                                            y: "0%"
                                        },
                                        exit: {
                                            opacity: 1,
                                            y: "-100%"
                                        },
                                        transition: {
                                            duration: 1.0,
                                            delay: 6.5,
                                            ease: [
                                                0,
                                                0.71,
                                                0.2,
                                                1.01
                                            ]
                                        },
                                        onClick: next,
                                        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $17fc925e4b927833$export$3b0a3a1406f56aea), {
                                            title: "next"
                                        })
                                    }, "step-4bt-key")
                                ]
                            })
                        ]
                    }, "step-5")
                });
            case "comeback-message":
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $ae2586eaae775944$export$6feb0569e282a70e), {
                    featureText: "Come back tomorrow to unlock your next stat: Your Airbuds Yearly Recap: shareable asset version \uD83D\uDE0F",
                    next: ()=>{}
                });
            default:
                return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $949ad98624b47189$export$2e2bcd8739ae039), {});
        }
    };
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)("div", {
        className: "app-stats-container curiosity-gradient-background ",
        children: [
            renderState(refCategories.current, step),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$cb5eab83e584f566), {
                className: "",
                prev: previous,
                next: next
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $891bbbacc5f56989$export$e3106ce591b86aaa), {
                closeAction: ()=>{
                    navigate("/menu");
                }
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $9cd772bad9dc8d45$export$2e2bcd8739ae039), {
                className: "story-bar",
                totalPages: categories.length,
                currentPage: step,
                duration: 0
            })
        ]
    });
};






const $34a83e38fb8b3bfc$var$root = document.getElementById("root");
const $34a83e38fb8b3bfc$var$useRootClass = ()=>{
    const location = (0, $96c7c697f6acb9e3$export$45d76561a5302f2b)();
    (0, $ajtHG.useEffect)(()=>{
        const rootElement = document.getElementById("root");
        const path = location.pathname.slice(1) || "home"; // Remove the slash or default to "home"
        rootElement.className = `${path}-screen fixed-screen`;
        if (path == "menu") rootElement.className = `${path}-screen scrollable-screen`;
    }, [
        location
    ]);
};
const $34a83e38fb8b3bfc$var$AppRoute = ()=>{
    $34a83e38fb8b3bfc$var$useRootClass();
    const { pauseMusic: pauseMusic } = (0, $e1bd9c9bc4ba88d5$export$8be4c01406f592a)();
    (0, $ajtHG.useEffect)(()=>{
        window.airbudsMessage = function(message) {
            try {
                const json = JSON.parse(message);
                if (json.hasOwnProperty("enterBackground")) pauseMusic();
            } catch (error) {
                console.log("failed to parse incoming message", message);
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $96c7c697f6acb9e3$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                index: true,
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $f87038cacdd3bc62$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "home",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $1cb9c0fd0ce5cecc$export$b94310965bed44e6), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "intro",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $82844ddb31b5eeae$export$b3c44ac484b3c461), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "sharing",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $949ad98624b47189$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "menu",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $dcedd9fcf24415e9$export$d9b273488cd8ce6f), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "artist",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $91fcc8cfd10476a9$export$1e2322822297ef53), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "artist-top",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b003ae56cfd06cfd$export$5f36f579f4cc8202), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "artist-top-list",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $6830037506aa62af$export$600f06439232a5ee), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "compat",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $962f8d1f1055734c$export$10255bda2baf681), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "validation",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $71adacfbe7bbc045$export$794e892580855985), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "stats",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $be0bbcaaf28c2eb6$export$3cdec2bba15e3523), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "thanks",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $3f2d0f5133e7d55f$export$a572bc837d51c193), {})
            }),
            /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $96c7c697f6acb9e3$export$e7b0ac011bb776c6), {
                path: "curiosity",
                element: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $8f79fac4467d0d99$export$b084ed8e1ba5627b), {})
            })
        ]
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($d84eef864594d615$exports))).createRoot($34a83e38fb8b3bfc$var$root).render(/*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $b6c962eba7db6225$export$43c6ed89e8a21a35), {
    children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $e1bd9c9bc4ba88d5$export$11b4a88f8f4bdfe8), {
        children: /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsxs)((0, $96c7c697f6acb9e3$export$9ba4e89fdfa1fc54), {
            children: [
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)((0, $e306937278b34acb$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9b3c114f2ec1a7b9$exports.jsx)($34a83e38fb8b3bfc$var$AppRoute, {})
            ]
        })
    })
}));


//# sourceMappingURL=index.f62e6ab8.js.map
